import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: any;
  /**
   * Represents textual data as UTF-8 character sequences. This type is most often
   * used by GraphQL to represent free-form human-readable text.
   */
  IP: any;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
};

export type AcademyArticleSearchResult = SearchResultInterface & {
  __typename?: 'AcademyArticleSearchResult';
  article: Article;
  category: Scalars['String'];
};

export type AcademyTopic = {
  __typename?: 'AcademyTopic';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  weight: Scalars['Int'];
};

/** The connection type for AcademyTopic. */
export type AcademyTopicConnection = {
  __typename?: 'AcademyTopicConnection';
  /** A list of edges. */
  edges: Array<AcademyTopicEdge>;
  /** A list of nodes. */
  nodes: Array<AcademyTopic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AcademyTopicEdge = {
  __typename?: 'AcademyTopicEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<AcademyTopic>;
};

/** Autogenerated input type of AcceptRequest */
export type AcceptRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of ActivateJobsInquiry */
export type ActivateJobsInquiryInput = {
  activationOrigin: JobsInquiryActivationOrigin;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export enum Activity {
  Anonymous = 'ANONYMOUS',
  Public = 'PUBLIC'
}

export type Alumni = {
  __typename?: 'Alumni';
  avatarUrl?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  connected?: Maybe<Scalars['Boolean']>;
  currentPosition?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  receivedRequestId?: Maybe<Scalars['ID']>;
  requestId?: Maybe<Scalars['ID']>;
  slug: Scalars['String'];
};

/** The connection type for Alumni. */
export type AlumniConnection = {
  __typename?: 'AlumniConnection';
  /** A list of edges. */
  edges: Array<AlumniEdge>;
  /** A list of nodes. */
  nodes: Array<Alumni>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type AlumniEdge = {
  __typename?: 'AlumniEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Alumni>;
};

export type Anonymous = {
  __typename?: 'Anonymous';
  username?: Maybe<Scalars['String']>;
  warRoomAvatarUrl?: Maybe<Scalars['String']>;
  warRoomPosition: Scalars['String'];
  warRoomUserAchievements: Array<UserAchievement>;
};

/** Autogenerated input type of ApplyForWarRoom */
export type ApplyForWarRoomInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  personalEmail?: InputMaybe<Scalars['String']>;
};

export type ApproveTestimonialAuthorAttributes = {
  linkedinUrl?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of ApproveTestimonialForPublicPortfolioCurrentUser */
export type ApproveTestimonialForPublicPortfolioCurrentUserInput = {
  author?: InputMaybe<ApproveTestimonialAuthorAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  confirmationScreenshotSignedId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of ArchiveCandidateHiring */
export type ArchiveCandidateHiringInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of ArchiveTestimonialForPublicPortfolioCurrentUser */
export type ArchiveTestimonialForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type Article = {
  __typename?: 'Article';
  academyTopic: AcademyTopic;
  author?: Maybe<Author>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isNew: Scalars['Boolean'];
  isSoon: Scalars['Boolean'];
  isUpdated: Scalars['Boolean'];
  markdown?: Maybe<Scalars['String']>;
  previewImage?: Maybe<File>;
  seoDescription?: Maybe<Scalars['String']>;
  seoTitle?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  weight: Scalars['Int'];
};

/** Autogenerated input type of AttachCompanySeriesStage */
export type AttachCompanySeriesStageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companySeriesStageId: Scalars['ID'];
};

/** Autogenerated input type of AttachCompanyStage */
export type AttachCompanyStageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyStageId: Scalars['ID'];
};

/** Autogenerated input type of AttachDepartment */
export type AttachDepartmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['ID'];
};

/** Autogenerated input type of AttachProduct */
export type AttachProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productTypeId: Scalars['ID'];
};

/** Autogenerated input type of AttachSalesRole */
export type AttachSalesRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  salesRoleId: Scalars['ID'];
};

export type Author = {
  __typename?: 'Author';
  avatar?: Maybe<File>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  joinedAt?: Maybe<Scalars['ISO8601DateTime']>;
  linkUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  warRoomProfileSlug?: Maybe<Scalars['String']>;
};

export type AverageHittingQuota = {
  __typename?: 'AverageHittingQuota';
  hitQuotaLastYear: Scalars['Int'];
  segmentName: Scalars['String'];
  total: Scalars['Int'];
};

export type AveragePerAccountSize = {
  __typename?: 'AveragePerAccountSize';
  basePay: Scalars['Float'];
  comissionAtFullQuota: Scalars['Float'];
  customerSegmentId?: Maybe<Scalars['String']>;
  signingPlusStock: Scalars['Float'];
};

export type AveragePerYearsOfExperience = {
  __typename?: 'AveragePerYearsOfExperience';
  basePay: Scalars['Float'];
  comissionAtFullQuota: Scalars['Float'];
  signingPlusStock: Scalars['Float'];
  yearsRange: Scalars['String'];
};

export type AverageSalariesData = {
  __typename?: 'AverageSalariesData';
  averagePerAccountSize: Array<AveragePerAccountSize>;
  averagePerYearsOfExperience: Array<AveragePerYearsOfExperience>;
  averageTotals: AverageTotals;
  hittingQuota: Array<AverageHittingQuota>;
  totalCompensationRange: TotalCompensationRange;
};

export type AverageTotals = {
  __typename?: 'AverageTotals';
  baseSalary: Scalars['Float'];
  commissionAtFullQuota: Scalars['Float'];
  signingPlusStock: Scalars['Float'];
  totalCompensation: Scalars['Float'];
};

export type Award = {
  __typename?: 'Award';
  icon: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  year: Scalars['Int'];
};

export type BaseMatch = {
  __typename?: 'BaseMatch';
  type: Scalars['String'];
};

export type BestCity = {
  __typename?: 'BestCity';
  avgBasePay: Scalars['Float'];
  avgHittingQuotaPercentage: Scalars['Float'];
  avgOte: Scalars['Float'];
  avgOverallRating?: Maybe<Scalars['Float']>;
  avgTotalAnnualCompensation: Scalars['Float'];
  avgWorkLifeBalanceRating?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Autogenerated input type of BlockUser */
export type BlockUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  otherUserUsername: Scalars['String'];
};

/** Autogenerated input type of CancelRequest */
export type CancelRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type CandidateAttributes = {
  annualQuota?: InputMaybe<Scalars['String']>;
  badges?: InputMaybe<Array<JobsHiringBadge>>;
  baseSalary?: InputMaybe<Scalars['String']>;
  bullet1?: InputMaybe<Scalars['String']>;
  bullet2?: InputMaybe<Scalars['String']>;
  csmAccountsNumber?: InputMaybe<Scalars['String']>;
  csmQuotaMetric?: InputMaybe<Scalars['String']>;
  csmQuotaType?: InputMaybe<Scalars['String']>;
  csmRenewalValue?: InputMaybe<Scalars['String']>;
  csmTotalBusinessValue?: InputMaybe<Scalars['String']>;
  csmUpsellValue?: InputMaybe<Scalars['String']>;
  dealSize?: InputMaybe<Scalars['String']>;
  flexAppliedCriteria?: InputMaybe<Array<JobsFlexAppliedCriteria>>;
  flexBandwidth?: InputMaybe<Scalars['String']>;
  flexBriefVideoUrl?: InputMaybe<Scalars['String']>;
  flexPreviousExperience?: InputMaybe<Scalars['String']>;
  flexRating?: InputMaybe<Scalars['Float']>;
  flexReasonForParticipation?: InputMaybe<Scalars['String']>;
  flexRoles?: InputMaybe<Array<JobsFlexRole>>;
  flexUnderstandingOfSales?: InputMaybe<Scalars['String']>;
  headline1?: InputMaybe<Scalars['String']>;
  headline2?: InputMaybe<Scalars['String']>;
  headline3?: InputMaybe<Scalars['String']>;
  idealJobDescription?: InputMaybe<Scalars['String']>;
  leadSources?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  marketingHeadline?: InputMaybe<Scalars['String']>;
  ote?: InputMaybe<Scalars['String']>;
  quotaAttainmentByTeamPerPeriod?: InputMaybe<Scalars['String']>;
  quotaAttainmentPerLastYear?: InputMaybe<Scalars['String']>;
  quotaAttainmentPerPeriod?: InputMaybe<Scalars['String']>;
  salesCycleLength?: InputMaybe<Scalars['String']>;
  teamRanking?: InputMaybe<Scalars['String']>;
  vpDepartmentSize?: InputMaybe<Scalars['String']>;
  vpManagedRoles?: InputMaybe<Scalars['String']>;
  vpQuotaType?: InputMaybe<Scalars['String']>;
};

export type CandidateAttributesVisability = {
  isAnnualQuotaVisible?: InputMaybe<Scalars['Boolean']>;
  isBaseSalaryVisible?: InputMaybe<Scalars['Boolean']>;
  isBullet1Visible?: InputMaybe<Scalars['Boolean']>;
  isBullet2Visible?: InputMaybe<Scalars['Boolean']>;
  isClientsVisible?: InputMaybe<Scalars['Boolean']>;
  isCsmAccountsNumberVisible?: InputMaybe<Scalars['Boolean']>;
  isCsmQuotaMetricVisible?: InputMaybe<Scalars['Boolean']>;
  isCsmQuotaTypeVisible?: InputMaybe<Scalars['Boolean']>;
  isCsmRenewalValueVisible?: InputMaybe<Scalars['Boolean']>;
  isCsmTotalBusinessValueVisible?: InputMaybe<Scalars['Boolean']>;
  isCsmUpsellValueVisible?: InputMaybe<Scalars['Boolean']>;
  isDealSizeVisible?: InputMaybe<Scalars['Boolean']>;
  isDepartmentsVisible?: InputMaybe<Scalars['Boolean']>;
  isFlexAppliedCriteriaVisible?: InputMaybe<Scalars['Boolean']>;
  isFlexBandwidthVisible?: InputMaybe<Scalars['Boolean']>;
  isFlexBriefVideoUrlVisible?: InputMaybe<Scalars['Boolean']>;
  isFlexPreviousExperienceVisible?: InputMaybe<Scalars['Boolean']>;
  isFlexRatingVisible?: InputMaybe<Scalars['Boolean']>;
  isFlexReasonForParticipationVisible?: InputMaybe<Scalars['Boolean']>;
  isFlexRolesVisible?: InputMaybe<Scalars['Boolean']>;
  isFlexUnderstandingOfSalesVisible?: InputMaybe<Scalars['Boolean']>;
  isHeadline1Visible?: InputMaybe<Scalars['Boolean']>;
  isHeadline2Visible?: InputMaybe<Scalars['Boolean']>;
  isHeadline3Visible?: InputMaybe<Scalars['Boolean']>;
  isIdealJobDescriptionVisible?: InputMaybe<Scalars['Boolean']>;
  isLeadSourcesVisible?: InputMaybe<Scalars['Boolean']>;
  isLinkedinUrlVisible?: InputMaybe<Scalars['Boolean']>;
  isMarketingHeadlineVisible?: InputMaybe<Scalars['Boolean']>;
  isOteVisible?: InputMaybe<Scalars['Boolean']>;
  isQuotaAttainmentByTeamPerPeriodVisible?: InputMaybe<Scalars['Boolean']>;
  isQuotaAttainmentPerLastYearVisible?: InputMaybe<Scalars['Boolean']>;
  isQuotaAttainmentPerPeriodVisible?: InputMaybe<Scalars['Boolean']>;
  isSalesCycleLengthVisible?: InputMaybe<Scalars['Boolean']>;
  isTeamRankingVisible?: InputMaybe<Scalars['Boolean']>;
  isVpDepartmentSizeVisible?: InputMaybe<Scalars['Boolean']>;
  isVpManagedRolesVisible?: InputMaybe<Scalars['Boolean']>;
  isVpQuotaTypeVisible?: InputMaybe<Scalars['Boolean']>;
  isWorkHistoriesVisible?: InputMaybe<Scalars['Boolean']>;
};

export type City = {
  __typename?: 'City';
  continentCode: Scalars['String'];
  continentName: Scalars['String'];
  countryCode: Scalars['String'];
  countryFlagEmoji?: Maybe<Scalars['String']>;
  countryName: Scalars['String'];
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  metroAreaShortName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  stateCode?: Maybe<Scalars['String']>;
  stateName?: Maybe<Scalars['String']>;
};

/** The connection type for City. */
export type CityConnection = {
  __typename?: 'CityConnection';
  /** A list of edges. */
  edges: Array<CityEdge>;
  /** A list of nodes. */
  nodes: Array<City>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CityEdge = {
  __typename?: 'CityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<City>;
};

export type CityMatch = {
  __typename?: 'CityMatch';
  cityName: Scalars['String'];
  type: Scalars['String'];
};

export type CitySearchParams = {
  countryName?: InputMaybe<Scalars['String']>;
  countryNames?: InputMaybe<Array<Scalars['String']>>;
  ip?: InputMaybe<Scalars['IP']>;
  position?: InputMaybe<GeoPositionAttributes>;
  term?: InputMaybe<Scalars['String']>;
};

export type Client = {
  __typename?: 'Client';
  company: Company;
  id: Scalars['ID'];
  isPublic: Scalars['Boolean'];
  position?: Maybe<Scalars['Int']>;
  workHistory?: Maybe<WorkHistory>;
};

export type Comment = {
  __typename?: 'Comment';
  author: UserAuthor;
  children: CommentConnection;
  createdAt: Scalars['ISO8601DateTime'];
  currentUserRating?: Maybe<Rating>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  highlightedText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAnonymous: Scalars['Boolean'];
  markedByUser?: Maybe<User>;
  media?: Maybe<File>;
  parent?: Maybe<Comment>;
  parentId?: Maybe<Scalars['Int']>;
  post: Post;
  postId: Scalars['Int'];
  previewText?: Maybe<Scalars['String']>;
  ratings: RatingConnection;
  rawText: Scalars['String'];
  text: Scalars['String'];
  textUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  totalRating: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
};


export type CommentChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CommentRatingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Comment. */
export type CommentConnection = {
  __typename?: 'CommentConnection';
  /** A list of edges. */
  edges: Array<CommentEdge>;
  /** A list of nodes. */
  nodes: Array<Comment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CommentEdge = {
  __typename?: 'CommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Comment>;
};

export enum CommentSortType {
  Best = 'best',
  Newest = 'newest'
}

export type CommissionBalance = {
  __typename?: 'CommissionBalance';
  currentBalance: Scalars['Int'];
  delta: Scalars['Int'];
};

export type CommissionOnboarding = {
  __typename?: 'CommissionOnboarding';
  items?: Maybe<Array<EarnItem>>;
  product?: Maybe<Scalars['JSON']>;
  type: Scalars['String'];
};

export type CommissionTransaction = {
  __typename?: 'CommissionTransaction';
  amount: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
};

/** Autogenerated return type of CommissionTransactionSubscription */
export type CommissionTransactionSubscriptionPayload = {
  __typename?: 'CommissionTransactionSubscriptionPayload';
  commissionChange?: Maybe<CommissionBalance>;
};

export type CompaniesCategory = {
  __typename?: 'CompaniesCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** The connection type for Company. */
export type CompaniesConnection = {
  __typename?: 'CompaniesConnection';
  /** A list of edges. */
  edges: Array<CompanyEdge>;
  /** A list of nodes. */
  nodes: Array<Company>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCompaniesWithData: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export enum CompaniesSort {
  AverageCompensation = 'AVERAGE_COMPENSATION',
  Name = 'NAME',
  Ranking = 'RANKING'
}

export type Company = CompanyInterface & {
  __typename?: 'Company';
  averageTimeForAPromotion?: Maybe<Scalars['Float']>;
  averageTimeForPromotion?: Maybe<CompanyPagesAverageRate>;
  averageTimeInTheCompany?: Maybe<Scalars['Float']>;
  averageWorktime?: Maybe<CompanyPagesAverageRate>;
  categories?: Maybe<Array<Scalars['String']>>;
  companyPagesSlug?: Maybe<Scalars['String']>;
  compensationRange?: Maybe<CompanyPagesRange>;
  compensationRanking?: Maybe<Scalars['Float']>;
  compensationRating?: Maybe<Scalars['Float']>;
  custom?: Maybe<Scalars['Boolean']>;
  domain?: Maybe<Scalars['String']>;
  employeeCount?: Maybe<Scalars['String']>;
  fullDescription?: Maybe<Scalars['String']>;
  hitQuota?: Maybe<CompanyPagesAverageRate>;
  homepageUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industries?: Maybe<Array<Industry>>;
  interviews?: Maybe<CompanyPagesInterviewConnection>;
  investmentRound?: Maybe<Scalars['String']>;
  jobSatisfactionRanking?: Maybe<Scalars['Float']>;
  jobSatisfactionRating?: Maybe<Scalars['Float']>;
  location?: Maybe<City>;
  logoUrl?: Maybe<Scalars['String']>;
  lowerName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  overallRanking?: Maybe<Scalars['Float']>;
  overallRating?: Maybe<Scalars['Float']>;
  quotaFairnessRanking?: Maybe<Scalars['Float']>;
  quotaFairnessRating?: Maybe<Scalars['Float']>;
  relatedCompanyPages?: Maybe<RelatedCompanyPageResponse>;
  repsHittingQuotaPercentage?: Maybe<Scalars['Float']>;
  repsHittingQuotaRanking?: Maybe<Scalars['Float']>;
  repsHittingQuotaRating?: Maybe<Scalars['Float']>;
  reviews?: Maybe<CompanyPagesReviewConnection>;
  roles?: Maybe<Array<CompanyPagesRole>>;
  salesTeam?: Maybe<CompanyPagesSalesTeam>;
  shortDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  totalFunding?: Maybe<Scalars['BigInt']>;
  webSiteUrl?: Maybe<Scalars['String']>;
  workLifeBalanceRanking?: Maybe<Scalars['Float']>;
  workLifeBalanceRating?: Maybe<Scalars['Float']>;
};


export type CompanyInterviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyReviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CompanyRolesArgs = {
  roleCategoryId?: InputMaybe<Scalars['ID']>;
};

/** An edge in a connection. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Company>;
};

export type CompanyInterface = {
  employeeCount?: Maybe<Scalars['String']>;
  fullDescription?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  investmentRound?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  shortDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  totalFunding?: Maybe<Scalars['BigInt']>;
  webSiteUrl?: Maybe<Scalars['String']>;
};

export type CompanyPagesAverageRate = {
  __typename?: 'CompanyPagesAverageRate';
  rate?: Maybe<CompanyPagesRate>;
  value?: Maybe<Scalars['Float']>;
};

export type CompanyPagesCatalog = {
  __typename?: 'CompanyPagesCatalog';
  company?: Maybe<Company>;
  content?: Maybe<Scalars['String']>;
  customerSegment?: Maybe<CustomerSegment>;
  id: Scalars['ID'];
  pageType: CompanyPagesCatalogPageType;
  region?: Maybe<Region>;
  roleCategory?: Maybe<RoleCategory>;
  title: Scalars['String'];
};

export enum CompanyPagesCatalogPageType {
  Compensation = 'COMPENSATION',
  Interviews = 'INTERVIEWS',
  Overview = 'OVERVIEW',
  Reviews = 'REVIEWS',
  Salaries = 'SALARIES'
}

export type CompanyPagesCatalogSearchResult = SearchResultInterface & {
  __typename?: 'CompanyPagesCatalogSearchResult';
  category: Scalars['String'];
  page: CompanyPagesCatalog;
};

/** Autogenerated input type of CompanyPagesCreateInterview */
export type CompanyPagesCreateInterviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  difficulty?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  interviewedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  jobTitle: Scalars['String'];
  locationId?: InputMaybe<Scalars['ID']>;
  org?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  outcome?: InputMaybe<Scalars['String']>;
  process?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Scalars['String']>;
  recommendationToPrepare?: InputMaybe<Scalars['String']>;
  roleCategoryId?: InputMaybe<Scalars['ID']>;
  totalInterviews?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of CompanyPagesCreateReview */
export type CompanyPagesCreateReviewInput = {
  aboutCulture?: InputMaybe<Scalars['String']>;
  adviceForNewReps?: InputMaybe<Scalars['String']>;
  adviceToManagment?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  cons?: InputMaybe<Scalars['String']>;
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  isRecommended?: InputMaybe<Scalars['Boolean']>;
  jobTitle: Scalars['String'];
  level?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['ID']>;
  org?: InputMaybe<Scalars['String']>;
  overallRating?: InputMaybe<Scalars['Float']>;
  pros?: InputMaybe<Scalars['String']>;
  quotaFairness?: InputMaybe<Scalars['Int']>;
  roleCategoryId?: InputMaybe<Scalars['ID']>;
  salesRepTurnover?: InputMaybe<Scalars['String']>;
  trajectory?: InputMaybe<Scalars['String']>;
  upwardMobility?: InputMaybe<Scalars['String']>;
  workLifeBalance?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of CompanyPagesCreateSalary */
export type CompanyPagesCreateSalaryInput = {
  basePay?: InputMaybe<Scalars['Float']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comissionAtFullQuota?: InputMaybe<Scalars['Float']>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyPagesRoleId?: InputMaybe<Scalars['ID']>;
  companyYearsOfExperience?: InputMaybe<Scalars['Int']>;
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  entryDate?: InputMaybe<Scalars['ISO8601Date']>;
  hitCompensation?: InputMaybe<Scalars['Boolean']>;
  hitQuotaLastYear?: InputMaybe<Scalars['Boolean']>;
  jobTitle: Scalars['String'];
  level?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['ID']>;
  org?: InputMaybe<Scalars['String']>;
  ote?: InputMaybe<Scalars['Float']>;
  prevYearTotalCompensation?: InputMaybe<Scalars['Float']>;
  roleCategoryId?: InputMaybe<Scalars['ID']>;
  signingBonus?: InputMaybe<Scalars['Float']>;
  signingPlusStock?: InputMaybe<Scalars['Float']>;
  stockBonus?: InputMaybe<Scalars['Float']>;
  totalAnnualCompensation?: InputMaybe<Scalars['Float']>;
  totalYearsOfExperience?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of CompanyPagesDestroyInterview */
export type CompanyPagesDestroyInterviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of CompanyPagesDestroyReview */
export type CompanyPagesDestroyReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of CompanyPagesDestroySalary */
export type CompanyPagesDestroySalaryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type CompanyPagesInterview = {
  __typename?: 'CompanyPagesInterview';
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  customerSegment?: Maybe<CustomerSegment>;
  difficulty?: Maybe<CompanyPagesInterviewsDifficulty>;
  duration?: Maybe<CompanyPagesInterviewsDuration>;
  id: Scalars['ID'];
  interviewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  jobTitle: Scalars['String'];
  location?: Maybe<City>;
  org?: Maybe<Scalars['String']>;
  origin?: Maybe<CompanyPagesInterviewsOrigin>;
  outcome?: Maybe<CompanyPagesInterviewsOutcome>;
  process?: Maybe<Scalars['String']>;
  questions?: Maybe<Scalars['String']>;
  recommendationToPrepare?: Maybe<Scalars['String']>;
  roleCategory?: Maybe<RoleCategory>;
  totalInterviews?: Maybe<Scalars['Int']>;
};

/** The connection type for CompanyPagesInterview. */
export type CompanyPagesInterviewConnection = {
  __typename?: 'CompanyPagesInterviewConnection';
  /** A list of edges. */
  edges: Array<CompanyPagesInterviewEdge>;
  /** A list of nodes. */
  nodes: Array<CompanyPagesInterview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CompanyPagesInterviewEdge = {
  __typename?: 'CompanyPagesInterviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CompanyPagesInterview>;
};

export enum CompanyPagesInterviewsDifficulty {
  Easy = 'EASY',
  Hard = 'HARD',
  Medium = 'MEDIUM'
}

export enum CompanyPagesInterviewsDuration {
  Duration_0_2Weeks = 'DURATION_0_2_WEEKS',
  Duration_2_4Weeks = 'DURATION_2_4_WEEKS',
  Duration_4_6Weeks = 'DURATION_4_6_WEEKS',
  Duration_6_8Weeks = 'DURATION_6_8_WEEKS',
  Duration_8_12Weeks = 'DURATION_8_12_WEEKS',
  Duration_12PlusWeeks = 'DURATION_12_PLUS_WEEKS'
}

export enum CompanyPagesInterviewsOrigin {
  AppliedOnline = 'APPLIED_ONLINE',
  InternalOpportunity = 'INTERNAL_OPPORTUNITY',
  JobCareerFair = 'JOB_CAREER_FAIR',
  ReachedOutToARecruiter = 'REACHED_OUT_TO_A_RECRUITER',
  RecruiterReachedOutToMe = 'RECRUITER_REACHED_OUT_TO_ME',
  ReferredByACurrentEmployee = 'REFERRED_BY_A_CURRENT_EMPLOYEE'
}

export enum CompanyPagesInterviewsOutcome {
  AcceptedOffer = 'ACCEPTED_OFFER',
  Declined = 'DECLINED',
  NoOffer = 'NO_OFFER',
  OfferReceived = 'OFFER_RECEIVED',
  WaitingToHearBack = 'WAITING_TO_HEAR_BACK'
}

export type CompanyPagesRange = {
  __typename?: 'CompanyPagesRange';
  avg?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export enum CompanyPagesRate {
  Good = 'GOOD',
  Low = 'LOW',
  Med = 'MED'
}

export type CompanyPagesReview = {
  __typename?: 'CompanyPagesReview';
  aboutCulture?: Maybe<Scalars['String']>;
  adviceForNewReps?: Maybe<Scalars['String']>;
  adviceToManagment?: Maybe<Scalars['String']>;
  company?: Maybe<Company>;
  cons?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  customerSegment?: Maybe<CustomerSegment>;
  id: Scalars['ID'];
  isRecommended?: Maybe<Scalars['Boolean']>;
  jobTitle: Scalars['String'];
  level?: Maybe<Scalars['String']>;
  location?: Maybe<City>;
  org?: Maybe<Scalars['String']>;
  overallRating: Scalars['Float'];
  pros?: Maybe<Scalars['String']>;
  quotaFairness?: Maybe<Scalars['Int']>;
  roleCategory?: Maybe<RoleCategory>;
  salesRepTurnover?: Maybe<CompanyPagesReviewsSalesRepTurnover>;
  trajectory?: Maybe<CompanyPagesReviewsTrajectory>;
  upwardMobility?: Maybe<CompanyPagesReviewsUpwardMobility>;
  workLifeBalance?: Maybe<Scalars['Int']>;
};

/** The connection type for CompanyPagesReview. */
export type CompanyPagesReviewConnection = {
  __typename?: 'CompanyPagesReviewConnection';
  /** A list of edges. */
  edges: Array<CompanyPagesReviewEdge>;
  /** A list of nodes. */
  nodes: Array<CompanyPagesReview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CompanyPagesReviewEdge = {
  __typename?: 'CompanyPagesReviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CompanyPagesReview>;
};

export enum CompanyPagesReviewsSalesRepTurnover {
  Average = 'AVERAGE',
  High = 'HIGH',
  Low = 'LOW'
}

export enum CompanyPagesReviewsTrajectory {
  Decline = 'DECLINE',
  Growth = 'GROWTH',
  Stagnant = 'STAGNANT'
}

export enum CompanyPagesReviewsUpwardMobility {
  No = 'NO',
  Some = 'SOME',
  Strong = 'STRONG'
}

export type CompanyPagesRole = {
  __typename?: 'CompanyPagesRole';
  baseRange?: Maybe<CompanyPagesRange>;
  baseRangeRelativeAverage?: Maybe<Scalars['Float']>;
  commissionRange?: Maybe<CompanyPagesRange>;
  company?: Maybe<Company>;
  id: Scalars['ID'];
  oteRange?: Maybe<CompanyPagesRange>;
  oteRangeRelativeAverage?: Maybe<Scalars['Float']>;
  roleCategory: RoleCategory;
  salaries?: Maybe<Array<CompanyPagesSalary>>;
  totalCompensationRange?: Maybe<CompanyPagesTotalCompensationRange>;
};


export type CompanyPagesRoleSalariesArgs = {
  location?: InputMaybe<Scalars['String']>;
};

/** The connection type for CompanyPagesRole. */
export type CompanyPagesRoleConnection = {
  __typename?: 'CompanyPagesRoleConnection';
  /** A list of edges. */
  edges: Array<CompanyPagesRoleEdge>;
  /** A list of nodes. */
  nodes: Array<CompanyPagesRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CompanyPagesRoleEdge = {
  __typename?: 'CompanyPagesRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CompanyPagesRole>;
};

export type CompanyPagesSalary = {
  __typename?: 'CompanyPagesSalary';
  accountSize?: Maybe<CustomerSegment>;
  basePay?: Maybe<Scalars['Float']>;
  comissionAtFullQuota?: Maybe<Scalars['Float']>;
  companyYearsOfExperience?: Maybe<Scalars['Int']>;
  entryDate?: Maybe<Scalars['ISO8601Date']>;
  hitCompensation?: Maybe<Scalars['Boolean']>;
  hitQuotaLastYear?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  jobTitle?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
  location?: Maybe<City>;
  org?: Maybe<Scalars['String']>;
  ote?: Maybe<Scalars['Float']>;
  prevYearTotalCompensation?: Maybe<Scalars['Float']>;
  role?: Maybe<CompanyPagesRole>;
  signingBonus?: Maybe<Scalars['Float']>;
  signingPlusStock?: Maybe<Scalars['Float']>;
  stockBonus?: Maybe<Scalars['Float']>;
  totalAnnualCompensation?: Maybe<Scalars['Float']>;
  totalYearsOfExperience?: Maybe<Scalars['Int']>;
};

export type CompanyPagesSalesTeam = {
  __typename?: 'CompanyPagesSalesTeam';
  id: Scalars['ID'];
  peopleWorkingLonger: Scalars['Float'];
  peopleWorkingLongerAverage: Scalars['Float'];
  tenureAverage: SalesTeamTenureAverages;
  timeToPromotion: Scalars['Float'];
  timeToPromotionAverage: Scalars['Float'];
};

export type CompanyPagesTotalCompensationRange = {
  __typename?: 'CompanyPagesTotalCompensationRange';
  average?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

/** Autogenerated input type of CompanyPagesUpdateInterview */
export type CompanyPagesUpdateInterviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  difficulty?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  interviewedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  jobTitle: Scalars['String'];
  locationId?: InputMaybe<Scalars['ID']>;
  org?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  outcome?: InputMaybe<Scalars['String']>;
  process?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Scalars['String']>;
  recommendationToPrepare?: InputMaybe<Scalars['String']>;
  roleCategoryId?: InputMaybe<Scalars['ID']>;
  totalInterviews?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of CompanyPagesUpdateReview */
export type CompanyPagesUpdateReviewInput = {
  aboutCulture?: InputMaybe<Scalars['String']>;
  adviceForNewReps?: InputMaybe<Scalars['String']>;
  adviceToManagment?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  cons?: InputMaybe<Scalars['String']>;
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  isRecommended?: InputMaybe<Scalars['Boolean']>;
  jobTitle: Scalars['String'];
  level?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['ID']>;
  org?: InputMaybe<Scalars['String']>;
  overallRating?: InputMaybe<Scalars['Float']>;
  pros?: InputMaybe<Scalars['String']>;
  quotaFairness?: InputMaybe<Scalars['Int']>;
  roleCategoryId?: InputMaybe<Scalars['ID']>;
  salesRepTurnover?: InputMaybe<Scalars['String']>;
  trajectory?: InputMaybe<Scalars['String']>;
  upwardMobility?: InputMaybe<Scalars['String']>;
  workLifeBalance?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of CompanyPagesUpdateSalary */
export type CompanyPagesUpdateSalaryInput = {
  basePay?: InputMaybe<Scalars['Float']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comissionAtFullQuota?: InputMaybe<Scalars['Float']>;
  companyId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyPagesRoleId?: InputMaybe<Scalars['ID']>;
  companyYearsOfExperience?: InputMaybe<Scalars['Int']>;
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  entryDate?: InputMaybe<Scalars['ISO8601Date']>;
  hitCompensation?: InputMaybe<Scalars['Boolean']>;
  hitQuotaLastYear?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  jobTitle: Scalars['String'];
  level?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['ID']>;
  org?: InputMaybe<Scalars['String']>;
  ote?: InputMaybe<Scalars['Float']>;
  prevYearTotalCompensation?: InputMaybe<Scalars['Float']>;
  roleCategoryId?: InputMaybe<Scalars['ID']>;
  signingBonus?: InputMaybe<Scalars['Float']>;
  signingPlusStock?: InputMaybe<Scalars['Float']>;
  stockBonus?: InputMaybe<Scalars['Float']>;
  totalAnnualCompensation?: InputMaybe<Scalars['Float']>;
  totalYearsOfExperience?: InputMaybe<Scalars['Int']>;
};

export type CompanySearchResult = SearchResultInterface & {
  __typename?: 'CompanySearchResult';
  category: Scalars['String'];
  company: Company;
};

export type CompanySeriesStage = {
  __typename?: 'CompanySeriesStage';
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: CompanySeriesStageSlug;
};

export enum CompanySeriesStageSlug {
  Bootstrapped = 'BOOTSTRAPPED',
  Growth = 'GROWTH',
  Large = 'LARGE',
  Massive = 'MASSIVE',
  Startup = 'STARTUP'
}

export type CompanyStage = {
  __typename?: 'CompanyStage';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Autogenerated input type of CompleteTooltip */
export type CompleteTooltipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  task: Scalars['String'];
};

/** Autogenerated input type of ConfirmTermsOfServiceByPotentialEmployer */
export type ConfirmTermsOfServiceByPotentialEmployerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  hashid: Scalars['ID'];
};

export type Connection = {
  __typename?: 'Connection';
  avatarUrl?: Maybe<Scalars['String']>;
  connected?: Maybe<Scalars['Boolean']>;
  currentCompany?: Maybe<Company>;
  currentPosition?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  receivedRequestId?: Maybe<Scalars['ID']>;
  requestId?: Maybe<Scalars['ID']>;
  slug: Scalars['String'];
};

/** The connection type for Connection. */
export type ConnectionConnection = {
  __typename?: 'ConnectionConnection';
  /** A list of edges. */
  edges: Array<ConnectionEdge>;
  /** A list of nodes. */
  nodes: Array<Connection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ConnectionEdge = {
  __typename?: 'ConnectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Connection>;
};

export type ConnectionSuggestionInterface = {
  id: Scalars['ID'];
  name: Scalars['String'];
  position?: Maybe<Scalars['String']>;
};

/** The connection type for ConnectionSuggestionInterface. */
export type ConnectionSuggestionInterfaceConnection = {
  __typename?: 'ConnectionSuggestionInterfaceConnection';
  /** A list of edges. */
  edges: Array<ConnectionSuggestionInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<ConnectionSuggestionInterface>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ConnectionSuggestionInterfaceEdge = {
  __typename?: 'ConnectionSuggestionInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ConnectionSuggestionInterface>;
};

export enum ConnectionSuggestionType {
  Colleagues = 'colleagues',
  Salespeople = 'salespeople',
  TopSuggestions = 'topSuggestions'
}

export type ConnectionTopSuggestionUser = ConnectionSuggestionInterface & {
  __typename?: 'ConnectionTopSuggestionUser';
  avatarUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  position?: Maybe<Scalars['String']>;
};

export type Contacts = {
  __typename?: 'Contacts';
  email?: Maybe<Scalars['String']>;
};

export type Content = DealStory | Link | LinkedinPost | Story | YoutubeLink;

export type Country = {
  __typename?: 'Country';
  name: Scalars['String'];
  shortName: Scalars['String'];
};

export type CountryState = {
  __typename?: 'CountryState';
  name: Scalars['String'];
};

/** Autogenerated input type of CreateAwardForPublicPortfolioCurrentUser */
export type CreateAwardForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  year: Scalars['Int'];
};

/** Autogenerated input type of CreateClientForPublicPortfolioCurrentUser */
export type CreateClientForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  origin?: InputMaybe<Scalars['String']>;
  workHistoryId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of CreateComment */
export type CreateCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']>;
  media?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  postId: Scalars['ID'];
  text: Scalars['String'];
};

/** Autogenerated input type of CreateConnections */
export type CreateConnectionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  unselectedColleagueIds: Array<Scalars['ID']>;
  unselectedSalespeopleIds: Array<Scalars['ID']>;
  unselectedTopSuggestionIds: Array<Scalars['ID']>;
};

/** Autogenerated input type of CreateCustomCompany */
export type CreateCustomCompanyInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  industryIds?: InputMaybe<Array<Scalars['Int']>>;
  logoUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Autogenerated input type of CreateCustomDepartment */
export type CreateCustomDepartmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Autogenerated input type of CreateCustomProduct */
export type CreateCustomProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Autogenerated input type of CreateCustomSalesRole */
export type CreateCustomSalesRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Autogenerated input type of CreateCustomUniversity */
export type CreateCustomUniversityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateDealAttributes = {
  amount: Scalars['Float'];
  closeDate: Scalars['ISO8601DateTime'];
  company: FindOrCreateCompanyAttributes;
  departments: Array<FindOrCreateDepartmentAttributes>;
  isPrivateCompany: Scalars['Boolean'];
  isPrivateDepartments: Scalars['Boolean'];
  post?: InputMaybe<DealStoryPostAttributes>;
  source?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreateDeals */
export type CreateDealsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  deals: Array<CreateDealAttributes>;
};

/** Autogenerated input type of CreateDealsSource */
export type CreateDealsSourceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  signedId: Scalars['String'];
};

/** Autogenerated input type of CreateEducationHistoryForPublicPortfolioCurrentUser */
export type CreateEducationHistoryForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  degreeName: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  fieldOfStudy: Scalars['String'];
  startDate: Scalars['ISO8601DateTime'];
  universityId: Scalars['ID'];
};

/** Autogenerated input type of CreatePollVote */
export type CreatePollVoteInput = {
  choiceId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of CreatePost */
export type CreatePostInput = {
  category: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<Scalars['String']>>;
  isAnonymous?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<Scalars['String']>;
  poll?: InputMaybe<PollAttributes>;
  salesGptSessionId?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  topicIds: Array<Scalars['Int']>;
};

/** Autogenerated input type of CreatePotentialEmployer */
export type CreatePotentialEmployerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyBusinessAddress?: InputMaybe<Scalars['String']>;
  companyDomain?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  numberOfHirings?: InputMaybe<Scalars['String']>;
  otherRoles?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  rolesOfHirings?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated input type of CreateRating */
export type CreateRatingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  reactableId: Scalars['ID'];
  reactableType: Scalars['String'];
  value: Scalars['Int'];
};

/** Autogenerated input type of CreateRequest */
export type CreateRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};

/** Autogenerated input type of CreateTopic */
export type CreateTopicInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  emoji: Scalars['String'];
  name: Scalars['String'];
};

/** Autogenerated input type of CreateWorkHistoryForPublicPortfolioCurrentUser */
export type CreateWorkHistoryForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
  currentWorkplace: Scalars['Boolean'];
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  origin?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  title: Scalars['String'];
};

export enum Currency {
  Inr = 'INR',
  Usd = 'USD'
}

export type CurrentUser = {
  __typename?: 'CurrentUser';
  abTests?: Maybe<Array<Scalars['String']>>;
  achievements?: Maybe<Array<UserAchievement>>;
  achievementsProgress?: Maybe<Array<UserAchievement>>;
  address?: Maybe<Scalars['String']>;
  admin?: Maybe<Scalars['Boolean']>;
  autoName?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['ISO8601Date']>;
  calendarLink?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  commentsCount: Scalars['Int'];
  company?: Maybe<Company>;
  companySeriesStages?: Maybe<Array<CompanySeriesStage>>;
  companyStages?: Maybe<Array<CompanyStage>>;
  contacts?: Maybe<Array<UserContact>>;
  createdAt: Scalars['ISO8601DateTime'];
  departmentIds?: Maybe<Array<Scalars['Int']>>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  enabledFeatures?: Maybe<Array<Scalars['String']>>;
  facebookUrl?: Maybe<Scalars['String']>;
  fakeVacancyIds: Array<Scalars['Int']>;
  firstname?: Maybe<Scalars['String']>;
  hasSeenNewReferProgram?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  industries?: Maybe<Array<Industry>>;
  industry?: Maybe<Scalars['String']>;
  instagramUrl?: Maybe<Scalars['String']>;
  inviteReferrerUser?: Maybe<User>;
  languages?: Maybe<Scalars['String']>;
  lastColleaguesSyncError?: Maybe<Scalars['String']>;
  lastColleaguesSyncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastContactsSyncError?: Maybe<Scalars['String']>;
  lastContactsSyncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastLinkedinSyncError?: Maybe<Scalars['String']>;
  lastLinkedinSyncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastSeenAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastname?: Maybe<Scalars['String']>;
  linkedinProfilePicUrl?: Maybe<Scalars['String']>;
  linkedinSlug?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  marker?: Maybe<Scalars['String']>;
  onboardingState: Scalars['String'];
  onboardingVacancy?: Maybe<JobsVacancy>;
  orderPosition?: Maybe<Scalars['Int']>;
  personalEmail?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  posts?: Maybe<Array<Post>>;
  postsCount: Scalars['Int'];
  prevScore?: Maybe<Scalars['Int']>;
  privateHash: Scalars['String'];
  productTypeIds?: Maybe<Array<Scalars['Int']>>;
  productTypes?: Maybe<Array<ProductType>>;
  public: Scalars['Boolean'];
  publicEmail?: Maybe<Scalars['String']>;
  referralsCount: Scalars['Int'];
  role?: Maybe<Scalars['String']>;
  salesRoles?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  solidClients?: Maybe<Array<Client>>;
  submittedCompaniesData: Scalars['Boolean'];
  superInviteMarker?: Maybe<Scalars['String']>;
  tooltips?: Maybe<Array<Scalars['String']>>;
  toured?: Maybe<Scalars['Boolean']>;
  twitterUrl?: Maybe<Scalars['String']>;
  uiTheme?: Maybe<Scalars['String']>;
  unreadConnectionRequestsCount: Scalars['Int'];
  unreadWarRoomNotifications?: Maybe<Scalars['Boolean']>;
  unseenWarRoomNotifications?: Maybe<Scalars['Boolean']>;
  unusedSuperInvitesCount: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  username?: Maybe<Scalars['String']>;
  warRoomAvatarUrl?: Maybe<Scalars['String']>;
  warRoomCompanySeriesStageIds?: Maybe<Array<Scalars['Int']>>;
  warRoomCompanyStageIds?: Maybe<Array<Scalars['Int']>>;
  warRoomCurrentBalance?: Maybe<Scalars['Int']>;
  warRoomDescription?: Maybe<Scalars['String']>;
  warRoomIndustryIds?: Maybe<Array<Scalars['Int']>>;
  warRoomJobSearchStatus?: Maybe<Scalars['String']>;
  warRoomJobSearchStatusExpiredAt?: Maybe<Scalars['ISO8601DateTime']>;
  warRoomPosition?: Maybe<Scalars['String']>;
  warRoomSalesRoleIds?: Maybe<Array<Scalars['Int']>>;
  warRoomSalesRoles?: Maybe<Array<SalesRole>>;
  warRoomState: Scalars['String'];
  warRoomTotalBalance?: Maybe<Scalars['Int']>;
  warRoomYearsOfExperience?: Maybe<Scalars['Int']>;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type CurrentUserUnreadWarRoomNotificationsArgs = {
  platform?: InputMaybe<Platform>;
};


export type CurrentUserUnseenWarRoomNotificationsArgs = {
  platform?: InputMaybe<Platform>;
};

export type CustomerSegment = {
  __typename?: 'CustomerSegment';
  emoji?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** Autogenerated input type of DeactivateCurrentUser */
export type DeactivateCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type Deal = DealInterface & {
  __typename?: 'Deal';
  amount: Scalars['Float'];
  closeDate: Scalars['ISO8601DateTime'];
  company?: Maybe<Company>;
  createdAt: Scalars['ISO8601DateTime'];
  departments?: Maybe<Array<Department>>;
  id: Scalars['ID'];
  interactionsCount: Scalars['Int'];
  isOwner: Scalars['Boolean'];
  isPrivateCompany: Scalars['Boolean'];
  isPrivateDepartments: Scalars['Boolean'];
  post?: Maybe<Post>;
  user: User;
};

/** The connection type for Deal. */
export type DealConnection = DealConnectionInterface & {
  __typename?: 'DealConnection';
  /** A list of edges. */
  edges: Array<DealEdge>;
  /** A list of nodes. */
  nodes: Array<Deal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  statistics: DealsStatistics;
  totalCount: Scalars['Int'];
};

export type DealConnectionInterface = {
  statistics: DealsStatistics;
};

/** An edge in a connection. */
export type DealEdge = {
  __typename?: 'DealEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Deal>;
};

export type DealInterface = {
  amount: Scalars['Float'];
  closeDate: Scalars['ISO8601DateTime'];
  company?: Maybe<Company>;
  createdAt: Scalars['ISO8601DateTime'];
  departments?: Maybe<Array<Department>>;
  id: Scalars['ID'];
  interactionsCount: Scalars['Int'];
  isOwner: Scalars['Boolean'];
  isPrivateCompany: Scalars['Boolean'];
  isPrivateDepartments: Scalars['Boolean'];
  post?: Maybe<Post>;
};

export type DealStory = {
  __typename?: 'DealStory';
  coverContentType?: Maybe<Scalars['String']>;
  coverFileName?: Maybe<Scalars['String']>;
  coverFileSize?: Maybe<Scalars['Int']>;
  coverUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  coverUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  deal: Deal;
  highlightedText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  previewImageUrl?: Maybe<Scalars['String']>;
  rawText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textImageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type DealStoryPostAttributes = {
  text: Scalars['String'];
};

export type DealsStatistics = {
  __typename?: 'DealsStatistics';
  totalAmount: Scalars['Float'];
  totalCount: Scalars['Int'];
};

export type Department = {
  __typename?: 'Department';
  createdAt: Scalars['ISO8601DateTime'];
  custom: Scalars['Boolean'];
  emoji?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  users?: Maybe<Array<User>>;
};

/** Autogenerated input type of DestroyAwardForPublicPortfolioCurrentUser */
export type DestroyAwardForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DestroyClientForPublicPortfolioCurrentUser */
export type DestroyClientForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DestroyComment */
export type DestroyCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DestroyDeal */
export type DestroyDealInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DestroyEducationHistoryForPublicPortfolioCurrentUser */
export type DestroyEducationHistoryForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DestroyPost */
export type DestroyPostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};

/** Autogenerated input type of DestroyRating */
export type DestroyRatingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  reactableId: Scalars['ID'];
  reactableType: Scalars['String'];
};

/** Autogenerated input type of DestroyTestimonialForPublicPortfolioCurrentUser */
export type DestroyTestimonialForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DestroyWorkHistoryForPublicPortfolioCurrentUser */
export type DestroyWorkHistoryForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of DetachCompanySeriesStage */
export type DetachCompanySeriesStageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companySeriesStageId: Scalars['ID'];
};

/** Autogenerated input type of DetachCompanyStage */
export type DetachCompanyStageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyStageId: Scalars['ID'];
};

/** Autogenerated input type of DetachDepartment */
export type DetachDepartmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentId: Scalars['ID'];
};

/** Autogenerated input type of DetachProduct */
export type DetachProductInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productTypeId: Scalars['ID'];
};

/** Autogenerated input type of DetachSalesRole */
export type DetachSalesRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  salesRoleId: Scalars['ID'];
};

/** Autogenerated return type of DirectMessagesSubscription */
export type DirectMessagesSubscriptionPayload = {
  __typename?: 'DirectMessagesSubscriptionPayload';
  newMessage?: Maybe<Message>;
  readThreadEvent?: Maybe<ReadThreadEvent>;
};

export type EarnItem = {
  __typename?: 'EarnItem';
  price: Scalars['Int'];
  state: Scalars['String'];
  type: Scalars['String'];
};

export type EducationHistory = {
  __typename?: 'EducationHistory';
  degreeName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['ISO8601DateTime']>;
  fieldOfStudy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  manuallyEdited: Scalars['Boolean'];
  schoolName?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
  university?: Maybe<University>;
};

export type Employee = {
  __typename?: 'Employee';
  avatarUrl?: Maybe<Scalars['String']>;
  connected?: Maybe<Scalars['Boolean']>;
  currentPosition?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  receivedRequestId?: Maybe<Scalars['ID']>;
  requestId?: Maybe<Scalars['ID']>;
  slug: Scalars['String'];
};

/** The connection type for Employee. */
export type EmployeeConnection = {
  __typename?: 'EmployeeConnection';
  /** A list of edges. */
  edges: Array<EmployeeEdge>;
  /** A list of nodes. */
  nodes: Array<Employee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type EmployeeEdge = {
  __typename?: 'EmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Employee>;
};

export type EndorseTestimonialAuthorAttributes = {
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of EndorseTestimonialForPublicPortfolioUser */
export type EndorseTestimonialForPublicPortfolioUserInput = {
  author?: InputMaybe<EndorseTestimonialAuthorAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  sign: Scalars['String'];
  skills?: InputMaybe<Array<Scalars['String']>>;
};

export type Expectation = {
  __typename?: 'Expectation';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Autogenerated input type of ExpressDesireToImportConnectionsForPublicPortfolioUser */
export type ExpressDesireToImportConnectionsForPublicPortfolioUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type File = {
  __typename?: 'File';
  name?: Maybe<Scalars['String']>;
  signedId?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

/** Autogenerated input type of FillInquiry */
export type FillInquiryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type FindOrCreateCompanyAttributes = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type FindOrCreateDepartmentAttributes = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of FinishOnboarding */
export type FinishOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of FireHiringEvent */
export type FireHiringEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventName: JobsHiringEventName;
  id: Scalars['ID'];
};

/** Autogenerated input type of FlagIssue */
export type FlagIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  flaggableId: Scalars['ID'];
  flaggableType: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type FloatRangeRightBoundOptional = {
  __typename?: 'FloatRangeRightBoundOptional';
  max?: Maybe<Scalars['Float']>;
  min: Scalars['Float'];
};

export type FloatRangeRightBoundOptionalInput = {
  max?: InputMaybe<Scalars['Float']>;
  min: Scalars['Float'];
};

export type GenericMatch = BaseMatch | CityMatch | UniversityMatch | WorkHistoryMatch;

export type GeoPositionAttributes = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type HighlightedText = {
  __typename?: 'HighlightedText';
  highlightFrom?: Maybe<Scalars['Int']>;
  highlightTo?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
};

/** Autogenerated input type of HiringResendIntroduceEmail */
export type HiringResendIntroduceEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type Industry = {
  __typename?: 'Industry';
  emoji?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Attributes for creating or updating jobs inquiry fake hiring */
export type InquiryFakeHiringAttributes = {
  candidateState: JobsHiringCandidateState;
  vacancyUid: Scalars['String'];
};

export type IntRangeRightBoundOptional = {
  __typename?: 'IntRangeRightBoundOptional';
  max?: Maybe<Scalars['Int']>;
  min: Scalars['Int'];
};

export type IntRangeRightBoundOptionalInput = {
  max?: InputMaybe<Scalars['Int']>;
  min: Scalars['Int'];
};

export type JobsBaseInquiryInterface = {
  accomplishments?: Maybe<Scalars['String']>;
  aeAnnualizedQuota?: Maybe<Scalars['Int']>;
  aeLeadSourceOther?: Maybe<Scalars['String']>;
  aeLeadSourcesMain?: Maybe<Array<JobsInquiryAeLeadSource>>;
  aeQuotaPerPeriod?: Maybe<Scalars['Int']>;
  aeQuotaTypeMain?: Maybe<JobsInquiryAeQuota>;
  aeQuotaTypeOther?: Maybe<Scalars['String']>;
  baseSalary?: Maybe<Scalars['Int']>;
  clientDescription?: Maybe<Scalars['String']>;
  csmAccountsNumber?: Maybe<JobsInquiryCsmAccountNumber>;
  csmQuotaMetricMain?: Maybe<Array<JobsInquiryCsmQuotaMetric>>;
  csmQuotaMetricOther?: Maybe<Scalars['String']>;
  csmQuotaPeriodMain?: Maybe<JobsInquiryCsmQuotaPeriod>;
  csmQuotaPeriodOther?: Maybe<Scalars['String']>;
  csmQuotaTypeMain?: Maybe<JobsInquiryCsmQuota>;
  csmQuotaTypeOther?: Maybe<Scalars['String']>;
  csmRenewalValue?: Maybe<JobsInquiryCsmRenewalValue>;
  csmTotalBusinessValue?: Maybe<JobsInquiryCsmBusinessValue>;
  csmUpsellValue?: Maybe<JobsInquiryCsmUpsellValue>;
  currency?: Maybe<Currency>;
  dealBreakerOther?: Maybe<Scalars['String']>;
  dealBreakersMain?: Maybe<Array<JobsInquiryDealBreaker>>;
  dealSize?: Maybe<JobsInquiryDealSize>;
  desiredCompanySeriesStages?: Maybe<Array<CompanySeriesStage>>;
  employmentTypes: Array<JobsInquiryEmployment>;
  filledAt?: Maybe<Scalars['ISO8601DateTime']>;
  flexAppliedCriteria?: Maybe<Array<JobsFlexAppliedCriteria>>;
  flexBandwidth?: Maybe<Scalars['String']>;
  flexBriefVideoUrl?: Maybe<Scalars['String']>;
  flexConsideredCompanyTypes?: Maybe<Array<JobsFlexFlexConsideredCompanyType>>;
  flexOnboardingState?: Maybe<Scalars['String']>;
  flexPreviousExperience?: Maybe<Scalars['String']>;
  flexRating?: Maybe<Scalars['Float']>;
  flexReasonForParticipation?: Maybe<Scalars['String']>;
  flexRoles?: Maybe<Array<JobsFlexRole>>;
  flexState?: Maybe<Scalars['String']>;
  flexUnderstandingOfSales?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idealJobDescription?: Maybe<Scalars['String']>;
  lastActiveAt?: Maybe<Scalars['ISO8601DateTime']>;
  onboardingState: JobsInquiryOnboardingState;
  ote?: Maybe<Scalars['Int']>;
  positionMain?: Maybe<JobsInquiryPosition>;
  positionOther?: Maybe<Scalars['String']>;
  quotaAttainmentByTeamPerPeriod?: Maybe<Scalars['Int']>;
  quotaAttainmentPerLastYear?: Maybe<Scalars['Int']>;
  quotaAttainmentPerPeriod?: Maybe<Scalars['Int']>;
  rankOnTeam?: Maybe<Scalars['Int']>;
  revenue?: Maybe<Scalars['Int']>;
  salesCycleLength?: Maybe<JobsInquirySalesCycleLength>;
  salesMethodologies?: Maybe<Array<JobsInquirySalesMethodology>>;
  sdrQuotaPerPeriod?: Maybe<Scalars['String']>;
  sdrQuotaTypes?: Maybe<Array<JobsInquirySdrQuota>>;
  state: JobsInquiryState;
  teamSize?: Maybe<Scalars['Int']>;
  vpDepartmentSize?: Maybe<JobsInquiryVpDepartmentSize>;
  vpManagedRoles?: Maybe<Array<JobsInquiryVpManagedRole>>;
  vpQuotaType?: Maybe<JobsInquiryVpQuota>;
  vpResponsibilities?: Maybe<Scalars['String']>;
  willingToRelocate?: Maybe<Scalars['Boolean']>;
};

export type JobsCandidateInterface = {
  annualQuota?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  badges?: Maybe<Array<JobsHiringBadge>>;
  baseSalary?: Maybe<Scalars['String']>;
  bullet1?: Maybe<Scalars['String']>;
  bullet2?: Maybe<Scalars['String']>;
  captions?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  csmAccountsNumber?: Maybe<Scalars['String']>;
  csmQuotaMetric?: Maybe<Scalars['String']>;
  csmQuotaType?: Maybe<Scalars['String']>;
  csmRenewalValue?: Maybe<Scalars['String']>;
  csmTotalBusinessValue?: Maybe<Scalars['String']>;
  csmUpsellValue?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  dealSize?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  flexAppliedCriteria?: Maybe<Array<JobsFlexAppliedCriteria>>;
  flexBandwidth?: Maybe<Scalars['String']>;
  flexBriefVideoUrl?: Maybe<Scalars['String']>;
  flexPreviousExperience?: Maybe<Scalars['String']>;
  flexRating?: Maybe<Scalars['Float']>;
  flexReasonForParticipation?: Maybe<Scalars['String']>;
  flexRoles?: Maybe<Array<JobsFlexRole>>;
  flexUnderstandingOfSales?: Maybe<Scalars['String']>;
  headline1?: Maybe<Scalars['String']>;
  headline2?: Maybe<Scalars['String']>;
  headline3?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idealJobDescription?: Maybe<Scalars['String']>;
  initials?: Maybe<Scalars['String']>;
  inquiredPosition?: Maybe<JobsInquiryPosition>;
  lastname?: Maybe<Scalars['String']>;
  leadSources?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  marketingHeadline?: Maybe<Scalars['String']>;
  ote?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  quotaAttainmentByTeamPerPeriod?: Maybe<Scalars['String']>;
  quotaAttainmentPerLastYear?: Maybe<Scalars['String']>;
  quotaAttainmentPerPeriod?: Maybe<Scalars['Int']>;
  salesCycleLength?: Maybe<Scalars['String']>;
  teamRanking?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  vpDepartmentSize?: Maybe<Scalars['String']>;
  vpManagedRoles?: Maybe<Scalars['String']>;
  vpQuotaType?: Maybe<Scalars['String']>;
  willingToRelocate?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of JobsCandidatesUpdateHiring */
export type JobsCandidatesUpdateHiringInput = {
  candidateStateViewed: Scalars['Boolean'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type JobsEmployer = {
  __typename?: 'JobsEmployer';
  company: Company;
  descriptionHtml?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  keyPoints: Array<Scalars['String']>;
  roleUrl?: Maybe<Scalars['String']>;
};

export enum JobsEmployersAnnualRevenue {
  Revenue_0_500K = 'REVENUE_0_500K',
  Revenue_2M_10M = 'REVENUE_2M_10M',
  Revenue_10M_30M = 'REVENUE_10M_30M',
  Revenue_500K_2M = 'REVENUE_500K_2M',
  RevenueMore_30M = 'REVENUE_MORE_30M'
}

export enum JobsEmployersFunding {
  ACSeries = 'A_C_SERIES',
  Bootstraping = 'BOOTSTRAPING',
  DBeyoundSeries = 'D_BEYOUND_SERIES',
  GoingToVc = 'GOING_TO_VC',
  VcSeed = 'VC_SEED'
}

export enum JobsEmployersSalesTeamSize {
  Size_0_1 = 'SIZE_0_1',
  Size_2_5 = 'SIZE_2_5',
  Size_6_20 = 'SIZE_6_20',
  Size_21_50 = 'SIZE_21_50',
  SizeMore_50 = 'SIZE_MORE_50'
}

export enum JobsFieldsAccessLevel {
  Admin = 'ADMIN',
  Everyone = 'EVERYONE'
}

export type JobsFieldsBooleanInterface = {
  placeholder?: Maybe<Scalars['String']>;
};

export type JobsFieldsCategoryInterface = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  position: Scalars['Int'];
  title: Scalars['String'];
};

export type JobsFieldsConfiguration = {
  __typename?: 'JobsFieldsConfiguration';
  autocomplete?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Int']>;
};

export type JobsFieldsFloatInterface = {
  placeholder: Scalars['String'];
  range?: Maybe<FloatRangeRightBoundOptional>;
};

export type JobsFieldsFloatRangeInterface = {
  placeholder: JobsFieldsRangePlaceholder;
  range?: Maybe<FloatRangeRightBoundOptional>;
};

export type JobsFieldsIntegerInterface = {
  placeholder?: Maybe<Scalars['String']>;
  range?: Maybe<IntRangeRightBoundOptional>;
};

export type JobsFieldsIntegerRangeInterface = {
  placeholder: JobsFieldsRangePlaceholder;
  range?: Maybe<IntRangeRightBoundOptional>;
};

export type JobsFieldsInterface = {
  availableForRoles: Array<JobsRole>;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  requiredForRoles: Array<JobsRole>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsFieldsRangePlaceholder = {
  __typename?: 'JobsFieldsRangePlaceholder';
  max?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['String']>;
};

export enum JobsFieldsRecordType {
  City = 'CITY',
  Company = 'COMPANY',
  Department = 'DEPARTMENT',
  Industry = 'INDUSTRY'
}

export enum JobsFieldsScope {
  Flex = 'FLEX',
  MlSettings = 'ML_SETTINGS',
  Talent = 'TALENT'
}

export type JobsFieldsSelectInterface = {
  options: Array<JobsFieldsSelectOption>;
  placeholder?: Maybe<Scalars['String']>;
};

export type JobsFieldsSelectOption = {
  __typename?: 'JobsFieldsSelectOption';
  default: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type JobsFieldsSingleSelectRecordInterface = {
  placeholder?: Maybe<Scalars['String']>;
  recordType: JobsFieldsRecordType;
};

export type JobsFieldsStringArrayInterface = {
  placeholder?: Maybe<Scalars['String']>;
};

export type JobsFieldsStringInterface = {
  placeholder?: Maybe<Scalars['String']>;
};

export type JobsFieldsTooltip = {
  __typename?: 'JobsFieldsTooltip';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum JobsFlexAppliedCriteria {
  Closed_6FigureDeal = 'CLOSED_6_FIGURE_DEAL',
  DidOwnProspectingBuilding = 'DID_OWN_PROSPECTING_BUILDING',
  HaveExperienceSellingForEarlyStageCompanies = 'HAVE_EXPERIENCE_SELLING_FOR_EARLY_STAGE_COMPANIES',
  HaveTrackRecordOfAchieving = 'HAVE_TRACK_RECORD_OF_ACHIEVING',
  Made_50DialsPerDay = 'MADE_50_DIALS_PER_DAY',
  WorkedAsInboundSdr = 'WORKED_AS_INBOUND_SDR'
}

export enum JobsFlexBandwidth {
  Bandwidth_0_5HoursPerWeek = 'BANDWIDTH_0_5_HOURS_PER_WEEK',
  Bandwidth_6_15HoursPerWeek = 'BANDWIDTH_6_15_HOURS_PER_WEEK',
  Bandwidth_16_30HoursPerWeek = 'BANDWIDTH_16_30_HOURS_PER_WEEK',
  Bandwidth_31HoursPerWeek = 'BANDWIDTH_31_HOURS_PER_WEEK',
  BandwidthFullTime = 'BANDWIDTH_FULL_TIME'
}

export enum JobsFlexFlexConsideredCompanyType {
  BrandNewProduct = 'BRAND_NEW_PRODUCT',
  Established = 'ESTABLISHED',
  NewerProduct = 'NEWER_PRODUCT',
  OpenToAllOpportunities = 'OPEN_TO_ALL_OPPORTUNITIES'
}

export enum JobsFlexRole {
  Ae = 'AE',
  Consultant = 'CONSULTANT',
  SdrBdr = 'SDR_BDR'
}

export type JobsHiring = {
  __typename?: 'JobsHiring';
  acceptedByEmployer: Scalars['Boolean'];
  candidateState?: Maybe<JobsHiringCandidateState>;
  candidateStateUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  candidateStateViewed?: Maybe<Scalars['Boolean']>;
  employer: JobsEmployer;
  hashid: Scalars['String'];
  hoursToExpire?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  origin: JobsHiringOrigin;
  vacancy?: Maybe<JobsVacancy>;
};

export enum JobsHiringBadge {
  Diverse = 'DIVERSE',
  FrequentlyPromoted = 'FREQUENTLY_PROMOTED',
  Leader = 'LEADER',
  Veteran = 'VETERAN'
}

export enum JobsHiringCandidateState {
  AcceptedAnotherOffer = 'ACCEPTED_ANOTHER_OFFER',
  Archived = 'ARCHIVED',
  Hired = 'HIRED',
  Interested = 'INTERESTED',
  Interviewing = 'INTERVIEWING',
  Introduction = 'INTRODUCTION',
  Rejected = 'REJECTED'
}

export enum JobsHiringEventName {
  AcceptByCandidate = 'accept_by_candidate',
  RejectByCandidate = 'reject_by_candidate'
}

export enum JobsHiringMeeting {
  Assessment = 'assessment',
  Interview = 'interview'
}

export enum JobsHiringOrigin {
  AlgorithmBackgroundMatch = 'algorithm_background_match',
  AlgorithmBackoffice = 'algorithm_backoffice',
  AlgorithmDemo = 'algorithm_demo',
  AlgorithmFlexOnboarding = 'algorithm_flex_onboarding',
  AlgorithmOnboarding = 'algorithm_onboarding',
  AlgorithmRefresh = 'algorithm_refresh',
  AlgorithmVacancyActivated = 'algorithm_vacancy_activated',
  AlgorithmVacancyEdited = 'algorithm_vacancy_edited',
  Manual = 'manual'
}

export enum JobsHiringSubmissionSource {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type JobsInquiry = JobsBaseInquiryInterface & {
  __typename?: 'JobsInquiry';
  accomplishments?: Maybe<Scalars['String']>;
  activable: Scalars['Boolean'];
  activeHirings?: Maybe<Array<JobsHiring>>;
  activeHiringsCount: Scalars['Int'];
  aeAnnualizedQuota?: Maybe<Scalars['Int']>;
  aeLeadSourceOther?: Maybe<Scalars['String']>;
  aeLeadSourcesMain?: Maybe<Array<JobsInquiryAeLeadSource>>;
  aeQuotaPerPeriod?: Maybe<Scalars['Int']>;
  aeQuotaTypeMain?: Maybe<JobsInquiryAeQuota>;
  aeQuotaTypeOther?: Maybe<Scalars['String']>;
  baseSalary?: Maybe<Scalars['Int']>;
  clientDescription?: Maybe<Scalars['String']>;
  csmAccountsNumber?: Maybe<JobsInquiryCsmAccountNumber>;
  csmQuotaMetricMain?: Maybe<Array<JobsInquiryCsmQuotaMetric>>;
  csmQuotaMetricOther?: Maybe<Scalars['String']>;
  csmQuotaPeriodMain?: Maybe<JobsInquiryCsmQuotaPeriod>;
  csmQuotaPeriodOther?: Maybe<Scalars['String']>;
  csmQuotaTypeMain?: Maybe<JobsInquiryCsmQuota>;
  csmQuotaTypeOther?: Maybe<Scalars['String']>;
  csmRenewalValue?: Maybe<JobsInquiryCsmRenewalValue>;
  csmTotalBusinessValue?: Maybe<JobsInquiryCsmBusinessValue>;
  csmUpsellValue?: Maybe<JobsInquiryCsmUpsellValue>;
  currency?: Maybe<Currency>;
  dealBreakerOther?: Maybe<Scalars['String']>;
  dealBreakersMain?: Maybe<Array<JobsInquiryDealBreaker>>;
  dealSize?: Maybe<JobsInquiryDealSize>;
  desiredCompanySeriesStages?: Maybe<Array<CompanySeriesStage>>;
  employmentTypes: Array<JobsInquiryEmployment>;
  fakeHiring?: Maybe<JobsInquiryFakeHiring>;
  filledAt?: Maybe<Scalars['ISO8601DateTime']>;
  flexAppliedCriteria?: Maybe<Array<JobsFlexAppliedCriteria>>;
  flexBandwidth?: Maybe<Scalars['String']>;
  flexBriefVideoUrl?: Maybe<Scalars['String']>;
  flexConsideredCompanyTypes?: Maybe<Array<JobsFlexFlexConsideredCompanyType>>;
  flexOnboardingState?: Maybe<Scalars['String']>;
  flexPreviousExperience?: Maybe<Scalars['String']>;
  flexRating?: Maybe<Scalars['Float']>;
  flexReasonForParticipation?: Maybe<Scalars['String']>;
  flexRoles?: Maybe<Array<JobsFlexRole>>;
  flexState?: Maybe<Scalars['String']>;
  flexUnderstandingOfSales?: Maybe<Scalars['String']>;
  hiringsForReview?: Maybe<Array<JobsHiring>>;
  id: Scalars['ID'];
  idealJobDescription?: Maybe<Scalars['String']>;
  lastActiveAt?: Maybe<Scalars['ISO8601DateTime']>;
  onboardingState: JobsInquiryOnboardingState;
  ote?: Maybe<Scalars['Int']>;
  positionMain?: Maybe<JobsInquiryPosition>;
  positionOther?: Maybe<Scalars['String']>;
  quotaAttainmentByTeamPerPeriod?: Maybe<Scalars['Int']>;
  quotaAttainmentPerLastYear?: Maybe<Scalars['Int']>;
  quotaAttainmentPerPeriod?: Maybe<Scalars['Int']>;
  rankOnTeam?: Maybe<Scalars['Int']>;
  revenue?: Maybe<Scalars['Int']>;
  salesCycleLength?: Maybe<JobsInquirySalesCycleLength>;
  salesMethodologies?: Maybe<Array<JobsInquirySalesMethodology>>;
  sdrQuotaPerPeriod?: Maybe<Scalars['String']>;
  sdrQuotaTypes?: Maybe<Array<JobsInquirySdrQuota>>;
  source: JobsInquirySource;
  stale: Scalars['Boolean'];
  state: JobsInquiryState;
  teamSize?: Maybe<Scalars['Int']>;
  vpDepartmentSize?: Maybe<JobsInquiryVpDepartmentSize>;
  vpManagedRoles?: Maybe<Array<JobsInquiryVpManagedRole>>;
  vpQuotaType?: Maybe<JobsInquiryVpQuota>;
  vpResponsibilities?: Maybe<Scalars['String']>;
  willingToRelocate?: Maybe<Scalars['Boolean']>;
};

export enum JobsInquiryActivationOrigin {
  Email = 'email',
  ProfileUpdate = 'profile_update',
  RefreshInquiry = 'refresh_inquiry',
  Sms = 'sms'
}

export enum JobsInquiryAeLeadSource {
  Customer = 'CUSTOMER',
  Marketing = 'MARKETING',
  Sdr = 'SDR',
  Self = 'SELF'
}

export enum JobsInquiryAeQuota {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY'
}

export enum JobsInquiryCsmAccountNumber {
  Number_1_10 = 'NUMBER_1_10',
  Number_11_50 = 'NUMBER_11_50',
  Number_51_100 = 'NUMBER_51_100',
  Number_101_250 = 'NUMBER_101_250',
  Number_251_500 = 'NUMBER_251_500',
  NumberMore_500 = 'NUMBER_MORE_500'
}

export enum JobsInquiryCsmBusinessValue {
  Value_1_1M_2MUsd = 'VALUE_1_1M_2M_USD',
  Value_2_1M_5MUsd = 'VALUE_2_1M_5M_USD',
  Value_251K_1MUsd = 'VALUE_251K_1M_USD',
  ValueLess_250KUsd = 'VALUE_LESS_250K_USD',
  ValueMore_5MUsd = 'VALUE_MORE_5M_USD'
}

export enum JobsInquiryCsmQuota {
  CsmIndividualQuota = 'CSM_INDIVIDUAL_QUOTA',
  CsmNoQuota = 'CSM_NO_QUOTA',
  CsmTeamQuota = 'CSM_TEAM_QUOTA'
}

export enum JobsInquiryCsmQuotaMetric {
  CsmCustomerSatisfaction = 'CSM_CUSTOMER_SATISFACTION',
  CsmEngagement = 'CSM_ENGAGEMENT',
  CsmOpportunities = 'CSM_OPPORTUNITIES',
  CsmRenewals = 'CSM_RENEWALS',
  CsmUpsells = 'CSM_UPSELLS'
}

export enum JobsInquiryCsmQuotaPeriod {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY'
}

export enum JobsInquiryCsmRenewalValue {
  Value_1K_5KUsd = 'VALUE_1K_5K_USD',
  Value_5K_25KUsd = 'VALUE_5K_25K_USD',
  Value_25K_100KUsd = 'VALUE_25K_100K_USD',
  ValueLess_1KUsd = 'VALUE_LESS_1K_USD',
  ValueMore_100KUsd = 'VALUE_MORE_100K_USD'
}

export enum JobsInquiryCsmUpsellValue {
  Value_1K_5KUsd = 'VALUE_1K_5K_USD',
  Value_5K_25KUsd = 'VALUE_5K_25K_USD',
  Value_25K_100KUsd = 'VALUE_25K_100K_USD',
  ValueLess_1KUsd = 'VALUE_LESS_1K_USD',
  ValueMore_100KUsd = 'VALUE_MORE_100K_USD'
}

export enum JobsInquiryDealBreaker {
  NewProduct = 'NEW_PRODUCT',
  None = 'NONE',
  OfficeWork = 'OFFICE_WORK',
  RemoteCompany = 'REMOTE_COMPANY',
  WithoutSdr = 'WITHOUT_SDR'
}

export enum JobsInquiryDealSize {
  Deal_10000_50000 = 'DEAL_10000_50000',
  Deal_50000_100000 = 'DEAL_50000_100000',
  Deal_100000_500000 = 'DEAL_100000_500000',
  DealLess_10000 = 'DEAL_LESS_10000',
  DealMore_500000 = 'DEAL_MORE_500000'
}

export enum JobsInquiryEmployment {
  FullTime = 'FULL_TIME',
  SideHustle = 'SIDE_HUSTLE'
}

export type JobsInquiryFakeHiring = {
  __typename?: 'JobsInquiryFakeHiring';
  candidateState: JobsHiringCandidateState;
  vacancy?: Maybe<JobsVacancy>;
  vacancyUid: Scalars['String'];
};

export enum JobsInquiryOnboardingState {
  AccomplishmentsStep = 'ACCOMPLISHMENTS_STEP',
  AeLeadSourcesStep = 'AE_LEAD_SOURCES_STEP',
  AeQuotaPerPeriodStep = 'AE_QUOTA_PER_PERIOD_STEP',
  AeQuotaTypeStep = 'AE_QUOTA_TYPE_STEP',
  BaseSalaryStep = 'BASE_SALARY_STEP',
  ClientsStep = 'CLIENTS_STEP',
  CompanyStageStep = 'COMPANY_STAGE_STEP',
  CsmAccountsNumberStep = 'CSM_ACCOUNTS_NUMBER_STEP',
  CsmDealCycleStep = 'CSM_DEAL_CYCLE_STEP',
  CsmQuotaMetric = 'CSM_QUOTA_METRIC',
  CsmQuotaPeriod = 'CSM_QUOTA_PERIOD',
  CsmQuotaType = 'CSM_QUOTA_TYPE',
  CsmRenewalValueStep = 'CSM_RENEWAL_VALUE_STEP',
  CsmTotalBusinessValueStep = 'CSM_TOTAL_BUSINESS_VALUE_STEP',
  CsmUpsellValueStep = 'CSM_UPSELL_VALUE_STEP',
  CurrentPositionStep = 'CURRENT_POSITION_STEP',
  DealBreakersStep = 'DEAL_BREAKERS_STEP',
  DealSizeStep = 'DEAL_SIZE_STEP',
  EmploymentTypeStep = 'EMPLOYMENT_TYPE_STEP',
  IdealJobDescriptionStep = 'IDEAL_JOB_DESCRIPTION_STEP',
  LinkedinUrlStep = 'LINKEDIN_URL_STEP',
  LocationStep = 'LOCATION_STEP',
  OteStep = 'OTE_STEP',
  PhoneNumberStep = 'PHONE_NUMBER_STEP',
  PositionStep = 'POSITION_STEP',
  QuotaAttainmentByTeamPerPeriodStep = 'QUOTA_ATTAINMENT_BY_TEAM_PER_PERIOD_STEP',
  QuotaAttainmentPerLastYearStep = 'QUOTA_ATTAINMENT_PER_LAST_YEAR_STEP',
  QuotaAttainmentPerPeriodStep = 'QUOTA_ATTAINMENT_PER_PERIOD_STEP',
  RankOnTeamStep = 'RANK_ON_TEAM_STEP',
  RelocationStep = 'RELOCATION_STEP',
  RevenueStep = 'REVENUE_STEP',
  SalesCycleLengthStep = 'SALES_CYCLE_LENGTH_STEP',
  SalesMethodologiesStep = 'SALES_METHODOLOGIES_STEP',
  SdrQuotaPerPeriodStep = 'SDR_QUOTA_PER_PERIOD_STEP',
  SdrQuotaTypeStep = 'SDR_QUOTA_TYPE_STEP',
  SuggestedLocationStep = 'SUGGESTED_LOCATION_STEP',
  TeamSizeStep = 'TEAM_SIZE_STEP',
  VpDepartmentSizeStep = 'VP_DEPARTMENT_SIZE_STEP',
  VpManagedRolesStep = 'VP_MANAGED_ROLES_STEP',
  VpQuotaMeasurementStep = 'VP_QUOTA_MEASUREMENT_STEP'
}

export enum JobsInquiryPosition {
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  Csm = 'CSM',
  Sdr = 'SDR',
  Vp = 'VP'
}

export enum JobsInquirySalesCycleLength {
  Value_1Month_3Months = 'VALUE_1_MONTH_3_MONTHS',
  Value_1Week_1Month = 'VALUE_1_WEEK_1_MONTH',
  Value_3Months_1Year = 'VALUE_3_MONTHS_1_YEAR',
  ValueLess_1Week = 'VALUE_LESS_1_WEEK',
  ValueLonger_1Year = 'VALUE_LONGER_1_YEAR'
}

export enum JobsInquirySalesMethodology {
  Challenger = 'CHALLENGER',
  ConceptualSelling = 'CONCEPTUAL_SELLING',
  Meddic = 'MEDDIC',
  NoFormalTraining = 'NO_FORMAL_TRAINING',
  Sandler = 'SANDLER',
  SnapSelling = 'SNAP_SELLING',
  SpinSelling = 'SPIN_SELLING'
}

export enum JobsInquirySdrQuota {
  Appointment = 'APPOINTMENT',
  Opportunity = 'OPPORTUNITY',
  Pipeline = 'PIPELINE',
  Revenue = 'REVENUE'
}

export enum JobsInquirySource {
  Linkedin = 'LINKEDIN',
  Other = 'OTHER'
}

export enum JobsInquiryState {
  Filled = 'filled',
  Initialized = 'initialized',
  Removed = 'removed'
}

export enum JobsInquiryVpDepartmentSize {
  VpDepartmentSize_1_20 = 'VP_DEPARTMENT_SIZE_1_20',
  VpDepartmentSize_21_50 = 'VP_DEPARTMENT_SIZE_21_50',
  VpDepartmentSize_51_75 = 'VP_DEPARTMENT_SIZE_51_75',
  VpDepartmentSize_76_100 = 'VP_DEPARTMENT_SIZE_76_100',
  VpDepartmentSizeMore_100 = 'VP_DEPARTMENT_SIZE_MORE_100'
}

export enum JobsInquiryVpManagedRole {
  VpManagedRoleAe = 'VP_MANAGED_ROLE_AE',
  VpManagedRoleAeManager = 'VP_MANAGED_ROLE_AE_MANAGER',
  VpManagedRoleCsm = 'VP_MANAGED_ROLE_CSM',
  VpManagedRoleDirector = 'VP_MANAGED_ROLE_DIRECTOR',
  VpManagedRoleOther = 'VP_MANAGED_ROLE_OTHER',
  VpManagedRoleSalesEnablement = 'VP_MANAGED_ROLE_SALES_ENABLEMENT',
  VpManagedRoleSalesOps = 'VP_MANAGED_ROLE_SALES_OPS',
  VpManagedRoleSdr = 'VP_MANAGED_ROLE_SDR',
  VpManagedRoleSdrManager = 'VP_MANAGED_ROLE_SDR_MANAGER',
  VpManagedRoleSe = 'VP_MANAGED_ROLE_SE'
}

export enum JobsInquiryVpQuota {
  VpQuotaIndividual = 'VP_QUOTA_INDIVIDUAL',
  VpQuotaTeam = 'VP_QUOTA_TEAM'
}

export enum JobsJobSearchStatus {
  ActivelyLooking = 'actively_looking',
  NotInterested = 'not_interested',
  PassivelyLooking = 'passively_looking'
}

/** Autogenerated input type of JobsModeratorsActivateVacancy */
export type JobsModeratorsActivateVacancyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vacancyId: Scalars['ID'];
};

export type JobsModeratorsCandidate = JobsCandidateInterface & {
  __typename?: 'JobsModeratorsCandidate';
  annualQuota?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  badges?: Maybe<Array<JobsHiringBadge>>;
  baseSalary?: Maybe<Scalars['String']>;
  bullet1?: Maybe<Scalars['String']>;
  bullet2?: Maybe<Scalars['String']>;
  captions?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  clients: Array<Client>;
  csmAccountsNumber?: Maybe<Scalars['String']>;
  csmQuotaMetric?: Maybe<Scalars['String']>;
  csmQuotaType?: Maybe<Scalars['String']>;
  csmRenewalValue?: Maybe<Scalars['String']>;
  csmTotalBusinessValue?: Maybe<Scalars['String']>;
  csmUpsellValue?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  dealSize?: Maybe<Scalars['String']>;
  departments: Array<Department>;
  firstname?: Maybe<Scalars['String']>;
  flexAppliedCriteria?: Maybe<Array<JobsFlexAppliedCriteria>>;
  flexBandwidth?: Maybe<Scalars['String']>;
  flexBriefVideoUrl?: Maybe<Scalars['String']>;
  flexPreviousExperience?: Maybe<Scalars['String']>;
  flexRating?: Maybe<Scalars['Float']>;
  flexReasonForParticipation?: Maybe<Scalars['String']>;
  flexRoles?: Maybe<Array<JobsFlexRole>>;
  flexUnderstandingOfSales?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  headline1?: Maybe<Scalars['String']>;
  headline2?: Maybe<Scalars['String']>;
  headline3?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idealJobDescription?: Maybe<Scalars['String']>;
  initials?: Maybe<Scalars['String']>;
  inquiredPosition?: Maybe<JobsInquiryPosition>;
  lastname?: Maybe<Scalars['String']>;
  leadSources?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  marketingHeadline?: Maybe<Scalars['String']>;
  ote?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  quotaAttainmentByTeamPerPeriod?: Maybe<Scalars['String']>;
  quotaAttainmentPerLastYear?: Maybe<Scalars['String']>;
  quotaAttainmentPerPeriod?: Maybe<Scalars['Int']>;
  salesCycleLength?: Maybe<Scalars['String']>;
  state: JobsModeratorsHiringState;
  teamRanking?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  visibilityOfAttributes: JobsModeratorsCandidateVisibilityOfAttributes;
  vpDepartmentSize?: Maybe<Scalars['String']>;
  vpManagedRoles?: Maybe<Scalars['String']>;
  vpQuotaType?: Maybe<Scalars['String']>;
  willingToRelocate?: Maybe<Scalars['Boolean']>;
  workHistories: Array<WorkHistory>;
};

export type JobsModeratorsCandidateVisibilityOfAttributes = {
  __typename?: 'JobsModeratorsCandidateVisibilityOfAttributes';
  isAnnualQuotaVisible?: Maybe<Scalars['Boolean']>;
  isBaseSalaryVisible?: Maybe<Scalars['Boolean']>;
  isBullet1Visible?: Maybe<Scalars['Boolean']>;
  isBullet2Visible?: Maybe<Scalars['Boolean']>;
  isClientsVisible?: Maybe<Scalars['Boolean']>;
  isCsmAccountsNumberVisible?: Maybe<Scalars['Boolean']>;
  isCsmQuotaMetricVisible?: Maybe<Scalars['Boolean']>;
  isCsmQuotaTypeVisible?: Maybe<Scalars['Boolean']>;
  isCsmRenewalValueVisible?: Maybe<Scalars['Boolean']>;
  isCsmTotalBusinessValueVisible?: Maybe<Scalars['Boolean']>;
  isCsmUpsellValueVisible?: Maybe<Scalars['Boolean']>;
  isDealSizeVisible?: Maybe<Scalars['Boolean']>;
  isDepartmentsVisible?: Maybe<Scalars['Boolean']>;
  isFlexAppliedCriteriaVisible?: Maybe<Scalars['Boolean']>;
  isFlexBandwidthVisible?: Maybe<Scalars['Boolean']>;
  isFlexBriefVideoUrlVisible?: Maybe<Scalars['Boolean']>;
  isFlexPreviousExperienceVisible?: Maybe<Scalars['Boolean']>;
  isFlexRatingVisible?: Maybe<Scalars['Boolean']>;
  isFlexReasonForParticipationVisible?: Maybe<Scalars['Boolean']>;
  isFlexRolesVisible?: Maybe<Scalars['Boolean']>;
  isFlexUnderstandingOfSalesVisible?: Maybe<Scalars['Boolean']>;
  isHeadline1Visible?: Maybe<Scalars['Boolean']>;
  isHeadline2Visible?: Maybe<Scalars['Boolean']>;
  isHeadline3Visible?: Maybe<Scalars['Boolean']>;
  isIdealJobDescriptionVisible?: Maybe<Scalars['Boolean']>;
  isLeadSourcesVisible?: Maybe<Scalars['Boolean']>;
  isLinkedinUrlVisible?: Maybe<Scalars['Boolean']>;
  isMarketingHeadlineVisible?: Maybe<Scalars['Boolean']>;
  isOteVisible?: Maybe<Scalars['Boolean']>;
  isQuotaAttainmentByTeamPerPeriodVisible?: Maybe<Scalars['Boolean']>;
  isQuotaAttainmentPerLastYearVisible?: Maybe<Scalars['Boolean']>;
  isQuotaAttainmentPerPeriodVisible?: Maybe<Scalars['Boolean']>;
  isSalesCycleLengthVisible?: Maybe<Scalars['Boolean']>;
  isTeamRankingVisible?: Maybe<Scalars['Boolean']>;
  isVpDepartmentSizeVisible?: Maybe<Scalars['Boolean']>;
  isVpManagedRolesVisible?: Maybe<Scalars['Boolean']>;
  isVpQuotaTypeVisible?: Maybe<Scalars['Boolean']>;
  isWorkHistoriesVisible?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of JobsModeratorsCreateEmployer */
export type JobsModeratorsCreateEmployerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsCreateHiring */
export type JobsModeratorsCreateHiringInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inquiryId: Scalars['ID'];
  origin?: InputMaybe<JobsHiringOrigin>;
  vacancyId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsCreateHirings */
export type JobsModeratorsCreateHiringsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inquiryId: Scalars['ID'];
  origin?: InputMaybe<JobsHiringOrigin>;
  vacancyIds: Array<Scalars['ID']>;
};

/** Autogenerated input type of JobsModeratorsCreateInquiryNote */
export type JobsModeratorsCreateInquiryNoteInput = {
  body?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inquiryId: Scalars['ID'];
  subcategory?: InputMaybe<JobsModeratorsInquiryNoteSubcategory>;
};

/** Autogenerated input type of JobsModeratorsCreateVacancy */
export type JobsModeratorsCreateVacancyInput = {
  autoCandidateSubmissionsEnabled?: InputMaybe<Scalars['Boolean']>;
  booleanFields?: InputMaybe<Array<JobsModeratorsFieldsBooleanAttributes>>;
  cityIds?: InputMaybe<Array<Scalars['ID']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  employerId: Scalars['ID'];
  employmentType?: InputMaybe<JobsVacancyEmployment>;
  floatFields?: InputMaybe<Array<JobsModeratorsFieldsFloatAttributes>>;
  floatRangeFields?: InputMaybe<Array<JobsModeratorsFieldsFloatRangeAttributes>>;
  gptPrompt?: InputMaybe<Scalars['String']>;
  headcount?: InputMaybe<Scalars['Int']>;
  hiringsBacklogLimit?: InputMaybe<Scalars['Int']>;
  integerFields?: InputMaybe<Array<JobsModeratorsFieldsIntegerAttributes>>;
  integerRangeFields?: InputMaybe<Array<JobsModeratorsFieldsIntegerRangeAttributes>>;
  matchScoreThreshold?: InputMaybe<Scalars['Float']>;
  multiSelectFields?: InputMaybe<Array<JobsModeratorsFieldsMultiSelectAttributes>>;
  multiSelectRecordFields?: InputMaybe<Array<JobsModeratorsFieldsMultiSelectRecordAttributes>>;
  openToRemoteWork?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<JobsRole>;
  primaryRecruiterId?: InputMaybe<Scalars['ID']>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']>>;
  remoteOnlyAtSelectedLocations?: InputMaybe<Scalars['Boolean']>;
  singleSelectFields?: InputMaybe<Array<JobsModeratorsFieldsSingleSelectAttributes>>;
  singleSelectRecordFields?: InputMaybe<Array<JobsModeratorsFieldsSingleSelectRecordAttributes>>;
  stringArrayFields?: InputMaybe<Array<JobsModeratorsFieldsStringArrayAttributes>>;
  stringFields?: InputMaybe<Array<JobsModeratorsFieldsStringAttributes>>;
  title?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of JobsModeratorsCreateVacancySubmission */
export type JobsModeratorsCreateVacancySubmissionInput = {
  avgDealSize?: InputMaybe<Scalars['String']>;
  avgSalesCycle?: InputMaybe<Scalars['String']>;
  baseSalary?: InputMaybe<Scalars['String']>;
  brandMaturity?: InputMaybe<JobsVacancySubmissionBrandMaturity>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  compensation?: InputMaybe<Scalars['String']>;
  compensationDescription?: InputMaybe<Scalars['String']>;
  customerProfile?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  jobUrl?: InputMaybe<Scalars['String']>;
  keyPoint1?: InputMaybe<Scalars['String']>;
  keyPoint2?: InputMaybe<Scalars['String']>;
  keyPoint3?: InputMaybe<Scalars['String']>;
  keyPoint4?: InputMaybe<Scalars['String']>;
  keyPoint5?: InputMaybe<Scalars['String']>;
  keyPoint6?: InputMaybe<Scalars['String']>;
  keyPoint7?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  minBandwidth?: InputMaybe<Scalars['String']>;
  ote?: InputMaybe<Scalars['String']>;
  quotaAttainmentByTeam?: InputMaybe<Scalars['Int']>;
  roleName?: InputMaybe<Scalars['String']>;
  vacancyId: Scalars['ID'];
  visibilityOfAttributes?: InputMaybe<JobsModeratorsVacancySubmissionVisibilityAttributes>;
  workType?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of JobsModeratorsDeactivateVacancy */
export type JobsModeratorsDeactivateVacancyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vacancyId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsDeleteVacancy */
export type JobsModeratorsDeleteVacancyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vacancyId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsDestroyInquiryNote */
export type JobsModeratorsDestroyInquiryNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inquiryNoteId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsEditEmployersClients */
export type JobsModeratorsEditEmployersClientsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  clients: Array<JobsModeratorsEmployerClientAttributes>;
  employerId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsEditEmployersRecruiters */
export type JobsModeratorsEditEmployersRecruitersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employerId: Scalars['ID'];
  recruiters: Array<JobsModeratorsRecruiterAttributes>;
};

export type JobsModeratorsEmployer = {
  __typename?: 'JobsModeratorsEmployer';
  accountOwner?: Maybe<JobsModeratorsEmployersAccountOwner>;
  activatedVacancies: Array<JobsModeratorsVacancy>;
  activatedVacanciesCount: Scalars['Int'];
  activatedVacanciesHeadcount: Scalars['Int'];
  clients: Array<JobsModeratorsEmployerClient>;
  company: Company;
  daysSinceLastHiringReviewed?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['String']>;
  descriptionMarkdown?: Maybe<Scalars['String']>;
  greenhouseIntegrated: Scalars['Boolean'];
  hiringProcessHtml?: Maybe<Scalars['String']>;
  hiringProcessMarkdown?: Maybe<Scalars['String']>;
  hiringsHiredCount: Scalars['Int'];
  hiringsInterviewedCount: Scalars['Int'];
  hiringsIntroducedCount: Scalars['Int'];
  hiringsOfferedCount: Scalars['Int'];
  hiringsScheduledCount: Scalars['Int'];
  hiringsToExpireCount: Scalars['Int'];
  hiringsToReviewCount: Scalars['Int'];
  id: Scalars['ID'];
  keyPoints: Array<Scalars['String']>;
  recruiters: Array<JobsModeratorsRecruiter>;
  roleUrl?: Maybe<Scalars['String']>;
  slackChannel?: Maybe<Scalars['String']>;
  talentAccessSubscription?: Maybe<JobsModeratorsEmployerSubscription>;
  vacancies: Array<JobsModeratorsVacancy>;
  vacanciesToMergeWith: Array<JobsModeratorsVacancy>;
};

export type JobsModeratorsEmployerClient = {
  __typename?: 'JobsModeratorsEmployerClient';
  company: Company;
  employer: JobsModeratorsEmployer;
  id: Scalars['ID'];
};

/** Attributes for creating, updating, or deleting jobs employer's clients */
export type JobsModeratorsEmployerClientAttributes = {
  companyId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
};

/** The connection type for JobsModeratorsEmployer. */
export type JobsModeratorsEmployerConnection = {
  __typename?: 'JobsModeratorsEmployerConnection';
  /** A list of edges. */
  edges: Array<JobsModeratorsEmployerEdge>;
  /** A list of nodes. */
  nodes: Array<JobsModeratorsEmployer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type JobsModeratorsEmployerEdge = {
  __typename?: 'JobsModeratorsEmployerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobsModeratorsEmployer>;
};

export type JobsModeratorsEmployerHiringGroups = {
  __typename?: 'JobsModeratorsEmployerHiringGroups';
  hiringsAccepted?: Maybe<Array<JobsModeratorsHiring>>;
  hiringsInProcess?: Maybe<Array<JobsModeratorsHiring>>;
  hiringsInReview?: Maybe<Array<JobsModeratorsHiring>>;
};

/** Attributes for sorting employers for a moderator */
export type JobsModeratorsEmployerSortAttributes = {
  field: JobsModeratorsEmployerSortField;
  order: SortOrder;
};

export enum JobsModeratorsEmployerSortField {
  CompanyName = 'COMPANY_NAME',
  DaysSinceLastHiringReviewed = 'DAYS_SINCE_LAST_HIRING_REVIEWED',
  HiringsHiredCount = 'HIRINGS_HIRED_COUNT',
  HiringsInterviewedCount = 'HIRINGS_INTERVIEWED_COUNT',
  HiringsIntroducedCount = 'HIRINGS_INTRODUCED_COUNT',
  HiringsOfferedCount = 'HIRINGS_OFFERED_COUNT',
  HiringsScheduledCount = 'HIRINGS_SCHEDULED_COUNT',
  HiringsToExpireCount = 'HIRINGS_TO_EXPIRE_COUNT',
  HiringsToReviewCount = 'HIRINGS_TO_REVIEW_COUNT'
}

export type JobsModeratorsEmployerSubscription = {
  __typename?: 'JobsModeratorsEmployerSubscription';
  active: Scalars['Boolean'];
  expiresAt: Scalars['ISO8601DateTime'];
  quantity: Scalars['Int'];
};

export enum JobsModeratorsEmployerSubscriptionState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum JobsModeratorsEmployerSubscriptionType {
  TalentAccess = 'TALENT_ACCESS'
}

export type JobsModeratorsEmployersAccountOwner = {
  __typename?: 'JobsModeratorsEmployersAccountOwner';
  calendarLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  slackId: Scalars['String'];
  user: JobsModeratorsUser;
};

export type JobsModeratorsField = JobsModeratorsFieldsBoolean | JobsModeratorsFieldsFloat | JobsModeratorsFieldsFloatRange | JobsModeratorsFieldsInteger | JobsModeratorsFieldsIntegerRange | JobsModeratorsFieldsMultiSelect | JobsModeratorsFieldsMultiSelectRecord | JobsModeratorsFieldsSingleSelect | JobsModeratorsFieldsSingleSelectRecord | JobsModeratorsFieldsString | JobsModeratorsFieldsStringArray;

export type JobsModeratorsFieldValueInterface = {
  field: JobsModeratorsField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
};

export type JobsModeratorsFieldValuesBoolean = JobsModeratorsFieldValueInterface & {
  __typename?: 'JobsModeratorsFieldValuesBoolean';
  field: JobsModeratorsField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
  value?: Maybe<Scalars['Boolean']>;
};

export type JobsModeratorsFieldValuesFloat = JobsModeratorsFieldValueInterface & {
  __typename?: 'JobsModeratorsFieldValuesFloat';
  field: JobsModeratorsField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
  value?: Maybe<Scalars['Float']>;
};

export type JobsModeratorsFieldValuesFloatRange = JobsModeratorsFieldValueInterface & {
  __typename?: 'JobsModeratorsFieldValuesFloatRange';
  field: JobsModeratorsField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  range?: Maybe<FloatRangeRightBoundOptional>;
  shouldClause: Scalars['Boolean'];
};

export type JobsModeratorsFieldValuesInteger = JobsModeratorsFieldValueInterface & {
  __typename?: 'JobsModeratorsFieldValuesInteger';
  field: JobsModeratorsField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
  value?: Maybe<Scalars['Int']>;
};

export type JobsModeratorsFieldValuesIntegerRange = JobsModeratorsFieldValueInterface & {
  __typename?: 'JobsModeratorsFieldValuesIntegerRange';
  field: JobsModeratorsField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  range?: Maybe<IntRangeRightBoundOptional>;
  shouldClause: Scalars['Boolean'];
};

export type JobsModeratorsFieldValuesMultiSelect = JobsModeratorsFieldValueInterface & {
  __typename?: 'JobsModeratorsFieldValuesMultiSelect';
  field: JobsModeratorsField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
  values: Array<Scalars['String']>;
};

export type JobsModeratorsFieldValuesMultiSelectRecord = JobsModeratorsFieldValueInterface & {
  __typename?: 'JobsModeratorsFieldValuesMultiSelectRecord';
  field: JobsModeratorsField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  records: Array<JobsModeratorsFieldValuesSelectRecordType>;
  shouldClause: Scalars['Boolean'];
};

export type JobsModeratorsFieldValuesSelectRecordType = City | Company | Department | Industry;

export type JobsModeratorsFieldValuesSingleSelect = JobsModeratorsFieldValueInterface & {
  __typename?: 'JobsModeratorsFieldValuesSingleSelect';
  field: JobsModeratorsField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type JobsModeratorsFieldValuesSingleSelectRecord = JobsModeratorsFieldValueInterface & {
  __typename?: 'JobsModeratorsFieldValuesSingleSelectRecord';
  field: JobsModeratorsField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  record: JobsModeratorsFieldValuesSelectRecordType;
  shouldClause: Scalars['Boolean'];
};

export type JobsModeratorsFieldValuesString = JobsModeratorsFieldValueInterface & {
  __typename?: 'JobsModeratorsFieldValuesString';
  field: JobsModeratorsField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type JobsModeratorsFieldValuesStringArray = JobsModeratorsFieldValueInterface & {
  __typename?: 'JobsModeratorsFieldValuesStringArray';
  field: JobsModeratorsField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
  values?: Maybe<Array<Scalars['String']>>;
};

export enum JobsModeratorsFieldsAccessLevel {
  Admin = 'ADMIN',
  Everyone = 'EVERYONE'
}

export type JobsModeratorsFieldsBoolean = JobsFieldsBooleanInterface & JobsFieldsInterface & {
  __typename?: 'JobsModeratorsFieldsBoolean';
  accessLevels: Array<JobsModeratorsFieldsAccessLevel>;
  availableForRoles: Array<JobsRole>;
  category: JobsModeratorsFieldsCategory;
  component?: Maybe<Scalars['String']>;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  requiredForRoles: Array<JobsRole>;
  scopes: Array<JobsFieldsScope>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsModeratorsFieldsBooleanAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type JobsModeratorsFieldsCategory = JobsFieldsCategoryInterface & {
  __typename?: 'JobsModeratorsFieldsCategory';
  description?: Maybe<Scalars['String']>;
  fields: Array<JobsModeratorsField>;
  id: Scalars['ID'];
  isStaticCategory?: Maybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  title: Scalars['String'];
};


export type JobsModeratorsFieldsCategoryFieldsArgs = {
  accessLevels?: InputMaybe<Array<JobsFieldsAccessLevel>>;
  availableForRoles?: InputMaybe<Array<JobsRole>>;
  popularForRoles?: InputMaybe<Array<JobsRole>>;
  scopes?: InputMaybe<Array<JobsFieldsScope>>;
};

export type JobsModeratorsFieldsFloat = JobsFieldsFloatInterface & JobsFieldsInterface & {
  __typename?: 'JobsModeratorsFieldsFloat';
  accessLevels: Array<JobsModeratorsFieldsAccessLevel>;
  availableForRoles: Array<JobsRole>;
  category: JobsModeratorsFieldsCategory;
  component?: Maybe<Scalars['String']>;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder: Scalars['String'];
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  range?: Maybe<FloatRangeRightBoundOptional>;
  requiredForRoles: Array<JobsRole>;
  scopes: Array<JobsFieldsScope>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsModeratorsFieldsFloatAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type JobsModeratorsFieldsFloatRange = JobsFieldsFloatRangeInterface & JobsFieldsInterface & {
  __typename?: 'JobsModeratorsFieldsFloatRange';
  accessLevels: Array<JobsModeratorsFieldsAccessLevel>;
  availableForRoles: Array<JobsRole>;
  category: JobsModeratorsFieldsCategory;
  component?: Maybe<Scalars['String']>;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder: JobsFieldsRangePlaceholder;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  range?: Maybe<FloatRangeRightBoundOptional>;
  requiredForRoles: Array<JobsRole>;
  scopes: Array<JobsFieldsScope>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsModeratorsFieldsFloatRangeAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<FloatRangeRightBoundOptionalInput>;
};

export type JobsModeratorsFieldsInteger = JobsFieldsIntegerInterface & JobsFieldsInterface & {
  __typename?: 'JobsModeratorsFieldsInteger';
  accessLevels: Array<JobsModeratorsFieldsAccessLevel>;
  availableForRoles: Array<JobsRole>;
  category: JobsModeratorsFieldsCategory;
  component?: Maybe<Scalars['String']>;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  range?: Maybe<IntRangeRightBoundOptional>;
  requiredForRoles: Array<JobsRole>;
  scopes: Array<JobsFieldsScope>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsModeratorsFieldsIntegerAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type JobsModeratorsFieldsIntegerRange = JobsFieldsIntegerRangeInterface & JobsFieldsInterface & {
  __typename?: 'JobsModeratorsFieldsIntegerRange';
  accessLevels: Array<JobsModeratorsFieldsAccessLevel>;
  availableForRoles: Array<JobsRole>;
  category: JobsModeratorsFieldsCategory;
  component?: Maybe<Scalars['String']>;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder: JobsFieldsRangePlaceholder;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  range?: Maybe<IntRangeRightBoundOptional>;
  requiredForRoles: Array<JobsRole>;
  scopes: Array<JobsFieldsScope>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsModeratorsFieldsIntegerRangeAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<IntRangeRightBoundOptionalInput>;
};

export type JobsModeratorsFieldsMultiSelect = JobsFieldsInterface & JobsFieldsSelectInterface & {
  __typename?: 'JobsModeratorsFieldsMultiSelect';
  accessLevels: Array<JobsModeratorsFieldsAccessLevel>;
  availableForRoles: Array<JobsRole>;
  category: JobsModeratorsFieldsCategory;
  component?: Maybe<Scalars['String']>;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  options: Array<JobsFieldsSelectOption>;
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  requiredForRoles: Array<JobsRole>;
  scopes: Array<JobsFieldsScope>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsModeratorsFieldsMultiSelectAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type JobsModeratorsFieldsMultiSelectRecord = JobsFieldsInterface & JobsFieldsSingleSelectRecordInterface & {
  __typename?: 'JobsModeratorsFieldsMultiSelectRecord';
  accessLevels: Array<JobsModeratorsFieldsAccessLevel>;
  availableForRoles: Array<JobsRole>;
  category: JobsModeratorsFieldsCategory;
  component?: Maybe<Scalars['String']>;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  recordType: JobsFieldsRecordType;
  requiredForRoles: Array<JobsRole>;
  scopes: Array<JobsFieldsScope>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsModeratorsFieldsMultiSelectRecordAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  recordIds?: InputMaybe<Array<Scalars['ID']>>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
};

export type JobsModeratorsFieldsSingleSelect = JobsFieldsInterface & JobsFieldsSelectInterface & {
  __typename?: 'JobsModeratorsFieldsSingleSelect';
  accessLevels: Array<JobsModeratorsFieldsAccessLevel>;
  availableForRoles: Array<JobsRole>;
  category: JobsModeratorsFieldsCategory;
  component?: Maybe<Scalars['String']>;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  options: Array<JobsFieldsSelectOption>;
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  requiredForRoles: Array<JobsRole>;
  scopes: Array<JobsFieldsScope>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsModeratorsFieldsSingleSelectAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type JobsModeratorsFieldsSingleSelectRecord = JobsFieldsInterface & JobsFieldsSingleSelectRecordInterface & {
  __typename?: 'JobsModeratorsFieldsSingleSelectRecord';
  accessLevels: Array<JobsModeratorsFieldsAccessLevel>;
  availableForRoles: Array<JobsRole>;
  category: JobsModeratorsFieldsCategory;
  component?: Maybe<Scalars['String']>;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  recordType: JobsFieldsRecordType;
  requiredForRoles: Array<JobsRole>;
  scopes: Array<JobsFieldsScope>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsModeratorsFieldsSingleSelectRecordAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  recordId?: InputMaybe<Scalars['ID']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
};

export type JobsModeratorsFieldsString = JobsFieldsInterface & JobsFieldsStringInterface & {
  __typename?: 'JobsModeratorsFieldsString';
  accessLevels: Array<JobsModeratorsFieldsAccessLevel>;
  availableForRoles: Array<JobsRole>;
  category: JobsModeratorsFieldsCategory;
  component?: Maybe<Scalars['String']>;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  requiredForRoles: Array<JobsRole>;
  scopes: Array<JobsFieldsScope>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsModeratorsFieldsStringArray = JobsFieldsInterface & JobsFieldsStringArrayInterface & {
  __typename?: 'JobsModeratorsFieldsStringArray';
  accessLevels: Array<JobsModeratorsFieldsAccessLevel>;
  availableForRoles: Array<JobsRole>;
  category: JobsModeratorsFieldsCategory;
  component?: Maybe<Scalars['String']>;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  requiredForRoles: Array<JobsRole>;
  scopes: Array<JobsFieldsScope>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsModeratorsFieldsStringArrayAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type JobsModeratorsFieldsStringAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of JobsModeratorsFireHiringEvent */
export type JobsModeratorsFireHiringEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventName: JobsModeratorsHiringEventName;
  hiringId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsFireInquiryEvent */
export type JobsModeratorsFireInquiryEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventName: JobsModeratorsInquiryEventName;
  inquiryId: Scalars['ID'];
};

export type JobsModeratorsHiring = {
  __typename?: 'JobsModeratorsHiring';
  acceptedByCandidateAt?: Maybe<Scalars['ISO8601DateTime']>;
  acceptedByEmployerAt?: Maybe<Scalars['ISO8601DateTime']>;
  acceptedByOpsAt?: Maybe<Scalars['ISO8601DateTime']>;
  availableEvents: Array<Scalars['String']>;
  employer: JobsModeratorsEmployer;
  id: Scalars['ID'];
  inquiry: JobsModeratorsInquiry;
  interviewDate?: Maybe<Scalars['ISO8601Date']>;
  interviewNumber?: Maybe<Scalars['Int']>;
  introductionDate?: Maybe<Scalars['ISO8601Date']>;
  matchingModelInterpretation?: Maybe<Scalars['String']>;
  matchingScore?: Maybe<Scalars['Float']>;
  origin: JobsHiringOrigin;
  scheduledMessages?: Maybe<Array<JobsModeratorsScheduledMessage>>;
  secondsInState: Scalars['Int'];
  state: JobsModeratorsHiringState;
  stateUpdatedAt: Scalars['ISO8601DateTime'];
  submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  talentPortalUrl: Scalars['String'];
  vacancy?: Maybe<JobsModeratorsVacancy>;
};

/** The connection type for JobsModeratorsHiring. */
export type JobsModeratorsHiringConnection = {
  __typename?: 'JobsModeratorsHiringConnection';
  /** A list of edges. */
  edges: Array<JobsModeratorsHiringEdge>;
  /** A list of nodes. */
  nodes: Array<JobsModeratorsHiring>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type JobsModeratorsHiringEdge = {
  __typename?: 'JobsModeratorsHiringEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobsModeratorsHiring>;
};

export enum JobsModeratorsHiringEventName {
  AcceptAnotherOffer = 'accept_another_offer',
  AcceptByCandidate = 'accept_by_candidate',
  AcceptByEmployer = 'accept_by_employer',
  Deactivate = 'deactivate',
  Expire = 'expire',
  FinishMeeting = 'finish_meeting',
  Hire = 'hire',
  Introduce = 'introduce',
  Offer = 'offer',
  Pair = 'pair',
  RejectByCandidate = 'reject_by_candidate',
  RejectByEmployer = 'reject_by_employer',
  RejectByOps = 'reject_by_ops',
  Restore = 'restore',
  ScheduleMeeting = 'schedule_meeting',
  Submit = 'submit'
}

export type JobsModeratorsHiringExplanation = {
  __typename?: 'JobsModeratorsHiringExplanation';
  badges?: Maybe<Array<JobsHiringBadge>>;
  bullet1?: Maybe<Scalars['String']>;
  bullet2?: Maybe<Scalars['String']>;
  headline1?: Maybe<Scalars['String']>;
  headline2?: Maybe<Scalars['String']>;
  headline3?: Maybe<Scalars['String']>;
};

/** Attributes for sorting hirings for a moderator */
export type JobsModeratorsHiringSortAttributes = {
  field: JobsModeratorsHiringSortField;
  order: SortOrder;
};

export enum JobsModeratorsHiringSortField {
  AcceptedByCandidateAt = 'accepted_by_candidate_at',
  AcceptedByEmployerAt = 'accepted_by_employer_at',
  InterviewDate = 'interview_date',
  StateUpdatedAt = 'state_updated_at',
  VacancyTitle = 'vacancy_title'
}

export enum JobsModeratorsHiringState {
  AcceptedAnotherOffer = 'accepted_another_offer',
  Deactivated = 'deactivated',
  Draft = 'draft',
  Expired = 'expired',
  Hired = 'hired',
  Interviewed = 'interviewed',
  Introduced = 'introduced',
  Matched = 'matched',
  Offered = 'offered',
  Paired = 'paired',
  Queued = 'queued',
  RejectedByCandidate = 'rejected_by_candidate',
  RejectedByEmployer = 'rejected_by_employer',
  RejectedByOps = 'rejected_by_ops',
  ScheduledAssessment = 'scheduled_assessment',
  ScheduledInterview = 'scheduled_interview',
  Submitted = 'submitted'
}

export type JobsModeratorsHiringStateCounter = {
  __typename?: 'JobsModeratorsHiringStateCounter';
  count: Scalars['Int'];
  state: JobsModeratorsHiringState;
};

export type JobsModeratorsInquiry = JobsBaseInquiryInterface & {
  __typename?: 'JobsModeratorsInquiry';
  accomplishments?: Maybe<Scalars['String']>;
  aeAnnualizedQuota?: Maybe<Scalars['Int']>;
  aeLeadSourceOther?: Maybe<Scalars['String']>;
  aeLeadSourcesMain?: Maybe<Array<JobsInquiryAeLeadSource>>;
  aeQuotaPerPeriod?: Maybe<Scalars['Int']>;
  aeQuotaTypeMain?: Maybe<JobsInquiryAeQuota>;
  aeQuotaTypeOther?: Maybe<Scalars['String']>;
  assignee?: Maybe<JobsModeratorsUser>;
  availableEvents?: Maybe<Array<JobsModeratorsInquiryEventName>>;
  baseSalary?: Maybe<Scalars['Int']>;
  canCreateHirings: Scalars['Boolean'];
  clientDescription?: Maybe<Scalars['String']>;
  csmAccountsNumber?: Maybe<JobsInquiryCsmAccountNumber>;
  csmQuotaMetricMain?: Maybe<Array<JobsInquiryCsmQuotaMetric>>;
  csmQuotaMetricOther?: Maybe<Scalars['String']>;
  csmQuotaPeriodMain?: Maybe<JobsInquiryCsmQuotaPeriod>;
  csmQuotaPeriodOther?: Maybe<Scalars['String']>;
  csmQuotaTypeMain?: Maybe<JobsInquiryCsmQuota>;
  csmQuotaTypeOther?: Maybe<Scalars['String']>;
  csmRenewalValue?: Maybe<JobsInquiryCsmRenewalValue>;
  csmTotalBusinessValue?: Maybe<JobsInquiryCsmBusinessValue>;
  csmUpsellValue?: Maybe<JobsInquiryCsmUpsellValue>;
  currency?: Maybe<Currency>;
  dealBreakerOther?: Maybe<Scalars['String']>;
  dealBreakersMain?: Maybe<Array<JobsInquiryDealBreaker>>;
  dealSize?: Maybe<JobsInquiryDealSize>;
  desiredCompanySeriesStages?: Maybe<Array<CompanySeriesStage>>;
  employmentTypes: Array<JobsInquiryEmployment>;
  filledAt?: Maybe<Scalars['ISO8601DateTime']>;
  flexAppliedCriteria?: Maybe<Array<JobsFlexAppliedCriteria>>;
  flexBandwidth?: Maybe<Scalars['String']>;
  flexBriefVideoUrl?: Maybe<Scalars['String']>;
  flexConsideredCompanyTypes?: Maybe<Array<JobsFlexFlexConsideredCompanyType>>;
  flexOnboardingState?: Maybe<Scalars['String']>;
  flexPreviousExperience?: Maybe<Scalars['String']>;
  flexRating?: Maybe<Scalars['Float']>;
  flexReasonForParticipation?: Maybe<Scalars['String']>;
  flexRoles?: Maybe<Array<JobsFlexRole>>;
  flexState?: Maybe<Scalars['String']>;
  flexUnderstandingOfSales?: Maybe<Scalars['String']>;
  frontUrl: Scalars['String'];
  hirings?: Maybe<Array<JobsModeratorsHiring>>;
  id: Scalars['ID'];
  idealJobDescription?: Maybe<Scalars['String']>;
  lastActiveAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastNote?: Maybe<JobsModeratorsInquiryNote>;
  notes?: Maybe<Array<JobsModeratorsInquiryNote>>;
  onboardingState: JobsInquiryOnboardingState;
  ote?: Maybe<Scalars['Int']>;
  positionMain?: Maybe<JobsInquiryPosition>;
  positionOther?: Maybe<Scalars['String']>;
  quotaAttainmentByTeamPerPeriod?: Maybe<Scalars['Int']>;
  quotaAttainmentPerLastYear?: Maybe<Scalars['Int']>;
  quotaAttainmentPerPeriod?: Maybe<Scalars['Int']>;
  rankOnTeam?: Maybe<Scalars['Int']>;
  refreshedAt?: Maybe<Scalars['ISO8601DateTime']>;
  revenue?: Maybe<Scalars['Int']>;
  salesCycleLength?: Maybe<JobsInquirySalesCycleLength>;
  salesMethodologies?: Maybe<Array<JobsInquirySalesMethodology>>;
  screened: Scalars['Boolean'];
  sdrQuotaPerPeriod?: Maybe<Scalars['String']>;
  sdrQuotaTypes?: Maybe<Array<JobsInquirySdrQuota>>;
  state: JobsInquiryState;
  teamSize?: Maybe<Scalars['Int']>;
  tier?: Maybe<Scalars['Int']>;
  user?: Maybe<JobsModeratorsUser>;
  vpDepartmentSize?: Maybe<JobsInquiryVpDepartmentSize>;
  vpManagedRoles?: Maybe<Array<JobsInquiryVpManagedRole>>;
  vpQuotaType?: Maybe<JobsInquiryVpQuota>;
  vpResponsibilities?: Maybe<Scalars['String']>;
  willingToRelocate?: Maybe<Scalars['Boolean']>;
  workHistories: Array<WorkHistory>;
};

/** The connection type for JobsModeratorsInquiry. */
export type JobsModeratorsInquiryConnection = {
  __typename?: 'JobsModeratorsInquiryConnection';
  /** A list of edges. */
  edges: Array<JobsModeratorsInquiryEdge>;
  /** A list of nodes. */
  nodes: Array<JobsModeratorsInquiry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type JobsModeratorsInquiryEdge = {
  __typename?: 'JobsModeratorsInquiryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobsModeratorsInquiry>;
};

export enum JobsModeratorsInquiryEventName {
  Remove = 'remove'
}

export type JobsModeratorsInquiryMatch = {
  __typename?: 'JobsModeratorsInquiryMatch';
  inquiry: JobsModeratorsInquiry;
  inquiryId: Scalars['ID'];
  matchingModelInterpretation?: Maybe<Array<Scalars['String']>>;
  score?: Maybe<Scalars['Float']>;
};

export type JobsModeratorsInquiryNote = {
  __typename?: 'JobsModeratorsInquiryNote';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  hiring?: Maybe<JobsModeratorsHiring>;
  id: Scalars['ID'];
  inquiry: JobsModeratorsInquiry;
  mainCategory: JobsModeratorsInquiryNoteMainCategory;
  subcategory: JobsModeratorsInquiryNoteSubcategory;
  title: Scalars['String'];
  user?: Maybe<JobsModeratorsUser>;
};

export enum JobsModeratorsInquiryNoteMainCategory {
  MainCategoryModel = 'MAIN_CATEGORY_MODEL',
  MainCategoryProfileUpdates = 'MAIN_CATEGORY_PROFILE_UPDATES',
  MainCategoryTeamNotes = 'MAIN_CATEGORY_TEAM_NOTES'
}

export enum JobsModeratorsInquiryNoteSubcategory {
  SubcategoryCall = 'SUBCATEGORY_CALL',
  SubcategoryCandidateHiringRejection = 'SUBCATEGORY_CANDIDATE_HIRING_REJECTION',
  SubcategoryCandidateMessage = 'SUBCATEGORY_CANDIDATE_MESSAGE',
  SubcategoryCandidateProfileUpdate = 'SUBCATEGORY_CANDIDATE_PROFILE_UPDATE',
  SubcategoryEmployerHiringRejection = 'SUBCATEGORY_EMPLOYER_HIRING_REJECTION',
  SubcategoryGeneral = 'SUBCATEGORY_GENERAL',
  SubcategoryNoShowInterview = 'SUBCATEGORY_NO_SHOW_INTERVIEW',
  SubcategoryOpsHiringRejection = 'SUBCATEGORY_OPS_HIRING_REJECTION',
  SubcategoryOpsProfileUpdate = 'SUBCATEGORY_OPS_PROFILE_UPDATE',
  SubcategoryPairingModel = 'SUBCATEGORY_PAIRING_MODEL',
  SubcategoryProfile = 'SUBCATEGORY_PROFILE',
  SubcategorySubmittedCardUpdate = 'SUBCATEGORY_SUBMITTED_CARD_UPDATE',
  SubcategoryTieringModel = 'SUBCATEGORY_TIERING_MODEL'
}

/** Attributes for sorting inquiries for a moderator */
export type JobsModeratorsInquirySortAttributes = {
  field: JobsModeratorsInquirySortField;
  order: SortOrder;
};

export enum JobsModeratorsInquirySortField {
  FilledAt = 'FILLED_AT',
  LastActiveOrFilledAt = 'LAST_ACTIVE_OR_FILLED_AT'
}

/** Autogenerated input type of JobsModeratorsMatchInquiry */
export type JobsModeratorsMatchInquiryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inquiryId: Scalars['ID'];
};

/** Autogenerated return type of JobsModeratorsMatchInquiry */
export type JobsModeratorsMatchInquiryPayload = {
  __typename?: 'JobsModeratorsMatchInquiryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  inquiry?: Maybe<JobsModeratorsInquiry>;
};

/** Autogenerated input type of JobsModeratorsMergeVacancy */
export type JobsModeratorsMergeVacancyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  mergeWithVacancyId: Scalars['ID'];
  vacancyId: Scalars['ID'];
};

export type JobsModeratorsOpsRejectionReason = {
  __typename?: 'JobsModeratorsOpsRejectionReason';
  category: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type JobsModeratorsRecruiter = {
  __typename?: 'JobsModeratorsRecruiter';
  email: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobTitle?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['Boolean']>;
  schedulingLink?: Maybe<Scalars['String']>;
  slackId?: Maybe<Scalars['String']>;
};

/** Attributes for creating, updating, or deleting jobs employer's recruiters */
export type JobsModeratorsRecruiterAttributes = {
  email: Scalars['String'];
  firstname: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  lastname: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  schedulingLink?: InputMaybe<Scalars['String']>;
  slackId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of JobsModeratorsRejectInquiryVacancySuggestionByOps */
export type JobsModeratorsRejectInquiryVacancySuggestionByOpsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inquiryId: Scalars['ID'];
  otherRejectionReason?: InputMaybe<Scalars['String']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['ID']>>;
  vacancyId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsRejectJobsHiringByOps */
export type JobsModeratorsRejectJobsHiringByOpsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  hiringId: Scalars['ID'];
  otherRejectionReason?: InputMaybe<Scalars['String']>;
  rejectionReasonIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Autogenerated input type of JobsModeratorsRemoveInquiry */
export type JobsModeratorsRemoveInquiryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inquiryId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsRenewActiveJobStatus */
export type JobsModeratorsRenewActiveJobStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsScheduleMeeting */
export type JobsModeratorsScheduleMeetingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  hiringId: Scalars['ID'];
  interviewDate: Scalars['ISO8601Date'];
  meetingType: JobsHiringMeeting;
};

export type JobsModeratorsScheduledMessage = {
  __typename?: 'JobsModeratorsScheduledMessage';
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']>;
  failedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  scheduledAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of JobsModeratorsSubmitHiring */
export type JobsModeratorsSubmitHiringInput = {
  candidateAttributes: CandidateAttributes;
  candidateAttributesVisability: CandidateAttributesVisability;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  hiringId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsUpdateCompany */
export type JobsModeratorsUpdateCompanyInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsUpdateEmployer */
export type JobsModeratorsUpdateEmployerInput = {
  accountOwnerId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  descriptionHtml?: InputMaybe<Scalars['String']>;
  descriptionMarkdown?: InputMaybe<Scalars['String']>;
  employerId: Scalars['ID'];
  hiringProcessHtml?: InputMaybe<Scalars['String']>;
  hiringProcessMarkdown?: InputMaybe<Scalars['String']>;
  industries?: InputMaybe<Array<Scalars['String']>>;
  keyPoints?: InputMaybe<Array<Scalars['String']>>;
  roleUrl?: InputMaybe<Scalars['String']>;
  slackChannel?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of JobsModeratorsUpdateHiring */
export type JobsModeratorsUpdateHiringInput = {
  acceptedByCandidateAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  acceptedByEmployerAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  employerId: Scalars['ID'];
  hiringId: Scalars['ID'];
  interviewDate?: InputMaybe<Scalars['ISO8601Date']>;
  introductionDate?: InputMaybe<Scalars['ISO8601Date']>;
  vacancyId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of JobsModeratorsUpdateInquiry */
export type JobsModeratorsUpdateInquiryInput = {
  accomplishments?: InputMaybe<Scalars['String']>;
  aeLeadSourceOther?: InputMaybe<Scalars['String']>;
  aeLeadSourcesMain?: InputMaybe<Array<JobsInquiryAeLeadSource>>;
  aeQuotaPerPeriod?: InputMaybe<Scalars['Int']>;
  aeQuotaTypeMain?: InputMaybe<JobsInquiryAeQuota>;
  aeQuotaTypeOther?: InputMaybe<Scalars['String']>;
  assigneeId?: InputMaybe<Scalars['ID']>;
  baseSalary?: InputMaybe<Scalars['Int']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  csmAccountsNumber?: InputMaybe<JobsInquiryCsmAccountNumber>;
  csmQuotaMetricMain?: InputMaybe<Array<JobsInquiryCsmQuotaMetric>>;
  csmQuotaMetricOther?: InputMaybe<Scalars['String']>;
  csmQuotaPeriodMain?: InputMaybe<JobsInquiryCsmQuotaPeriod>;
  csmQuotaPeriodOther?: InputMaybe<Scalars['String']>;
  csmQuotaTypeMain?: InputMaybe<JobsInquiryCsmQuota>;
  csmQuotaTypeOther?: InputMaybe<Scalars['String']>;
  csmRenewalValue?: InputMaybe<JobsInquiryCsmRenewalValue>;
  csmTotalBusinessValue?: InputMaybe<JobsInquiryCsmBusinessValue>;
  csmUpsellValue?: InputMaybe<JobsInquiryCsmUpsellValue>;
  currency?: InputMaybe<Currency>;
  dealBreakerOther?: InputMaybe<Scalars['String']>;
  dealBreakersMain?: InputMaybe<Array<JobsInquiryDealBreaker>>;
  dealSize?: InputMaybe<JobsInquiryDealSize>;
  desiredCompanySeriesStageIds?: InputMaybe<Array<Scalars['Int']>>;
  employmentTypes?: InputMaybe<Array<JobsInquiryEmployment>>;
  fakeHiring?: InputMaybe<InquiryFakeHiringAttributes>;
  flexAppliedCriteria?: InputMaybe<Array<JobsFlexAppliedCriteria>>;
  flexBandwidth?: InputMaybe<JobsFlexBandwidth>;
  flexBriefVideoUrl?: InputMaybe<Scalars['String']>;
  flexConsideredCompanyTypes?: InputMaybe<Array<JobsFlexFlexConsideredCompanyType>>;
  flexOnboardingState?: InputMaybe<Scalars['String']>;
  flexPreviousExperience?: InputMaybe<Scalars['String']>;
  flexRating?: InputMaybe<Scalars['Float']>;
  flexReasonForParticipation?: InputMaybe<Scalars['String']>;
  flexRoles?: InputMaybe<Array<JobsFlexRole>>;
  flexState?: InputMaybe<Scalars['String']>;
  flexUnderstandingOfSales?: InputMaybe<Scalars['String']>;
  idealJobDescription?: InputMaybe<Scalars['String']>;
  inquiryId: Scalars['ID'];
  onboardingState?: InputMaybe<JobsInquiryOnboardingState>;
  ote?: InputMaybe<Scalars['Int']>;
  positionMain?: InputMaybe<JobsInquiryPosition>;
  positionOther?: InputMaybe<Scalars['String']>;
  quotaAttainmentByTeamPerPeriod?: InputMaybe<Scalars['Int']>;
  quotaAttainmentPerLastYear?: InputMaybe<Scalars['Int']>;
  quotaAttainmentPerPeriod?: InputMaybe<Scalars['Int']>;
  rankOnTeam?: InputMaybe<Scalars['Int']>;
  revenue?: InputMaybe<Scalars['Int']>;
  salesCycleLength?: InputMaybe<JobsInquirySalesCycleLength>;
  salesMethodologies?: InputMaybe<Array<JobsInquirySalesMethodology>>;
  screened?: InputMaybe<Scalars['Boolean']>;
  sdrQuotaPerPeriod?: InputMaybe<Scalars['String']>;
  sdrQuotaTypes?: InputMaybe<Array<JobsInquirySdrQuota>>;
  source?: InputMaybe<JobsInquirySource>;
  teamSize?: InputMaybe<Scalars['Int']>;
  tier?: InputMaybe<Scalars['Int']>;
  vpDepartmentSize?: InputMaybe<JobsInquiryVpDepartmentSize>;
  vpManagedRoles?: InputMaybe<Array<JobsInquiryVpManagedRole>>;
  vpQuotaType?: InputMaybe<JobsInquiryVpQuota>;
  vpResponsibilities?: InputMaybe<Scalars['String']>;
  willingToRelocate?: InputMaybe<Scalars['Boolean']>;
  workHistoryId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of JobsModeratorsUpdateSubmittedHiring */
export type JobsModeratorsUpdateSubmittedHiringInput = {
  candidateAttributes: CandidateAttributes;
  candidateAttributesVisability?: InputMaybe<CandidateAttributesVisability>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  hiringId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsUpdateUser */
export type JobsModeratorsUpdateUserInput = {
  cityId?: InputMaybe<Scalars['Int']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  departmentIds?: InputMaybe<Array<Scalars['ID']>>;
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  productTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  unarchivedClientCompanyIds?: InputMaybe<Array<Scalars['ID']>>;
  userId: Scalars['ID'];
  warRoomCompanySeriesStageIds?: InputMaybe<Array<Scalars['ID']>>;
  warRoomCompanyStageIds?: InputMaybe<Array<Scalars['ID']>>;
  warRoomIndustryIds?: InputMaybe<Array<Scalars['ID']>>;
  warRoomJobSearchStatus?: InputMaybe<Scalars['String']>;
  warRoomSalesRoleIds?: InputMaybe<Array<Scalars['ID']>>;
  warRoomYearsOfExperience?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of JobsModeratorsUpdateVacancy */
export type JobsModeratorsUpdateVacancyInput = {
  autoCandidateSubmissionsEnabled?: InputMaybe<Scalars['Boolean']>;
  booleanFields?: InputMaybe<Array<JobsModeratorsFieldsBooleanAttributes>>;
  cityIds?: InputMaybe<Array<Scalars['ID']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  employmentType?: InputMaybe<JobsVacancyEmployment>;
  floatFields?: InputMaybe<Array<JobsModeratorsFieldsFloatAttributes>>;
  floatRangeFields?: InputMaybe<Array<JobsModeratorsFieldsFloatRangeAttributes>>;
  gptPrompt?: InputMaybe<Scalars['String']>;
  headcount?: InputMaybe<Scalars['Int']>;
  hiringsBacklogLimit?: InputMaybe<Scalars['Int']>;
  integerFields?: InputMaybe<Array<JobsModeratorsFieldsIntegerAttributes>>;
  integerRangeFields?: InputMaybe<Array<JobsModeratorsFieldsIntegerRangeAttributes>>;
  matchScoreThreshold?: InputMaybe<Scalars['Float']>;
  /** If provided then all other field are ingored and vacancy will not be updated, only merged */
  mergeWithVacancyId?: InputMaybe<Scalars['ID']>;
  multiSelectFields?: InputMaybe<Array<JobsModeratorsFieldsMultiSelectAttributes>>;
  multiSelectRecordFields?: InputMaybe<Array<JobsModeratorsFieldsMultiSelectRecordAttributes>>;
  openToRemoteWork?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<JobsRole>;
  primaryRecruiterId?: InputMaybe<Scalars['ID']>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']>>;
  remoteOnlyAtSelectedLocations?: InputMaybe<Scalars['Boolean']>;
  singleSelectFields?: InputMaybe<Array<JobsModeratorsFieldsSingleSelectAttributes>>;
  singleSelectRecordFields?: InputMaybe<Array<JobsModeratorsFieldsSingleSelectRecordAttributes>>;
  stringArrayFields?: InputMaybe<Array<JobsModeratorsFieldsStringArrayAttributes>>;
  stringFields?: InputMaybe<Array<JobsModeratorsFieldsStringAttributes>>;
  title?: InputMaybe<Scalars['String']>;
  vacancyId: Scalars['ID'];
};

/** Autogenerated input type of JobsModeratorsUpdateVacancySubmission */
export type JobsModeratorsUpdateVacancySubmissionInput = {
  avgDealSize?: InputMaybe<Scalars['String']>;
  avgSalesCycle?: InputMaybe<Scalars['String']>;
  baseSalary?: InputMaybe<Scalars['String']>;
  brandMaturity?: InputMaybe<JobsVacancySubmissionBrandMaturity>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  compensation?: InputMaybe<Scalars['String']>;
  compensationDescription?: InputMaybe<Scalars['String']>;
  customerProfile?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  jobUrl?: InputMaybe<Scalars['String']>;
  keyPoint1?: InputMaybe<Scalars['String']>;
  keyPoint2?: InputMaybe<Scalars['String']>;
  keyPoint3?: InputMaybe<Scalars['String']>;
  keyPoint4?: InputMaybe<Scalars['String']>;
  keyPoint5?: InputMaybe<Scalars['String']>;
  keyPoint6?: InputMaybe<Scalars['String']>;
  keyPoint7?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  minBandwidth?: InputMaybe<Scalars['String']>;
  ote?: InputMaybe<Scalars['String']>;
  quotaAttainmentByTeam?: InputMaybe<Scalars['Int']>;
  roleName?: InputMaybe<Scalars['String']>;
  vacancyId: Scalars['ID'];
  visibilityOfAttributes?: InputMaybe<JobsModeratorsVacancySubmissionVisibilityAttributes>;
  workType?: InputMaybe<Scalars['String']>;
};

export type JobsModeratorsUser = {
  __typename?: 'JobsModeratorsUser';
  autoName?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  companySeriesStages?: Maybe<Array<CompanySeriesStage>>;
  companyStages?: Maybe<Array<CompanyStage>>;
  departmentIds?: Maybe<Array<Scalars['Int']>>;
  departments?: Maybe<Array<Department>>;
  firstname?: Maybe<Scalars['String']>;
  fullEmail: Scalars['String'];
  id: Scalars['Int'];
  industries?: Maybe<Array<Industry>>;
  initials?: Maybe<Scalars['String']>;
  jobsAccountOwner: Scalars['Boolean'];
  lastname?: Maybe<Scalars['String']>;
  linkedinSlug?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  productTypeIds?: Maybe<Array<Scalars['Int']>>;
  productTypes?: Maybe<Array<ProductType>>;
  solidClients: Array<Client>;
  warRoomCompanySeriesStageIds?: Maybe<Array<Scalars['Int']>>;
  warRoomCompanyStageIds?: Maybe<Array<Scalars['Int']>>;
  warRoomIndustryIds?: Maybe<Array<Scalars['Int']>>;
  warRoomJobSearchStatus?: Maybe<Scalars['String']>;
  warRoomJobSearchStatusExpiredAt?: Maybe<Scalars['ISO8601DateTime']>;
  warRoomSalesRoleIds?: Maybe<Array<Scalars['Int']>>;
  warRoomSalesRoles?: Maybe<Array<SalesRole>>;
  warRoomYearsOfExperience?: Maybe<Scalars['Int']>;
};

export type JobsModeratorsVacancy = {
  __typename?: 'JobsModeratorsVacancy';
  autoCandidateSubmissionsEnabled: Scalars['Boolean'];
  cities?: Maybe<Array<City>>;
  comments?: Maybe<Scalars['String']>;
  countries?: Maybe<Array<Country>>;
  createdAt: Scalars['ISO8601DateTime'];
  creator?: Maybe<JobsModeratorsVacancyCreator>;
  daysSinceLastHiringReviewed?: Maybe<Scalars['Int']>;
  defaultSubmission?: Maybe<JobsModeratorsVacancySubmission>;
  description?: Maybe<Scalars['String']>;
  employer?: Maybe<JobsModeratorsEmployer>;
  employerHiringCategories?: Maybe<JobsModeratorsEmployerHiringGroups>;
  employmentType: JobsVacancyEmployment;
  fieldValues: Array<JobsModeratorsVacancyFieldValue>;
  fiveDaysActivity: Scalars['Int'];
  fromGreenhouse: Scalars['Boolean'];
  gptPrompt?: Maybe<Scalars['String']>;
  headcount?: Maybe<Scalars['Int']>;
  hiringsBacklogLimit?: Maybe<Scalars['Int']>;
  hiringsHiredCount: Scalars['Int'];
  hiringsInterviewedCount: Scalars['Int'];
  hiringsIntroducedCount: Scalars['Int'];
  hiringsOfferedCount: Scalars['Int'];
  hiringsScheduledCount: Scalars['Int'];
  hiringsToExpireCount: Scalars['Int'];
  hiringsToReviewCount: Scalars['Int'];
  id: Scalars['ID'];
  isImportedFromGreenhouse: Scalars['Boolean'];
  lowerTitle?: Maybe<Scalars['String']>;
  matchScoreThreshold?: Maybe<Scalars['Float']>;
  openToRemoteWork?: Maybe<Scalars['Boolean']>;
  position?: Maybe<JobsRole>;
  recruiters?: Maybe<Array<JobsRecruitersRecruiter>>;
  remoteOnlyAtSelectedLocations?: Maybe<Scalars['Boolean']>;
  state: JobsVacancyState;
  submission?: Maybe<JobsModeratorsVacancySubmission>;
  title: Scalars['String'];
};

/** The connection type for JobsModeratorsVacancy. */
export type JobsModeratorsVacancyConnection = {
  __typename?: 'JobsModeratorsVacancyConnection';
  /** A list of edges. */
  edges: Array<JobsModeratorsVacancyEdge>;
  /** A list of nodes. */
  nodes: Array<JobsModeratorsVacancy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type JobsModeratorsVacancyCreator = JobsModeratorsVacancyCreatorInterface & {
  __typename?: 'JobsModeratorsVacancyCreator';
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type JobsModeratorsVacancyCreatorInterface = {
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** An edge in a connection. */
export type JobsModeratorsVacancyEdge = {
  __typename?: 'JobsModeratorsVacancyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobsModeratorsVacancy>;
};

export type JobsModeratorsVacancyFieldValue = JobsModeratorsFieldValuesBoolean | JobsModeratorsFieldValuesFloat | JobsModeratorsFieldValuesFloatRange | JobsModeratorsFieldValuesInteger | JobsModeratorsFieldValuesIntegerRange | JobsModeratorsFieldValuesMultiSelect | JobsModeratorsFieldValuesMultiSelectRecord | JobsModeratorsFieldValuesSingleSelect | JobsModeratorsFieldValuesSingleSelectRecord | JobsModeratorsFieldValuesString | JobsModeratorsFieldValuesStringArray;

export type JobsModeratorsVacancyMatch = {
  __typename?: 'JobsModeratorsVacancyMatch';
  matchingModelInterpretation?: Maybe<Array<Scalars['String']>>;
  score?: Maybe<Scalars['Float']>;
  vacancy: JobsModeratorsVacancy;
};

/** Attributes for sorting vacancies for a moderator */
export type JobsModeratorsVacancySortAttributes = {
  field: JobsModeratorsVacancySortField;
  order: SortOrder;
};

export enum JobsModeratorsVacancySortField {
  Employer = 'employer',
  EmploymentType = 'employment_type',
  FiveDaysActivity = 'five_days_activity',
  State = 'state',
  Title = 'title'
}

export type JobsModeratorsVacancySubmission = JobsVacancySubmissionInterface & {
  __typename?: 'JobsModeratorsVacancySubmission';
  avgDealSize?: Maybe<Scalars['String']>;
  avgSalesCycle?: Maybe<Scalars['String']>;
  baseSalary?: Maybe<Scalars['String']>;
  brandMaturity?: Maybe<JobsVacancySubmissionBrandMaturity>;
  companyName: Scalars['String'];
  compensation?: Maybe<Scalars['String']>;
  compensationDescription?: Maybe<Scalars['String']>;
  customerProfile?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  industry: Scalars['String'];
  jobUrl?: Maybe<Scalars['String']>;
  keyPoint1?: Maybe<Scalars['String']>;
  keyPoint2?: Maybe<Scalars['String']>;
  keyPoint3?: Maybe<Scalars['String']>;
  keyPoint4?: Maybe<Scalars['String']>;
  keyPoint5?: Maybe<Scalars['String']>;
  keyPoint6?: Maybe<Scalars['String']>;
  keyPoint7?: Maybe<Scalars['String']>;
  location: Scalars['String'];
  minBandwidth?: Maybe<Scalars['String']>;
  ote?: Maybe<Scalars['String']>;
  quotaAttainmentByTeam?: Maybe<Scalars['Int']>;
  roleName: Scalars['String'];
  visibilityOfAttributes: JobsVacancySubmissionVisibilityOfAttributes;
  workType?: Maybe<Scalars['String']>;
};

export type JobsModeratorsVacancySubmissionVisibilityAttributes = {
  isAvgDealSizeVisible?: InputMaybe<Scalars['Boolean']>;
  isAvgSalesCycleVisible?: InputMaybe<Scalars['Boolean']>;
  isBaseSalaryVisible?: InputMaybe<Scalars['Boolean']>;
  isBrandMaturityVisible?: InputMaybe<Scalars['Boolean']>;
  isCompanyNameVisible?: InputMaybe<Scalars['Boolean']>;
  isCompensationDescriptionVisible?: InputMaybe<Scalars['Boolean']>;
  isCompensationVisible?: InputMaybe<Scalars['Boolean']>;
  isCustomerProfileVisible?: InputMaybe<Scalars['Boolean']>;
  isIndustryVisible?: InputMaybe<Scalars['Boolean']>;
  isJobUrlVisible?: InputMaybe<Scalars['Boolean']>;
  isKeyPoint1Visible?: InputMaybe<Scalars['Boolean']>;
  isKeyPoint2Visible?: InputMaybe<Scalars['Boolean']>;
  isKeyPoint3Visible?: InputMaybe<Scalars['Boolean']>;
  isKeyPoint4Visible?: InputMaybe<Scalars['Boolean']>;
  isKeyPoint5Visible?: InputMaybe<Scalars['Boolean']>;
  isKeyPoint6Visible?: InputMaybe<Scalars['Boolean']>;
  isKeyPoint7Visible?: InputMaybe<Scalars['Boolean']>;
  isLocationVisible?: InputMaybe<Scalars['Boolean']>;
  isMinBandwidthVisible?: InputMaybe<Scalars['Boolean']>;
  isOteVisible?: InputMaybe<Scalars['Boolean']>;
  isQuotaAttainmentByTeamVisible?: InputMaybe<Scalars['Boolean']>;
  isRoleNameVisible?: InputMaybe<Scalars['Boolean']>;
  isWorkTypeVisible?: InputMaybe<Scalars['Boolean']>;
};

export type JobsRecruiter = {
  __typename?: 'JobsRecruiter';
  email: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  schedulingLink?: Maybe<Scalars['String']>;
};

export enum JobsRecruiterLead {
  BackOffice = 'BACK_OFFICE',
  Flex = 'FLEX',
  FullTime = 'FULL_TIME'
}

export enum JobsRecruiterState {
  Activated = 'ACTIVATED',
  Draft = 'DRAFT'
}

/** Autogenerated input type of JobsRecruitersAcceptCandidate */
export type JobsRecruitersAcceptCandidateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  hashid: Scalars['ID'];
};

/** Autogenerated input type of JobsRecruitersActivateCurrentRecruiter */
export type JobsRecruitersActivateCurrentRecruiterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of JobsRecruitersActivateVacancy */
export type JobsRecruitersActivateVacancyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vacancyId: Scalars['ID'];
};

export type JobsRecruitersCandidate = JobsCandidateInterface & {
  __typename?: 'JobsRecruitersCandidate';
  acceptedByCandidateAt?: Maybe<Scalars['ISO8601DateTime']>;
  acceptedByEmployerAt?: Maybe<Scalars['ISO8601DateTime']>;
  annualQuota?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  badges?: Maybe<Array<JobsHiringBadge>>;
  baseSalary?: Maybe<Scalars['String']>;
  bullet1?: Maybe<Scalars['String']>;
  bullet2?: Maybe<Scalars['String']>;
  captions?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  clients?: Maybe<Array<JobsRecruitersClient>>;
  csmAccountsNumber?: Maybe<Scalars['String']>;
  csmQuotaMetric?: Maybe<Scalars['String']>;
  csmQuotaType?: Maybe<Scalars['String']>;
  csmRenewalValue?: Maybe<Scalars['String']>;
  csmTotalBusinessValue?: Maybe<Scalars['String']>;
  csmUpsellValue?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  dealSize?: Maybe<Scalars['String']>;
  departments?: Maybe<Array<Department>>;
  firstname?: Maybe<Scalars['String']>;
  flexAppliedCriteria?: Maybe<Array<JobsFlexAppliedCriteria>>;
  flexBandwidth?: Maybe<Scalars['String']>;
  flexBriefVideoUrl?: Maybe<Scalars['String']>;
  flexPreviousExperience?: Maybe<Scalars['String']>;
  flexRating?: Maybe<Scalars['Float']>;
  flexReasonForParticipation?: Maybe<Scalars['String']>;
  flexRoles?: Maybe<Array<JobsFlexRole>>;
  flexUnderstandingOfSales?: Maybe<Scalars['String']>;
  hashid: Scalars['String'];
  headline1?: Maybe<Scalars['String']>;
  headline2?: Maybe<Scalars['String']>;
  headline3?: Maybe<Scalars['String']>;
  hoursToExpire?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  idealJobDescription?: Maybe<Scalars['String']>;
  initials?: Maybe<Scalars['String']>;
  inquiredPosition?: Maybe<JobsInquiryPosition>;
  lastname?: Maybe<Scalars['String']>;
  leadSources?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  marketingHeadline?: Maybe<Scalars['String']>;
  ote?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  quotaAttainmentByTeamPerPeriod?: Maybe<Scalars['String']>;
  quotaAttainmentPerLastYear?: Maybe<Scalars['String']>;
  quotaAttainmentPerPeriod?: Maybe<Scalars['Int']>;
  salesCycleLength?: Maybe<Scalars['String']>;
  selectedOnVacancy?: Maybe<JobsRecruitersVacancy>;
  state: JobsRecruitersCandidateState;
  teamRanking?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  userId: Scalars['ID'];
  viewed: Scalars['Boolean'];
  vpDepartmentSize?: Maybe<Scalars['String']>;
  vpManagedRoles?: Maybe<Scalars['String']>;
  vpQuotaType?: Maybe<Scalars['String']>;
  willingToRelocate?: Maybe<Scalars['Boolean']>;
  workHistories?: Maybe<Array<WorkHistory>>;
};

/** The connection type for JobsRecruitersCandidate. */
export type JobsRecruitersCandidateConnection = {
  __typename?: 'JobsRecruitersCandidateConnection';
  /** A list of edges. */
  edges: Array<JobsRecruitersCandidateEdge>;
  /** A list of nodes. */
  nodes: Array<JobsRecruitersCandidate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type JobsRecruitersCandidateEdge = {
  __typename?: 'JobsRecruitersCandidateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<JobsRecruitersCandidate>;
};

export enum JobsRecruitersCandidateState {
  AcceptedAnotherOffer = 'accepted_another_offer',
  Deactivated = 'deactivated',
  Draft = 'draft',
  Expired = 'expired',
  Hired = 'hired',
  Interviewed = 'interviewed',
  Introduced = 'introduced',
  Matched = 'matched',
  Offered = 'offered',
  Paired = 'paired',
  Queued = 'queued',
  RejectedByCandidate = 'rejected_by_candidate',
  RejectedByEmployer = 'rejected_by_employer',
  RejectedByOps = 'rejected_by_ops',
  ScheduledAssessment = 'scheduled_assessment',
  ScheduledInterview = 'scheduled_interview',
  Submitted = 'submitted'
}

export type JobsRecruitersClient = {
  __typename?: 'JobsRecruitersClient';
  company: Company;
  id: Scalars['ID'];
};

/** Autogenerated input type of JobsRecruitersCompleteTooltip */
export type JobsRecruitersCompleteTooltipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  task: Scalars['String'];
};

/** Autogenerated input type of JobsRecruitersCreateCustomCompany */
export type JobsRecruitersCreateCustomCompanyInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Autogenerated input type of JobsRecruitersCreateEmployer */
export type JobsRecruitersCreateEmployerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['ID'];
};

/** Autogenerated input type of JobsRecruitersCreateStripeBillingUrl */
export type JobsRecruitersCreateStripeBillingUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  returnUrl?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of JobsRecruitersCreateStripeSessionUrl */
export type JobsRecruitersCreateStripeSessionUrlInput = {
  cancelUrl?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productSlug: JobsRecruitersSubscriptionProductSlug;
  quantity?: InputMaybe<Scalars['Int']>;
  successUrl: Scalars['String'];
};

/** Autogenerated input type of JobsRecruitersCreateVacancy */
export type JobsRecruitersCreateVacancyInput = {
  booleanFields?: InputMaybe<Array<JobsRecruitersFieldsBooleanAttributes>>;
  cityIds?: InputMaybe<Array<Scalars['ID']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  countryStates?: InputMaybe<Array<Scalars['String']>>;
  employmentType?: InputMaybe<JobsVacancyEmployment>;
  floatFields?: InputMaybe<Array<JobsRecruitersFieldsFloatAttributes>>;
  floatRangeFields?: InputMaybe<Array<JobsRecruitersFieldsFloatRangeAttributes>>;
  gptPrompt?: InputMaybe<Scalars['String']>;
  headcount?: InputMaybe<Scalars['Int']>;
  integerFields?: InputMaybe<Array<JobsRecruitersFieldsIntegerAttributes>>;
  integerRangeFields?: InputMaybe<Array<JobsRecruitersFieldsIntegerRangeAttributes>>;
  multiSelectFields?: InputMaybe<Array<JobsRecruitersFieldsMultiSelectAttributes>>;
  multiSelectRecordFields?: InputMaybe<Array<JobsRecruitersFieldsMultiSelectRecordAttributes>>;
  openToRemoteWork?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<JobsRole>;
  primaryRecruiterId?: InputMaybe<Scalars['ID']>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']>>;
  remoteOnlyAtSelectedLocations?: InputMaybe<Scalars['Boolean']>;
  singleSelectFields?: InputMaybe<Array<JobsRecruitersFieldsSingleSelectAttributes>>;
  singleSelectRecordFields?: InputMaybe<Array<JobsRecruitersFieldsSingleSelectRecordAttributes>>;
  stringArrayFields?: InputMaybe<Array<JobsRecruitersFieldsStringArrayAttributes>>;
  stringFields?: InputMaybe<Array<JobsRecruitersFieldsStringAttributes>>;
  title?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of JobsRecruitersDeleteEmployer */
export type JobsRecruitersDeleteEmployerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of JobsRecruitersDeleteRecruiter */
export type JobsRecruitersDeleteRecruiterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  recruiterId: Scalars['ID'];
};

/** Autogenerated input type of JobsRecruitersDeleteVacancyField */
export type JobsRecruitersDeleteVacancyFieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fieldSlug: Scalars['String'];
  vacancyId: Scalars['ID'];
};

/** Autogenerated input type of JobsRecruitersDeleteVacancy */
export type JobsRecruitersDeleteVacancyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vacancyId: Scalars['ID'];
};

/** Autogenerated input type of JobsRecruitersDestroyCandidate */
export type JobsRecruitersDestroyCandidateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  hashid: Scalars['ID'];
};

export type JobsRecruitersDistribution = {
  __typename?: 'JobsRecruitersDistribution';
  distributionBins: Array<JobsRecruitersDistributionBin>;
  recommendation?: Maybe<IntRangeRightBoundOptional>;
  total: Scalars['Float'];
};

export type JobsRecruitersDistributionBin = {
  __typename?: 'JobsRecruitersDistributionBin';
  /** Percentage of total value in the bin */
  percentage: Scalars['Float'];
  /** Boundary values of the bin */
  range: IntRangeRightBoundOptional;
};

/** Autogenerated input type of JobsRecruitersEditRecruiter */
export type JobsRecruitersEditRecruiterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  recruiter: JobsRecruitersRecruiterAttributes;
};

export type JobsRecruitersEmployer = {
  __typename?: 'JobsRecruitersEmployer';
  annualRevenue?: Maybe<JobsEmployersAnnualRevenue>;
  company: Company;
  country?: Maybe<Country>;
  fundingType?: Maybe<JobsEmployersFunding>;
  greenhouseError?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isGreenhouseHarvestApiKeyPresent: Scalars['Boolean'];
  recruiters: Array<JobsRecruitersRecruiter>;
  salesTeamSize?: Maybe<JobsEmployersSalesTeamSize>;
  talentAccessSubscription?: Maybe<JobsRecruitersEmployerSubscription>;
};

export type JobsRecruitersEmployerAttributes = {
  companyId?: InputMaybe<Scalars['ID']>;
  greenhouseHarvestApiKey?: InputMaybe<Scalars['String']>;
};

export enum JobsRecruitersEmployerRejectionReason {
  NoStartupExperience = 'no_startup_experience',
  NotEnoughSaasExperience = 'not_enough_saas_experience',
  TooHoppy = 'too_hoppy',
  WrongGeo = 'wrong_geo',
  WrongSalesCycle = 'wrong_sales_cycle',
  WrongSeniority = 'wrong_seniority'
}

export type JobsRecruitersEmployerSubscription = {
  __typename?: 'JobsRecruitersEmployerSubscription';
  active: Scalars['Boolean'];
  expiresAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of JobsRecruitersEnableVacancies */
export type JobsRecruitersEnableVacanciesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  vacancyIds: Array<Scalars['ID']>;
};

export type JobsRecruitersField = JobsRecruitersFieldsBoolean | JobsRecruitersFieldsFloat | JobsRecruitersFieldsFloatRange | JobsRecruitersFieldsInteger | JobsRecruitersFieldsIntegerRange | JobsRecruitersFieldsMultiSelect | JobsRecruitersFieldsMultiSelectRecord | JobsRecruitersFieldsSingleSelect | JobsRecruitersFieldsSingleSelectRecord | JobsRecruitersFieldsString | JobsRecruitersFieldsStringArray;

export type JobsRecruitersFieldValueInterface = {
  field: JobsRecruitersField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
};

export type JobsRecruitersFieldValuesBoolean = JobsRecruitersFieldValueInterface & {
  __typename?: 'JobsRecruitersFieldValuesBoolean';
  field: JobsRecruitersField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
  value?: Maybe<Scalars['Boolean']>;
};

export type JobsRecruitersFieldValuesFloat = JobsRecruitersFieldValueInterface & {
  __typename?: 'JobsRecruitersFieldValuesFloat';
  field: JobsRecruitersField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
  value?: Maybe<Scalars['Float']>;
};

export type JobsRecruitersFieldValuesFloatRange = JobsRecruitersFieldValueInterface & {
  __typename?: 'JobsRecruitersFieldValuesFloatRange';
  field: JobsRecruitersField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  range?: Maybe<FloatRangeRightBoundOptional>;
  shouldClause: Scalars['Boolean'];
};

export type JobsRecruitersFieldValuesInteger = JobsRecruitersFieldValueInterface & {
  __typename?: 'JobsRecruitersFieldValuesInteger';
  field: JobsRecruitersField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
  value?: Maybe<Scalars['Int']>;
};

export type JobsRecruitersFieldValuesIntegerRange = JobsRecruitersFieldValueInterface & {
  __typename?: 'JobsRecruitersFieldValuesIntegerRange';
  field: JobsRecruitersField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  range?: Maybe<IntRangeRightBoundOptional>;
  shouldClause: Scalars['Boolean'];
};

export type JobsRecruitersFieldValuesMultiSelect = JobsRecruitersFieldValueInterface & {
  __typename?: 'JobsRecruitersFieldValuesMultiSelect';
  field: JobsRecruitersField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  selectedOptions: Array<JobsFieldsSelectOption>;
  shouldClause: Scalars['Boolean'];
  values: Array<Scalars['String']>;
};

export type JobsRecruitersFieldValuesMultiSelectRecord = JobsRecruitersFieldValueInterface & {
  __typename?: 'JobsRecruitersFieldValuesMultiSelectRecord';
  field: JobsRecruitersField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  records: Array<JobsRecruitersFieldValuesSelectRecordType>;
  shouldClause: Scalars['Boolean'];
};

export type JobsRecruitersFieldValuesSelectRecordType = City | Company | Department | Industry;

export type JobsRecruitersFieldValuesSingleSelect = JobsRecruitersFieldValueInterface & {
  __typename?: 'JobsRecruitersFieldValuesSingleSelect';
  field: JobsRecruitersField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  selectedOption: JobsFieldsSelectOption;
  shouldClause: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type JobsRecruitersFieldValuesSingleSelectRecord = JobsRecruitersFieldValueInterface & {
  __typename?: 'JobsRecruitersFieldValuesSingleSelectRecord';
  field: JobsRecruitersField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  record: JobsRecruitersFieldValuesSelectRecordType;
  shouldClause: Scalars['Boolean'];
};

export type JobsRecruitersFieldValuesString = JobsRecruitersFieldValueInterface & {
  __typename?: 'JobsRecruitersFieldValuesString';
  field: JobsRecruitersField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
  value?: Maybe<Scalars['String']>;
};

export type JobsRecruitersFieldValuesStringArray = JobsRecruitersFieldValueInterface & {
  __typename?: 'JobsRecruitersFieldValuesStringArray';
  field: JobsRecruitersField;
  id: Scalars['ID'];
  negation: Scalars['Boolean'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  shouldClause: Scalars['Boolean'];
  values?: Maybe<Array<Scalars['String']>>;
};

export type JobsRecruitersFieldsBoolean = JobsFieldsBooleanInterface & JobsFieldsInterface & {
  __typename?: 'JobsRecruitersFieldsBoolean';
  availableForRoles: Array<JobsRole>;
  category: JobsRecruitersFieldsCategory;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  requiredForRoles: Array<JobsRole>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsRecruitersFieldsBooleanAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  fieldSlug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type JobsRecruitersFieldsCategory = JobsFieldsCategoryInterface & {
  __typename?: 'JobsRecruitersFieldsCategory';
  description?: Maybe<Scalars['String']>;
  fields: Array<JobsRecruitersField>;
  id: Scalars['ID'];
  position: Scalars['Int'];
  title: Scalars['String'];
};


export type JobsRecruitersFieldsCategoryFieldsArgs = {
  accessLevels?: InputMaybe<Array<JobsFieldsAccessLevel>>;
  availableForRoles?: InputMaybe<Array<JobsRole>>;
  popularForRoles?: InputMaybe<Array<JobsRole>>;
  scopes?: InputMaybe<Array<JobsFieldsScope>>;
};

export type JobsRecruitersFieldsFloat = JobsFieldsFloatInterface & JobsFieldsInterface & {
  __typename?: 'JobsRecruitersFieldsFloat';
  availableForRoles: Array<JobsRole>;
  category: JobsRecruitersFieldsCategory;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder: Scalars['String'];
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  range?: Maybe<FloatRangeRightBoundOptional>;
  requiredForRoles: Array<JobsRole>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsRecruitersFieldsFloatAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  fieldSlug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type JobsRecruitersFieldsFloatRange = JobsFieldsFloatRangeInterface & JobsFieldsInterface & {
  __typename?: 'JobsRecruitersFieldsFloatRange';
  availableForRoles: Array<JobsRole>;
  category: JobsRecruitersFieldsCategory;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder: JobsFieldsRangePlaceholder;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  range?: Maybe<FloatRangeRightBoundOptional>;
  requiredForRoles: Array<JobsRole>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsRecruitersFieldsFloatRangeAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  fieldSlug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<FloatRangeRightBoundOptionalInput>;
};

export type JobsRecruitersFieldsInteger = JobsFieldsIntegerInterface & JobsFieldsInterface & {
  __typename?: 'JobsRecruitersFieldsInteger';
  availableForRoles: Array<JobsRole>;
  category: JobsRecruitersFieldsCategory;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  range?: Maybe<IntRangeRightBoundOptional>;
  requiredForRoles: Array<JobsRole>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsRecruitersFieldsIntegerAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  fieldSlug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type JobsRecruitersFieldsIntegerRange = JobsFieldsIntegerRangeInterface & JobsFieldsInterface & {
  __typename?: 'JobsRecruitersFieldsIntegerRange';
  availableForRoles: Array<JobsRole>;
  category: JobsRecruitersFieldsCategory;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder: JobsFieldsRangePlaceholder;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  range?: Maybe<IntRangeRightBoundOptional>;
  requiredForRoles: Array<JobsRole>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsRecruitersFieldsIntegerRangeAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  fieldSlug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<IntRangeRightBoundOptionalInput>;
};

export type JobsRecruitersFieldsMultiSelect = JobsFieldsInterface & JobsFieldsSelectInterface & {
  __typename?: 'JobsRecruitersFieldsMultiSelect';
  availableForRoles: Array<JobsRole>;
  category: JobsRecruitersFieldsCategory;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  options: Array<JobsFieldsSelectOption>;
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  requiredForRoles: Array<JobsRole>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsRecruitersFieldsMultiSelectAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  fieldSlug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type JobsRecruitersFieldsMultiSelectRecord = JobsFieldsInterface & JobsFieldsSingleSelectRecordInterface & {
  __typename?: 'JobsRecruitersFieldsMultiSelectRecord';
  availableForRoles: Array<JobsRole>;
  category: JobsRecruitersFieldsCategory;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  recordType: JobsFieldsRecordType;
  requiredForRoles: Array<JobsRole>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsRecruitersFieldsMultiSelectRecordAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  fieldSlug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  recordIds?: InputMaybe<Array<Scalars['ID']>>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
};

export type JobsRecruitersFieldsSingleSelect = JobsFieldsInterface & JobsFieldsSelectInterface & {
  __typename?: 'JobsRecruitersFieldsSingleSelect';
  availableForRoles: Array<JobsRole>;
  category: JobsRecruitersFieldsCategory;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  options: Array<JobsFieldsSelectOption>;
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  requiredForRoles: Array<JobsRole>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsRecruitersFieldsSingleSelectAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  fieldSlug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

export type JobsRecruitersFieldsSingleSelectRecord = JobsFieldsInterface & JobsFieldsSingleSelectRecordInterface & {
  __typename?: 'JobsRecruitersFieldsSingleSelectRecord';
  availableForRoles: Array<JobsRole>;
  category: JobsRecruitersFieldsCategory;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  recordType: JobsFieldsRecordType;
  requiredForRoles: Array<JobsRole>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsRecruitersFieldsSingleSelectRecordAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  fieldSlug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  recordId?: InputMaybe<Scalars['ID']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
};

export type JobsRecruitersFieldsString = JobsFieldsInterface & JobsFieldsStringInterface & {
  __typename?: 'JobsRecruitersFieldsString';
  availableForRoles: Array<JobsRole>;
  category: JobsRecruitersFieldsCategory;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  requiredForRoles: Array<JobsRole>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsRecruitersFieldsStringArray = JobsFieldsInterface & JobsFieldsStringArrayInterface & {
  __typename?: 'JobsRecruitersFieldsStringArray';
  availableForRoles: Array<JobsRole>;
  category: JobsRecruitersFieldsCategory;
  configuration: JobsFieldsConfiguration;
  id: Scalars['ID'];
  label: Scalars['String'];
  placeholder?: Maybe<Scalars['String']>;
  popularForRoles: Array<JobsRole>;
  position: Scalars['Int'];
  requiredForRoles: Array<JobsRole>;
  slug: Scalars['String'];
  tooltip: JobsFieldsTooltip;
};

export type JobsRecruitersFieldsStringArrayAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  fieldSlug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type JobsRecruitersFieldsStringAttributes = {
  fieldId?: InputMaybe<Scalars['ID']>;
  fieldSlug?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  negation?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Scalars['Int']>;
  shouldClause?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of JobsRecruitersImportGreenhouseVacancies */
export type JobsRecruitersImportGreenhouseVacanciesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type JobsRecruitersInquiry = {
  __typename?: 'JobsRecruitersInquiry';
  autoName?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  baseSalary?: Maybe<Scalars['Int']>;
  currentWorkHistory?: Maybe<WorkHistory>;
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  linkedinUrl?: Maybe<Scalars['String']>;
  ote?: Maybe<Scalars['Int']>;
  positionMain?: Maybe<JobsInquiryPosition>;
  positionOther?: Maybe<Scalars['String']>;
  quotaAttainmentPerPeriod?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of JobsRecruitersMarkCandidateAsViewed */
export type JobsRecruitersMarkCandidateAsViewedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  hashid: Scalars['ID'];
};

/** Autogenerated input type of JobsRecruitersMatchVacancy */
export type JobsRecruitersMatchVacancyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export enum JobsRecruitersPeopleForHiring {
  MoreThan_50 = 'MORE_THAN_50',
  People_1_5 = 'PEOPLE_1_5',
  People_5_10 = 'PEOPLE_5_10',
  People_10_25 = 'PEOPLE_10_25',
  People_25_50 = 'PEOPLE_25_50'
}

export type JobsRecruitersRecruiter = {
  __typename?: 'JobsRecruitersRecruiter';
  city?: Maybe<City>;
  company?: Maybe<Company>;
  email: Scalars['String'];
  employer?: Maybe<JobsRecruitersEmployer>;
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isImpersonateMode: Scalars['Boolean'];
  jobTitle?: Maybe<Scalars['String']>;
  joinedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastSelectedVacancy?: Maybe<JobsRecruitersVacancy>;
  lastname?: Maybe<Scalars['String']>;
  leadType: JobsRecruiterLead;
  onboardingStates: Array<Scalars['String']>;
  peopleForHiring?: Maybe<JobsRecruitersPeopleForHiring>;
  phone?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['Boolean']>;
  questionnaireFractionalSellersType?: Maybe<Scalars['String']>;
  questionnaireFreelanceSalesExpertsPurposes?: Maybe<Array<Scalars['String']>>;
  questionnairePurpose?: Maybe<Scalars['String']>;
  questionnaireRole?: Maybe<Scalars['String']>;
  role: JobsRecruitersRecruiterRole;
  rolesForHiring?: Maybe<Array<JobsRecruitersRolesForHiring>>;
  schedulingLink?: Maybe<Scalars['String']>;
  signInCount?: Maybe<Scalars['Int']>;
  state: JobsRecruiterState;
  tooltips: Array<Tooltip>;
};

/** Attributes for creating, updating, or deleting jobs employer's recruiters */
export type JobsRecruitersRecruiterAttributes = {
  email: Scalars['String'];
  firstname: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  lastname: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  schedulingLink?: InputMaybe<Scalars['String']>;
  slackId?: InputMaybe<Scalars['String']>;
};

export enum JobsRecruitersRecruiterRole {
  AccountOwner = 'ACCOUNT_OWNER',
  Regular = 'REGULAR'
}

/** Autogenerated input type of JobsRecruitersRejectCandidate */
export type JobsRecruitersRejectCandidateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  hashid: Scalars['ID'];
  reasonOther?: InputMaybe<Scalars['String']>;
  reasons: Array<JobsRecruitersEmployerRejectionReason>;
};

export enum JobsRecruitersRolesForHiring {
  Ae = 'AE',
  CsmAm = 'CSM_AM',
  Executive = 'EXECUTIVE',
  Other = 'OTHER',
  SalesEngineer = 'SALES_ENGINEER',
  Sdr = 'SDR'
}

/** Autogenerated input type of JobsRecruitersSendRecruiterAuthToken */
export type JobsRecruitersSendRecruiterAuthTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

export enum JobsRecruitersSubscriptionProductSlug {
  TalentAccess = 'TALENT_ACCESS'
}

/** Autogenerated input type of JobsRecruitersUpdateCurrentEmployer */
export type JobsRecruitersUpdateCurrentEmployerInput = {
  annualRevenue?: InputMaybe<JobsEmployersAnnualRevenue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  fundingType?: InputMaybe<JobsEmployersFunding>;
  greenhouseHarvestApiKey?: InputMaybe<Scalars['String']>;
  salesTeamSize?: InputMaybe<JobsEmployersSalesTeamSize>;
};

/** Autogenerated input type of JobsRecruitersUpdateCurrentRecruiter */
export type JobsRecruitersUpdateCurrentRecruiterInput = {
  cityId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employer?: InputMaybe<JobsRecruitersEmployerAttributes>;
  firstname?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastSelectedVacancyId?: InputMaybe<Scalars['ID']>;
  lastname?: InputMaybe<Scalars['String']>;
  leadType?: InputMaybe<JobsRecruiterLead>;
  onboardingStates?: InputMaybe<Array<Scalars['String']>>;
  peopleForHiring?: InputMaybe<JobsRecruitersPeopleForHiring>;
  phone?: InputMaybe<Scalars['String']>;
  questionnaireFractionalSellersType?: InputMaybe<Scalars['String']>;
  questionnaireFreelanceSalesExpertsPurposes?: InputMaybe<Array<Scalars['String']>>;
  questionnairePurpose?: InputMaybe<Scalars['String']>;
  questionnaireRole?: InputMaybe<Scalars['String']>;
  rolesForHiring?: InputMaybe<Array<JobsRecruitersRolesForHiring>>;
};

/** Autogenerated input type of JobsRecruitersUpdateCustomCompany */
export type JobsRecruitersUpdateCustomCompanyInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of JobsRecruitersUpdateVacancyField */
export type JobsRecruitersUpdateVacancyFieldInput = {
  booleanField?: InputMaybe<JobsRecruitersFieldsBooleanAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  floatField?: InputMaybe<JobsRecruitersFieldsFloatAttributes>;
  floatRangeField?: InputMaybe<JobsRecruitersFieldsFloatRangeAttributes>;
  integerField?: InputMaybe<JobsRecruitersFieldsIntegerAttributes>;
  integerRangeField?: InputMaybe<JobsRecruitersFieldsIntegerRangeAttributes>;
  multiSelectField?: InputMaybe<JobsRecruitersFieldsMultiSelectAttributes>;
  multiSelectRecordField?: InputMaybe<JobsRecruitersFieldsMultiSelectRecordAttributes>;
  singleSelectField?: InputMaybe<JobsRecruitersFieldsSingleSelectAttributes>;
  singleSelectRecordField?: InputMaybe<JobsRecruitersFieldsSingleSelectRecordAttributes>;
  stringArrayField?: InputMaybe<JobsRecruitersFieldsStringArrayAttributes>;
  stringField?: InputMaybe<JobsRecruitersFieldsStringAttributes>;
  vacancyId: Scalars['ID'];
};

/** Autogenerated input type of JobsRecruitersUpdateVacancy */
export type JobsRecruitersUpdateVacancyInput = {
  booleanFields?: InputMaybe<Array<JobsRecruitersFieldsBooleanAttributes>>;
  cityIds?: InputMaybe<Array<Scalars['ID']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  countryStates?: InputMaybe<Array<Scalars['String']>>;
  employmentType?: InputMaybe<JobsVacancyEmployment>;
  floatFields?: InputMaybe<Array<JobsRecruitersFieldsFloatAttributes>>;
  floatRangeFields?: InputMaybe<Array<JobsRecruitersFieldsFloatRangeAttributes>>;
  gptPrompt?: InputMaybe<Scalars['String']>;
  headcount?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  integerFields?: InputMaybe<Array<JobsRecruitersFieldsIntegerAttributes>>;
  integerRangeFields?: InputMaybe<Array<JobsRecruitersFieldsIntegerRangeAttributes>>;
  multiSelectFields?: InputMaybe<Array<JobsRecruitersFieldsMultiSelectAttributes>>;
  multiSelectRecordFields?: InputMaybe<Array<JobsRecruitersFieldsMultiSelectRecordAttributes>>;
  openToRemoteWork?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<JobsRole>;
  primaryRecruiterId?: InputMaybe<Scalars['ID']>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']>>;
  remoteOnlyAtSelectedLocations?: InputMaybe<Scalars['Boolean']>;
  singleSelectFields?: InputMaybe<Array<JobsRecruitersFieldsSingleSelectAttributes>>;
  singleSelectRecordFields?: InputMaybe<Array<JobsRecruitersFieldsSingleSelectRecordAttributes>>;
  stringArrayFields?: InputMaybe<Array<JobsRecruitersFieldsStringArrayAttributes>>;
  stringFields?: InputMaybe<Array<JobsRecruitersFieldsStringAttributes>>;
  title?: InputMaybe<Scalars['String']>;
};

export type JobsRecruitersVacancy = {
  __typename?: 'JobsRecruitersVacancy';
  avatarNumber: Scalars['Int'];
  candidates: JobsRecruitersCandidateConnection;
  cities?: Maybe<Array<City>>;
  countries?: Maybe<Array<Country>>;
  countryStates?: Maybe<Array<Scalars['String']>>;
  defaultSubmission: JobsRecruitersVacancySubmission;
  description?: Maybe<Scalars['String']>;
  employmentType: JobsVacancyEmployment;
  fieldValueBoolean?: Maybe<JobsRecruitersFieldValuesBoolean>;
  fieldValueFloat?: Maybe<JobsRecruitersFieldValuesFloat>;
  fieldValueFloatRange?: Maybe<JobsRecruitersFieldValuesFloatRange>;
  fieldValueInteger?: Maybe<JobsRecruitersFieldValuesInteger>;
  fieldValueIntegerRange?: Maybe<JobsRecruitersFieldValuesIntegerRange>;
  fieldValueMultiSelect?: Maybe<JobsRecruitersFieldValuesMultiSelect>;
  fieldValueMultiSelectRecord?: Maybe<JobsRecruitersFieldValuesMultiSelectRecord>;
  fieldValueSingleSelect?: Maybe<JobsRecruitersFieldValuesSingleSelect>;
  fieldValueSingleSelectRecord?: Maybe<JobsRecruitersFieldValuesSingleSelectRecord>;
  fieldValueString?: Maybe<JobsRecruitersFieldValuesString>;
  fieldValueStringArray?: Maybe<JobsRecruitersFieldValuesStringArray>;
  fieldValues: Array<JobsRecruitersVacancyFieldValue>;
  gptPrompt?: Maybe<Scalars['String']>;
  hasExpiredCandidates: Scalars['Boolean'];
  headcount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isBasedOnVacancy: Scalars['Boolean'];
  isImportedFromGreenhouse: Scalars['Boolean'];
  isSalesJob?: Maybe<Scalars['Boolean']>;
  openToRemoteWork?: Maybe<Scalars['Boolean']>;
  position?: Maybe<JobsRole>;
  recruiters: Array<JobsRecruitersRecruiter>;
  remoteOnlyAtSelectedLocations?: Maybe<Scalars['Boolean']>;
  state: JobsVacancyState;
  stateUpdatedAt: Scalars['ISO8601DateTime'];
  title: Scalars['String'];
};


export type JobsRecruitersVacancyCandidatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isAcceptedByEmployer?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Array<JobsRecruitersCandidateState>>;
};


export type JobsRecruitersVacancyFieldValueBooleanArgs = {
  slug: Scalars['String'];
};


export type JobsRecruitersVacancyFieldValueFloatArgs = {
  slug: Scalars['String'];
};


export type JobsRecruitersVacancyFieldValueFloatRangeArgs = {
  slug: Scalars['String'];
};


export type JobsRecruitersVacancyFieldValueIntegerArgs = {
  slug: Scalars['String'];
};


export type JobsRecruitersVacancyFieldValueIntegerRangeArgs = {
  slug: Scalars['String'];
};


export type JobsRecruitersVacancyFieldValueMultiSelectArgs = {
  slug: Scalars['String'];
};


export type JobsRecruitersVacancyFieldValueMultiSelectRecordArgs = {
  slug: Scalars['String'];
};


export type JobsRecruitersVacancyFieldValueSingleSelectArgs = {
  slug: Scalars['String'];
};


export type JobsRecruitersVacancyFieldValueSingleSelectRecordArgs = {
  slug: Scalars['String'];
};


export type JobsRecruitersVacancyFieldValueStringArgs = {
  slug: Scalars['String'];
};


export type JobsRecruitersVacancyFieldValueStringArrayArgs = {
  slug: Scalars['String'];
};

export type JobsRecruitersVacancyFieldValue = JobsRecruitersFieldValuesBoolean | JobsRecruitersFieldValuesFloat | JobsRecruitersFieldValuesFloatRange | JobsRecruitersFieldValuesInteger | JobsRecruitersFieldValuesIntegerRange | JobsRecruitersFieldValuesMultiSelect | JobsRecruitersFieldValuesMultiSelectRecord | JobsRecruitersFieldValuesSingleSelect | JobsRecruitersFieldValuesSingleSelectRecord | JobsRecruitersFieldValuesString | JobsRecruitersFieldValuesStringArray;

export type JobsRecruitersVacancyPromptTemplate = {
  __typename?: 'JobsRecruitersVacancyPromptTemplate';
  body: Scalars['String'];
  title: Scalars['String'];
};

export type JobsRecruitersVacancySubmission = JobsVacancySubmissionInterface & {
  __typename?: 'JobsRecruitersVacancySubmission';
  avgDealSize?: Maybe<Scalars['String']>;
  avgSalesCycle?: Maybe<Scalars['String']>;
  baseSalary?: Maybe<Scalars['String']>;
  brandMaturity?: Maybe<JobsVacancySubmissionBrandMaturity>;
  companyName: Scalars['String'];
  compensation?: Maybe<Scalars['String']>;
  compensationDescription?: Maybe<Scalars['String']>;
  customerProfile?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  industry: Scalars['String'];
  jobUrl?: Maybe<Scalars['String']>;
  keyPoint1?: Maybe<Scalars['String']>;
  keyPoint2?: Maybe<Scalars['String']>;
  keyPoint3?: Maybe<Scalars['String']>;
  keyPoint4?: Maybe<Scalars['String']>;
  keyPoint5?: Maybe<Scalars['String']>;
  keyPoint6?: Maybe<Scalars['String']>;
  keyPoint7?: Maybe<Scalars['String']>;
  location: Scalars['String'];
  minBandwidth?: Maybe<Scalars['String']>;
  ote?: Maybe<Scalars['String']>;
  quotaAttainmentByTeam?: Maybe<Scalars['Int']>;
  roleName: Scalars['String'];
  visibilityOfAttributes: JobsVacancySubmissionVisibilityOfAttributes;
  workType?: Maybe<Scalars['String']>;
};

export enum JobsRole {
  AccountExecutive = 'ACCOUNT_EXECUTIVE',
  CsmAm = 'CSM_AM',
  Other = 'OTHER',
  Sdr = 'SDR',
  Vp = 'VP'
}

export type JobsVacancy = {
  __typename?: 'JobsVacancy';
  cities?: Maybe<Array<City>>;
  company: Company;
  countries?: Maybe<Array<Country>>;
  description?: Maybe<Scalars['String']>;
  employer: JobsEmployer;
  employmentType: JobsVacancyEmployment;
  id: Scalars['ID'];
  openToRemoteWork?: Maybe<Scalars['Boolean']>;
  oteRange?: Maybe<Array<Scalars['Int']>>;
  primaryRecruiter?: Maybe<JobsRecruiter>;
  submission?: Maybe<JobsVacancySubmission>;
  title: Scalars['String'];
  uid: Scalars['String'];
};

export enum JobsVacancyEmployment {
  Contract = 'CONTRACT',
  FullTime = 'FULL_TIME',
  SideHustle = 'SIDE_HUSTLE'
}

export enum JobsVacancyState {
  Activated = 'ACTIVATED',
  Deactivated = 'DEACTIVATED',
  Deleted = 'DELETED',
  DeletedFromAts = 'DELETED_FROM_ATS',
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Paused = 'PAUSED'
}

export type JobsVacancySubmission = JobsVacancySubmissionInterface & {
  __typename?: 'JobsVacancySubmission';
  avgDealSize?: Maybe<Scalars['String']>;
  avgSalesCycle?: Maybe<Scalars['String']>;
  baseSalary?: Maybe<Scalars['String']>;
  brandMaturity?: Maybe<JobsVacancySubmissionBrandMaturity>;
  companyName: Scalars['String'];
  compensation?: Maybe<Scalars['String']>;
  compensationDescription?: Maybe<Scalars['String']>;
  customerProfile?: Maybe<Scalars['String']>;
  industry: Scalars['String'];
  jobUrl?: Maybe<Scalars['String']>;
  keyPoint1?: Maybe<Scalars['String']>;
  keyPoint2?: Maybe<Scalars['String']>;
  keyPoint3?: Maybe<Scalars['String']>;
  keyPoint4?: Maybe<Scalars['String']>;
  keyPoint5?: Maybe<Scalars['String']>;
  keyPoint6?: Maybe<Scalars['String']>;
  keyPoint7?: Maybe<Scalars['String']>;
  location: Scalars['String'];
  minBandwidth?: Maybe<Scalars['String']>;
  ote?: Maybe<Scalars['String']>;
  quotaAttainmentByTeam?: Maybe<Scalars['Int']>;
  roleName: Scalars['String'];
  workType?: Maybe<Scalars['String']>;
};

export enum JobsVacancySubmissionBrandMaturity {
  BrandNew = 'BRAND_NEW',
  Established = 'ESTABLISHED',
  Newer = 'NEWER'
}

export type JobsVacancySubmissionInterface = {
  avgDealSize?: Maybe<Scalars['String']>;
  avgSalesCycle?: Maybe<Scalars['String']>;
  baseSalary?: Maybe<Scalars['String']>;
  brandMaturity?: Maybe<JobsVacancySubmissionBrandMaturity>;
  companyName: Scalars['String'];
  compensation?: Maybe<Scalars['String']>;
  compensationDescription?: Maybe<Scalars['String']>;
  customerProfile?: Maybe<Scalars['String']>;
  industry: Scalars['String'];
  jobUrl?: Maybe<Scalars['String']>;
  keyPoint1?: Maybe<Scalars['String']>;
  keyPoint2?: Maybe<Scalars['String']>;
  keyPoint3?: Maybe<Scalars['String']>;
  keyPoint4?: Maybe<Scalars['String']>;
  keyPoint5?: Maybe<Scalars['String']>;
  keyPoint6?: Maybe<Scalars['String']>;
  keyPoint7?: Maybe<Scalars['String']>;
  location: Scalars['String'];
  minBandwidth?: Maybe<Scalars['String']>;
  ote?: Maybe<Scalars['String']>;
  quotaAttainmentByTeam?: Maybe<Scalars['Int']>;
  roleName: Scalars['String'];
  workType?: Maybe<Scalars['String']>;
};

export type JobsVacancySubmissionVisibilityOfAttributes = {
  __typename?: 'JobsVacancySubmissionVisibilityOfAttributes';
  isAvgDealSizeVisible: Scalars['Boolean'];
  isAvgSalesCycleVisible: Scalars['Boolean'];
  isBaseSalaryVisible: Scalars['Boolean'];
  isBrandMaturityVisible: Scalars['Boolean'];
  isCompanyNameVisible: Scalars['Boolean'];
  isCompensationDescriptionVisible: Scalars['Boolean'];
  isCompensationVisible: Scalars['Boolean'];
  isCustomerProfileVisible: Scalars['Boolean'];
  isIndustryVisible: Scalars['Boolean'];
  isJobUrlVisible: Scalars['Boolean'];
  isKeyPoint1Visible: Scalars['Boolean'];
  isKeyPoint2Visible: Scalars['Boolean'];
  isKeyPoint3Visible: Scalars['Boolean'];
  isKeyPoint4Visible: Scalars['Boolean'];
  isKeyPoint5Visible: Scalars['Boolean'];
  isKeyPoint6Visible: Scalars['Boolean'];
  isKeyPoint7Visible: Scalars['Boolean'];
  isLocationVisible: Scalars['Boolean'];
  isMinBandwidthVisible: Scalars['Boolean'];
  isOteVisible: Scalars['Boolean'];
  isQuotaAttainmentByTeamVisible: Scalars['Boolean'];
  isRoleNameVisible: Scalars['Boolean'];
  isWorkTypeVisible: Scalars['Boolean'];
};

export type Link = {
  __typename?: 'Link';
  createdAt: Scalars['ISO8601DateTime'];
  highlightedText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  link: Scalars['String'];
  linkDescription?: Maybe<Scalars['String']>;
  linkImageContentType?: Maybe<Scalars['String']>;
  linkImageFileName?: Maybe<Scalars['String']>;
  linkImageFileSize?: Maybe<Scalars['Int']>;
  linkImageUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  linkOriginalImageUrl?: Maybe<Scalars['String']>;
  linkTitle?: Maybe<Scalars['String']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  rawText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textImageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type LinkedinPost = {
  __typename?: 'LinkedinPost';
  createdAt: Scalars['ISO8601DateTime'];
  highlightedText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  linkedinAvatarUrl?: Maybe<Scalars['String']>;
  linkedinName: Scalars['String'];
  linkedinPostUrl: Scalars['String'];
  linkedinText: Scalars['String'];
  previewImageUrl?: Maybe<Scalars['String']>;
  rawText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textImageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of LinkedinProfileImported */
export type LinkedinProfileImportedPayload = {
  __typename?: 'LinkedinProfileImportedPayload';
  isSuccessful: Scalars['Boolean'];
  portfolioCurrentUser: PortfolioCurrentUser;
};

export type Location = City | CountryState;

export enum LocationType {
  City = 'CITY',
  CountryState = 'COUNTRY_STATE'
}

/** Autogenerated input type of MarkCommentsViewed */
export type MarkCommentsViewedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  commentIds?: InputMaybe<Array<Scalars['ID']>>;
  postSlug: Scalars['String'];
};

/** Autogenerated input type of MarkPostsAsRead */
export type MarkPostsAsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of MatchJobsInquiryAfterOnboarding */
export type MatchJobsInquiryAfterOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type Message = {
  __typename?: 'Message';
  body: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  media?: Maybe<File>;
  readAt?: Maybe<Scalars['ISO8601DateTime']>;
  sender: User;
  thread: Thread;
};

/** The connection type for Message. */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** A list of edges. */
  edges: Array<MessageEdge>;
  /** A list of nodes. */
  nodes: Array<Message>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Message>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptConnectionRequest?: Maybe<Request>;
  activateJobsInquiry?: Maybe<JobsInquiry>;
  applyForWarRoom?: Maybe<User>;
  approveTestimonialForPublicPortfolioCurrentUser?: Maybe<Testimonial>;
  archiveCandidateHiring?: Maybe<Scalars['Boolean']>;
  archiveTestimonialForPublicPortfolioCurrentUser?: Maybe<Testimonial>;
  attachCompanySeriesStage?: Maybe<CompanySeriesStage>;
  attachCompanyStage?: Maybe<CompanyStage>;
  attachDepartment?: Maybe<Department>;
  attachProductType?: Maybe<ProductType>;
  attachSalesRole?: Maybe<SalesRole>;
  cancelConnectionRequest?: Maybe<Scalars['Boolean']>;
  completeTooltip?: Maybe<Scalars['Boolean']>;
  confirmTermsOfServiceByPotentialEmployer?: Maybe<PotentialEmployer>;
  createAwardForPublicPortfolioCurrentUser?: Maybe<Award>;
  createClientForPublicPortfolioCurrentUser?: Maybe<Client>;
  createComment?: Maybe<Comment>;
  createCompanyPagesInterview?: Maybe<CompanyPagesInterview>;
  createCompanyPagesReview?: Maybe<CompanyPagesReview>;
  createCompanyPagesSalary?: Maybe<CompanyPagesSalary>;
  createConnectionRequest?: Maybe<Request>;
  createConnections?: Maybe<Scalars['Boolean']>;
  createCustomCompany?: Maybe<Company>;
  createCustomDepartment?: Maybe<Department>;
  createCustomProductType?: Maybe<ProductType>;
  createCustomSalesRole?: Maybe<SalesRole>;
  createCustomUniversity?: Maybe<University>;
  createDeals?: Maybe<Array<PortfolioDeal>>;
  createDealsSource?: Maybe<PortfolioDealsSource>;
  createEducationHistoryForPublicPortfolioCurrentUser?: Maybe<EducationHistory>;
  createJobsModeratorsEmployer?: Maybe<JobsModeratorsEmployer>;
  createJobsModeratorsHiring?: Maybe<JobsModeratorsHiring>;
  createJobsModeratorsHirings?: Maybe<JobsModeratorsInquiry>;
  createJobsModeratorsInquiryNote?: Maybe<JobsModeratorsInquiryNote>;
  createPollVote?: Maybe<PollVote>;
  createPost?: Maybe<Post>;
  createPotentialEmployer?: Maybe<PotentialEmployer>;
  createRating?: Maybe<Rating>;
  createTopic?: Maybe<Topic>;
  createWorkHistoryForPublicPortfolioCurrentUser?: Maybe<WorkHistory>;
  deactivateCurrentUser?: Maybe<CurrentUser>;
  destroyAwardForPublicPortfolioCurrentUser?: Maybe<Award>;
  destroyClientForPublicPortfolioCurrentUser?: Maybe<Client>;
  destroyComment?: Maybe<Comment>;
  destroyCompanyPagesInterview?: Maybe<CompanyPagesInterview>;
  destroyCompanyPagesReview?: Maybe<CompanyPagesReview>;
  destroyCompanyPagesSalary?: Maybe<CompanyPagesSalary>;
  destroyDeal?: Maybe<PortfolioDeal>;
  destroyEducationHistoryForPublicPortfolioCurrentUser?: Maybe<EducationHistory>;
  destroyJobsModeratorsInquiryNote?: Maybe<JobsModeratorsInquiryNote>;
  destroyPost?: Maybe<Post>;
  destroyRating?: Maybe<Rating>;
  destroyTestimonialForPublicPortfolioCurrentUser?: Maybe<Testimonial>;
  destroyWorkHistoryForPublicPortfolioCurrentUser?: Maybe<WorkHistory>;
  detachCompanySeriesStage?: Maybe<CompanySeriesStage>;
  detachCompanyStage?: Maybe<CompanyStage>;
  detachDepartment?: Maybe<Department>;
  detachProductType?: Maybe<ProductType>;
  detachSalesRole?: Maybe<SalesRole>;
  directMessagesBlockUser?: Maybe<User>;
  directMessagesReadThreadMessages?: Maybe<Scalars['Boolean']>;
  directMessagesSendMessage?: Maybe<Message>;
  directMessagesUnblockUser?: Maybe<User>;
  endorseTestimonialForPublicPortfolioUser?: Maybe<Testimonial>;
  expressDesireToImportConnectionsForPublicPortfolioUser?: Maybe<Scalars['Boolean']>;
  fillJobsInquiry?: Maybe<JobsInquiry>;
  finishOnboarding?: Maybe<CurrentUser>;
  fireJobsHiringEvent?: Maybe<JobsHiring>;
  fireJobsModeratorsHiringEvent?: Maybe<JobsModeratorsHiring>;
  fireJobsModeratorsInquiryEvent?: Maybe<JobsModeratorsInquiry>;
  flagIssue?: Maybe<Scalars['Int']>;
  hiringResendIntroduceEmail?: Maybe<JobsHiring>;
  jobsModeratorsActivateVacancy?: Maybe<JobsModeratorsVacancy>;
  jobsModeratorsCreateVacancy?: Maybe<JobsModeratorsVacancy>;
  jobsModeratorsCreateVacancySubmission?: Maybe<JobsModeratorsVacancySubmission>;
  jobsModeratorsDeactivateVacancy?: Maybe<JobsModeratorsVacancy>;
  jobsModeratorsDeleteVacancy?: Maybe<JobsModeratorsVacancy>;
  jobsModeratorsEditEmployersClients?: Maybe<JobsModeratorsEmployer>;
  jobsModeratorsEditEmployersRecruiters?: Maybe<JobsModeratorsEmployer>;
  jobsModeratorsMergeVacancy?: Maybe<JobsModeratorsVacancy>;
  jobsModeratorsRejectInquiryVacancySuggestionByOps?: Maybe<Scalars['Boolean']>;
  jobsModeratorsSubmitHiring?: Maybe<JobsModeratorsCandidate>;
  jobsModeratorsUpdateCompany?: Maybe<Company>;
  jobsModeratorsUpdateEmployer?: Maybe<JobsModeratorsEmployer>;
  jobsModeratorsUpdateVacancy?: Maybe<JobsModeratorsVacancy>;
  jobsModeratorsUpdateVacancySubmission?: Maybe<JobsModeratorsVacancySubmission>;
  jobsRecruitersAcceptCandidate?: Maybe<JobsRecruitersCandidate>;
  jobsRecruitersActivateCurrentRecruiter?: Maybe<JobsRecruitersRecruiter>;
  jobsRecruitersActivateVacancy?: Maybe<JobsRecruitersVacancy>;
  jobsRecruitersCompleteTooltip?: Maybe<Scalars['Boolean']>;
  jobsRecruitersCreateCustomCompany?: Maybe<Company>;
  jobsRecruitersCreateEmployer?: Maybe<JobsRecruitersEmployer>;
  jobsRecruitersCreateStripeBillingUrl?: Maybe<Scalars['String']>;
  jobsRecruitersCreateStripeSessionUrl?: Maybe<Scalars['String']>;
  jobsRecruitersCreateVacancy?: Maybe<JobsRecruitersVacancy>;
  jobsRecruitersDeleteEmployer?: Maybe<JobsRecruitersRecruiter>;
  jobsRecruitersDeleteEmployerRecruiter?: Maybe<JobsRecruitersRecruiter>;
  jobsRecruitersDeleteVacancy?: Maybe<JobsRecruitersVacancy>;
  jobsRecruitersDeleteVacancyField?: Maybe<JobsRecruitersVacancy>;
  jobsRecruitersDestroyCandidate?: Maybe<JobsRecruitersCandidate>;
  jobsRecruitersEditEmployersRecruiter?: Maybe<JobsRecruitersRecruiter>;
  jobsRecruitersEnableVacancies?: Maybe<Array<JobsRecruitersVacancy>>;
  jobsRecruitersImportGreenhouseVacancies?: Maybe<Array<JobsRecruitersVacancy>>;
  jobsRecruitersMarkCandidateAsViewed?: Maybe<JobsRecruitersCandidate>;
  jobsRecruitersMatchVacancy?: Maybe<JobsRecruitersVacancy>;
  jobsRecruitersRejectCandidate?: Maybe<JobsRecruitersCandidate>;
  /** Response `true` if Recruiter with provided email exists and the token has been sent and `false` otherwise */
  jobsRecruitersSendRecruiterAuthToken?: Maybe<Scalars['Boolean']>;
  jobsRecruitersUpdateCurrentEmployer?: Maybe<JobsRecruitersEmployer>;
  jobsRecruitersUpdateCurrentRecruiter?: Maybe<JobsRecruitersRecruiter>;
  jobsRecruitersUpdateCustomCompany?: Maybe<Company>;
  jobsRecruitersUpdateVacancy?: Maybe<JobsRecruitersVacancy>;
  jobsRecruitersUpdateVacancyField?: Maybe<JobsRecruitersVacancy>;
  markCommentsViewed?: Maybe<Post>;
  markPostsAsRead?: Maybe<Scalars['Boolean']>;
  matchJobsInquiryAfterOnboarding?: Maybe<JobsInquiry>;
  matchJobsModeratorsInquiry?: Maybe<JobsModeratorsMatchInquiryPayload>;
  reRequestTestimonialForPublicPortfolioCurrentUser?: Maybe<Testimonial>;
  readAllNotifications?: Maybe<Scalars['Int']>;
  readConnectionRequests?: Maybe<Array<Request>>;
  readNotification?: Maybe<Notification>;
  refreshJobsInquiry?: Maybe<JobsInquiry>;
  rejectConnectionRequest?: Maybe<Request>;
  rejectJobsHiring?: Maybe<Scalars['Boolean']>;
  rejectJobsModeratorsHiringByOps?: Maybe<JobsModeratorsHiring>;
  removeConnection?: Maybe<Scalars['Boolean']>;
  removeJobsModeratorsInquiry?: Maybe<JobsModeratorsInquiry>;
  renewActiveJobStatus?: Maybe<User>;
  renewJobsModeratorsActiveJobStatus?: Maybe<JobsModeratorsUser>;
  reportSalesGptFeedback?: Maybe<SalesGptQuery>;
  requestTestimonialForPublicPortfolioCurrentUser?: Maybe<Array<Testimonial>>;
  saveSalesGptSummary?: Maybe<SalesGptQuery>;
  sayThanks?: Maybe<Scalars['Boolean']>;
  scheduleHiringMeeting?: Maybe<JobsHiring>;
  scheduleJobsModeratorsMeeting?: Maybe<JobsModeratorsHiring>;
  sendSuperInvite?: Maybe<Scalars['Boolean']>;
  startTestimonialEndorsingForPublicPortfolioUser?: Maybe<Testimonial>;
  triggerContactsFetching?: Maybe<Scalars['Boolean']>;
  triggerLinkedinScraping?: Maybe<Scalars['Boolean']>;
  undoTestimonialForPublicPortfolioCurrentUser?: Maybe<Testimonial>;
  updateAcademyArticle?: Maybe<Article>;
  updateAwardForPublicPortfolioCurrentUser?: Maybe<Award>;
  updateClientForPublicPortfolioCurrentUser?: Maybe<Client>;
  updateClientPositionForPublicPortfolioCurrentUser?: Maybe<PublicPortfolioCurrentUser>;
  updateComment?: Maybe<Comment>;
  updateCompanyPagesInterview?: Maybe<CompanyPagesInterview>;
  updateCompanyPagesReview?: Maybe<CompanyPagesReview>;
  updateCompanyPagesSalary?: Maybe<CompanyPagesSalary>;
  updateConfigurationForPublicPortfolioCurrentUser?: Maybe<PublicPortfolioConfiguration>;
  updateCurrentPortfolioUser?: Maybe<PortfolioCurrentUser>;
  updateCurrentUser?: Maybe<CurrentUser>;
  updateDeal?: Maybe<PortfolioDeal>;
  updateEducationHistoryForPublicPortfolioCurrentUser?: Maybe<EducationHistory>;
  updateJobsCandidatesHiring?: Maybe<JobsHiring>;
  updateJobsInquiry?: Maybe<JobsInquiry>;
  updateJobsModeratorsHiring?: Maybe<JobsModeratorsHiring>;
  updateJobsModeratorsInquiry?: Maybe<JobsModeratorsInquiry>;
  updateJobsModeratorsSubmittedHiring?: Maybe<JobsModeratorsHiring>;
  updateJobsModeratorsUser?: Maybe<JobsModeratorsUser>;
  updatePost?: Maybe<Post>;
  updatePublicPortfolioCurrentUser?: Maybe<PublicPortfolioCurrentUser>;
  updateTestimonialPositionForPublicPortfolioCurrentUser?: Maybe<Testimonial>;
  updateWorkHistoryForPublicPortfolioCurrentUser?: Maybe<WorkHistory>;
  upsertDealQuarter?: Maybe<PortfolioDealQuarter>;
  viewAllNotifications?: Maybe<Scalars['Int']>;
};


export type MutationAcceptConnectionRequestArgs = {
  input: AcceptRequestInput;
};


export type MutationActivateJobsInquiryArgs = {
  input: ActivateJobsInquiryInput;
};


export type MutationApplyForWarRoomArgs = {
  input: ApplyForWarRoomInput;
};


export type MutationApproveTestimonialForPublicPortfolioCurrentUserArgs = {
  input: ApproveTestimonialForPublicPortfolioCurrentUserInput;
};


export type MutationArchiveCandidateHiringArgs = {
  input: ArchiveCandidateHiringInput;
};


export type MutationArchiveTestimonialForPublicPortfolioCurrentUserArgs = {
  input: ArchiveTestimonialForPublicPortfolioCurrentUserInput;
};


export type MutationAttachCompanySeriesStageArgs = {
  input: AttachCompanySeriesStageInput;
};


export type MutationAttachCompanyStageArgs = {
  input: AttachCompanyStageInput;
};


export type MutationAttachDepartmentArgs = {
  input: AttachDepartmentInput;
};


export type MutationAttachProductTypeArgs = {
  input: AttachProductInput;
};


export type MutationAttachSalesRoleArgs = {
  input: AttachSalesRoleInput;
};


export type MutationCancelConnectionRequestArgs = {
  input: CancelRequestInput;
};


export type MutationCompleteTooltipArgs = {
  input: CompleteTooltipInput;
};


export type MutationConfirmTermsOfServiceByPotentialEmployerArgs = {
  input: ConfirmTermsOfServiceByPotentialEmployerInput;
};


export type MutationCreateAwardForPublicPortfolioCurrentUserArgs = {
  input: CreateAwardForPublicPortfolioCurrentUserInput;
};


export type MutationCreateClientForPublicPortfolioCurrentUserArgs = {
  input: CreateClientForPublicPortfolioCurrentUserInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateCompanyPagesInterviewArgs = {
  input: CompanyPagesCreateInterviewInput;
};


export type MutationCreateCompanyPagesReviewArgs = {
  input: CompanyPagesCreateReviewInput;
};


export type MutationCreateCompanyPagesSalaryArgs = {
  input: CompanyPagesCreateSalaryInput;
};


export type MutationCreateConnectionRequestArgs = {
  input: CreateRequestInput;
};


export type MutationCreateConnectionsArgs = {
  input: CreateConnectionsInput;
};


export type MutationCreateCustomCompanyArgs = {
  input: CreateCustomCompanyInput;
};


export type MutationCreateCustomDepartmentArgs = {
  input: CreateCustomDepartmentInput;
};


export type MutationCreateCustomProductTypeArgs = {
  input: CreateCustomProductInput;
};


export type MutationCreateCustomSalesRoleArgs = {
  input: CreateCustomSalesRoleInput;
};


export type MutationCreateCustomUniversityArgs = {
  input: CreateCustomUniversityInput;
};


export type MutationCreateDealsArgs = {
  input: CreateDealsInput;
};


export type MutationCreateDealsSourceArgs = {
  input: CreateDealsSourceInput;
};


export type MutationCreateEducationHistoryForPublicPortfolioCurrentUserArgs = {
  input: CreateEducationHistoryForPublicPortfolioCurrentUserInput;
};


export type MutationCreateJobsModeratorsEmployerArgs = {
  input: JobsModeratorsCreateEmployerInput;
};


export type MutationCreateJobsModeratorsHiringArgs = {
  input: JobsModeratorsCreateHiringInput;
};


export type MutationCreateJobsModeratorsHiringsArgs = {
  input: JobsModeratorsCreateHiringsInput;
};


export type MutationCreateJobsModeratorsInquiryNoteArgs = {
  input: JobsModeratorsCreateInquiryNoteInput;
};


export type MutationCreatePollVoteArgs = {
  input: CreatePollVoteInput;
};


export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


export type MutationCreatePotentialEmployerArgs = {
  input: CreatePotentialEmployerInput;
};


export type MutationCreateRatingArgs = {
  input: CreateRatingInput;
};


export type MutationCreateTopicArgs = {
  input: CreateTopicInput;
};


export type MutationCreateWorkHistoryForPublicPortfolioCurrentUserArgs = {
  input: CreateWorkHistoryForPublicPortfolioCurrentUserInput;
};


export type MutationDeactivateCurrentUserArgs = {
  input: DeactivateCurrentUserInput;
};


export type MutationDestroyAwardForPublicPortfolioCurrentUserArgs = {
  input: DestroyAwardForPublicPortfolioCurrentUserInput;
};


export type MutationDestroyClientForPublicPortfolioCurrentUserArgs = {
  input: DestroyClientForPublicPortfolioCurrentUserInput;
};


export type MutationDestroyCommentArgs = {
  input: DestroyCommentInput;
};


export type MutationDestroyCompanyPagesInterviewArgs = {
  input: CompanyPagesDestroyInterviewInput;
};


export type MutationDestroyCompanyPagesReviewArgs = {
  input: CompanyPagesDestroyReviewInput;
};


export type MutationDestroyCompanyPagesSalaryArgs = {
  input: CompanyPagesDestroySalaryInput;
};


export type MutationDestroyDealArgs = {
  input: DestroyDealInput;
};


export type MutationDestroyEducationHistoryForPublicPortfolioCurrentUserArgs = {
  input: DestroyEducationHistoryForPublicPortfolioCurrentUserInput;
};


export type MutationDestroyJobsModeratorsInquiryNoteArgs = {
  input: JobsModeratorsDestroyInquiryNoteInput;
};


export type MutationDestroyPostArgs = {
  input: DestroyPostInput;
};


export type MutationDestroyRatingArgs = {
  input: DestroyRatingInput;
};


export type MutationDestroyTestimonialForPublicPortfolioCurrentUserArgs = {
  input: DestroyTestimonialForPublicPortfolioCurrentUserInput;
};


export type MutationDestroyWorkHistoryForPublicPortfolioCurrentUserArgs = {
  input: DestroyWorkHistoryForPublicPortfolioCurrentUserInput;
};


export type MutationDetachCompanySeriesStageArgs = {
  input: DetachCompanySeriesStageInput;
};


export type MutationDetachCompanyStageArgs = {
  input: DetachCompanyStageInput;
};


export type MutationDetachDepartmentArgs = {
  input: DetachDepartmentInput;
};


export type MutationDetachProductTypeArgs = {
  input: DetachProductInput;
};


export type MutationDetachSalesRoleArgs = {
  input: DetachSalesRoleInput;
};


export type MutationDirectMessagesBlockUserArgs = {
  input: BlockUserInput;
};


export type MutationDirectMessagesReadThreadMessagesArgs = {
  input: ReadThreadMessagesInput;
};


export type MutationDirectMessagesSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationDirectMessagesUnblockUserArgs = {
  input: UnblockUserInput;
};


export type MutationEndorseTestimonialForPublicPortfolioUserArgs = {
  input: EndorseTestimonialForPublicPortfolioUserInput;
};


export type MutationExpressDesireToImportConnectionsForPublicPortfolioUserArgs = {
  input: ExpressDesireToImportConnectionsForPublicPortfolioUserInput;
};


export type MutationFillJobsInquiryArgs = {
  input: FillInquiryInput;
};


export type MutationFinishOnboardingArgs = {
  input: FinishOnboardingInput;
};


export type MutationFireJobsHiringEventArgs = {
  input: FireHiringEventInput;
};


export type MutationFireJobsModeratorsHiringEventArgs = {
  input: JobsModeratorsFireHiringEventInput;
};


export type MutationFireJobsModeratorsInquiryEventArgs = {
  input: JobsModeratorsFireInquiryEventInput;
};


export type MutationFlagIssueArgs = {
  input: FlagIssueInput;
};


export type MutationHiringResendIntroduceEmailArgs = {
  input: HiringResendIntroduceEmailInput;
};


export type MutationJobsModeratorsActivateVacancyArgs = {
  input: JobsModeratorsActivateVacancyInput;
};


export type MutationJobsModeratorsCreateVacancyArgs = {
  input: JobsModeratorsCreateVacancyInput;
};


export type MutationJobsModeratorsCreateVacancySubmissionArgs = {
  input: JobsModeratorsCreateVacancySubmissionInput;
};


export type MutationJobsModeratorsDeactivateVacancyArgs = {
  input: JobsModeratorsDeactivateVacancyInput;
};


export type MutationJobsModeratorsDeleteVacancyArgs = {
  input: JobsModeratorsDeleteVacancyInput;
};


export type MutationJobsModeratorsEditEmployersClientsArgs = {
  input: JobsModeratorsEditEmployersClientsInput;
};


export type MutationJobsModeratorsEditEmployersRecruitersArgs = {
  input: JobsModeratorsEditEmployersRecruitersInput;
};


export type MutationJobsModeratorsMergeVacancyArgs = {
  input: JobsModeratorsMergeVacancyInput;
};


export type MutationJobsModeratorsRejectInquiryVacancySuggestionByOpsArgs = {
  input: JobsModeratorsRejectInquiryVacancySuggestionByOpsInput;
};


export type MutationJobsModeratorsSubmitHiringArgs = {
  input: JobsModeratorsSubmitHiringInput;
};


export type MutationJobsModeratorsUpdateCompanyArgs = {
  input: JobsModeratorsUpdateCompanyInput;
};


export type MutationJobsModeratorsUpdateEmployerArgs = {
  input: JobsModeratorsUpdateEmployerInput;
};


export type MutationJobsModeratorsUpdateVacancyArgs = {
  input: JobsModeratorsUpdateVacancyInput;
};


export type MutationJobsModeratorsUpdateVacancySubmissionArgs = {
  input: JobsModeratorsUpdateVacancySubmissionInput;
};


export type MutationJobsRecruitersAcceptCandidateArgs = {
  input: JobsRecruitersAcceptCandidateInput;
};


export type MutationJobsRecruitersActivateCurrentRecruiterArgs = {
  input: JobsRecruitersActivateCurrentRecruiterInput;
};


export type MutationJobsRecruitersActivateVacancyArgs = {
  input: JobsRecruitersActivateVacancyInput;
};


export type MutationJobsRecruitersCompleteTooltipArgs = {
  input: JobsRecruitersCompleteTooltipInput;
};


export type MutationJobsRecruitersCreateCustomCompanyArgs = {
  input: JobsRecruitersCreateCustomCompanyInput;
};


export type MutationJobsRecruitersCreateEmployerArgs = {
  input: JobsRecruitersCreateEmployerInput;
};


export type MutationJobsRecruitersCreateStripeBillingUrlArgs = {
  input: JobsRecruitersCreateStripeBillingUrlInput;
};


export type MutationJobsRecruitersCreateStripeSessionUrlArgs = {
  input: JobsRecruitersCreateStripeSessionUrlInput;
};


export type MutationJobsRecruitersCreateVacancyArgs = {
  input: JobsRecruitersCreateVacancyInput;
};


export type MutationJobsRecruitersDeleteEmployerArgs = {
  input: JobsRecruitersDeleteEmployerInput;
};


export type MutationJobsRecruitersDeleteEmployerRecruiterArgs = {
  input: JobsRecruitersDeleteRecruiterInput;
};


export type MutationJobsRecruitersDeleteVacancyArgs = {
  input: JobsRecruitersDeleteVacancyInput;
};


export type MutationJobsRecruitersDeleteVacancyFieldArgs = {
  input: JobsRecruitersDeleteVacancyFieldInput;
};


export type MutationJobsRecruitersDestroyCandidateArgs = {
  input: JobsRecruitersDestroyCandidateInput;
};


export type MutationJobsRecruitersEditEmployersRecruiterArgs = {
  input: JobsRecruitersEditRecruiterInput;
};


export type MutationJobsRecruitersEnableVacanciesArgs = {
  input: JobsRecruitersEnableVacanciesInput;
};


export type MutationJobsRecruitersImportGreenhouseVacanciesArgs = {
  input: JobsRecruitersImportGreenhouseVacanciesInput;
};


export type MutationJobsRecruitersMarkCandidateAsViewedArgs = {
  input: JobsRecruitersMarkCandidateAsViewedInput;
};


export type MutationJobsRecruitersMatchVacancyArgs = {
  input: JobsRecruitersMatchVacancyInput;
};


export type MutationJobsRecruitersRejectCandidateArgs = {
  input: JobsRecruitersRejectCandidateInput;
};


export type MutationJobsRecruitersSendRecruiterAuthTokenArgs = {
  input: JobsRecruitersSendRecruiterAuthTokenInput;
};


export type MutationJobsRecruitersUpdateCurrentEmployerArgs = {
  input: JobsRecruitersUpdateCurrentEmployerInput;
};


export type MutationJobsRecruitersUpdateCurrentRecruiterArgs = {
  input: JobsRecruitersUpdateCurrentRecruiterInput;
};


export type MutationJobsRecruitersUpdateCustomCompanyArgs = {
  input: JobsRecruitersUpdateCustomCompanyInput;
};


export type MutationJobsRecruitersUpdateVacancyArgs = {
  input: JobsRecruitersUpdateVacancyInput;
};


export type MutationJobsRecruitersUpdateVacancyFieldArgs = {
  input: JobsRecruitersUpdateVacancyFieldInput;
};


export type MutationMarkCommentsViewedArgs = {
  input: MarkCommentsViewedInput;
};


export type MutationMarkPostsAsReadArgs = {
  input: MarkPostsAsReadInput;
};


export type MutationMatchJobsInquiryAfterOnboardingArgs = {
  input: MatchJobsInquiryAfterOnboardingInput;
};


export type MutationMatchJobsModeratorsInquiryArgs = {
  input: JobsModeratorsMatchInquiryInput;
};


export type MutationReRequestTestimonialForPublicPortfolioCurrentUserArgs = {
  input: ReRequestTestimonialForPublicPortfolioCurrentUserInput;
};


export type MutationReadAllNotificationsArgs = {
  input: ReadAllNotificationsInput;
};


export type MutationReadConnectionRequestsArgs = {
  input: ReadRequestsInput;
};


export type MutationReadNotificationArgs = {
  input: ReadNotificationInput;
};


export type MutationRefreshJobsInquiryArgs = {
  input: RefreshInquiryInput;
};


export type MutationRejectConnectionRequestArgs = {
  input: RejectRequestInput;
};


export type MutationRejectJobsHiringArgs = {
  input: RejectJobsHiringInput;
};


export type MutationRejectJobsModeratorsHiringByOpsArgs = {
  input: JobsModeratorsRejectJobsHiringByOpsInput;
};


export type MutationRemoveConnectionArgs = {
  input: RemoveConnectionInput;
};


export type MutationRemoveJobsModeratorsInquiryArgs = {
  input: JobsModeratorsRemoveInquiryInput;
};


export type MutationRenewActiveJobStatusArgs = {
  input: RenewActiveJobStatusInput;
};


export type MutationRenewJobsModeratorsActiveJobStatusArgs = {
  input: JobsModeratorsRenewActiveJobStatusInput;
};


export type MutationReportSalesGptFeedbackArgs = {
  input: ReportSalesGptFeedbackInput;
};


export type MutationRequestTestimonialForPublicPortfolioCurrentUserArgs = {
  input: RequestTestimonialForPublicPortfolioCurrentUserInput;
};


export type MutationSaveSalesGptSummaryArgs = {
  input: SaveSalesGptSummaryInput;
};


export type MutationSayThanksArgs = {
  input: SayThanksInput;
};


export type MutationScheduleHiringMeetingArgs = {
  input: ScheduleHiringMeetingInput;
};


export type MutationScheduleJobsModeratorsMeetingArgs = {
  input: JobsModeratorsScheduleMeetingInput;
};


export type MutationSendSuperInviteArgs = {
  input: SendSuperInviteInput;
};


export type MutationStartTestimonialEndorsingForPublicPortfolioUserArgs = {
  input: StartTestimonialEndorsingForPublicPortfolioUserInput;
};


export type MutationTriggerContactsFetchingArgs = {
  input: TriggerContactsFetchingInput;
};


export type MutationTriggerLinkedinScrapingArgs = {
  input: TriggerLinkedinScrapingInput;
};


export type MutationUndoTestimonialForPublicPortfolioCurrentUserArgs = {
  input: UndoTestimonialForPublicPortfolioCurrentUserInput;
};


export type MutationUpdateAcademyArticleArgs = {
  input: UpdateArticleInput;
};


export type MutationUpdateAwardForPublicPortfolioCurrentUserArgs = {
  input: UpdateAwardForPublicPortfolioCurrentUserInput;
};


export type MutationUpdateClientForPublicPortfolioCurrentUserArgs = {
  input: UpdateClientForPublicPortfolioCurrentUserInput;
};


export type MutationUpdateClientPositionForPublicPortfolioCurrentUserArgs = {
  input: UpdateClientPositionForPublicPortfolioCurrentUserInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateCompanyPagesInterviewArgs = {
  input: CompanyPagesUpdateInterviewInput;
};


export type MutationUpdateCompanyPagesReviewArgs = {
  input: CompanyPagesUpdateReviewInput;
};


export type MutationUpdateCompanyPagesSalaryArgs = {
  input: CompanyPagesUpdateSalaryInput;
};


export type MutationUpdateConfigurationForPublicPortfolioCurrentUserArgs = {
  input: UpdateConfigurationForPublicPortfolioCurrentUserInput;
};


export type MutationUpdateCurrentPortfolioUserArgs = {
  input: UpdateCurrentPortfolioUserInput;
};


export type MutationUpdateCurrentUserArgs = {
  input: UpdateCurrentUserInput;
};


export type MutationUpdateDealArgs = {
  input: UpdateDealInput;
};


export type MutationUpdateEducationHistoryForPublicPortfolioCurrentUserArgs = {
  input: UpdateEducationHistoryForPublicPortfolioCurrentUserInput;
};


export type MutationUpdateJobsCandidatesHiringArgs = {
  input: JobsCandidatesUpdateHiringInput;
};


export type MutationUpdateJobsInquiryArgs = {
  input: UpdateInquiryInput;
};


export type MutationUpdateJobsModeratorsHiringArgs = {
  input: JobsModeratorsUpdateHiringInput;
};


export type MutationUpdateJobsModeratorsInquiryArgs = {
  input: JobsModeratorsUpdateInquiryInput;
};


export type MutationUpdateJobsModeratorsSubmittedHiringArgs = {
  input: JobsModeratorsUpdateSubmittedHiringInput;
};


export type MutationUpdateJobsModeratorsUserArgs = {
  input: JobsModeratorsUpdateUserInput;
};


export type MutationUpdatePostArgs = {
  input: UpdatePostInput;
};


export type MutationUpdatePublicPortfolioCurrentUserArgs = {
  input: UpdatePublicPortfolioCurrentUserInput;
};


export type MutationUpdateTestimonialPositionForPublicPortfolioCurrentUserArgs = {
  input: UpdateTestimonialPositionForPublicPortfolioCurrentUserInput;
};


export type MutationUpdateWorkHistoryForPublicPortfolioCurrentUserArgs = {
  input: UpdateWorkHistoryForPublicPortfolioCurrentUserInput;
};


export type MutationUpsertDealQuarterArgs = {
  input: UpsertDealQuarterInput;
};


export type MutationViewAllNotificationsArgs = {
  input: ViewAllNotificationsInput;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  kind: NotificationKind;
  readAt?: Maybe<Scalars['ISO8601DateTime']>;
  referenceable?: Maybe<NotificationReferenceable>;
  type: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  viewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  warRoomCommissionTransaction?: Maybe<CommissionTransaction>;
};

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** A list of edges. */
  edges: Array<NotificationEdge>;
  /** A list of nodes. */
  nodes: Array<Notification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Notification>;
};

export enum NotificationKind {
  ActionNeeded = 'action_needed',
  Common = 'common'
}

export type NotificationReferenceable = Comment | JobsHiring | Post | Rating | SalesGptQuery | Testimonial | User;

export type OnboardingData = {
  __typename?: 'OnboardingData';
  companyStages: Array<CompanyStage>;
  customerSegments: Array<CustomerSegment>;
  departments: Array<Department>;
  expectations: Array<Expectation>;
  industries: Array<Industry>;
  jobSearchStatuses: Array<Scalars['String']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export enum Platform {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type Poll = {
  __typename?: 'Poll';
  choices: Array<PollChoice>;
  createdAt: Scalars['ISO8601DateTime'];
  currentUserVote?: Maybe<PollVote>;
  expiredForCommission: Scalars['Boolean'];
  id: Scalars['Int'];
  post: Post;
  postId: Scalars['Int'];
  previewUsers?: Maybe<Array<User>>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  votedUsers: UserConnection;
  votes: PollVoteConnection;
  votesCount: Scalars['Int'];
};


export type PollVotedUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PollVotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Attributes for creating or updating a War Room poll */
export type PollAttributes = {
  choices: Array<PollChoiceAttributes>;
  id?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type PollChoice = {
  __typename?: 'PollChoice';
  createdAt: Scalars['ISO8601DateTime'];
  currentVote: Scalars['Boolean'];
  id: Scalars['Int'];
  poll: Poll;
  pollId: Scalars['Int'];
  position?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  votedUsers: UserConnection;
  votes: PollVoteConnection;
  votesCount: Scalars['Int'];
};


export type PollChoiceVotedUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PollChoiceVotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Attributes for creating or updating a War Room post */
export type PollChoiceAttributes = {
  id?: InputMaybe<Scalars['Int']>;
  position: Scalars['Int'];
  text: Scalars['String'];
};

export type PollVote = {
  __typename?: 'PollVote';
  choice: PollChoice;
  choiceId: Scalars['Int'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  poll: Poll;
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
};

/** The connection type for PollVote. */
export type PollVoteConnection = {
  __typename?: 'PollVoteConnection';
  /** A list of edges. */
  edges: Array<PollVoteEdge>;
  /** A list of nodes. */
  nodes: Array<PollVote>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PollVoteEdge = {
  __typename?: 'PollVoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PollVote>;
};

export type PortfolioCurrentUser = {
  __typename?: 'PortfolioCurrentUser';
  city?: Maybe<City>;
  customerSegment?: Maybe<CustomerSegment>;
  dealQuarters: Array<PortfolioDealQuarter>;
  deals: PortfolioDealConnection;
  id: Scalars['ID'];
  industry?: Maybe<Industry>;
  lastLinkedinSyncError?: Maybe<Scalars['String']>;
  lastLinkedinSyncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  productTypes: Array<ProductType>;
  ranking: PortfolioRanking;
  topDeals: PortfolioDealConnection;
};


export type PortfolioCurrentUserDealsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PortfolioCurrentUserTopDealsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PortfolioDeal = DealInterface & {
  __typename?: 'PortfolioDeal';
  amount: Scalars['Float'];
  closeDate: Scalars['ISO8601DateTime'];
  company?: Maybe<Company>;
  createdAt: Scalars['ISO8601DateTime'];
  departments?: Maybe<Array<Department>>;
  id: Scalars['ID'];
  interactionsCount: Scalars['Int'];
  isOwner: Scalars['Boolean'];
  isPrivateCompany: Scalars['Boolean'];
  isPrivateDepartments: Scalars['Boolean'];
  post?: Maybe<Post>;
};

/** The connection type for PortfolioDeal. */
export type PortfolioDealConnection = DealConnectionInterface & {
  __typename?: 'PortfolioDealConnection';
  /** A list of edges. */
  edges: Array<PortfolioDealEdge>;
  /** A list of nodes. */
  nodes: Array<PortfolioDeal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  statistics: DealsStatistics;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PortfolioDealEdge = {
  __typename?: 'PortfolioDealEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PortfolioDeal>;
};

export type PortfolioDealQuarter = {
  __typename?: 'PortfolioDealQuarter';
  quarter: Scalars['Int'];
  quota?: Maybe<Scalars['Int']>;
  revenue?: Maybe<Scalars['Int']>;
  year: Scalars['Int'];
};

export type PortfolioDealsSource = {
  __typename?: 'PortfolioDealsSource';
  id: Scalars['ID'];
};

export type PortfolioRanking = {
  __typename?: 'PortfolioRanking';
  rankingByCustomerSegment?: Maybe<Scalars['Float']>;
  rankingByIndustry?: Maybe<Scalars['Float']>;
  rankingByLocation?: Maybe<Scalars['Float']>;
};

export type PortfolioUserSearchResult = SearchResultInterface & {
  __typename?: 'PortfolioUserSearchResult';
  category: Scalars['String'];
  portfolioUser: PublicPortfolioUser;
};

export type Post = {
  __typename?: 'Post';
  algorithmMetadata?: Maybe<Scalars['JSON']>;
  archivedAt?: Maybe<Scalars['ISO8601DateTime']>;
  author: UserAuthor;
  category: Scalars['String'];
  comments: CommentConnection;
  commentsCount: Scalars['Int'];
  content: Content;
  contentId: Scalars['Int'];
  contentType: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  currentUserRating?: Maybe<Rating>;
  files?: Maybe<Array<File>>;
  id: Scalars['ID'];
  isAnonymous: Scalars['Boolean'];
  membersOnly: Scalars['Boolean'];
  metadataUsers: UserPostConnection;
  newCommentsCount: Scalars['Int'];
  official: Scalars['Boolean'];
  pinned: Scalars['Boolean'];
  pinnedAt?: Maybe<Scalars['ISO8601DateTime']>;
  poll?: Maybe<Poll>;
  previewComments: CommentConnection;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  ratedUsers: UserConnection;
  ratings: RatingConnection;
  searchableComments?: Maybe<Array<Comment>>;
  slug: Scalars['String'];
  topicId: Scalars['Int'];
  topics: Array<Topic>;
  totalRating: Scalars['Int'];
  /** @deprecated Started to use #algorithm_metadata instead */
  totalWeight: Scalars['Float'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  viewed?: Maybe<Scalars['Boolean']>;
  viewers: UserConnection;
  views: PostViewConnection;
  viewsCount: Scalars['Int'];
};


export type PostCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortType?: InputMaybe<Scalars['String']>;
};


export type PostMetadataUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PostPreviewCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PostRatedUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PostRatingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PostViewersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PostViewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Post. */
export type PostConnection = {
  __typename?: 'PostConnection';
  /** A list of edges. */
  edges: Array<PostEdge>;
  /** A list of nodes. */
  nodes: Array<Post>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PostEdge = {
  __typename?: 'PostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Post>;
};

export type PostView = {
  __typename?: 'PostView';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  postId: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
};

/** The connection type for PostView. */
export type PostViewConnection = {
  __typename?: 'PostViewConnection';
  /** A list of edges. */
  edges: Array<PostViewEdge>;
  /** A list of nodes. */
  nodes: Array<PostView>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PostViewEdge = {
  __typename?: 'PostViewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<PostView>;
};

export type PotentialEmployer = {
  __typename?: 'PotentialEmployer';
  company?: Maybe<Company>;
  companyBusinessAddress?: Maybe<Scalars['String']>;
  companyDomain?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hashid: Scalars['ID'];
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  numberOfHirings?: Maybe<Scalars['String']>;
  otherRoles?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rolesOfHirings?: Maybe<Array<Scalars['String']>>;
};

export type ProductType = {
  __typename?: 'ProductType';
  createdAt: Scalars['ISO8601DateTime'];
  custom: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  users?: Maybe<Array<User>>;
};

export type Public = {
  __typename?: 'Public';
  avatarUrl?: Maybe<Scalars['String']>;
  currentCompany?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  portfolioIsOpened?: Maybe<Scalars['Boolean']>;
  position?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type PublicPortfolioConfiguration = {
  __typename?: 'PublicPortfolioConfiguration';
  fieldCalendarLinkIsPublic: Scalars['Boolean'];
  fieldLinkedinSlugIsPublic: Scalars['Boolean'];
  fieldPhoneIsPublic: Scalars['Boolean'];
  fieldPublicEmailIsPublic: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  sectionAwardsIsPublic: Scalars['Boolean'];
  sectionClientsIsPublic: Scalars['Boolean'];
  sectionConnectionsIsPublic: Scalars['Boolean'];
  sectionContactsIsPublic: Scalars['Boolean'];
  sectionEducationHistoriesIsPublic: Scalars['Boolean'];
  sectionHeadlineIsPublic: Scalars['Boolean'];
  sectionSalesExperienceIsPublic: Scalars['Boolean'];
  sectionTestimonialsIsPublic: Scalars['Boolean'];
  sectionWorkHistoriesIsPublic: Scalars['Boolean'];
};

export type PublicPortfolioCurrentUser = PublicPortfolioUserIterface & {
  __typename?: 'PublicPortfolioCurrentUser';
  avatarUrl?: Maybe<Scalars['String']>;
  awards?: Maybe<Array<Award>>;
  calendarLink?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  clients?: Maybe<Array<Client>>;
  companySeriesStages?: Maybe<Array<CompanySeriesStage>>;
  companyStages?: Maybe<Array<CompanyStage>>;
  configuration: PublicPortfolioConfiguration;
  connections?: Maybe<ConnectionConnection>;
  contacts?: Maybe<Contacts>;
  createdAt: Scalars['ISO8601DateTime'];
  currentCompany?: Maybe<Company>;
  currentPosition?: Maybe<Scalars['String']>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars['String']>;
  educationHistories?: Maybe<Array<EducationHistory>>;
  firstname?: Maybe<Scalars['String']>;
  industries?: Maybe<Array<Industry>>;
  lastname?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  productTypes?: Maybe<Array<ProductType>>;
  publicEmail?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  testimonials?: Maybe<Array<Testimonial>>;
  tooltips: Array<Tooltip>;
  warRoomSalesRoles?: Maybe<Array<SalesRole>>;
  workHistories?: Maybe<Array<WorkHistory>>;
  workHistory: WorkHistory;
  yearsOfExperience?: Maybe<Scalars['Int']>;
};


export type PublicPortfolioCurrentUserConnectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type PublicPortfolioCurrentUserWorkHistoryArgs = {
  id: Scalars['ID'];
};

export type PublicPortfolioUser = PublicPortfolioUserIterface & {
  __typename?: 'PublicPortfolioUser';
  avatarUrl?: Maybe<Scalars['String']>;
  awards?: Maybe<Array<Award>>;
  calendarLink?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  clients?: Maybe<Array<Client>>;
  companySeriesStages?: Maybe<Array<CompanySeriesStage>>;
  companyStages?: Maybe<Array<CompanyStage>>;
  configuration: PublicPortfolioConfiguration;
  connected: Scalars['Boolean'];
  connections?: Maybe<ConnectionConnection>;
  contacts?: Maybe<Contacts>;
  createdAt: Scalars['ISO8601DateTime'];
  currentCompany?: Maybe<Company>;
  currentPosition?: Maybe<Scalars['String']>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars['String']>;
  educationHistories?: Maybe<Array<EducationHistory>>;
  firstname?: Maybe<Scalars['String']>;
  incomingConnectionRequest?: Maybe<Request>;
  industries?: Maybe<Array<Industry>>;
  lastname?: Maybe<Scalars['String']>;
  outgoingConnectionRequest?: Maybe<Request>;
  phone?: Maybe<Scalars['String']>;
  productTypes?: Maybe<Array<ProductType>>;
  publicEmail?: Maybe<Scalars['String']>;
  realUser?: Maybe<PublicPortfolioUser>;
  slug: Scalars['String'];
  testimonials?: Maybe<Array<Testimonial>>;
  warRoomSalesRoles?: Maybe<Array<SalesRole>>;
  workHistories?: Maybe<Array<WorkHistory>>;
  yearsOfExperience?: Maybe<Scalars['Int']>;
};


export type PublicPortfolioUserConnectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

export type PublicPortfolioUserIterface = {
  avatarUrl?: Maybe<Scalars['String']>;
  awards?: Maybe<Array<Award>>;
  calendarLink?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  clients?: Maybe<Array<Client>>;
  companySeriesStages?: Maybe<Array<CompanySeriesStage>>;
  companyStages?: Maybe<Array<CompanyStage>>;
  configuration: PublicPortfolioConfiguration;
  connections?: Maybe<ConnectionConnection>;
  contacts?: Maybe<Contacts>;
  createdAt: Scalars['ISO8601DateTime'];
  currentCompany?: Maybe<Company>;
  currentPosition?: Maybe<Scalars['String']>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars['String']>;
  educationHistories?: Maybe<Array<EducationHistory>>;
  firstname?: Maybe<Scalars['String']>;
  industries?: Maybe<Array<Industry>>;
  lastname?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  productTypes?: Maybe<Array<ProductType>>;
  publicEmail?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  testimonials?: Maybe<Array<Testimonial>>;
  warRoomSalesRoles?: Maybe<Array<SalesRole>>;
  workHistories?: Maybe<Array<WorkHistory>>;
  yearsOfExperience?: Maybe<Scalars['Int']>;
};


export type PublicPortfolioUserIterfaceConnectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /** Returns an Academy article by slug */
  academyArticle: Article;
  /** Returns Academy articles sorted by weight */
  academyArticles: Array<Article>;
  /** Returns an ordered list of Academy topics */
  academyTopics: AcademyTopicConnection;
  cities: CityConnection;
  /** Returns a comment by id */
  comment: Comment;
  /** Returns a list of comments from the given post */
  comments: CommentConnection;
  /** Returns current commission balance for the current user */
  commissionBalance: CommissionBalance;
  /** Returns data to build commission onboarding for current user */
  commissionOnboarding: CommissionOnboarding;
  /** Returns all companies with compgauge data */
  companies?: Maybe<CompaniesConnection>;
  /** Return possible company categories */
  companiesCategories: Array<CompaniesCategory>;
  /** AI based companies search */
  companiesSearch: Array<Company>;
  /** Returns company */
  company?: Maybe<Company>;
  /** Returns salaries average data */
  companyPagesAverageSalariesData?: Maybe<AverageSalariesData>;
  /** Returns best cities by sales role and optionally by customer segment */
  companyPagesBestCities: Array<BestCity>;
  /** Returns company pages interviews */
  companyPagesInterviews?: Maybe<CompanyPagesInterviewConnection>;
  /** Returns users that are currently working or used to be in the past */
  companyPagesPeople: EmployeeConnection;
  /** Returns all possible regions for salaries data aggregation */
  companyPagesRegions: RegionConnection;
  /** Returns company pages reivews */
  companyPagesReviews?: Maybe<CompanyPagesReviewConnection>;
  /** Returns role categories that contain data for provided customer segment */
  companyPagesRoleCategoriesByCustomerSegment?: Maybe<Array<RoleCategory>>;
  /** Returns salaries average data */
  companyPagesRoles?: Maybe<CompanyPagesRoleConnection>;
  /** Returns a company role */
  companyRole?: Maybe<CompanyPagesRole>;
  /** Return particular connection request */
  connectionRequest: Request;
  /** Returns user's requests for connection */
  connectionRequestsInbox: RequestConnection;
  /** Returns a list of suggested contacts for connections */
  connectionSuggestions: ConnectionSuggestionInterfaceConnection;
  /** Returns current user's job inquiry */
  currentJobsInquiry?: Maybe<JobsInquiry>;
  /** Returns current user data */
  currentUser: CurrentUser;
  customerSegments: Array<CustomerSegment>;
  deals: DealConnection;
  departments: Array<Department>;
  /** Returns direct message blocked users */
  directMessagesBlockedUsers: Array<User>;
  /** Returns suggested users for direct messaging */
  directMessagesSuggestedUsers?: Maybe<Array<User>>;
  /** Returns thread with other_user_username if it exists */
  directMessagesThread?: Maybe<Thread>;
  /** Returns direct message threads */
  directMessagesThreads: Array<Thread>;
  /** Returns users looked up by username attr (without blocked users) */
  directMessagesUsersByUsername: Array<UserSearch>;
  educationHistory: EducationHistory;
  industries: Array<Industry>;
  /** Returns an limited ordered list of CompanySeriesStage options for Jobs */
  jobsCompanySeriesStages: Array<CompanySeriesStage>;
  /** Returns a hiring by hashid */
  jobsHiring: JobsHiring;
  /** Returns Bravado account owners */
  jobsModeratorsAccountOwners: Array<JobsModeratorsEmployersAccountOwner>;
  jobsModeratorsBestHiringsExplanation: JobsModeratorsHiringExplanation;
  jobsModeratorsCandidate: JobsModeratorsCandidate;
  jobsModeratorsDefaultCandidate: JobsModeratorsCandidate;
  /** Returns job employer by id for moderator */
  jobsModeratorsEmployer?: Maybe<JobsModeratorsEmployer>;
  /** Returns jobs employers for moderator */
  jobsModeratorsEmployers: JobsModeratorsEmployerConnection;
  jobsModeratorsFields: Array<JobsModeratorsField>;
  jobsModeratorsFieldsCategories: Array<JobsModeratorsFieldsCategory>;
  /** Returns job hiring by id for moderator */
  jobsModeratorsHiring?: Maybe<JobsModeratorsHiring>;
  /** Returns a list of hiring states */
  jobsModeratorsHiringStates: Array<JobsModeratorsHiringState>;
  /** Returns a list of hiring states with counters */
  jobsModeratorsHiringStatesWithCounters: Array<JobsModeratorsHiringStateCounter>;
  /** Returns last job hirings for moderator */
  jobsModeratorsHirings?: Maybe<JobsModeratorsHiringConnection>;
  /** Returns last job inquiries for moderator */
  jobsModeratorsInquiries?: Maybe<JobsModeratorsInquiryConnection>;
  /** Returns job inquiry by id for moderator */
  jobsModeratorsInquiry?: Maybe<JobsModeratorsInquiry>;
  /** Returns a list of inquiry states visible for moderator */
  jobsModeratorsInquiryStates: Array<JobsInquiryState>;
  /** Returns a list of ops rejection reasons */
  jobsModeratorsOpsRejectionReasons: Array<JobsModeratorsOpsRejectionReason>;
  /** Returns Bravado recruiters */
  jobsModeratorsRecruiters: Array<JobsModeratorsUser>;
  jobsModeratorsSuggestedInquiries: Array<JobsModeratorsInquiryMatch>;
  jobsModeratorsSuggestedVacancies: Array<JobsModeratorsVacancyMatch>;
  /** Returns job vacancies for moderator */
  jobsModeratorsVacancies: JobsModeratorsVacancyConnection;
  jobsModeratorsVacancy: JobsModeratorsVacancy;
  jobsRecruitersCandidate: JobsRecruitersCandidate;
  jobsRecruitersCandidates: JobsRecruitersCandidateConnection;
  jobsRecruitersCheckEmployerExistence: Scalars['Boolean'];
  jobsRecruitersCheckRecruiterExistence: Scalars['Boolean'];
  jobsRecruitersCompanyCategorySuggestions: Array<Scalars['String']>;
  jobsRecruitersCurrentRecruiter?: Maybe<JobsRecruitersRecruiter>;
  jobsRecruitersEmployerRecruiters?: Maybe<Array<JobsRecruitersRecruiter>>;
  jobsRecruitersField: JobsRecruitersField;
  jobsRecruitersFields: Array<JobsRecruitersField>;
  jobsRecruitersFieldsCategories: Array<JobsRecruitersFieldsCategory>;
  jobsRecruitersInquiry?: Maybe<JobsRecruitersInquiry>;
  jobsRecruitersOteDistribution?: Maybe<JobsRecruitersDistribution>;
  jobsRecruitersVacancies: Array<JobsRecruitersVacancy>;
  jobsRecruitersVacancy: JobsRecruitersVacancy;
  jobsRecruitersVacancyPromptTemplates: Array<JobsRecruitersVacancyPromptTemplate>;
  /** Returns a vacancy by uid */
  jobsVacancy: JobsVacancy;
  /** Returns data for top users commission leaderboard and current user position in leaderboard */
  leaderboard: Scalars['JSON'];
  /** Returns a list with notifications received by the current user */
  notifications?: Maybe<NotificationConnection>;
  onboardingData: OnboardingData;
  /** Returns user's outgoing requests */
  outgoingConnectionRequests: RequestConnection;
  /** Returns a list of a suggested bravado users for connections(v2) */
  peopleYouMightKnow: SuggestedUserConnection;
  /** Returns a list with posts for War Room personal feed with pagination */
  personalFeedPosts: Array<Post>;
  /** Returns a list with pinned posts from War Room */
  pinnedPosts: PostConnection;
  /** Returns a list with the most popular topics from War Room */
  popularTopics: Array<Topic>;
  /** Returns current portfolio user */
  portfolioCurrentUser: PortfolioCurrentUser;
  portfolioDeal: PortfolioDeal;
  /** Returns a post by slug */
  post?: Maybe<Post>;
  /** Returns a list of posts from War Room */
  posts: PostConnection;
  productTypes: Array<ProductType>;
  /** Returns connections by user's slug and search query */
  publicPortfolioConnections?: Maybe<ConnectionConnection>;
  publicPortfolioCurrentUser: PublicPortfolioCurrentUser;
  /** Returns portfolio public user by slug */
  publicPortfolioUser?: Maybe<PublicPortfolioUser>;
  publicPortfolioUserTestifySign?: Maybe<Scalars['String']>;
  roleCategories: Array<RoleCategory>;
  salesDirectoryProfiles: SalesDirectoryPage;
  /** Returns flex cta by search session key */
  salesGptFlexCta?: Maybe<Scalars['String']>;
  /** Returns query, summary and sources for given a query session ID */
  salesGptQuery: SalesGptQuery;
  salesRoles: Array<SalesRole>;
  /** AI based Universal Search */
  search: SearchInfo;
  searchLocations: Array<Location>;
  /** Returns data for mentioning */
  searchUsers: Array<UserSearch>;
  suggestedGeolocation?: Maybe<City>;
  suggestedLinkedinProfiles: Array<VendorDbUser>;
  testimonial: Testimonial;
  /** Returns top 5 flex vacancies */
  topFlexJobsVacancies?: Maybe<Array<JobsVacancy>>;
  /** Returns a list of topics from War Room */
  topics: TopicConnection;
  /** Search universities */
  universities: UniversityConnection;
  university: University;
  /** Search university degrees */
  universityDegrees: Array<Scalars['String']>;
  /** Returns alumni of particular university */
  universityPagesPeople: AlumniConnection;
  /** Returns suggestions for university page */
  universityPagesSuggestions: SuggestedUserConnection;
  /** Returns a user by username */
  user?: Maybe<User>;
  /** Returns a list of posts by given user */
  userPosts: PostConnection;
  /** Returns a list of posts published by real identity */
  userPublicPosts: PostConnection;
  /** Search user refer */
  userReferrer?: Maybe<SuggestedUser>;
  /** Returns a list of posts with search term */
  warRoomSearchPosts: Array<Post>;
  /** Returns last war room activity type */
  warRoomSuggestedActivityType: Activity;
  /** Returns number of unreaded posts */
  warRoomUnreadPostsCount: Scalars['Int'];
};


export type QueryAcademyArticleArgs = {
  slug: Scalars['String'];
};


export type QueryAcademyArticlesArgs = {
  topicSlug?: InputMaybe<Scalars['String']>;
};


export type QueryAcademyTopicsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<CitySearchParams>;
};


export type QueryCommentArgs = {
  id: Scalars['ID'];
  parentOnTop?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  postSlug: Scalars['String'];
  sortType?: InputMaybe<CommentSortType>;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  regionId?: InputMaybe<Scalars['ID']>;
  roleCategoryId?: InputMaybe<Scalars['ID']>;
  searchLetter?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortType?: InputMaybe<CompaniesSort>;
};


export type QueryCompaniesCategoriesArgs = {
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryCompaniesSearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  minScore?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QueryCompanyArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryCompanyPagesAverageSalariesDataArgs = {
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  regionId?: InputMaybe<Scalars['ID']>;
  roleCategoryId: Scalars['ID'];
};


export type QueryCompanyPagesBestCitiesArgs = {
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  roleCategoryId: Scalars['ID'];
};


export type QueryCompanyPagesInterviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCompanyPagesPeopleArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type QueryCompanyPagesRegionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCompanyPagesReviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCompanyPagesRoleCategoriesByCustomerSegmentArgs = {
  customerSegmentId: Scalars['ID'];
};


export type QueryCompanyPagesRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  roleCategoryId: Scalars['ID'];
};


export type QueryCompanyRoleArgs = {
  companyRoleId: Scalars['ID'];
};


export type QueryConnectionRequestArgs = {
  id: Scalars['ID'];
};


export type QueryConnectionRequestsInboxArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryConnectionSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  type: ConnectionSuggestionType;
};


export type QueryDealsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryDirectMessagesThreadArgs = {
  username: Scalars['String'];
};


export type QueryDirectMessagesUsersByUsernameArgs = {
  query: Scalars['String'];
};


export type QueryEducationHistoryArgs = {
  id: Scalars['ID'];
};


export type QueryJobsHiringArgs = {
  hashid: Scalars['String'];
};


export type QueryJobsModeratorsBestHiringsExplanationArgs = {
  hiringIds: Array<Scalars['ID']>;
};


export type QueryJobsModeratorsCandidateArgs = {
  id: Scalars['ID'];
};


export type QueryJobsModeratorsDefaultCandidateArgs = {
  hiringId: Scalars['ID'];
};


export type QueryJobsModeratorsEmployerArgs = {
  id: Scalars['ID'];
};


export type QueryJobsModeratorsEmployersArgs = {
  accountOwnerIds?: InputMaybe<Array<Scalars['ID']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  needsAttention?: InputMaybe<Scalars['Boolean']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<JobsModeratorsEmployerSortAttributes>;
  subscriptionStates?: InputMaybe<Array<JobsModeratorsEmployerSubscriptionState>>;
  subscriptionTypes?: InputMaybe<Array<JobsModeratorsEmployerSubscriptionType>>;
};


export type QueryJobsModeratorsFieldsArgs = {
  accessLevels?: InputMaybe<Array<JobsFieldsAccessLevel>>;
  availableForRoles?: InputMaybe<Array<JobsRole>>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  popularForRoles?: InputMaybe<Array<JobsRole>>;
  scopes?: InputMaybe<Array<JobsFieldsScope>>;
};


export type QueryJobsModeratorsHiringArgs = {
  id: Scalars['ID'];
};


export type QueryJobsModeratorsHiringsArgs = {
  acceptedByCandidate?: InputMaybe<Scalars['Boolean']>;
  acceptedByEmployer?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  before?: InputMaybe<Scalars['String']>;
  employerIds?: InputMaybe<Array<Scalars['ID']>>;
  employmentTypes?: InputMaybe<Array<JobsVacancyEmployment>>;
  first?: InputMaybe<Scalars['Int']>;
  interviewNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  last?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<JobsModeratorsHiringSortAttributes>;
  states?: InputMaybe<Array<JobsModeratorsHiringState>>;
  submissionSources?: InputMaybe<Array<JobsHiringSubmissionSource>>;
  tiers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  vacancyId?: InputMaybe<Scalars['ID']>;
};


export type QueryJobsModeratorsInquiriesArgs = {
  acceptedByCandidate?: InputMaybe<Scalars['Boolean']>;
  acceptedByEmployer?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  assigneeIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  before?: InputMaybe<Scalars['String']>;
  employmentTypes?: InputMaybe<Array<JobsInquiryEmployment>>;
  first?: InputMaybe<Scalars['Int']>;
  hiringStates?: InputMaybe<Array<JobsModeratorsHiringState>>;
  jobSearchStatuses?: InputMaybe<Array<JobsJobSearchStatus>>;
  last?: InputMaybe<Scalars['Int']>;
  oteMax?: InputMaybe<Scalars['Int']>;
  oteMin?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['String']>;
  screened?: InputMaybe<Scalars['Boolean']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<JobsModeratorsInquirySortAttributes>;
  states?: InputMaybe<Array<JobsInquiryState>>;
  tiers?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryJobsModeratorsInquiryArgs = {
  id: Scalars['ID'];
};


export type QueryJobsModeratorsSuggestedInquiriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  vacancyId: Scalars['ID'];
};


export type QueryJobsModeratorsSuggestedVacanciesArgs = {
  inquiryId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryJobsModeratorsVacanciesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerAccountOwnerIds?: InputMaybe<Array<Scalars['ID']>>;
  employerIds?: InputMaybe<Array<Scalars['ID']>>;
  employmentTypes?: InputMaybe<Array<JobsVacancyEmployment>>;
  first?: InputMaybe<Scalars['Int']>;
  isWorkingInSalesSaas?: InputMaybe<Array<Scalars['Boolean']>>;
  last?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Array<JobsRole>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<JobsModeratorsVacancySortAttributes>;
  states?: InputMaybe<Array<JobsVacancyState>>;
};


export type QueryJobsModeratorsVacancyArgs = {
  id: Scalars['ID'];
};


export type QueryJobsRecruitersCandidateArgs = {
  hashid: Scalars['ID'];
};


export type QueryJobsRecruitersCandidatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isAcceptedByEmployer?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Array<JobsRecruitersCandidateState>>;
  vacancyId?: InputMaybe<Scalars['ID']>;
};


export type QueryJobsRecruitersCheckEmployerExistenceArgs = {
  companyId: Scalars['ID'];
};


export type QueryJobsRecruitersCheckRecruiterExistenceArgs = {
  email: Scalars['String'];
};


export type QueryJobsRecruitersCompanyCategorySuggestionsArgs = {
  companyId: Scalars['ID'];
};


export type QueryJobsRecruitersFieldArgs = {
  slug: Scalars['String'];
};


export type QueryJobsRecruitersFieldsArgs = {
  accessLevels?: InputMaybe<Array<JobsFieldsAccessLevel>>;
  availableForRoles?: InputMaybe<Array<JobsRole>>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  popularForRoles?: InputMaybe<Array<JobsRole>>;
  scopes?: InputMaybe<Array<JobsFieldsScope>>;
};


export type QueryJobsRecruitersInquiryArgs = {
  hashId: Scalars['String'];
};


export type QueryJobsRecruitersOteDistributionArgs = {
  useAverageCandidateIntake?: InputMaybe<Scalars['Boolean']>;
  vacancyId: Scalars['ID'];
};


export type QueryJobsRecruitersVacanciesArgs = {
  states?: InputMaybe<Array<JobsVacancyState>>;
};


export type QueryJobsRecruitersVacancyArgs = {
  id: Scalars['ID'];
};


export type QueryJobsRecruitersVacancyPromptTemplatesArgs = {
  employmentType: JobsVacancyEmployment;
  position: JobsRole;
};


export type QueryJobsVacancyArgs = {
  uid: Scalars['String'];
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  kinds?: InputMaybe<Array<NotificationKind>>;
  last?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<Platform>;
};


export type QueryOutgoingConnectionRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryPeopleYouMightKnowArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryPersonalFeedPostsArgs = {
  filterByTopicSlug?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: Scalars['Int'];
};


export type QueryPinnedPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryPortfolioDealArgs = {
  id: Scalars['ID'];
};


export type QueryPostArgs = {
  slug: Scalars['String'];
};


export type QueryPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filterByPopularityType?: InputMaybe<Scalars['String']>;
  filterByTopicSlug?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortType?: InputMaybe<Scalars['String']>;
  tab?: InputMaybe<Scalars['String']>;
};


export type QueryPublicPortfolioConnectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type QueryPublicPortfolioUserArgs = {
  slug: Scalars['String'];
};


export type QueryPublicPortfolioUserTestifySignArgs = {
  slug: Scalars['String'];
};


export type QuerySalesDirectoryProfilesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  prefix: Scalars['String'];
};


export type QuerySalesGptFlexCtaArgs = {
  sessionId: Scalars['String'];
};


export type QuerySalesGptQueryArgs = {
  sessionId: Scalars['String'];
};


export type QuerySearchArgs = {
  filterCategories?: InputMaybe<Array<SearchResultCategory>>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  produceAiSummary?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
};


export type QuerySearchLocationsArgs = {
  countryName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  term?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<LocationType>>;
};


export type QuerySearchUsersArgs = {
  boostUserUsernames?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerySuggestedGeolocationArgs = {
  ip?: InputMaybe<Scalars['String']>;
};


export type QueryTestimonialArgs = {
  sign: Scalars['String'];
};


export type QueryTopicsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryUniversitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryUniversityArgs = {
  slug: Scalars['String'];
};


export type QueryUniversityDegreesArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryUniversityPagesPeopleArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};


export type QueryUniversityPagesSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
};


export type QueryUserArgs = {
  username: Scalars['String'];
};


export type QueryUserPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  username?: InputMaybe<Scalars['String']>;
};


export type QueryUserPublicPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
};


export type QueryUserReferrerArgs = {
  invite: Scalars['String'];
};


export type QueryWarRoomSearchPostsArgs = {
  query?: InputMaybe<Scalars['String']>;
};

export type Rating = {
  __typename?: 'Rating';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  reactable: Reactable;
  reactableId: Scalars['Int'];
  reactableType: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
  value: Scalars['Int'];
};

/** The connection type for Rating. */
export type RatingConnection = {
  __typename?: 'RatingConnection';
  /** A list of edges. */
  edges: Array<RatingEdge>;
  /** A list of nodes. */
  nodes: Array<Rating>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type RatingEdge = {
  __typename?: 'RatingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Rating>;
};

/** Autogenerated input type of ReRequestTestimonialForPublicPortfolioCurrentUser */
export type ReRequestTestimonialForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type Reactable = Comment | Post;

/** Autogenerated input type of ReadAllNotifications */
export type ReadAllNotificationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Platform>;
};

/** Autogenerated input type of ReadNotification */
export type ReadNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated input type of ReadRequests */
export type ReadRequestsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

export type ReadThreadEvent = {
  __typename?: 'ReadThreadEvent';
  readAt: Scalars['ISO8601DateTime'];
  threadId: Scalars['ID'];
};

/** Autogenerated input type of ReadThreadMessages */
export type ReadThreadMessagesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  threadId: Scalars['ID'];
};

/** Autogenerated input type of RefreshInquiry */
export type RefreshInquiryInput = {
  baseSalary: Scalars['Int'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ote: Scalars['Int'];
  quotaAttainmentByTeamPerPeriod?: InputMaybe<Scalars['Int']>;
  quotaAttainmentPerLastYear?: InputMaybe<Scalars['Int']>;
  quotaAttainmentPerPeriod?: InputMaybe<Scalars['Int']>;
  rankOnTeam?: InputMaybe<Scalars['Int']>;
  teamSize?: InputMaybe<Scalars['Int']>;
  unarchivedClientCompanyIds: Array<Scalars['ID']>;
  vpDepartmentSize?: InputMaybe<JobsInquiryVpDepartmentSize>;
};

export type Region = {
  __typename?: 'Region';
  category: Scalars['String'];
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  section: Scalars['String'];
  slug: Scalars['String'];
};

/** The connection type for Region. */
export type RegionConnection = {
  __typename?: 'RegionConnection';
  /** A list of edges. */
  edges: Array<RegionEdge>;
  /** A list of nodes. */
  nodes: Array<Region>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type RegionEdge = {
  __typename?: 'RegionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Region>;
};

/** Autogenerated input type of RejectJobsHiring */
export type RejectJobsHiringInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  rejectionReason?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of RejectRequest */
export type RejectRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RelatedCompany = CompanyInterface & {
  __typename?: 'RelatedCompany';
  employeeCount?: Maybe<Scalars['String']>;
  fullDescription?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  investmentRound?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  shortDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  totalFunding?: Maybe<Scalars['BigInt']>;
  webSiteUrl?: Maybe<Scalars['String']>;
};

export type RelatedCompanyPageResponse = {
  __typename?: 'RelatedCompanyPageResponse';
  category?: Maybe<Scalars['String']>;
  list: Array<RelatedCompany>;
};

/** Autogenerated input type of RemoveConnection */
export type RemoveConnectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};

/** Autogenerated input type of RenewActiveJobStatus */
export type RenewActiveJobStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of ReportSalesGptFeedback */
export type ReportSalesGptFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  feedbackText?: InputMaybe<Scalars['String']>;
  feedbackType: SalesGptFeedback;
  isHarmful?: InputMaybe<Scalars['Boolean']>;
  isIncorrect?: InputMaybe<Scalars['Boolean']>;
  sessionId: Scalars['ID'];
};

export type Request = {
  __typename?: 'Request';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  read: Scalars['Boolean'];
  receiver: RequestParticipant;
  requestee?: Maybe<RequestParticipant>;
  status: Scalars['String'];
};

/** The connection type for Request. */
export type RequestConnection = {
  __typename?: 'RequestConnection';
  /** A list of edges. */
  edges: Array<RequestEdge>;
  /** A list of nodes. */
  nodes: Array<Request>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type RequestEdge = {
  __typename?: 'RequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Request>;
};

export type RequestParticipant = {
  __typename?: 'RequestParticipant';
  avatarUrl?: Maybe<Scalars['String']>;
  currentCompany?: Maybe<Company>;
  currentPosition?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

/** Autogenerated input type of RequestTestimonialForPublicPortfolioCurrentUser */
export type RequestTestimonialForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  emails: Array<Scalars['String']>;
  note: Scalars['String'];
};

export type RoleCategory = {
  __typename?: 'RoleCategory';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SalesDirectoryPage = {
  __typename?: 'SalesDirectoryPage';
  currentPage: Scalars['Int'];
  profiles: Array<SalesDirectoryUser>;
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type SalesDirectoryUser = {
  __typename?: 'SalesDirectoryUser';
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  slug: Scalars['String'];
};

export enum SalesGptFeedback {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type SalesGptQuery = {
  __typename?: 'SalesGptQuery';
  flexCta?: Maybe<Scalars['String']>;
  query: Scalars['String'];
  sessionId?: Maybe<Scalars['ID']>;
  sources?: Maybe<SearchResultInterfaceConnection>;
  summary?: Maybe<Scalars['String']>;
  summaryType: SearchSummaryType;
  wasCompanyPagesDataUsed: Scalars['Boolean'];
  wasExternalDataUsed: Scalars['Boolean'];
};


export type SalesGptQuerySourcesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SalesRole = {
  __typename?: 'SalesRole';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SalesTeamTenureAverage = {
  __typename?: 'SalesTeamTenureAverage';
  average: Scalars['Float'];
  experience: Scalars['Float'];
};

export type SalesTeamTenureAverages = {
  __typename?: 'SalesTeamTenureAverages';
  ae: SalesTeamTenureAverage;
  sdr: SalesTeamTenureAverage;
};

/** Autogenerated input type of SaveSalesGptSummary */
export type SaveSalesGptSummaryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['ID'];
  summary: Scalars['String'];
};

/** Autogenerated input type of SayThanks */
export type SayThanksInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  sessionId: Scalars['ID'];
};

/** Autogenerated input type of ScheduleHiringMeeting */
export type ScheduleHiringMeetingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  hiringId: Scalars['ID'];
  interviewDate: Scalars['ISO8601Date'];
  meetingType: JobsHiringMeeting;
};

export type SearchInfo = {
  __typename?: 'SearchInfo';
  id: Scalars['ID'];
  results: Array<SearchResultsCategory>;
  salesGptQuery?: Maybe<SalesGptQuery>;
};

export enum SearchResultCategory {
  AcademyArticles = 'ACADEMY_ARTICLES',
  Companies = 'COMPANIES',
  CompanyPagesCatalogs = 'COMPANY_PAGES_CATALOGS',
  Content = 'CONTENT',
  UserPortfolios = 'USER_PORTFOLIOS',
  WrComments = 'WR_COMMENTS',
  WrPosts = 'WR_POSTS',
  WrUsers = 'WR_USERS'
}

export type SearchResultInterface = {
  category: Scalars['String'];
};

/** The connection type for SearchResultInterface. */
export type SearchResultInterfaceConnection = {
  __typename?: 'SearchResultInterfaceConnection';
  /** A list of edges. */
  edges: Array<SearchResultInterfaceEdge>;
  /** A list of nodes. */
  nodes: Array<SearchResultInterface>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SearchResultInterfaceEdge = {
  __typename?: 'SearchResultInterfaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SearchResultInterface>;
};

export type SearchResultsCategory = {
  __typename?: 'SearchResultsCategory';
  category: SearchResultCategory;
  items: Array<SearchResultInterface>;
};

export enum SearchSummaryType {
  Certified = 'CERTIFIED',
  CreatePost = 'CREATE_POST',
  Flex = 'FLEX',
  NoResults = 'NO_RESULTS',
  Regular = 'REGULAR'
}

/** Autogenerated input type of SendMessage */
export type SendMessageInput = {
  body: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  mediaSignedBlobId?: InputMaybe<Scalars['String']>;
  otherUserUsername: Scalars['String'];
};

/** Autogenerated input type of SendSuperInvite */
export type SendSuperInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

/** Autogenerated input type of StartTestimonialEndorsingForPublicPortfolioUser */
export type StartTestimonialEndorsingForPublicPortfolioUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  testifySign: Scalars['String'];
};

export type Story = {
  __typename?: 'Story';
  coverContentType?: Maybe<Scalars['String']>;
  coverFileName?: Maybe<Scalars['String']>;
  coverFileSize?: Maybe<Scalars['Int']>;
  coverUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  coverUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  highlightedText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  previewImageUrl?: Maybe<Scalars['String']>;
  rawText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textImageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type Subscription = {
  __typename?: 'Subscription';
  commissionTransactions: CommissionTransactionSubscriptionPayload;
  directMessages: DirectMessagesSubscriptionPayload;
  linkedinProfileImported: LinkedinProfileImportedPayload;
};

export type SuggestedUser = {
  __typename?: 'SuggestedUser';
  avatarUrl?: Maybe<Scalars['String']>;
  currentCompany?: Maybe<Company>;
  currentPosition?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  matchMetadata?: Maybe<GenericMatch>;
  slug: Scalars['String'];
};

/** The connection type for SuggestedUser. */
export type SuggestedUserConnection = {
  __typename?: 'SuggestedUserConnection';
  /** A list of edges. */
  edges: Array<SuggestedUserEdge>;
  /** A list of nodes. */
  nodes: Array<SuggestedUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SuggestedUserEdge = {
  __typename?: 'SuggestedUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SuggestedUser>;
};

export type Testimonial = {
  __typename?: 'Testimonial';
  author: TestimonialAuthor;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  requestor: TestimonialRequestor;
  sign: Scalars['String'];
  skills: Array<Scalars['String']>;
  state: TestimonialState;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type TestimonialAuthor = {
  __typename?: 'TestimonialAuthor';
  avatarUrl?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
};

export type TestimonialRequestor = {
  __typename?: 'TestimonialRequestor';
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export enum TestimonialState {
  Approving = 'approving',
  Archived = 'archived',
  Declined = 'declined',
  Failed = 'failed',
  New = 'new',
  OnLinkedinVerification = 'on_linkedin_verification',
  OnManualVerification = 'on_manual_verification',
  Requested = 'requested',
  Verified = 'verified'
}

export type Thread = {
  __typename?: 'Thread';
  id: Scalars['ID'];
  lastMessage?: Maybe<Message>;
  messages: MessageConnection;
  otherUser: User;
  unreadMessages: Scalars['Int'];
};


export type ThreadMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type Tooltip = {
  __typename?: 'Tooltip';
  name: Scalars['String'];
};

export type Topic = {
  __typename?: 'Topic';
  author: User;
  category: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  emoji: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  posts: PostConnection;
  slug: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};


export type TopicPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Topic. */
export type TopicConnection = {
  __typename?: 'TopicConnection';
  /** A list of edges. */
  edges: Array<TopicEdge>;
  /** A list of nodes. */
  nodes: Array<Topic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TopicEdge = {
  __typename?: 'TopicEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Topic>;
};

export type TotalCompensationRange = {
  __typename?: 'TotalCompensationRange';
  maxCompensationRange: Scalars['Float'];
  minCompensationRange: Scalars['Float'];
};

/** Autogenerated input type of TriggerContactsFetching */
export type TriggerContactsFetchingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of TriggerLinkedinScraping */
export type TriggerLinkedinScrapingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UnblockUser */
export type UnblockUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  otherUserUsername: Scalars['String'];
};

/** Autogenerated input type of UndoTestimonialForPublicPortfolioCurrentUser */
export type UndoTestimonialForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type University = {
  __typename?: 'University';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  custom: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  parent?: Maybe<University>;
  slug?: Maybe<Scalars['String']>;
  verified: Scalars['Boolean'];
  websiteUrl?: Maybe<Scalars['String']>;
};

/** The connection type for University. */
export type UniversityConnection = {
  __typename?: 'UniversityConnection';
  /** A list of edges. */
  edges: Array<UniversityEdge>;
  /** A list of nodes. */
  nodes: Array<University>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UniversityEdge = {
  __typename?: 'UniversityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<University>;
};

export type UniversityMatch = {
  __typename?: 'UniversityMatch';
  type: Scalars['String'];
  universityName: Scalars['String'];
};

/** Autogenerated input type of UpdateArticle */
export type UpdateArticleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  markdown: Scalars['String'];
  slug: Scalars['String'];
};

/** Autogenerated input type of UpdateAwardForPublicPortfolioCurrentUser */
export type UpdateAwardForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of UpdateClientForPublicPortfolioCurrentUser */
export type UpdateClientForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isPublic: Scalars['Boolean'];
};

/** Autogenerated input type of UpdateClientPositionForPublicPortfolioCurrentUser */
export type UpdateClientPositionForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  position: Scalars['Int'];
};

/** Autogenerated input type of UpdateComment */
export type UpdateCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  media?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

/** Autogenerated input type of UpdateConfigurationForPublicPortfolioCurrentUser */
export type UpdateConfigurationForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fieldCalendarLinkIsPublic?: InputMaybe<Scalars['Boolean']>;
  fieldLinkedinSlugIsPublic?: InputMaybe<Scalars['Boolean']>;
  fieldPhoneIsPublic?: InputMaybe<Scalars['Boolean']>;
  fieldPublicEmailIsPublic?: InputMaybe<Scalars['Boolean']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  sectionAwardsIsPublic?: InputMaybe<Scalars['Boolean']>;
  sectionClientsIsPublic?: InputMaybe<Scalars['Boolean']>;
  sectionConnectionsIsPublic?: InputMaybe<Scalars['Boolean']>;
  sectionContactsIsPublic?: InputMaybe<Scalars['Boolean']>;
  sectionEducationHistoriesIsPublic?: InputMaybe<Scalars['Boolean']>;
  sectionHeadlineIsPublic?: InputMaybe<Scalars['Boolean']>;
  sectionSalesExperienceIsPublic?: InputMaybe<Scalars['Boolean']>;
  sectionTestimonialsIsPublic?: InputMaybe<Scalars['Boolean']>;
  sectionWorkHistoriesIsPublic?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of UpdateCurrentPortfolioUser */
export type UpdateCurrentPortfolioUserInput = {
  cityId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customerSegmentId?: InputMaybe<Scalars['ID']>;
  industryId?: InputMaybe<Scalars['ID']>;
  productTypeIds: Array<Scalars['ID']>;
};

/** Autogenerated input type of UpdateCurrentUser */
export type UpdateCurrentUserInput = {
  calendarLink?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['Int']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  departmentIds?: InputMaybe<Array<Scalars['Int']>>;
  fakeVacancyIds?: InputMaybe<Array<Scalars['Int']>>;
  firstname?: InputMaybe<Scalars['String']>;
  hasSeenNewReferProgram?: InputMaybe<Scalars['Boolean']>;
  lastname?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  onboardingVacancyUid?: InputMaybe<Scalars['ID']>;
  personalEmail?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  productTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  publicEmail?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  unarchivedClientCompanyIds?: InputMaybe<Array<Scalars['ID']>>;
  username?: InputMaybe<Scalars['String']>;
  warRoomAvatar?: InputMaybe<Scalars['String']>;
  warRoomCompanySeriesStageIds?: InputMaybe<Array<Scalars['Int']>>;
  warRoomCompanyStageIds?: InputMaybe<Array<Scalars['Int']>>;
  warRoomCustomerSegmentIds?: InputMaybe<Array<Scalars['Int']>>;
  warRoomDescription?: InputMaybe<Scalars['String']>;
  warRoomIndustryIds?: InputMaybe<Array<Scalars['Int']>>;
  warRoomJobSearchStatus?: InputMaybe<Scalars['String']>;
  warRoomPosition?: InputMaybe<Scalars['String']>;
  warRoomSalesRoleIds?: InputMaybe<Array<Scalars['Int']>>;
  warRoomYearsOfExperience?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of UpdateDeal */
export type UpdateDealInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isPrivateCompany?: InputMaybe<Scalars['Boolean']>;
  isPrivateDepartments?: InputMaybe<Scalars['Boolean']>;
  post?: InputMaybe<DealStoryPostAttributes>;
};

/** Autogenerated input type of UpdateEducationHistoryForPublicPortfolioCurrentUser */
export type UpdateEducationHistoryForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  degreeName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  fieldOfStudy?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  universityId: Scalars['ID'];
};

/** Autogenerated input type of UpdateInquiry */
export type UpdateInquiryInput = {
  accomplishments?: InputMaybe<Scalars['String']>;
  aeLeadSourceOther?: InputMaybe<Scalars['String']>;
  aeLeadSourcesMain?: InputMaybe<Array<JobsInquiryAeLeadSource>>;
  aeQuotaPerPeriod?: InputMaybe<Scalars['Int']>;
  aeQuotaTypeMain?: InputMaybe<JobsInquiryAeQuota>;
  aeQuotaTypeOther?: InputMaybe<Scalars['String']>;
  baseSalary?: InputMaybe<Scalars['Int']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  csmAccountsNumber?: InputMaybe<JobsInquiryCsmAccountNumber>;
  csmQuotaMetricMain?: InputMaybe<Array<JobsInquiryCsmQuotaMetric>>;
  csmQuotaMetricOther?: InputMaybe<Scalars['String']>;
  csmQuotaPeriodMain?: InputMaybe<JobsInquiryCsmQuotaPeriod>;
  csmQuotaPeriodOther?: InputMaybe<Scalars['String']>;
  csmQuotaTypeMain?: InputMaybe<JobsInquiryCsmQuota>;
  csmQuotaTypeOther?: InputMaybe<Scalars['String']>;
  csmRenewalValue?: InputMaybe<JobsInquiryCsmRenewalValue>;
  csmTotalBusinessValue?: InputMaybe<JobsInquiryCsmBusinessValue>;
  csmUpsellValue?: InputMaybe<JobsInquiryCsmUpsellValue>;
  currency?: InputMaybe<Currency>;
  dealBreakerOther?: InputMaybe<Scalars['String']>;
  dealBreakersMain?: InputMaybe<Array<JobsInquiryDealBreaker>>;
  dealSize?: InputMaybe<JobsInquiryDealSize>;
  desiredCompanySeriesStageIds?: InputMaybe<Array<Scalars['Int']>>;
  employmentTypes?: InputMaybe<Array<JobsInquiryEmployment>>;
  fakeHiring?: InputMaybe<InquiryFakeHiringAttributes>;
  flexAppliedCriteria?: InputMaybe<Array<JobsFlexAppliedCriteria>>;
  flexBandwidth?: InputMaybe<JobsFlexBandwidth>;
  flexBriefVideoUrl?: InputMaybe<Scalars['String']>;
  flexConsideredCompanyTypes?: InputMaybe<Array<JobsFlexFlexConsideredCompanyType>>;
  flexOnboardingState?: InputMaybe<Scalars['String']>;
  flexPreviousExperience?: InputMaybe<Scalars['String']>;
  flexRating?: InputMaybe<Scalars['Float']>;
  flexReasonForParticipation?: InputMaybe<Scalars['String']>;
  flexRoles?: InputMaybe<Array<JobsFlexRole>>;
  flexState?: InputMaybe<Scalars['String']>;
  flexUnderstandingOfSales?: InputMaybe<Scalars['String']>;
  idealJobDescription?: InputMaybe<Scalars['String']>;
  onboardingState?: InputMaybe<JobsInquiryOnboardingState>;
  ote?: InputMaybe<Scalars['Int']>;
  positionMain?: InputMaybe<JobsInquiryPosition>;
  positionOther?: InputMaybe<Scalars['String']>;
  quotaAttainmentByTeamPerPeriod?: InputMaybe<Scalars['Int']>;
  quotaAttainmentPerLastYear?: InputMaybe<Scalars['Int']>;
  quotaAttainmentPerPeriod?: InputMaybe<Scalars['Int']>;
  rankOnTeam?: InputMaybe<Scalars['Int']>;
  revenue?: InputMaybe<Scalars['Int']>;
  salesCycleLength?: InputMaybe<JobsInquirySalesCycleLength>;
  salesMethodologies?: InputMaybe<Array<JobsInquirySalesMethodology>>;
  sdrQuotaPerPeriod?: InputMaybe<Scalars['String']>;
  sdrQuotaTypes?: InputMaybe<Array<JobsInquirySdrQuota>>;
  source?: InputMaybe<JobsInquirySource>;
  teamSize?: InputMaybe<Scalars['Int']>;
  vpDepartmentSize?: InputMaybe<JobsInquiryVpDepartmentSize>;
  vpManagedRoles?: InputMaybe<Array<JobsInquiryVpManagedRole>>;
  vpQuotaType?: InputMaybe<JobsInquiryVpQuota>;
  vpResponsibilities?: InputMaybe<Scalars['String']>;
  willingToRelocate?: InputMaybe<Scalars['Boolean']>;
  workHistoryId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated input type of UpdatePost */
export type UpdatePostInput = {
  category?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<Scalars['String']>>;
  link?: InputMaybe<Scalars['String']>;
  poll?: InputMaybe<PollAttributes>;
  slug: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  topicIds?: InputMaybe<Array<Scalars['Int']>>;
};

/** Autogenerated input type of UpdatePublicPortfolioCurrentUser */
export type UpdatePublicPortfolioCurrentUserInput = {
  avatarSignedBlobId?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactsEmail?: InputMaybe<Scalars['String']>;
  currentCompanyId?: InputMaybe<Scalars['ID']>;
  currentPosition?: InputMaybe<Scalars['String']>;
  departmentIds?: InputMaybe<Array<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  industryIds?: InputMaybe<Array<Scalars['ID']>>;
  lastname?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  productTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  slug?: InputMaybe<Scalars['String']>;
  yearsOfExperience?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of UpdateTestimonialPositionForPublicPortfolioCurrentUser */
export type UpdateTestimonialPositionForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  newPosition: Scalars['Int'];
};

/** Autogenerated input type of UpdateWorkHistoryForPublicPortfolioCurrentUser */
export type UpdateWorkHistoryForPublicPortfolioCurrentUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  currentWorkplace?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpsertDealQuarter */
export type UpsertDealQuarterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  quarter: Scalars['Int'];
  quota?: InputMaybe<Scalars['Float']>;
  revenue?: InputMaybe<Scalars['Float']>;
  year: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  abTests?: Maybe<Array<Scalars['String']>>;
  achievements?: Maybe<Array<UserAchievement>>;
  achievementsProgress?: Maybe<Array<UserAchievement>>;
  address?: Maybe<Scalars['String']>;
  admin?: Maybe<Scalars['Boolean']>;
  autoName?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['ISO8601Date']>;
  calendarLink?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  commentsCount: Scalars['Int'];
  company?: Maybe<Company>;
  companySeriesStages?: Maybe<Array<CompanySeriesStage>>;
  companyStages?: Maybe<Array<CompanyStage>>;
  contacts?: Maybe<Array<UserContact>>;
  createdAt: Scalars['ISO8601DateTime'];
  departmentIds?: Maybe<Array<Scalars['Int']>>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  enabledFeatures?: Maybe<Array<Scalars['String']>>;
  facebookUrl?: Maybe<Scalars['String']>;
  fakeVacancyIds: Array<Scalars['Int']>;
  firstname?: Maybe<Scalars['String']>;
  hasSeenNewReferProgram?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  industries?: Maybe<Array<Industry>>;
  industry?: Maybe<Scalars['String']>;
  instagramUrl?: Maybe<Scalars['String']>;
  inviteReferrerUser?: Maybe<User>;
  languages?: Maybe<Scalars['String']>;
  lastColleaguesSyncError?: Maybe<Scalars['String']>;
  lastColleaguesSyncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastContactsSyncError?: Maybe<Scalars['String']>;
  lastContactsSyncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastLinkedinSyncError?: Maybe<Scalars['String']>;
  lastLinkedinSyncedAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastSeenAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastname?: Maybe<Scalars['String']>;
  linkedinProfilePicUrl?: Maybe<Scalars['String']>;
  linkedinSlug?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  marker?: Maybe<Scalars['String']>;
  onboardingState: Scalars['String'];
  onboardingVacancy?: Maybe<JobsVacancy>;
  orderPosition?: Maybe<Scalars['Int']>;
  personalEmail?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  posts?: Maybe<Array<Post>>;
  postsCount: Scalars['Int'];
  prevScore?: Maybe<Scalars['Int']>;
  privateHash: Scalars['String'];
  productTypeIds?: Maybe<Array<Scalars['Int']>>;
  productTypes?: Maybe<Array<ProductType>>;
  public: Scalars['Boolean'];
  publicEmail?: Maybe<Scalars['String']>;
  referralsCount: Scalars['Int'];
  role?: Maybe<Scalars['String']>;
  salesRoles?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  solidClients?: Maybe<Array<Client>>;
  submittedCompaniesData: Scalars['Boolean'];
  superInviteMarker?: Maybe<Scalars['String']>;
  tooltips?: Maybe<Array<Scalars['String']>>;
  toured?: Maybe<Scalars['Boolean']>;
  twitterUrl?: Maybe<Scalars['String']>;
  uiTheme?: Maybe<Scalars['String']>;
  unreadConnectionRequestsCount: Scalars['Int'];
  unreadWarRoomNotifications?: Maybe<Scalars['Boolean']>;
  unseenWarRoomNotifications?: Maybe<Scalars['Boolean']>;
  unusedSuperInvitesCount: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  username?: Maybe<Scalars['String']>;
  warRoomAvatarUrl?: Maybe<Scalars['String']>;
  warRoomCompanySeriesStageIds?: Maybe<Array<Scalars['Int']>>;
  warRoomCompanyStageIds?: Maybe<Array<Scalars['Int']>>;
  warRoomCurrentBalance?: Maybe<Scalars['Int']>;
  warRoomDescription?: Maybe<Scalars['String']>;
  warRoomIndustryIds?: Maybe<Array<Scalars['Int']>>;
  warRoomJobSearchStatus?: Maybe<Scalars['String']>;
  warRoomJobSearchStatusExpiredAt?: Maybe<Scalars['ISO8601DateTime']>;
  warRoomPosition?: Maybe<Scalars['String']>;
  warRoomSalesRoleIds?: Maybe<Array<Scalars['Int']>>;
  warRoomSalesRoles?: Maybe<Array<SalesRole>>;
  warRoomState: Scalars['String'];
  warRoomTotalBalance?: Maybe<Scalars['Int']>;
  warRoomYearsOfExperience?: Maybe<Scalars['Int']>;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type UserUnreadWarRoomNotificationsArgs = {
  platform?: InputMaybe<Platform>;
};


export type UserUnseenWarRoomNotificationsArgs = {
  platform?: InputMaybe<Platform>;
};

export type UserAchievement = {
  __typename?: 'UserAchievement';
  achieved?: Maybe<Scalars['String']>;
  helpMessage?: Maybe<Scalars['String']>;
  level: Scalars['String'];
  slug: Scalars['String'];
  stateMessage: Scalars['String'];
  title: Scalars['String'];
};

export type UserAuthor = Anonymous | Public;

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** A list of nodes. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserContact = ConnectionSuggestionInterface & {
  __typename?: 'UserContact';
  emails: Array<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  position?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserPost = {
  __typename?: 'UserPost';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['Int'];
  post: Post;
  postId: Scalars['Int'];
  postViewedAt: Scalars['ISO8601DateTime'];
  updatedAt: Scalars['ISO8601DateTime'];
  user: User;
};

/** The connection type for UserPost. */
export type UserPostConnection = {
  __typename?: 'UserPostConnection';
  /** A list of edges. */
  edges: Array<UserPostEdge>;
  /** A list of nodes. */
  nodes: Array<UserPost>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserPostEdge = {
  __typename?: 'UserPostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<UserPost>;
};

export type UserSearch = {
  __typename?: 'UserSearch';
  username?: Maybe<Scalars['String']>;
  warRoomAvatarUrl?: Maybe<Scalars['String']>;
};

export type VendorDbUser = {
  __typename?: 'VendorDbUser';
  company?: Maybe<Scalars['String']>;
  emails: Array<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  linkedinSlug: Scalars['String'];
  position?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ViewAllNotifications */
export type ViewAllNotificationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Platform>;
};

export type WarRoomPostCommentSearchResult = SearchResultInterface & {
  __typename?: 'WarRoomPostCommentSearchResult';
  category: Scalars['String'];
  highlightedText: HighlightedText;
  record: Comment;
};

export type WarRoomPostSearchResult = SearchResultInterface & {
  __typename?: 'WarRoomPostSearchResult';
  category: Scalars['String'];
  comments?: Maybe<Array<WarRoomPostCommentSearchResult>>;
  post: Post;
};

export type WarRoomUserSearchResult = SearchResultInterface & {
  __typename?: 'WarRoomUserSearchResult';
  category: Scalars['String'];
  warRoomUser?: Maybe<User>;
};

export type WorkHistory = {
  __typename?: 'WorkHistory';
  company?: Maybe<Company>;
  currentWorkplace: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
  title?: Maybe<Scalars['String']>;
};

export type WorkHistoryMatch = {
  __typename?: 'WorkHistoryMatch';
  companyName: Scalars['String'];
  companySlug: Scalars['String'];
  positionName: Scalars['String'];
  type: Scalars['String'];
};

export type YoutubeLink = {
  __typename?: 'YoutubeLink';
  coverUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  highlightedText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  link: Scalars['String'];
  previewImageUrl?: Maybe<Scalars['String']>;
  rawText?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textImageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type CityFragmentFragment = { __typename?: 'City', id: string, name: string, stateCode?: string | null | undefined, countryName: string, countryCode: string };

export type CompanyFragmentFragment = { __typename?: 'Company', id: string, logoUrl?: string | null | undefined, name: string };

type DealPreview_Deal_Fragment = { __typename?: 'Deal', id: string, closeDate: any, amount: number, isPrivateCompany: boolean, isPrivateDepartments: boolean, departments?: Array<{ __typename?: 'Department', id: string, name: string }> | null | undefined, company?: { __typename?: 'Company', id: string, name: string } | null | undefined, post?: { __typename?: 'Post', id: string, slug: string, content: { __typename?: 'DealStory', id: number, text?: string | null | undefined } | { __typename?: 'Link' } | { __typename?: 'LinkedinPost' } | { __typename?: 'Story' } | { __typename?: 'YoutubeLink' } } | null | undefined };

type DealPreview_PortfolioDeal_Fragment = { __typename?: 'PortfolioDeal', id: string, closeDate: any, amount: number, isPrivateCompany: boolean, isPrivateDepartments: boolean, departments?: Array<{ __typename?: 'Department', id: string, name: string }> | null | undefined, company?: { __typename?: 'Company', id: string, name: string } | null | undefined, post?: { __typename?: 'Post', id: string, slug: string, content: { __typename?: 'DealStory', id: number, text?: string | null | undefined } | { __typename?: 'Link' } | { __typename?: 'LinkedinPost' } | { __typename?: 'Story' } | { __typename?: 'YoutubeLink' } } | null | undefined };

export type DealPreviewFragment = DealPreview_Deal_Fragment | DealPreview_PortfolioDeal_Fragment;

export type CommentPreviewFragment = { __typename?: 'Comment', id: string, text: string, deletedAt?: any | null | undefined, author: { __typename: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename: 'Public', slug: string, firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined }, post: { __typename?: 'Post', slug: string } };

export type JobsHiringPreviewFragment = { __typename?: 'JobsHiring', id: string, hashid: string, employer: { __typename?: 'JobsEmployer', id: string, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } }, vacancy?: { __typename?: 'JobsVacancy', id: string, title: string, primaryRecruiter?: { __typename?: 'JobsRecruiter', firstname?: string | null | undefined, lastname?: string | null | undefined } | null | undefined } | null | undefined };

export type PostPreviewFragment = { __typename?: 'Post', slug: string, archivedAt?: any | null | undefined, author: { __typename: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename: 'Public', slug: string, firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined }, content: { __typename?: 'DealStory' } | { __typename?: 'Link', id: number, title: string } | { __typename?: 'LinkedinPost', id: number, title: string } | { __typename?: 'Story', id: number, title: string, rawText?: string | null | undefined } | { __typename?: 'YoutubeLink', id: number, title: string } };

export type RatingPreviewFragment = { __typename?: 'Rating', id: string, value: number, user: { __typename?: 'User', username?: string | null | undefined, avatarUrl?: string | null | undefined }, reactable: { __typename?: 'Comment', id: string, text: string, deletedAt?: any | null | undefined, author: { __typename: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename: 'Public', slug: string, firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined }, post: { __typename?: 'Post', slug: string } } | { __typename?: 'Post', slug: string, archivedAt?: any | null | undefined, author: { __typename: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename: 'Public', slug: string, firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined }, content: { __typename?: 'DealStory' } | { __typename?: 'Link', id: number, title: string } | { __typename?: 'LinkedinPost', id: number, title: string } | { __typename?: 'Story', id: number, title: string, rawText?: string | null | undefined } | { __typename?: 'YoutubeLink', id: number, title: string } } };

export type TestimonialPreviewFragment = { __typename?: 'Testimonial', id: string, requestor: { __typename?: 'TestimonialRequestor', slug: string }, author: { __typename?: 'TestimonialAuthor', firstname?: string | null | undefined, lastname?: string | null | undefined } };

export type UserPreviewFragment = { __typename?: 'User', username?: string | null | undefined, avatarUrl?: string | null | undefined };

export type ConfigurationFragmentFragment = { __typename?: 'PublicPortfolioConfiguration', fieldCalendarLinkIsPublic: boolean, fieldLinkedinSlugIsPublic: boolean, fieldPhoneIsPublic: boolean, fieldPublicEmailIsPublic: boolean, isPublic: boolean, sectionAwardsIsPublic: boolean, sectionClientsIsPublic: boolean, sectionConnectionsIsPublic: boolean, sectionContactsIsPublic: boolean, sectionHeadlineIsPublic: boolean, sectionSalesExperienceIsPublic: boolean, sectionTestimonialsIsPublic: boolean, sectionWorkHistoriesIsPublic: boolean, sectionEducationHistoriesIsPublic: boolean };

export type PortfolioCurrentUserFragmentFragment = { __typename?: 'CurrentUser', id: string, avatarUrl?: string | null | undefined, autoName?: string | null | undefined, firstname?: string | null | undefined, lastname?: string | null | undefined, phone?: string | null | undefined, publicEmail?: string | null | undefined, warRoomYearsOfExperience?: number | null | undefined, position?: string | null | undefined, linkedinSlug?: string | null | undefined, warRoomJobSearchStatus?: string | null | undefined, linkedinUrl?: string | null | undefined, calendarLink?: string | null | undefined, departmentIds?: Array<number> | null | undefined, productTypeIds?: Array<number> | null | undefined, warRoomIndustryIds?: Array<number> | null | undefined, warRoomCompanyStageIds?: Array<number> | null | undefined, warRoomSalesRoleIds?: Array<number> | null | undefined, warRoomCompanySeriesStageIds?: Array<number> | null | undefined, slug: string, company?: { __typename?: 'Company', id: string, logoUrl?: string | null | undefined, name: string } | null | undefined, city?: { __typename?: 'City', id: string, name: string, stateCode?: string | null | undefined, countryName: string, countryCode: string } | null | undefined, solidClients?: Array<{ __typename?: 'Client', id: string, isPublic: boolean, position?: number | null | undefined, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined, companyPagesSlug?: string | null | undefined } }> | null | undefined, departments?: Array<{ __typename?: 'Department', id: string, name: string }> | null | undefined, companyStages?: Array<{ __typename?: 'CompanyStage', id: string, name: string }> | null | undefined, warRoomSalesRoles?: Array<{ __typename?: 'SalesRole', id: string, name: string }> | null | undefined, industries?: Array<{ __typename?: 'Industry', id: string, name: string }> | null | undefined, productTypes?: Array<{ __typename?: 'ProductType', id: number, name: string }> | null | undefined, companySeriesStages?: Array<{ __typename?: 'CompanySeriesStage', id: string, name: string, slug: CompanySeriesStageSlug }> | null | undefined };

export type EducationHistoryFragmentFragment = { __typename?: 'EducationHistory', id?: string | null | undefined, degreeName?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, manuallyEdited: boolean, university?: { __typename?: 'University', id: string, slug?: string | null | undefined, name: string, logoUrl?: string | null | undefined, custom: boolean, verified: boolean, parent?: { __typename?: 'University', slug?: string | null | undefined, name: string, logoUrl?: string | null | undefined } | null | undefined } | null | undefined };

export type TestimonialFragmentFragment = { __typename?: 'Testimonial', id: string, sign: string, skills: Array<string>, position?: number | null | undefined, description?: string | null | undefined, state: TestimonialState, author: { __typename?: 'TestimonialAuthor', email?: string | null | undefined, avatarUrl?: string | null | undefined, firstname?: string | null | undefined, jobTitle?: string | null | undefined, lastname?: string | null | undefined }, requestor: { __typename?: 'TestimonialRequestor', firstname?: string | null | undefined, lastname?: string | null | undefined, slug: string } };

export type UpdateArticleMutationVariables = Exact<{
  input: UpdateArticleInput;
}>;


export type UpdateArticleMutation = { __typename?: 'Mutation', updateAcademyArticle?: { __typename?: 'Article', html?: string | null | undefined, markdown?: string | null | undefined } | null | undefined };

export type CreateConnectionsMutationVariables = Exact<{
  input: CreateConnectionsInput;
}>;


export type CreateConnectionsMutation = { __typename?: 'Mutation', createConnections?: boolean | null | undefined };

export type CreateDealsMutationVariables = Exact<{
  input: CreateDealsInput;
}>;


export type CreateDealsMutation = { __typename?: 'Mutation', createDeals?: Array<{ __typename?: 'PortfolioDeal', id: string, closeDate: any, amount: number, isPrivateCompany: boolean, isPrivateDepartments: boolean, departments?: Array<{ __typename?: 'Department', id: string, name: string }> | null | undefined, company?: { __typename?: 'Company', id: string, name: string } | null | undefined, post?: { __typename?: 'Post', id: string, slug: string, content: { __typename?: 'DealStory', id: number, text?: string | null | undefined } | { __typename?: 'Link' } | { __typename?: 'LinkedinPost' } | { __typename?: 'Story' } | { __typename?: 'YoutubeLink' } } | null | undefined }> | null | undefined };

export type CreateDealsSourceMutationVariables = Exact<{
  input: CreateDealsSourceInput;
}>;


export type CreateDealsSourceMutation = { __typename?: 'Mutation', createDealsSource?: { __typename?: 'PortfolioDealsSource', id: string } | null | undefined };

export type DestroyDealMutationVariables = Exact<{
  input: DestroyDealInput;
}>;


export type DestroyDealMutation = { __typename?: 'Mutation', destroyDeal?: { __typename?: 'PortfolioDeal', id: string } | null | undefined };

export type FlagIssueMutationVariables = Exact<{
  input: FlagIssueInput;
}>;


export type FlagIssueMutation = { __typename?: 'Mutation', flagIssue?: number | null | undefined };

export type ActivateJobsInquiryMutationVariables = Exact<{
  input: ActivateJobsInquiryInput;
}>;


export type ActivateJobsInquiryMutation = { __typename?: 'Mutation', activateJobsInquiry?: { __typename?: 'JobsInquiry', id: string, lastActiveAt?: any | null | undefined, activable: boolean } | null | undefined };

export type FireJobsHiringEventMutationVariables = Exact<{
  input: FireHiringEventInput;
}>;


export type FireJobsHiringEventMutation = { __typename?: 'Mutation', fireJobsHiringEvent?: { __typename?: 'JobsHiring', id: string } | null | undefined };

export type RejectJobsHiringMutationVariables = Exact<{
  input: RejectJobsHiringInput;
}>;


export type RejectJobsHiringMutation = { __typename?: 'Mutation', rejectJobsHiring?: boolean | null | undefined };

export type AcceptConnectionRequestMutationVariables = Exact<{
  input: AcceptRequestInput;
}>;


export type AcceptConnectionRequestMutation = { __typename?: 'Mutation', incomingConnectionRequest?: { __typename?: 'Request', id: string, status: string } | null | undefined };

export type ApproveTestimonialForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: ApproveTestimonialForPublicPortfolioCurrentUserInput;
}>;


export type ApproveTestimonialForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', approveTestimonialForPublicPortfolioCurrentUser?: { __typename?: 'Testimonial', state: TestimonialState } | null | undefined };

export type ArchiveTestimonialForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: ArchiveTestimonialForPublicPortfolioCurrentUserInput;
}>;


export type ArchiveTestimonialForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', archiveTestimonialForPublicPortfolioCurrentUser?: { __typename?: 'Testimonial', state: TestimonialState } | null | undefined };

export type CancelConnectionRequestMutationVariables = Exact<{
  input: CancelRequestInput;
}>;


export type CancelConnectionRequestMutation = { __typename?: 'Mutation', cancelConnectionRequest?: boolean | null | undefined };

export type CreateConnectionRequestMutationVariables = Exact<{
  input: CreateRequestInput;
}>;


export type CreateConnectionRequestMutation = { __typename?: 'Mutation', outgoingConnectionRequest?: { __typename?: 'Request', id: string, status: string } | null | undefined };

export type DestroyTestimonialForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: DestroyTestimonialForPublicPortfolioCurrentUserInput;
}>;


export type DestroyTestimonialForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', destroyTestimonialForPublicPortfolioCurrentUser?: { __typename?: 'Testimonial', state: TestimonialState } | null | undefined };

export type EndorseTestimonialForPublicPortfolioUserMutationVariables = Exact<{
  input: EndorseTestimonialForPublicPortfolioUserInput;
}>;


export type EndorseTestimonialForPublicPortfolioUserMutation = { __typename?: 'Mutation', endorseTestimonialForPublicPortfolioUser?: { __typename?: 'Testimonial', skills: Array<string>, sign: string, description?: string | null | undefined, author: { __typename?: 'TestimonialAuthor', firstname?: string | null | undefined, lastname?: string | null | undefined } } | null | undefined };

export type PortfolioUpdateCurrentUserMutationMutationVariables = Exact<{
  input: UpdateCurrentUserInput;
}>;


export type PortfolioUpdateCurrentUserMutationMutation = { __typename?: 'Mutation', updateCurrentUser?: { __typename?: 'CurrentUser', id: string, avatarUrl?: string | null | undefined, autoName?: string | null | undefined, firstname?: string | null | undefined, lastname?: string | null | undefined, phone?: string | null | undefined, publicEmail?: string | null | undefined, warRoomYearsOfExperience?: number | null | undefined, position?: string | null | undefined, linkedinSlug?: string | null | undefined, warRoomJobSearchStatus?: string | null | undefined, linkedinUrl?: string | null | undefined, calendarLink?: string | null | undefined, departmentIds?: Array<number> | null | undefined, productTypeIds?: Array<number> | null | undefined, warRoomIndustryIds?: Array<number> | null | undefined, warRoomCompanyStageIds?: Array<number> | null | undefined, warRoomSalesRoleIds?: Array<number> | null | undefined, warRoomCompanySeriesStageIds?: Array<number> | null | undefined, slug: string, company?: { __typename?: 'Company', id: string, logoUrl?: string | null | undefined, name: string } | null | undefined, city?: { __typename?: 'City', id: string, name: string, stateCode?: string | null | undefined, countryName: string, countryCode: string } | null | undefined, solidClients?: Array<{ __typename?: 'Client', id: string, isPublic: boolean, position?: number | null | undefined, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined, companyPagesSlug?: string | null | undefined } }> | null | undefined, departments?: Array<{ __typename?: 'Department', id: string, name: string }> | null | undefined, companyStages?: Array<{ __typename?: 'CompanyStage', id: string, name: string }> | null | undefined, warRoomSalesRoles?: Array<{ __typename?: 'SalesRole', id: string, name: string }> | null | undefined, industries?: Array<{ __typename?: 'Industry', id: string, name: string }> | null | undefined, productTypes?: Array<{ __typename?: 'ProductType', id: number, name: string }> | null | undefined, companySeriesStages?: Array<{ __typename?: 'CompanySeriesStage', id: string, name: string, slug: CompanySeriesStageSlug }> | null | undefined } | null | undefined };

export type ReRequestTestimonialForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: ReRequestTestimonialForPublicPortfolioCurrentUserInput;
}>;


export type ReRequestTestimonialForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', reRequestTestimonialForPublicPortfolioCurrentUser?: { __typename?: 'Testimonial', state: TestimonialState } | null | undefined };

export type ReadConnectionRequestsMutationVariables = Exact<{
  input: ReadRequestsInput;
}>;


export type ReadConnectionRequestsMutation = { __typename?: 'Mutation', readConnectionRequests?: Array<{ __typename?: 'Request', id: string, status: string }> | null | undefined };

export type RejectConnectionRequestMutationVariables = Exact<{
  input: RejectRequestInput;
}>;


export type RejectConnectionRequestMutation = { __typename?: 'Mutation', incomingConnectionRequest?: { __typename?: 'Request', id: string, status: string } | null | undefined };

export type RemoveConnectionMutationVariables = Exact<{
  input: RemoveConnectionInput;
}>;


export type RemoveConnectionMutation = { __typename?: 'Mutation', removeConnection?: boolean | null | undefined };

export type RequestTestimonialForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: RequestTestimonialForPublicPortfolioCurrentUserInput;
}>;


export type RequestTestimonialForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', requestTestimonialForPublicPortfolioCurrentUser?: Array<{ __typename?: 'Testimonial', id: string, sign: string, skills: Array<string>, position?: number | null | undefined, description?: string | null | undefined, state: TestimonialState, author: { __typename?: 'TestimonialAuthor', email?: string | null | undefined, avatarUrl?: string | null | undefined, firstname?: string | null | undefined, jobTitle?: string | null | undefined, lastname?: string | null | undefined }, requestor: { __typename?: 'TestimonialRequestor', firstname?: string | null | undefined, lastname?: string | null | undefined, slug: string } }> | null | undefined };

export type StartTestimonialEndorsingForPublicPortfolioUserMutationVariables = Exact<{
  input: StartTestimonialEndorsingForPublicPortfolioUserInput;
}>;


export type StartTestimonialEndorsingForPublicPortfolioUserMutation = { __typename?: 'Mutation', startTestimonialEndorsingForPublicPortfolioUser?: { __typename?: 'Testimonial', sign: string } | null | undefined };

export type TriggerLinkedInScrapingMutationVariables = Exact<{
  input: TriggerLinkedinScrapingInput;
}>;


export type TriggerLinkedInScrapingMutation = { __typename?: 'Mutation', triggerLinkedinScraping?: boolean | null | undefined };

export type UndoTestimonialForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: UndoTestimonialForPublicPortfolioCurrentUserInput;
}>;


export type UndoTestimonialForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', undoTestimonialForPublicPortfolioCurrentUser?: { __typename?: 'Testimonial', state: TestimonialState } | null | undefined };

export type UpdateConfigurationForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: UpdateConfigurationForPublicPortfolioCurrentUserInput;
}>;


export type UpdateConfigurationForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', updateConfigurationForPublicPortfolioCurrentUser?: { __typename?: 'PublicPortfolioConfiguration', fieldCalendarLinkIsPublic: boolean, fieldLinkedinSlugIsPublic: boolean, fieldPhoneIsPublic: boolean, fieldPublicEmailIsPublic: boolean, isPublic: boolean, sectionAwardsIsPublic: boolean, sectionClientsIsPublic: boolean, sectionConnectionsIsPublic: boolean, sectionContactsIsPublic: boolean, sectionHeadlineIsPublic: boolean, sectionSalesExperienceIsPublic: boolean, sectionTestimonialsIsPublic: boolean, sectionWorkHistoriesIsPublic: boolean, sectionEducationHistoriesIsPublic: boolean } | null | undefined };

export type UpdatePublicPortfolioCurrentUserMutationVariables = Exact<{
  input: UpdatePublicPortfolioCurrentUserInput;
}>;


export type UpdatePublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', updatePublicPortfolioCurrentUser?: { __typename?: 'PublicPortfolioCurrentUser', avatarUrl?: string | null | undefined } | null | undefined };

export type UpdateTestimonialPositionForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: UpdateTestimonialPositionForPublicPortfolioCurrentUserInput;
}>;


export type UpdateTestimonialPositionForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', updateTestimonialPositionForPublicPortfolioCurrentUser?: { __typename?: 'Testimonial', position?: number | null | undefined } | null | undefined };

export type ReadNotificationMutationVariables = Exact<{
  input: ReadNotificationInput;
}>;


export type ReadNotificationMutation = { __typename?: 'Mutation', readNotification?: { __typename?: 'Notification', id: string, readAt?: any | null | undefined } | null | undefined };

export type ReadAllNotificationsMutationVariables = Exact<{
  input: ReadAllNotificationsInput;
}>;


export type ReadAllNotificationsMutation = { __typename?: 'Mutation', readAllNotifications?: number | null | undefined };

export type RenewActiveJobStatusMutationVariables = Exact<{
  input: RenewActiveJobStatusInput;
}>;


export type RenewActiveJobStatusMutation = { __typename?: 'Mutation', renewActiveJobStatus?: { __typename?: 'User', id: string, warRoomJobSearchStatus?: string | null | undefined, warRoomJobSearchStatusExpiredAt?: any | null | undefined } | null | undefined };

export type SendSuperInviteMutationVariables = Exact<{
  input: SendSuperInviteInput;
}>;


export type SendSuperInviteMutation = { __typename?: 'Mutation', sendSuperInvite?: boolean | null | undefined };

export type TriggerContactsFetchingMutationVariables = Exact<{
  input: TriggerContactsFetchingInput;
}>;


export type TriggerContactsFetchingMutation = { __typename?: 'Mutation', triggerContactsFetching?: boolean | null | undefined };

export type UpdateCurrentPortfolioUserMutationVariables = Exact<{
  input: UpdateCurrentPortfolioUserInput;
}>;


export type UpdateCurrentPortfolioUserMutation = { __typename?: 'Mutation', updateCurrentPortfolioUser?: { __typename?: 'PortfolioCurrentUser', id: string, city?: { __typename?: 'City', id: string, name: string } | null | undefined, industry?: { __typename?: 'Industry', id: string, name: string } | null | undefined, customerSegment?: { __typename?: 'CustomerSegment', id: string, name: string } | null | undefined, ranking: { __typename?: 'PortfolioRanking', rankingByLocation?: number | null | undefined, rankingByIndustry?: number | null | undefined, rankingByCustomerSegment?: number | null | undefined } } | null | undefined };

export type UpsertDealQuarterMutationVariables = Exact<{
  input: UpsertDealQuarterInput;
}>;


export type UpsertDealQuarterMutation = { __typename?: 'Mutation', upsertDealQuarter?: { __typename?: 'PortfolioDealQuarter', year: number, quarter: number, revenue?: number | null | undefined, quota?: number | null | undefined } | null | undefined };

export type ViewAllNotificationsMutationVariables = Exact<{
  input: ViewAllNotificationsInput;
}>;


export type ViewAllNotificationsMutation = { __typename?: 'Mutation', viewAllNotifications?: number | null | undefined };

export type CreateRatingMutationVariables = Exact<{
  input: CreateRatingInput;
}>;


export type CreateRatingMutation = { __typename?: 'Mutation', createRating?: { __typename?: 'Rating', value: number } | null | undefined };

export type DestroyRatingMutationVariables = Exact<{
  input: DestroyRatingInput;
}>;


export type DestroyRatingMutation = { __typename?: 'Mutation', destroyRating?: { __typename?: 'Rating', value: number } | null | undefined };

export type WarRoomMarkPostsAsReadMutationMutationVariables = Exact<{
  input: MarkPostsAsReadInput;
}>;


export type WarRoomMarkPostsAsReadMutationMutation = { __typename?: 'Mutation', markPostsAsRead?: boolean | null | undefined };

export type AcademyArticleQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type AcademyArticleQuery = { __typename?: 'Query', academyArticle: { __typename?: 'Article', title: string, description?: string | null | undefined, html?: string | null | undefined, isSoon: boolean, slug: string, createdAt: any, updatedAt: any, seoDescription?: string | null | undefined, seoTitle?: string | null | undefined, author?: { __typename?: 'Author', name: string, title?: string | null | undefined, joinedAt?: any | null | undefined, linkUrl?: string | null | undefined, avatar?: { __typename?: 'File', url: string } | null | undefined } | null | undefined, previewImage?: { __typename?: 'File', url: string } | null | undefined } };

export type AcademyArticleEditQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type AcademyArticleEditQuery = { __typename?: 'Query', academyArticle: { __typename?: 'Article', html?: string | null | undefined, markdown?: string | null | undefined } };

export type AcademyArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type AcademyArticlesQuery = { __typename?: 'Query', academyArticles: Array<{ __typename?: 'Article', id: number, title: string, description?: string | null | undefined, isNew: boolean, isUpdated: boolean, isSoon: boolean, slug: string, academyTopic: { __typename?: 'AcademyTopic', title: string, slug: string }, previewImage?: { __typename?: 'File', url: string } | null | undefined }> };

export type AcademyArticlesTableOfContentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AcademyArticlesTableOfContentsQuery = { __typename?: 'Query', academyArticles: Array<{ __typename?: 'Article', title: string, description?: string | null | undefined, isNew: boolean, isUpdated: boolean, isSoon: boolean, weight: number, slug: string, academyTopic: { __typename?: 'AcademyTopic', title: string, weight: number }, previewImage?: { __typename?: 'File', url: string } | null | undefined }> };

export type CommissionBalanceQueryVariables = Exact<{ [key: string]: never; }>;


export type CommissionBalanceQuery = { __typename?: 'Query', commissionBalance: { __typename?: 'CommissionBalance', currentBalance: number, delta: number } };

export type CommissionOnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type CommissionOnboardingQuery = { __typename?: 'Query', commissionOnboarding: { __typename?: 'CommissionOnboarding', product?: any | null | undefined, type: string, items?: Array<{ __typename?: 'EarnItem', price: number, state: string, type: string }> | null | undefined } };

export type CompaniesSearchQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type CompaniesSearchQuery = { __typename?: 'Query', companiesSearch: Array<{ __typename?: 'Company', domain?: string | null | undefined, id: string, name: string, logoUrl?: string | null | undefined, webSiteUrl?: string | null | undefined }> };

export type ConnectionSuggestionsQueryVariables = Exact<{
  type: ConnectionSuggestionType;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ConnectionSuggestionsQuery = { __typename?: 'Query', connectionSuggestions: { __typename?: 'ConnectionSuggestionInterfaceConnection', totalCount: number, edges: Array<{ __typename?: 'ConnectionSuggestionInterfaceEdge', node?: { __typename?: 'ConnectionTopSuggestionUser', avatarUrl?: string | null | undefined, id: string, name: string, position?: string | null | undefined } | { __typename?: 'UserContact', id: string, name: string, position?: string | null | undefined } | null | undefined }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } };

export type ConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectionsQuery = { __typename?: 'Query', connectionRequestsInbox: { __typename?: 'RequestConnection', totalCount: number, edges: Array<{ __typename?: 'RequestEdge', node?: { __typename?: 'Request', id: string, createdAt: any, read: boolean, status: string, requestor?: { __typename?: 'RequestParticipant', avatarUrl?: string | null | undefined, slug: string, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined } | null | undefined }> } };

export type CurrentUserContactsSyncStateQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserContactsSyncStateQueryQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, lastContactsSyncedAt?: any | null | undefined, lastContactsSyncError?: string | null | undefined, lastColleaguesSyncedAt?: any | null | undefined, lastColleaguesSyncError?: string | null | undefined } };

export type SegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type SegmentsQuery = { __typename?: 'Query', customerSegments: Array<{ __typename?: 'CustomerSegment', id: string, emoji?: string | null | undefined, name: string }> };

export type DealQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DealQuery = { __typename?: 'Query', portfolioDeal: { __typename?: 'PortfolioDeal', id: string, closeDate: any, amount: number, isPrivateCompany: boolean, isPrivateDepartments: boolean, departments?: Array<{ __typename?: 'Department', id: string, name: string }> | null | undefined, company?: { __typename?: 'Company', id: string, name: string } | null | undefined, post?: { __typename?: 'Post', id: string, slug: string, content: { __typename?: 'DealStory', id: number, text?: string | null | undefined } | { __typename?: 'Link' } | { __typename?: 'LinkedinPost' } | { __typename?: 'Story' } | { __typename?: 'YoutubeLink' } } | null | undefined } };

export type DirectMessagesThreadsQueryVariables = Exact<{ [key: string]: never; }>;


export type DirectMessagesThreadsQuery = { __typename?: 'Query', directMessagesThreads: Array<{ __typename?: 'Thread', id: string, unreadMessages: number }> };

export type IndustriesQueryVariables = Exact<{ [key: string]: never; }>;


export type IndustriesQuery = { __typename?: 'Query', industries: Array<{ __typename?: 'Industry', id: string, name: string, emoji?: string | null | undefined }> };

export type CompanySeriesStagesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanySeriesStagesQuery = { __typename?: 'Query', jobsCompanySeriesStages: Array<{ __typename?: 'CompanySeriesStage', id: string, name: string, slug: CompanySeriesStageSlug, description: string }> };

export type JobsInquiryHiringsCountQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsInquiryHiringsCountQueryQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', id: string, hiringsForReview?: Array<{ __typename?: 'JobsHiring', id: string }> | null | undefined } | null | undefined };

export type JobsInquiryMatchingResultsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsInquiryMatchingResultsQueryQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', id: string, source: JobsInquirySource, hiringsForReview?: Array<{ __typename?: 'JobsHiring', id: string }> | null | undefined, fakeHiring?: { __typename?: 'JobsInquiryFakeHiring', vacancy?: { __typename?: 'JobsVacancy', title: string } | null | undefined } | null | undefined } | null | undefined };

export type JobsInquiryStateQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsInquiryStateQueryQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', id: string, state: JobsInquiryState } | null | undefined };

export type TopFlexJobsVacanciesQueryVariables = Exact<{ [key: string]: never; }>;


export type TopFlexJobsVacanciesQuery = { __typename?: 'Query', topFlexJobsVacancies?: Array<{ __typename?: 'JobsVacancy', id: string, uid: string, employmentType: JobsVacancyEmployment, openToRemoteWork?: boolean | null | undefined, company: { __typename?: 'Company', id: string, logoUrl?: string | null | undefined }, submission?: { __typename?: 'JobsVacancySubmission', location: string, ote?: string | null | undefined, companyName: string, roleName: string, compensation?: string | null | undefined, minBandwidth?: string | null | undefined } | null | undefined }> | null | undefined };

export type NotificationsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Platform>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications?: { __typename?: 'NotificationConnection', edges: Array<{ __typename?: 'NotificationEdge', node?: { __typename?: 'Notification', id: string, readAt?: any | null | undefined, createdAt: any, type: string, kind: NotificationKind, warRoomCommissionTransaction?: { __typename?: 'CommissionTransaction', id: string, amount: number } | null | undefined, referenceable?: { __typename?: 'Comment', id: string, text: string, deletedAt?: any | null | undefined, author: { __typename: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename: 'Public', slug: string, firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined }, post: { __typename?: 'Post', slug: string } } | { __typename?: 'JobsHiring', id: string, hashid: string, employer: { __typename?: 'JobsEmployer', id: string, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } }, vacancy?: { __typename?: 'JobsVacancy', id: string, title: string, primaryRecruiter?: { __typename?: 'JobsRecruiter', firstname?: string | null | undefined, lastname?: string | null | undefined } | null | undefined } | null | undefined } | { __typename?: 'Post', slug: string, archivedAt?: any | null | undefined, author: { __typename: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename: 'Public', slug: string, firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined }, content: { __typename?: 'DealStory' } | { __typename?: 'Link', id: number, title: string } | { __typename?: 'LinkedinPost', id: number, title: string } | { __typename?: 'Story', id: number, title: string, rawText?: string | null | undefined } | { __typename?: 'YoutubeLink', id: number, title: string } } | { __typename?: 'Rating', id: string, value: number, user: { __typename?: 'User', username?: string | null | undefined, avatarUrl?: string | null | undefined }, reactable: { __typename?: 'Comment', id: string, text: string, deletedAt?: any | null | undefined, author: { __typename: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename: 'Public', slug: string, firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined }, post: { __typename?: 'Post', slug: string } } | { __typename?: 'Post', slug: string, archivedAt?: any | null | undefined, author: { __typename: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename: 'Public', slug: string, firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined }, content: { __typename?: 'DealStory' } | { __typename?: 'Link', id: number, title: string } | { __typename?: 'LinkedinPost', id: number, title: string } | { __typename?: 'Story', id: number, title: string, rawText?: string | null | undefined } | { __typename?: 'YoutubeLink', id: number, title: string } } } | { __typename?: 'SalesGptQuery' } | { __typename?: 'Testimonial', id: string, requestor: { __typename?: 'TestimonialRequestor', slug: string }, author: { __typename?: 'TestimonialAuthor', firstname?: string | null | undefined, lastname?: string | null | undefined } } | { __typename?: 'User', slug: string } | null | undefined } | null | undefined }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } | null | undefined };

export type PortfolioConnectionRequestsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PortfolioConnectionRequestsQuery = { __typename?: 'Query', portfolioConnectionRequests?: { __typename?: 'PublicPortfolioUser', connected: boolean, incomingConnectionRequest?: { __typename?: 'Request', id: string, status: string } | null | undefined, outgoingConnectionRequest?: { __typename?: 'Request', id: string, status: string } | null | undefined } | null | undefined };

export type JobsUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsUserProfileQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, avatarUrl?: string | null | undefined, autoName?: string | null | undefined, firstname?: string | null | undefined, lastname?: string | null | undefined, phone?: string | null | undefined, publicEmail?: string | null | undefined, warRoomYearsOfExperience?: number | null | undefined, position?: string | null | undefined, linkedinSlug?: string | null | undefined, warRoomJobSearchStatus?: string | null | undefined, linkedinUrl?: string | null | undefined, calendarLink?: string | null | undefined, departmentIds?: Array<number> | null | undefined, productTypeIds?: Array<number> | null | undefined, warRoomIndustryIds?: Array<number> | null | undefined, warRoomCompanyStageIds?: Array<number> | null | undefined, warRoomSalesRoleIds?: Array<number> | null | undefined, warRoomCompanySeriesStageIds?: Array<number> | null | undefined, slug: string, company?: { __typename?: 'Company', id: string, logoUrl?: string | null | undefined, name: string } | null | undefined, city?: { __typename?: 'City', id: string, name: string, stateCode?: string | null | undefined, countryName: string, countryCode: string } | null | undefined, solidClients?: Array<{ __typename?: 'Client', id: string, isPublic: boolean, position?: number | null | undefined, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined, companyPagesSlug?: string | null | undefined } }> | null | undefined, departments?: Array<{ __typename?: 'Department', id: string, name: string }> | null | undefined, companyStages?: Array<{ __typename?: 'CompanyStage', id: string, name: string }> | null | undefined, warRoomSalesRoles?: Array<{ __typename?: 'SalesRole', id: string, name: string }> | null | undefined, industries?: Array<{ __typename?: 'Industry', id: string, name: string }> | null | undefined, productTypes?: Array<{ __typename?: 'ProductType', id: number, name: string }> | null | undefined, companySeriesStages?: Array<{ __typename?: 'CompanySeriesStage', id: string, name: string, slug: CompanySeriesStageSlug }> | null | undefined } };

export type PortfolioSuggestedConnectionsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PortfolioSuggestedConnectionsQuery = { __typename?: 'Query', suggestedConnections: { __typename?: 'SuggestedUserConnection', nodes: Array<{ __typename?: 'SuggestedUser', firstname?: string | null | undefined, lastname?: string | null | undefined, slug: string, avatarUrl?: string | null | undefined, currentPosition?: string | null | undefined }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } };

export type PortfolioBenchmarkQueryVariables = Exact<{ [key: string]: never; }>;


export type PortfolioBenchmarkQuery = { __typename?: 'Query', portfolioCurrentUser: { __typename?: 'PortfolioCurrentUser', id: string, city?: { __typename?: 'City', id: string, name: string } | null | undefined, industry?: { __typename?: 'Industry', id: string, name: string } | null | undefined, customerSegment?: { __typename?: 'CustomerSegment', id: string, name: string } | null | undefined, ranking: { __typename?: 'PortfolioRanking', rankingByLocation?: number | null | undefined, rankingByIndustry?: number | null | undefined, rankingByCustomerSegment?: number | null | undefined }, deals: { __typename?: 'PortfolioDealConnection', nodes: Array<{ __typename?: 'PortfolioDeal', id: string, closeDate: any }> }, dealQuarters: Array<{ __typename?: 'PortfolioDealQuarter', quarter: number, year: number, quota?: number | null | undefined, revenue?: number | null | undefined }> } };

export type PortfolioCurrentUserDealSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type PortfolioCurrentUserDealSummaryQuery = { __typename?: 'Query', portfolioCurrentUser: { __typename?: 'PortfolioCurrentUser', id: string, deals: { __typename?: 'PortfolioDealConnection', statistics: { __typename?: 'DealsStatistics', totalCount: number, totalAmount: number } } } };

export type CurrentUserDealsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserDealsSummaryQuery = { __typename?: 'Query', portfolioCurrentUser: { __typename?: 'PortfolioCurrentUser', id: string, topDeals: { __typename?: 'PortfolioDealConnection', nodes: Array<{ __typename?: 'PortfolioDeal', id: string, amount: number, isPrivateCompany: boolean, company?: { __typename?: 'Company', id: string, name: string } | null | undefined }> } } };

export type PortfolioCurrentUserDealsQueryVariables = Exact<{ [key: string]: never; }>;


export type PortfolioCurrentUserDealsQuery = { __typename?: 'Query', portfolioCurrentUser: { __typename?: 'PortfolioCurrentUser', id: string, dealQuarters: Array<{ __typename?: 'PortfolioDealQuarter', year: number, quarter: number, quota?: number | null | undefined, revenue?: number | null | undefined }>, deals: { __typename?: 'PortfolioDealConnection', nodes: Array<{ __typename?: 'PortfolioDeal', id: string, closeDate: any, amount: number, isPrivateCompany: boolean, isPrivateDepartments: boolean, departments?: Array<{ __typename?: 'Department', id: string, name: string }> | null | undefined, company?: { __typename?: 'Company', id: string, name: string } | null | undefined, post?: { __typename?: 'Post', id: string, slug: string, content: { __typename?: 'DealStory', id: number, text?: string | null | undefined } | { __typename?: 'Link' } | { __typename?: 'LinkedinPost' } | { __typename?: 'Story' } | { __typename?: 'YoutubeLink' } } | null | undefined }> } } };

export type PortfolioCurrentUserLinkedInImportQueryVariables = Exact<{ [key: string]: never; }>;


export type PortfolioCurrentUserLinkedInImportQuery = { __typename?: 'Query', portfolioCurrentUser: { __typename?: 'PortfolioCurrentUser', id: string, lastLinkedinSyncedAt?: any | null | undefined, lastLinkedinSyncError?: string | null | undefined } };

export type PortfolioCurrentUserRankingSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type PortfolioCurrentUserRankingSettingsQuery = { __typename?: 'Query', portfolioCurrentUser: { __typename?: 'PortfolioCurrentUser', id: string, industry?: { __typename?: 'Industry', id: string } | null | undefined, customerSegment?: { __typename?: 'CustomerSegment', id: string } | null | undefined, city?: { __typename?: 'City', id: string, name: string } | null | undefined, productTypes: Array<{ __typename?: 'ProductType', id: number, name: string }> } };

export type PostQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PostQuery = { __typename?: 'Query', post?: { __typename?: 'Post', archivedAt?: any | null | undefined, category: string, commentsCount: number, contentId: number, contentType: string, createdAt: any, id: string, isAnonymous: boolean, official: boolean, pinned: boolean, pinnedAt?: any | null | undefined, publishedAt?: any | null | undefined, slug: string, totalRating: number, totalWeight: number, updatedAt: any, viewsCount: number, content: { __typename?: 'DealStory', id: number, text?: string | null | undefined, title: string, deal: { __typename?: 'Deal', id: string, closeDate: any, amount: number, isPrivateCompany: boolean, isPrivateDepartments: boolean, departments?: Array<{ __typename?: 'Department', id: string, name: string }> | null | undefined, company?: { __typename?: 'Company', id: string, name: string } | null | undefined, post?: { __typename?: 'Post', id: string, slug: string, content: { __typename?: 'DealStory', id: number, text?: string | null | undefined } | { __typename?: 'Link' } | { __typename?: 'LinkedinPost' } | { __typename?: 'Story' } | { __typename?: 'YoutubeLink' } } | null | undefined } } | { __typename?: 'Link', link: string, text?: string | null | undefined, title: string } | { __typename?: 'LinkedinPost', text?: string | null | undefined, title: string } | { __typename?: 'Story', text?: string | null | undefined, title: string } | { __typename?: 'YoutubeLink', link: string, text?: string | null | undefined, title: string }, topics: Array<{ __typename?: 'Topic', id: number, name: string }>, files?: Array<{ __typename?: 'File', name?: string | null | undefined, signedId?: string | null | undefined, url: string }> | null | undefined, poll?: { __typename?: 'Poll', id: number, title: string, choices: Array<{ __typename?: 'PollChoice', id: number, text: string, position?: number | null | undefined }> } | null | undefined } | null | undefined };

export type PublicPortfolioCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicPortfolioCurrentUserQuery = { __typename?: 'Query', publicPortfolioCurrentUser: { __typename?: 'PublicPortfolioCurrentUser', testimonials?: Array<{ __typename?: 'Testimonial', id: string, sign: string, skills: Array<string>, position?: number | null | undefined, description?: string | null | undefined, state: TestimonialState, author: { __typename?: 'TestimonialAuthor', email?: string | null | undefined, avatarUrl?: string | null | undefined, firstname?: string | null | undefined, jobTitle?: string | null | undefined, lastname?: string | null | undefined }, requestor: { __typename?: 'TestimonialRequestor', firstname?: string | null | undefined, lastname?: string | null | undefined, slug: string } }> | null | undefined, configuration: { __typename?: 'PublicPortfolioConfiguration', fieldCalendarLinkIsPublic: boolean, fieldLinkedinSlugIsPublic: boolean, fieldPhoneIsPublic: boolean, fieldPublicEmailIsPublic: boolean, isPublic: boolean, sectionAwardsIsPublic: boolean, sectionClientsIsPublic: boolean, sectionConnectionsIsPublic: boolean, sectionContactsIsPublic: boolean, sectionHeadlineIsPublic: boolean, sectionSalesExperienceIsPublic: boolean, sectionTestimonialsIsPublic: boolean, sectionWorkHistoriesIsPublic: boolean, sectionEducationHistoriesIsPublic: boolean }, educationHistories?: Array<{ __typename?: 'EducationHistory', id?: string | null | undefined, degreeName?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, manuallyEdited: boolean, university?: { __typename?: 'University', id: string, slug?: string | null | undefined, name: string, logoUrl?: string | null | undefined, custom: boolean, verified: boolean, parent?: { __typename?: 'University', slug?: string | null | undefined, name: string, logoUrl?: string | null | undefined } | null | undefined } | null | undefined }> | null | undefined } };

export type UserPublicPostsQueryVariables = Exact<{
  slug: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type UserPublicPostsQuery = { __typename?: 'Query', userPublicPosts: { __typename?: 'PostConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean }, nodes: Array<{ __typename?: 'Post', archivedAt?: any | null | undefined, category: string, commentsCount: number, contentId: number, contentType: string, createdAt: any, membersOnly: boolean, id: string, isAnonymous: boolean, official: boolean, pinned: boolean, pinnedAt?: any | null | undefined, publishedAt?: any | null | undefined, slug: string, totalRating: number, totalWeight: number, updatedAt: any, viewsCount: number, author: { __typename?: 'Anonymous', username?: string | null | undefined } | { __typename?: 'Public', slug: string }, currentUserRating?: { __typename?: 'Rating', value: number } | null | undefined, content: { __typename?: 'DealStory', id: number, text?: string | null | undefined, title: string } | { __typename?: 'Link', link: string, text?: string | null | undefined, title: string } | { __typename?: 'LinkedinPost', text?: string | null | undefined, title: string } | { __typename?: 'Story', text?: string | null | undefined, title: string } | { __typename?: 'YoutubeLink', link: string, text?: string | null | undefined, title: string }, topics: Array<{ __typename?: 'Topic', id: number, name: string, emoji: string, slug: string }>, files?: Array<{ __typename?: 'File', name?: string | null | undefined, signedId?: string | null | undefined, url: string }> | null | undefined }> } };

export type PublicPortfolioUserQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicPortfolioUserQuery = { __typename?: 'Query', publicPortfolioUser?: { __typename?: 'PublicPortfolioUser', departments?: Array<{ __typename?: 'Department', id: string, name: string }> | null | undefined, companyStages?: Array<{ __typename?: 'CompanyStage', id: string, name: string }> | null | undefined, warRoomSalesRoles?: Array<{ __typename?: 'SalesRole', id: string, name: string }> | null | undefined, industries?: Array<{ __typename?: 'Industry', id: string, name: string }> | null | undefined, productTypes?: Array<{ __typename?: 'ProductType', id: number, name: string }> | null | undefined, companySeriesStages?: Array<{ __typename?: 'CompanySeriesStage', id: string, name: string, slug: CompanySeriesStageSlug }> | null | undefined, testimonials?: Array<{ __typename?: 'Testimonial', id: string, sign: string, skills: Array<string>, position?: number | null | undefined, description?: string | null | undefined, state: TestimonialState, author: { __typename?: 'TestimonialAuthor', avatarUrl?: string | null | undefined, firstname?: string | null | undefined, jobTitle?: string | null | undefined, lastname?: string | null | undefined }, requestor: { __typename?: 'TestimonialRequestor', firstname?: string | null | undefined, lastname?: string | null | undefined, slug: string } }> | null | undefined, configuration: { __typename?: 'PublicPortfolioConfiguration', fieldCalendarLinkIsPublic: boolean, fieldLinkedinSlugIsPublic: boolean, fieldPhoneIsPublic: boolean, fieldPublicEmailIsPublic: boolean, isPublic: boolean, sectionAwardsIsPublic: boolean, sectionClientsIsPublic: boolean, sectionConnectionsIsPublic: boolean, sectionContactsIsPublic: boolean, sectionHeadlineIsPublic: boolean, sectionSalesExperienceIsPublic: boolean, sectionTestimonialsIsPublic: boolean, sectionWorkHistoriesIsPublic: boolean, sectionEducationHistoriesIsPublic: boolean }, educationHistories?: Array<{ __typename?: 'EducationHistory', id?: string | null | undefined, degreeName?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, manuallyEdited: boolean, university?: { __typename?: 'University', id: string, slug?: string | null | undefined, name: string, logoUrl?: string | null | undefined, custom: boolean, verified: boolean, parent?: { __typename?: 'University', slug?: string | null | undefined, name: string, logoUrl?: string | null | undefined } | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type PublicPortfolioTestifySignQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicPortfolioTestifySignQuery = { __typename?: 'Query', publicPortfolioUserTestifySign?: string | null | undefined };

export type PublicPortfolioUserVisibilityQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicPortfolioUserVisibilityQuery = { __typename?: 'Query', publicPortfolioUser?: { __typename?: 'PublicPortfolioUser', configuration: { __typename?: 'PublicPortfolioConfiguration', isPublic: boolean } } | null | undefined };

export type SalesDirectoryProfilesQueryVariables = Exact<{
  prefix: Scalars['String'];
  perPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type SalesDirectoryProfilesQuery = { __typename?: 'Query', salesDirectoryProfiles: { __typename?: 'SalesDirectoryPage', currentPage: number, totalPages: number, totalCount: number, profiles: Array<{ __typename?: 'SalesDirectoryUser', firstname: string, lastname: string, slug: string }> } };

export type SearchUsersQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  boostUserUsernames?: InputMaybe<Scalars['String']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'UserSearch', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined }> };

export type SuggestedGeolocationQueryVariables = Exact<{
  ip: Scalars['String'];
}>;


export type SuggestedGeolocationQuery = { __typename?: 'Query', suggestedGeolocation?: { __typename?: 'City', id: string, name: string, stateCode?: string | null | undefined, countryName: string, countryCode: string } | null | undefined };

export type TestimonialQueryVariables = Exact<{
  sign: Scalars['String'];
}>;


export type TestimonialQuery = { __typename?: 'Query', testimonial: { __typename?: 'Testimonial', id: string, sign: string, skills: Array<string>, description?: string | null | undefined, state: TestimonialState, author: { __typename?: 'TestimonialAuthor', firstname?: string | null | undefined, lastname?: string | null | undefined }, requestor: { __typename?: 'TestimonialRequestor', firstname?: string | null | undefined, lastname?: string | null | undefined, slug: string } } };

export type OnboardingDataQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingDataQuery = { __typename?: 'Query', onboardingData: { __typename?: 'OnboardingData', jobSearchStatuses: Array<string>, departments: Array<{ __typename?: 'Department', id: string, name: string, emoji?: string | null | undefined }>, companyStages: Array<{ __typename?: 'CompanyStage', id: string, name: string }>, customerSegments: Array<{ __typename?: 'CustomerSegment', id: string, name: string, emoji?: string | null | undefined }>, industries: Array<{ __typename?: 'Industry', id: string, name: string, emoji?: string | null | undefined }>, expectations: Array<{ __typename?: 'Expectation', id: string, name: string }> } };

export type WarRoomUnreadPostsCountQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type WarRoomUnreadPostsCountQueryQuery = { __typename?: 'Query', warRoomUnreadPostsCount: number };

export type RealUserQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type RealUserQuery = { __typename?: 'Query', publicPortfolioUser?: { __typename?: 'PublicPortfolioUser', realUser?: { __typename?: 'PublicPortfolioUser', slug: string } | null | undefined } | null | undefined };

export type UserReferrerQueryVariables = Exact<{
  invite: Scalars['String'];
}>;


export type UserReferrerQuery = { __typename?: 'Query', userReferrer?: { __typename?: 'SuggestedUser', firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined } | null | undefined };

export type CommissionTransactionsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CommissionTransactionsSubscription = { __typename?: 'Subscription', commissionTransactions: { __typename?: 'CommissionTransactionSubscriptionPayload', commissionChange?: { __typename?: 'CommissionBalance', currentBalance: number, delta: number } | null | undefined } };

export type Unnamed_1_SubscriptionVariables = Exact<{ [key: string]: never; }>;


export type Unnamed_1_Subscription = { __typename?: 'Subscription', linkedinProfileImported: { __typename?: 'LinkedinProfileImportedPayload', isSuccessful: boolean, portfolioCurrentUser: { __typename?: 'PortfolioCurrentUser', id: string } } };

export type CompaniesAutocompleteSearchQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type CompaniesAutocompleteSearchQuery = { __typename?: 'Query', companiesSearch: Array<{ __typename?: 'Company', id: string, name: string, domain?: string | null | undefined, logoUrl?: string | null | undefined }> };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCustomCompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCustomCompany?: { __typename?: 'Company', id: string, name: string, domain?: string | null | undefined, logoUrl?: string | null | undefined } | null | undefined };

export type CreateWarRoomRatingMutationVariables = Exact<{
  input: CreateRatingInput;
}>;


export type CreateWarRoomRatingMutation = { __typename?: 'Mutation', createRating?: { __typename?: 'Rating', reactable: { __typename?: 'Comment', totalRating: number, currentUserRating?: { __typename?: 'Rating', value: number } | null | undefined } | { __typename?: 'Post' } } | null | undefined };

export type DestroyWarRoomRatingMutationVariables = Exact<{
  input: DestroyRatingInput;
}>;


export type DestroyWarRoomRatingMutation = { __typename?: 'Mutation', destroyRating?: { __typename?: 'Rating', reactable: { __typename?: 'Comment', totalRating: number, currentUserRating?: { __typename?: 'Rating', value: number } | null | undefined } | { __typename?: 'Post' } } | null | undefined };

export type ReportSalesGptFeedbackMutationVariables = Exact<{
  input: ReportSalesGptFeedbackInput;
}>;


export type ReportSalesGptFeedbackMutation = { __typename?: 'Mutation', reportSalesGptFeedback?: { __typename?: 'SalesGptQuery', sessionId?: string | null | undefined } | null | undefined };

export type RestoreSalesGptAnswerQueryVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type RestoreSalesGptAnswerQuery = { __typename?: 'Query', salesGptQuery: { __typename?: 'SalesGptQuery', sessionId?: string | null | undefined, query: string, summary?: string | null | undefined, sources?: { __typename?: 'SearchResultInterfaceConnection', nodes: Array<{ __typename?: 'AcademyArticleSearchResult', category: string, article: { __typename?: 'Article', id: number, title: string, slug: string, description?: string | null | undefined, createdAt: any, previewImage?: { __typename?: 'File', url: string } | null | undefined } } | { __typename?: 'CompanyPagesCatalogSearchResult', category: string } | { __typename?: 'CompanySearchResult', category: string } | { __typename?: 'PortfolioUserSearchResult', category: string } | { __typename?: 'WarRoomPostCommentSearchResult', category: string, record: { __typename?: 'Comment', id: string, rawText: string, createdAt: any, totalRating: number, post: { __typename?: 'Post', slug: string }, author: { __typename?: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename?: 'Public', firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined, portfolioIsOpened?: boolean | null | undefined }, currentUserRating?: { __typename?: 'Rating', value: number } | null | undefined } } | { __typename?: 'WarRoomPostSearchResult', category: string } | { __typename?: 'WarRoomUserSearchResult', category: string }> } | null | undefined } };

type SalesGptFragment_AcademyArticleSearchResult_Fragment = { __typename?: 'AcademyArticleSearchResult', category: string, article: { __typename?: 'Article', id: number, title: string, slug: string, description?: string | null | undefined, createdAt: any, previewImage?: { __typename?: 'File', url: string } | null | undefined } };

type SalesGptFragment_CompanyPagesCatalogSearchResult_Fragment = { __typename?: 'CompanyPagesCatalogSearchResult', category: string };

type SalesGptFragment_CompanySearchResult_Fragment = { __typename?: 'CompanySearchResult', category: string };

type SalesGptFragment_PortfolioUserSearchResult_Fragment = { __typename?: 'PortfolioUserSearchResult', category: string };

type SalesGptFragment_WarRoomPostCommentSearchResult_Fragment = { __typename?: 'WarRoomPostCommentSearchResult', category: string, record: { __typename?: 'Comment', id: string, rawText: string, createdAt: any, totalRating: number, post: { __typename?: 'Post', slug: string }, author: { __typename?: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename?: 'Public', firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined, portfolioIsOpened?: boolean | null | undefined }, currentUserRating?: { __typename?: 'Rating', value: number } | null | undefined } };

type SalesGptFragment_WarRoomPostSearchResult_Fragment = { __typename?: 'WarRoomPostSearchResult', category: string };

type SalesGptFragment_WarRoomUserSearchResult_Fragment = { __typename?: 'WarRoomUserSearchResult', category: string };

export type SalesGptFragmentFragment = SalesGptFragment_AcademyArticleSearchResult_Fragment | SalesGptFragment_CompanyPagesCatalogSearchResult_Fragment | SalesGptFragment_CompanySearchResult_Fragment | SalesGptFragment_PortfolioUserSearchResult_Fragment | SalesGptFragment_WarRoomPostCommentSearchResult_Fragment | SalesGptFragment_WarRoomPostSearchResult_Fragment | SalesGptFragment_WarRoomUserSearchResult_Fragment;

export type SalesGptFlexCtaQueryVariables = Exact<{
  sessionId: Scalars['String'];
}>;


export type SalesGptFlexCtaQuery = { __typename?: 'Query', salesGptFlexCta?: string | null | undefined };

export type SaveSalesGptSummaryMutationVariables = Exact<{
  input: SaveSalesGptSummaryInput;
}>;


export type SaveSalesGptSummaryMutation = { __typename?: 'Mutation', saveSalesGptSummary?: { __typename?: 'SalesGptQuery', sessionId?: string | null | undefined, summary?: string | null | undefined } | null | undefined };

export type SayThanksMutationVariables = Exact<{
  input: SayThanksInput;
}>;


export type SayThanksMutation = { __typename?: 'Mutation', sayThanks?: boolean | null | undefined };

export type SearchForQueryVariables = Exact<{
  query: Scalars['String'];
  filterCategories?: InputMaybe<Array<SearchResultCategory> | SearchResultCategory>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  produceAiSummary?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchForQuery = { __typename?: 'Query', search: { __typename?: 'SearchInfo', id: string, salesGptQuery?: { __typename?: 'SalesGptQuery', sessionId?: string | null | undefined, summaryType: SearchSummaryType, summary?: string | null | undefined, flexCta?: string | null | undefined, wasExternalDataUsed: boolean, wasCompanyPagesDataUsed: boolean, sources?: { __typename?: 'SearchResultInterfaceConnection', nodes: Array<{ __typename?: 'AcademyArticleSearchResult', category: string, article: { __typename?: 'Article', id: number, title: string, slug: string, description?: string | null | undefined, createdAt: any, previewImage?: { __typename?: 'File', url: string } | null | undefined } } | { __typename?: 'CompanyPagesCatalogSearchResult', category: string } | { __typename?: 'CompanySearchResult', category: string } | { __typename?: 'PortfolioUserSearchResult', category: string } | { __typename?: 'WarRoomPostCommentSearchResult', category: string, record: { __typename?: 'Comment', id: string, rawText: string, createdAt: any, totalRating: number, post: { __typename?: 'Post', slug: string }, author: { __typename?: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename?: 'Public', firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined, portfolioIsOpened?: boolean | null | undefined }, currentUserRating?: { __typename?: 'Rating', value: number } | null | undefined } } | { __typename?: 'WarRoomPostSearchResult', category: string } | { __typename?: 'WarRoomUserSearchResult', category: string }> } | null | undefined } | null | undefined, results: Array<{ __typename?: 'SearchResultsCategory', category: SearchResultCategory, items: Array<{ __typename?: 'AcademyArticleSearchResult', category: string, article: { __typename?: 'Article', id: number, slug: string, title: string, author?: { __typename?: 'Author', name: string } | null | undefined, previewImage?: { __typename?: 'File', url: string } | null | undefined } } | { __typename?: 'CompanyPagesCatalogSearchResult', category: string, page: { __typename?: 'CompanyPagesCatalog', id: string, title: string, pageType: CompanyPagesCatalogPageType, company?: { __typename?: 'Company', slug?: string | null | undefined } | null | undefined, roleCategory?: { __typename?: 'RoleCategory', slug?: string | null | undefined } | null | undefined, customerSegment?: { __typename?: 'CustomerSegment', slug: string } | null | undefined, region?: { __typename?: 'Region', slug: string } | null | undefined } } | { __typename?: 'CompanySearchResult', category: string, company: { __typename?: 'Company', id: string, slug?: string | null | undefined, name: string, investmentRound?: string | null | undefined, logoUrl?: string | null | undefined, employeeCount?: string | null | undefined, shortDescription?: string | null | undefined, overallRating?: number | null | undefined, location?: { __typename?: 'City', name: string } | null | undefined } } | { __typename?: 'PortfolioUserSearchResult', category: string, portfolioUser: { __typename?: 'PublicPortfolioUser', slug: string, avatarUrl?: string | null | undefined, lastname?: string | null | undefined, firstname?: string | null | undefined, currentPosition?: string | null | undefined, id: string, currentCompany?: { __typename?: 'Company', name: string } | null | undefined, city?: { __typename?: 'City', name: string, stateCode?: string | null | undefined } | null | undefined } } | { __typename?: 'WarRoomPostCommentSearchResult', category: string } | { __typename?: 'WarRoomPostSearchResult', category: string, comments?: Array<{ __typename?: 'WarRoomPostCommentSearchResult', record: { __typename?: 'Comment', id: string, createdAt: any, author: { __typename?: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename?: 'Public', firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined } }, highlightedText: { __typename?: 'HighlightedText', text: string, highlightTo?: number | null | undefined, highlightFrom?: number | null | undefined } }> | null | undefined, post: { __typename?: 'Post', id: string, slug: string, viewed?: boolean | null | undefined, category: string, commentsCount: number, content: { __typename?: 'DealStory', title: string, rawText?: string | null | undefined } | { __typename?: 'Link', title: string, rawText?: string | null | undefined } | { __typename?: 'LinkedinPost', title: string, rawText?: string | null | undefined } | { __typename?: 'Story', title: string, rawText?: string | null | undefined } | { __typename?: 'YoutubeLink', title: string, rawText?: string | null | undefined }, author: { __typename?: 'Anonymous', username?: string | null | undefined } | { __typename?: 'Public', firstname?: string | null | undefined, lastname?: string | null | undefined }, topics: Array<{ __typename?: 'Topic', id: number, name: string, emoji: string, slug: string }> } } | { __typename?: 'WarRoomUserSearchResult', category: string, warRoomUser?: { __typename?: 'User', username?: string | null | undefined, avatarUrl?: string | null | undefined, warRoomPosition?: string | null | undefined, warRoomDescription?: string | null | undefined, id?: string | null | undefined } | null | undefined }> }> } };

type SearchResultFragment_AcademyArticleSearchResult_Fragment = { __typename?: 'AcademyArticleSearchResult', category: string, article: { __typename?: 'Article', id: number, slug: string, title: string, author?: { __typename?: 'Author', name: string } | null | undefined, previewImage?: { __typename?: 'File', url: string } | null | undefined } };

type SearchResultFragment_CompanyPagesCatalogSearchResult_Fragment = { __typename?: 'CompanyPagesCatalogSearchResult', category: string, page: { __typename?: 'CompanyPagesCatalog', id: string, title: string, pageType: CompanyPagesCatalogPageType, company?: { __typename?: 'Company', slug?: string | null | undefined } | null | undefined, roleCategory?: { __typename?: 'RoleCategory', slug?: string | null | undefined } | null | undefined, customerSegment?: { __typename?: 'CustomerSegment', slug: string } | null | undefined, region?: { __typename?: 'Region', slug: string } | null | undefined } };

type SearchResultFragment_CompanySearchResult_Fragment = { __typename?: 'CompanySearchResult', category: string, company: { __typename?: 'Company', id: string, slug?: string | null | undefined, name: string, investmentRound?: string | null | undefined, logoUrl?: string | null | undefined, employeeCount?: string | null | undefined, shortDescription?: string | null | undefined, overallRating?: number | null | undefined, location?: { __typename?: 'City', name: string } | null | undefined } };

type SearchResultFragment_PortfolioUserSearchResult_Fragment = { __typename?: 'PortfolioUserSearchResult', category: string, portfolioUser: { __typename?: 'PublicPortfolioUser', slug: string, avatarUrl?: string | null | undefined, lastname?: string | null | undefined, firstname?: string | null | undefined, currentPosition?: string | null | undefined, id: string, currentCompany?: { __typename?: 'Company', name: string } | null | undefined, city?: { __typename?: 'City', name: string, stateCode?: string | null | undefined } | null | undefined } };

type SearchResultFragment_WarRoomPostCommentSearchResult_Fragment = { __typename?: 'WarRoomPostCommentSearchResult', category: string };

type SearchResultFragment_WarRoomPostSearchResult_Fragment = { __typename?: 'WarRoomPostSearchResult', category: string, comments?: Array<{ __typename?: 'WarRoomPostCommentSearchResult', record: { __typename?: 'Comment', id: string, createdAt: any, author: { __typename?: 'Anonymous', username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } | { __typename?: 'Public', firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined } }, highlightedText: { __typename?: 'HighlightedText', text: string, highlightTo?: number | null | undefined, highlightFrom?: number | null | undefined } }> | null | undefined, post: { __typename?: 'Post', id: string, slug: string, viewed?: boolean | null | undefined, category: string, commentsCount: number, content: { __typename?: 'DealStory', title: string, rawText?: string | null | undefined } | { __typename?: 'Link', title: string, rawText?: string | null | undefined } | { __typename?: 'LinkedinPost', title: string, rawText?: string | null | undefined } | { __typename?: 'Story', title: string, rawText?: string | null | undefined } | { __typename?: 'YoutubeLink', title: string, rawText?: string | null | undefined }, author: { __typename?: 'Anonymous', username?: string | null | undefined } | { __typename?: 'Public', firstname?: string | null | undefined, lastname?: string | null | undefined }, topics: Array<{ __typename?: 'Topic', id: number, name: string, emoji: string, slug: string }> } };

type SearchResultFragment_WarRoomUserSearchResult_Fragment = { __typename?: 'WarRoomUserSearchResult', category: string, warRoomUser?: { __typename?: 'User', username?: string | null | undefined, avatarUrl?: string | null | undefined, warRoomPosition?: string | null | undefined, warRoomDescription?: string | null | undefined, id?: string | null | undefined } | null | undefined };

export type SearchResultFragmentFragment = SearchResultFragment_AcademyArticleSearchResult_Fragment | SearchResultFragment_CompanyPagesCatalogSearchResult_Fragment | SearchResultFragment_CompanySearchResult_Fragment | SearchResultFragment_PortfolioUserSearchResult_Fragment | SearchResultFragment_WarRoomPostCommentSearchResult_Fragment | SearchResultFragment_WarRoomPostSearchResult_Fragment | SearchResultFragment_WarRoomUserSearchResult_Fragment;

export type HeaderCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaderCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } };

export type CurrentUserQueryVariables = Exact<{
  platform?: InputMaybe<Platform>;
}>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, unreadConnectionRequestsCount: number, unseenWarRoomNotifications?: boolean | null | undefined, unreadWarRoomNotifications?: boolean | null | undefined } };

export type UpdateCurrentUserReferralMutationVariables = Exact<{
  input: UpdateCurrentUserInput;
}>;


export type UpdateCurrentUserReferralMutation = { __typename?: 'Mutation', updateCurrentUser?: { __typename?: 'CurrentUser', hasSeenNewReferProgram?: boolean | null | undefined } | null | undefined };

export type FlexChallengeQueryVariables = Exact<{ [key: string]: never; }>;


export type FlexChallengeQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', id: string, flexState?: string | null | undefined, flexAppliedCriteria?: Array<JobsFlexAppliedCriteria> | null | undefined, flexBandwidth?: string | null | undefined, flexBriefVideoUrl?: string | null | undefined, flexConsideredCompanyTypes?: Array<JobsFlexFlexConsideredCompanyType> | null | undefined, flexPreviousExperience?: string | null | undefined, flexReasonForParticipation?: string | null | undefined, flexRoles?: Array<JobsFlexRole> | null | undefined, flexUnderstandingOfSales?: string | null | undefined, flexOnboardingState?: string | null | undefined } | null | undefined };

export type UpdateFlexChallengeMutationVariables = Exact<{
  input: UpdateInquiryInput;
}>;


export type UpdateFlexChallengeMutation = { __typename?: 'Mutation', updateJobsInquiry?: { __typename?: 'JobsInquiry', id: string, flexState?: string | null | undefined } | null | undefined };

export type MatchJobsInquiryAfterOnboardingMutationVariables = Exact<{
  input: MatchJobsInquiryAfterOnboardingInput;
}>;


export type MatchJobsInquiryAfterOnboardingMutation = { __typename?: 'Mutation', matchJobsInquiryAfterOnboarding?: { __typename?: 'JobsInquiry', id: string } | null | undefined };

export type ResendEmailMutationVariables = Exact<{
  input: HiringResendIntroduceEmailInput;
}>;


export type ResendEmailMutation = { __typename?: 'Mutation', hiringResendIntroduceEmail?: { __typename?: 'JobsHiring', id: string } | null | undefined };

export type JobsIndexPageCurrentJobsInquiryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsIndexPageCurrentJobsInquiryQueryQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', id: string, state: JobsInquiryState, activeHiringsCount: number } | null | undefined };

export type AcceptAndScheduleMutationVariables = Exact<{
  hiringId: Scalars['ID'];
}>;


export type AcceptAndScheduleMutation = { __typename?: 'Mutation', fireJobsHiringEvent?: { __typename?: 'JobsHiring', id: string, vacancy?: { __typename?: 'JobsVacancy', id: string, primaryRecruiter?: { __typename?: 'JobsRecruiter', firstname?: string | null | undefined, lastname?: string | null | undefined, email: string, schedulingLink?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type ScheduleHiringMeetingMutationVariables = Exact<{
  input: ScheduleHiringMeetingInput;
}>;


export type ScheduleHiringMeetingMutation = { __typename?: 'Mutation', scheduleHiringMeeting?: { __typename?: 'JobsHiring', acceptedByEmployer: boolean, candidateState?: JobsHiringCandidateState | null | undefined, candidateStateUpdatedAt?: any | null | undefined, candidateStateViewed?: boolean | null | undefined, hoursToExpire?: number | null | undefined, id: string, origin: JobsHiringOrigin } | null | undefined };

export type JobsInquiryHiringsQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsInquiryHiringsQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', id: string, activeHirings?: Array<{ __typename?: 'JobsHiring', id: string, candidateState?: JobsHiringCandidateState | null | undefined, vacancy?: { __typename?: 'JobsVacancy', id: string, title: string, primaryRecruiter?: { __typename?: 'JobsRecruiter', email: string, firstname?: string | null | undefined, lastname?: string | null | undefined, schedulingLink?: string | null | undefined } | null | undefined, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } } | null | undefined }> | null | undefined, hiringsForReview?: Array<{ __typename?: 'JobsHiring', id: string, hashid: string, acceptedByEmployer: boolean, vacancy?: { __typename?: 'JobsVacancy', id: string, title: string, employmentType: JobsVacancyEmployment, cities?: Array<{ __typename?: 'City', id: string, name: string, stateName?: string | null | undefined }> | null | undefined, countries?: Array<{ __typename?: 'Country', name: string }> | null | undefined, employer: { __typename?: 'JobsEmployer', id: string, descriptionHtml?: string | null | undefined, keyPoints: Array<string>, roleUrl?: string | null | undefined, company: { __typename?: 'Company', id: string, logoUrl?: string | null | undefined, name: string } }, submission?: { __typename?: 'JobsVacancySubmission', avgDealSize?: string | null | undefined, avgSalesCycle?: string | null | undefined, baseSalary?: string | null | undefined, brandMaturity?: JobsVacancySubmissionBrandMaturity | null | undefined, companyName: string, compensation?: string | null | undefined, compensationDescription?: string | null | undefined, customerProfile?: string | null | undefined, industry: string, jobUrl?: string | null | undefined, keyPoint1?: string | null | undefined, keyPoint2?: string | null | undefined, keyPoint3?: string | null | undefined, keyPoint4?: string | null | undefined, keyPoint5?: string | null | undefined, keyPoint6?: string | null | undefined, keyPoint7?: string | null | undefined, location: string, minBandwidth?: string | null | undefined, ote?: string | null | undefined, quotaAttainmentByTeam?: number | null | undefined, roleName: string, workType?: string | null | undefined } | null | undefined, primaryRecruiter?: { __typename?: 'JobsRecruiter', firstname?: string | null | undefined, lastname?: string | null | undefined, email: string, schedulingLink?: string | null | undefined } | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type JobsOnboardingIndexPageCurrentJobsInquiryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsOnboardingIndexPageCurrentJobsInquiryQueryQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', aeLeadSourceOther?: string | null | undefined, aeLeadSourcesMain?: Array<JobsInquiryAeLeadSource> | null | undefined, aeQuotaPerPeriod?: number | null | undefined, aeQuotaTypeMain?: JobsInquiryAeQuota | null | undefined, aeQuotaTypeOther?: string | null | undefined, baseSalary?: number | null | undefined, csmAccountsNumber?: JobsInquiryCsmAccountNumber | null | undefined, csmQuotaMetricMain?: Array<JobsInquiryCsmQuotaMetric> | null | undefined, csmQuotaMetricOther?: string | null | undefined, csmQuotaPeriodMain?: JobsInquiryCsmQuotaPeriod | null | undefined, csmQuotaPeriodOther?: string | null | undefined, csmQuotaTypeMain?: JobsInquiryCsmQuota | null | undefined, csmQuotaTypeOther?: string | null | undefined, csmRenewalValue?: JobsInquiryCsmRenewalValue | null | undefined, csmTotalBusinessValue?: JobsInquiryCsmBusinessValue | null | undefined, csmUpsellValue?: JobsInquiryCsmUpsellValue | null | undefined, currency?: Currency | null | undefined, dealBreakerOther?: string | null | undefined, dealBreakersMain?: Array<JobsInquiryDealBreaker> | null | undefined, dealSize?: JobsInquiryDealSize | null | undefined, employmentTypes: Array<JobsInquiryEmployment>, id: string, idealJobDescription?: string | null | undefined, onboardingState: JobsInquiryOnboardingState, ote?: number | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, quotaAttainmentByTeamPerPeriod?: number | null | undefined, quotaAttainmentPerLastYear?: number | null | undefined, quotaAttainmentPerPeriod?: number | null | undefined, rankOnTeam?: number | null | undefined, revenue?: number | null | undefined, salesCycleLength?: JobsInquirySalesCycleLength | null | undefined, salesMethodologies?: Array<JobsInquirySalesMethodology> | null | undefined, sdrQuotaPerPeriod?: string | null | undefined, sdrQuotaTypes?: Array<JobsInquirySdrQuota> | null | undefined, state: JobsInquiryState, teamSize?: number | null | undefined, vpDepartmentSize?: JobsInquiryVpDepartmentSize | null | undefined, vpManagedRoles?: Array<JobsInquiryVpManagedRole> | null | undefined, vpQuotaType?: JobsInquiryVpQuota | null | undefined, willingToRelocate?: boolean | null | undefined, desiredCompanySeriesStages?: Array<{ __typename?: 'CompanySeriesStage', description: string, id: string, name: string, slug: CompanySeriesStageSlug }> | null | undefined } | null | undefined };

export type ArchiveCandidateHiringMutationVariables = Exact<{
  input: ArchiveCandidateHiringInput;
}>;


export type ArchiveCandidateHiringMutation = { __typename?: 'Mutation', archiveCandidateHiring?: boolean | null | undefined };

export type FakeHiringQueryVariables = Exact<{ [key: string]: never; }>;


export type FakeHiringQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', id: string, fakeHiring?: { __typename?: 'JobsInquiryFakeHiring', candidateState: JobsHiringCandidateState, vacancy?: { __typename?: 'JobsVacancy', id: string, title: string, employmentType: JobsVacancyEmployment, cities?: Array<{ __typename?: 'City', id: string, name: string, stateName?: string | null | undefined }> | null | undefined, countries?: Array<{ __typename?: 'Country', name: string }> | null | undefined, employer: { __typename?: 'JobsEmployer', id: string, roleUrl?: string | null | undefined, descriptionHtml?: string | null | undefined, keyPoints: Array<string>, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } }, submission?: { __typename?: 'JobsVacancySubmission', companyName: string, roleName: string, ote?: string | null | undefined, baseSalary?: string | null | undefined, quotaAttainmentByTeam?: number | null | undefined, compensation?: string | null | undefined, minBandwidth?: string | null | undefined, compensationDescription?: string | null | undefined, avgDealSize?: string | null | undefined, avgSalesCycle?: string | null | undefined, industry: string, customerProfile?: string | null | undefined, brandMaturity?: JobsVacancySubmissionBrandMaturity | null | undefined, location: string, workType?: string | null | undefined, jobUrl?: string | null | undefined, keyPoint1?: string | null | undefined, keyPoint2?: string | null | undefined, keyPoint3?: string | null | undefined, keyPoint4?: string | null | undefined, keyPoint5?: string | null | undefined, keyPoint6?: string | null | undefined, keyPoint7?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type JobsHiringFragment = { __typename?: 'JobsHiring', id: string, candidateState?: JobsHiringCandidateState | null | undefined };

export type JobsOpportunitiesMixinRemoveFakeHiringMutationMutationVariables = Exact<{
  input: UpdateInquiryInput;
}>;


export type JobsOpportunitiesMixinRemoveFakeHiringMutationMutation = { __typename?: 'Mutation', updateJobsInquiry?: { __typename?: 'JobsInquiry', id: string, fakeHiring?: { __typename?: 'JobsInquiryFakeHiring', vacancyUid: string, candidateState: JobsHiringCandidateState } | null | undefined } | null | undefined };

export type JobsHiringQueryVariables = Exact<{
  hashid: Scalars['String'];
}>;


export type JobsHiringQuery = { __typename?: 'Query', jobsHiring: { __typename?: 'JobsHiring', id: string, hashid: string, candidateStateUpdatedAt?: any | null | undefined, candidateState?: JobsHiringCandidateState | null | undefined, candidateStateViewed?: boolean | null | undefined, vacancy?: { __typename?: 'JobsVacancy', id: string, title: string, employmentType: JobsVacancyEmployment, employer: { __typename?: 'JobsEmployer', id: string, roleUrl?: string | null | undefined, descriptionHtml?: string | null | undefined, keyPoints: Array<string>, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } }, submission?: { __typename?: 'JobsVacancySubmission', companyName: string, roleName: string, ote?: string | null | undefined, baseSalary?: string | null | undefined, quotaAttainmentByTeam?: number | null | undefined, compensation?: string | null | undefined, minBandwidth?: string | null | undefined, compensationDescription?: string | null | undefined, avgDealSize?: string | null | undefined, avgSalesCycle?: string | null | undefined, industry: string, customerProfile?: string | null | undefined, brandMaturity?: JobsVacancySubmissionBrandMaturity | null | undefined, location: string, workType?: string | null | undefined, jobUrl?: string | null | undefined, keyPoint1?: string | null | undefined, keyPoint2?: string | null | undefined, keyPoint3?: string | null | undefined, keyPoint4?: string | null | undefined, keyPoint5?: string | null | undefined, keyPoint6?: string | null | undefined, keyPoint7?: string | null | undefined } | null | undefined, primaryRecruiter?: { __typename?: 'JobsRecruiter', email: string, firstname?: string | null | undefined, lastname?: string | null | undefined, schedulingLink?: string | null | undefined } | null | undefined, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } } | null | undefined } };

export type UpdateJobsCandidatesHiringMutationVariables = Exact<{
  input: JobsCandidatesUpdateHiringInput;
}>;


export type UpdateJobsCandidatesHiringMutation = { __typename?: 'Mutation', updateJobsCandidatesHiring?: { __typename?: 'JobsHiring', id: string, candidateStateViewed?: boolean | null | undefined } | null | undefined };

export type JobsPlaceholderCurrentJobsInquiryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsPlaceholderCurrentJobsInquiryQueryQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', aeLeadSourceOther?: string | null | undefined, aeLeadSourcesMain?: Array<JobsInquiryAeLeadSource> | null | undefined, aeQuotaPerPeriod?: number | null | undefined, aeQuotaTypeMain?: JobsInquiryAeQuota | null | undefined, aeQuotaTypeOther?: string | null | undefined, baseSalary?: number | null | undefined, csmAccountsNumber?: JobsInquiryCsmAccountNumber | null | undefined, csmQuotaMetricMain?: Array<JobsInquiryCsmQuotaMetric> | null | undefined, csmQuotaMetricOther?: string | null | undefined, csmQuotaPeriodMain?: JobsInquiryCsmQuotaPeriod | null | undefined, csmQuotaPeriodOther?: string | null | undefined, csmQuotaTypeMain?: JobsInquiryCsmQuota | null | undefined, csmQuotaTypeOther?: string | null | undefined, csmRenewalValue?: JobsInquiryCsmRenewalValue | null | undefined, csmTotalBusinessValue?: JobsInquiryCsmBusinessValue | null | undefined, csmUpsellValue?: JobsInquiryCsmUpsellValue | null | undefined, currency?: Currency | null | undefined, dealBreakerOther?: string | null | undefined, dealBreakersMain?: Array<JobsInquiryDealBreaker> | null | undefined, dealSize?: JobsInquiryDealSize | null | undefined, employmentTypes: Array<JobsInquiryEmployment>, id: string, idealJobDescription?: string | null | undefined, onboardingState: JobsInquiryOnboardingState, ote?: number | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, quotaAttainmentByTeamPerPeriod?: number | null | undefined, quotaAttainmentPerLastYear?: number | null | undefined, quotaAttainmentPerPeriod?: number | null | undefined, rankOnTeam?: number | null | undefined, revenue?: number | null | undefined, salesCycleLength?: JobsInquirySalesCycleLength | null | undefined, salesMethodologies?: Array<JobsInquirySalesMethodology> | null | undefined, sdrQuotaPerPeriod?: string | null | undefined, sdrQuotaTypes?: Array<JobsInquirySdrQuota> | null | undefined, state: JobsInquiryState, teamSize?: number | null | undefined, vpDepartmentSize?: JobsInquiryVpDepartmentSize | null | undefined, vpManagedRoles?: Array<JobsInquiryVpManagedRole> | null | undefined, vpQuotaType?: JobsInquiryVpQuota | null | undefined, willingToRelocate?: boolean | null | undefined, desiredCompanySeriesStages?: Array<{ __typename?: 'CompanySeriesStage', description: string, id: string, name: string, slug: CompanySeriesStageSlug }> | null | undefined } | null | undefined };

export type JobsProfilePageCurrentJobsInquiryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsProfilePageCurrentJobsInquiryQueryQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', id: string, flexState?: string | null | undefined, source: JobsInquirySource, state: JobsInquiryState, stale: boolean, currency?: Currency | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, willingToRelocate?: boolean | null | undefined, employmentTypes: Array<JobsInquiryEmployment>, dealBreakersMain?: Array<JobsInquiryDealBreaker> | null | undefined, dealBreakerOther?: string | null | undefined, idealJobDescription?: string | null | undefined, desiredCompanySeriesStages?: Array<{ __typename?: 'CompanySeriesStage', description: string, id: string, name: string, slug: CompanySeriesStageSlug }> | null | undefined, fakeHiring?: { __typename?: 'JobsInquiryFakeHiring', candidateState: JobsHiringCandidateState, vacancy?: { __typename?: 'JobsVacancy', id: string, employmentType: JobsVacancyEmployment, submission?: { __typename?: 'JobsVacancySubmission', companyName: string, roleName: string, minBandwidth?: string | null | undefined } | null | undefined, employer: { __typename?: 'JobsEmployer', id: string, company: { __typename?: 'Company', id: string, logoUrl?: string | null | undefined } } } | null | undefined } | null | undefined, activeHirings?: Array<{ __typename?: 'JobsHiring', id: string, candidateState?: JobsHiringCandidateState | null | undefined, candidateStateViewed?: boolean | null | undefined, hashid: string, vacancy?: { __typename?: 'JobsVacancy', id: string, employmentType: JobsVacancyEmployment, title: string, submission?: { __typename?: 'JobsVacancySubmission', companyName: string, roleName: string, minBandwidth?: string | null | undefined } | null | undefined, employer: { __typename?: 'JobsEmployer', id: string, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } }, primaryRecruiter?: { __typename?: 'JobsRecruiter', email: string, firstname?: string | null | undefined, lastname?: string | null | undefined, schedulingLink?: string | null | undefined } | null | undefined, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } } | null | undefined }> | null | undefined, hiringsForReview?: Array<{ __typename?: 'JobsHiring', id: string, hashid: string, acceptedByEmployer: boolean, hoursToExpire?: number | null | undefined, vacancy?: { __typename?: 'JobsVacancy', id: string, employmentType: JobsVacancyEmployment, submission?: { __typename?: 'JobsVacancySubmission', companyName: string, minBandwidth?: string | null | undefined, compensation?: string | null | undefined, ote?: string | null | undefined, location: string, roleName: string } | null | undefined, company: { __typename?: 'Company', id: string, logoUrl?: string | null | undefined, name: string } } | null | undefined }> | null | undefined } | null | undefined };

export type JobsUpdateInquiryMutationMutationVariables = Exact<{
  input: UpdateInquiryInput;
}>;


export type JobsUpdateInquiryMutationMutation = { __typename?: 'Mutation', updateJobsInquiry?: { __typename?: 'JobsInquiry', id: string, flexState?: string | null | undefined, source: JobsInquirySource, state: JobsInquiryState, stale: boolean, currency?: Currency | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, willingToRelocate?: boolean | null | undefined, employmentTypes: Array<JobsInquiryEmployment>, dealBreakersMain?: Array<JobsInquiryDealBreaker> | null | undefined, dealBreakerOther?: string | null | undefined, idealJobDescription?: string | null | undefined, desiredCompanySeriesStages?: Array<{ __typename?: 'CompanySeriesStage', description: string, id: string, name: string, slug: CompanySeriesStageSlug }> | null | undefined, fakeHiring?: { __typename?: 'JobsInquiryFakeHiring', candidateState: JobsHiringCandidateState, vacancy?: { __typename?: 'JobsVacancy', id: string, employmentType: JobsVacancyEmployment, submission?: { __typename?: 'JobsVacancySubmission', companyName: string, roleName: string, minBandwidth?: string | null | undefined } | null | undefined, employer: { __typename?: 'JobsEmployer', id: string, company: { __typename?: 'Company', id: string, logoUrl?: string | null | undefined } } } | null | undefined } | null | undefined, activeHirings?: Array<{ __typename?: 'JobsHiring', id: string, candidateState?: JobsHiringCandidateState | null | undefined, candidateStateViewed?: boolean | null | undefined, hashid: string, vacancy?: { __typename?: 'JobsVacancy', id: string, employmentType: JobsVacancyEmployment, title: string, submission?: { __typename?: 'JobsVacancySubmission', companyName: string, roleName: string, minBandwidth?: string | null | undefined } | null | undefined, employer: { __typename?: 'JobsEmployer', id: string, company: { __typename?: 'Company', id: string, logoUrl?: string | null | undefined } }, primaryRecruiter?: { __typename?: 'JobsRecruiter', firstname?: string | null | undefined, lastname?: string | null | undefined, schedulingLink?: string | null | undefined } | null | undefined, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } } | null | undefined }> | null | undefined, hiringsForReview?: Array<{ __typename?: 'JobsHiring', id: string, acceptedByEmployer: boolean, hoursToExpire?: number | null | undefined, vacancy?: { __typename?: 'JobsVacancy', id: string, employmentType: JobsVacancyEmployment, submission?: { __typename?: 'JobsVacancySubmission', companyName: string, minBandwidth?: string | null | undefined, compensation?: string | null | undefined, ote?: string | null | undefined, location: string, roleName: string } | null | undefined, company: { __typename?: 'Company', id: string, logoUrl?: string | null | undefined, name: string } } | null | undefined }> | null | undefined } | null | undefined };

export type JobsProfileUpdatePageCurrentJobsInquiryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsProfileUpdatePageCurrentJobsInquiryQueryQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', aeQuotaTypeMain?: JobsInquiryAeQuota | null | undefined, aeQuotaTypeOther?: string | null | undefined, baseSalary?: number | null | undefined, csmQuotaPeriodMain?: JobsInquiryCsmQuotaPeriod | null | undefined, csmQuotaTypeMain?: JobsInquiryCsmQuota | null | undefined, currency?: Currency | null | undefined, id: string, ote?: number | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, quotaAttainmentByTeamPerPeriod?: number | null | undefined, quotaAttainmentPerLastYear?: number | null | undefined, quotaAttainmentPerPeriod?: number | null | undefined, rankOnTeam?: number | null | undefined, stale: boolean, teamSize?: number | null | undefined, vpDepartmentSize?: JobsInquiryVpDepartmentSize | null | undefined } | null | undefined };

export type JobsProfileUpdatePageJobsInquiryFragmentFragment = { __typename?: 'JobsInquiry', aeQuotaTypeMain?: JobsInquiryAeQuota | null | undefined, aeQuotaTypeOther?: string | null | undefined, baseSalary?: number | null | undefined, csmQuotaPeriodMain?: JobsInquiryCsmQuotaPeriod | null | undefined, csmQuotaTypeMain?: JobsInquiryCsmQuota | null | undefined, currency?: Currency | null | undefined, id: string, ote?: number | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, quotaAttainmentByTeamPerPeriod?: number | null | undefined, quotaAttainmentPerLastYear?: number | null | undefined, quotaAttainmentPerPeriod?: number | null | undefined, rankOnTeam?: number | null | undefined, stale: boolean, teamSize?: number | null | undefined, vpDepartmentSize?: JobsInquiryVpDepartmentSize | null | undefined };

export type JobsProfileUpdatePageRefreshJobsInquiryMutationMutationVariables = Exact<{
  input: RefreshInquiryInput;
}>;


export type JobsProfileUpdatePageRefreshJobsInquiryMutationMutation = { __typename?: 'Mutation', refreshJobsInquiry?: { __typename?: 'JobsInquiry', aeQuotaTypeMain?: JobsInquiryAeQuota | null | undefined, aeQuotaTypeOther?: string | null | undefined, baseSalary?: number | null | undefined, csmQuotaPeriodMain?: JobsInquiryCsmQuotaPeriod | null | undefined, csmQuotaTypeMain?: JobsInquiryCsmQuota | null | undefined, currency?: Currency | null | undefined, id: string, ote?: number | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, quotaAttainmentByTeamPerPeriod?: number | null | undefined, quotaAttainmentPerLastYear?: number | null | undefined, quotaAttainmentPerPeriod?: number | null | undefined, rankOnTeam?: number | null | undefined, stale: boolean, teamSize?: number | null | undefined, vpDepartmentSize?: JobsInquiryVpDepartmentSize | null | undefined, hiringsForReview?: Array<{ __typename?: 'JobsHiring', id: string }> | null | undefined } | null | undefined };

export type CurrentJobsInquiryQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentJobsInquiryQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', id: string, flexState?: string | null | undefined } | null | undefined };

export type JobsVacancyQueryQueryVariables = Exact<{
  uid: Scalars['String'];
}>;


export type JobsVacancyQueryQuery = { __typename?: 'Query', jobsVacancy: { __typename?: 'JobsVacancy', id: string, uid: string, title: string, employmentType: JobsVacancyEmployment, employer: { __typename?: 'JobsEmployer', id: string, descriptionHtml?: string | null | undefined, keyPoints: Array<string>, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } }, submission?: { __typename?: 'JobsVacancySubmission', companyName: string, roleName: string, ote?: string | null | undefined, baseSalary?: string | null | undefined, quotaAttainmentByTeam?: number | null | undefined, compensation?: string | null | undefined, minBandwidth?: string | null | undefined, compensationDescription?: string | null | undefined, avgDealSize?: string | null | undefined, avgSalesCycle?: string | null | undefined, industry: string, customerProfile?: string | null | undefined, brandMaturity?: JobsVacancySubmissionBrandMaturity | null | undefined, location: string, workType?: string | null | undefined, jobUrl?: string | null | undefined, keyPoint1?: string | null | undefined, keyPoint2?: string | null | undefined, keyPoint3?: string | null | undefined, keyPoint4?: string | null | undefined, keyPoint5?: string | null | undefined, keyPoint6?: string | null | undefined, keyPoint7?: string | null | undefined } | null | undefined } };

export type JobsInquiryFragment = { __typename?: 'JobsInquiry', id: string, hiringsForReview?: Array<{ __typename?: 'JobsHiring', id: string, employer: { __typename?: 'JobsEmployer', id: string, descriptionHtml?: string | null | undefined, keyPoints: Array<string>, roleUrl?: string | null | undefined, company: { __typename?: 'Company', id: string, domain?: string | null | undefined, homepageUrl?: string | null | undefined, name: string, logoUrl?: string | null | undefined } } }> | null | undefined };

export type JobsOnboardingCurrentJobsInquiryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type JobsOnboardingCurrentJobsInquiryQueryQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', aeLeadSourceOther?: string | null | undefined, aeLeadSourcesMain?: Array<JobsInquiryAeLeadSource> | null | undefined, aeQuotaPerPeriod?: number | null | undefined, aeQuotaTypeMain?: JobsInquiryAeQuota | null | undefined, aeQuotaTypeOther?: string | null | undefined, baseSalary?: number | null | undefined, csmAccountsNumber?: JobsInquiryCsmAccountNumber | null | undefined, csmQuotaMetricMain?: Array<JobsInquiryCsmQuotaMetric> | null | undefined, csmQuotaMetricOther?: string | null | undefined, csmQuotaPeriodMain?: JobsInquiryCsmQuotaPeriod | null | undefined, csmQuotaPeriodOther?: string | null | undefined, csmQuotaTypeMain?: JobsInquiryCsmQuota | null | undefined, csmQuotaTypeOther?: string | null | undefined, csmRenewalValue?: JobsInquiryCsmRenewalValue | null | undefined, csmTotalBusinessValue?: JobsInquiryCsmBusinessValue | null | undefined, csmUpsellValue?: JobsInquiryCsmUpsellValue | null | undefined, currency?: Currency | null | undefined, dealBreakerOther?: string | null | undefined, dealBreakersMain?: Array<JobsInquiryDealBreaker> | null | undefined, dealSize?: JobsInquiryDealSize | null | undefined, employmentTypes: Array<JobsInquiryEmployment>, id: string, idealJobDescription?: string | null | undefined, onboardingState: JobsInquiryOnboardingState, ote?: number | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, quotaAttainmentByTeamPerPeriod?: number | null | undefined, quotaAttainmentPerLastYear?: number | null | undefined, quotaAttainmentPerPeriod?: number | null | undefined, rankOnTeam?: number | null | undefined, revenue?: number | null | undefined, salesCycleLength?: JobsInquirySalesCycleLength | null | undefined, salesMethodologies?: Array<JobsInquirySalesMethodology> | null | undefined, sdrQuotaPerPeriod?: string | null | undefined, sdrQuotaTypes?: Array<JobsInquirySdrQuota> | null | undefined, state: JobsInquiryState, teamSize?: number | null | undefined, vpDepartmentSize?: JobsInquiryVpDepartmentSize | null | undefined, vpManagedRoles?: Array<JobsInquiryVpManagedRole> | null | undefined, vpQuotaType?: JobsInquiryVpQuota | null | undefined, willingToRelocate?: boolean | null | undefined, desiredCompanySeriesStages?: Array<{ __typename?: 'CompanySeriesStage', description: string, id: string, name: string, slug: CompanySeriesStageSlug }> | null | undefined } | null | undefined };

export type FillJobsInquiryMutationVariables = Exact<{
  input: FillInquiryInput;
}>;


export type FillJobsInquiryMutation = { __typename?: 'Mutation', fillJobsInquiry?: { __typename?: 'JobsInquiry', id: string, state: JobsInquiryState } | null | undefined };

export type JobsOnboardingJobsInquiryFragmentFragment = { __typename?: 'JobsInquiry', aeLeadSourceOther?: string | null | undefined, aeLeadSourcesMain?: Array<JobsInquiryAeLeadSource> | null | undefined, aeQuotaPerPeriod?: number | null | undefined, aeQuotaTypeMain?: JobsInquiryAeQuota | null | undefined, aeQuotaTypeOther?: string | null | undefined, baseSalary?: number | null | undefined, csmAccountsNumber?: JobsInquiryCsmAccountNumber | null | undefined, csmQuotaMetricMain?: Array<JobsInquiryCsmQuotaMetric> | null | undefined, csmQuotaMetricOther?: string | null | undefined, csmQuotaPeriodMain?: JobsInquiryCsmQuotaPeriod | null | undefined, csmQuotaPeriodOther?: string | null | undefined, csmQuotaTypeMain?: JobsInquiryCsmQuota | null | undefined, csmQuotaTypeOther?: string | null | undefined, csmRenewalValue?: JobsInquiryCsmRenewalValue | null | undefined, csmTotalBusinessValue?: JobsInquiryCsmBusinessValue | null | undefined, csmUpsellValue?: JobsInquiryCsmUpsellValue | null | undefined, currency?: Currency | null | undefined, dealBreakerOther?: string | null | undefined, dealBreakersMain?: Array<JobsInquiryDealBreaker> | null | undefined, dealSize?: JobsInquiryDealSize | null | undefined, employmentTypes: Array<JobsInquiryEmployment>, id: string, idealJobDescription?: string | null | undefined, onboardingState: JobsInquiryOnboardingState, ote?: number | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, quotaAttainmentByTeamPerPeriod?: number | null | undefined, quotaAttainmentPerLastYear?: number | null | undefined, quotaAttainmentPerPeriod?: number | null | undefined, rankOnTeam?: number | null | undefined, revenue?: number | null | undefined, salesCycleLength?: JobsInquirySalesCycleLength | null | undefined, salesMethodologies?: Array<JobsInquirySalesMethodology> | null | undefined, sdrQuotaPerPeriod?: string | null | undefined, sdrQuotaTypes?: Array<JobsInquirySdrQuota> | null | undefined, state: JobsInquiryState, teamSize?: number | null | undefined, vpDepartmentSize?: JobsInquiryVpDepartmentSize | null | undefined, vpManagedRoles?: Array<JobsInquiryVpManagedRole> | null | undefined, vpQuotaType?: JobsInquiryVpQuota | null | undefined, willingToRelocate?: boolean | null | undefined, desiredCompanySeriesStages?: Array<{ __typename?: 'CompanySeriesStage', description: string, id: string, name: string, slug: CompanySeriesStageSlug }> | null | undefined };

export type JobsOnboardingUpdateJobsInquiryMutationMutationVariables = Exact<{
  input: UpdateInquiryInput;
}>;


export type JobsOnboardingUpdateJobsInquiryMutationMutation = { __typename?: 'Mutation', updateJobsInquiry?: { __typename?: 'JobsInquiry', aeLeadSourceOther?: string | null | undefined, aeLeadSourcesMain?: Array<JobsInquiryAeLeadSource> | null | undefined, aeQuotaPerPeriod?: number | null | undefined, aeQuotaTypeMain?: JobsInquiryAeQuota | null | undefined, aeQuotaTypeOther?: string | null | undefined, baseSalary?: number | null | undefined, csmAccountsNumber?: JobsInquiryCsmAccountNumber | null | undefined, csmQuotaMetricMain?: Array<JobsInquiryCsmQuotaMetric> | null | undefined, csmQuotaMetricOther?: string | null | undefined, csmQuotaPeriodMain?: JobsInquiryCsmQuotaPeriod | null | undefined, csmQuotaPeriodOther?: string | null | undefined, csmQuotaTypeMain?: JobsInquiryCsmQuota | null | undefined, csmQuotaTypeOther?: string | null | undefined, csmRenewalValue?: JobsInquiryCsmRenewalValue | null | undefined, csmTotalBusinessValue?: JobsInquiryCsmBusinessValue | null | undefined, csmUpsellValue?: JobsInquiryCsmUpsellValue | null | undefined, currency?: Currency | null | undefined, dealBreakerOther?: string | null | undefined, dealBreakersMain?: Array<JobsInquiryDealBreaker> | null | undefined, dealSize?: JobsInquiryDealSize | null | undefined, employmentTypes: Array<JobsInquiryEmployment>, id: string, idealJobDescription?: string | null | undefined, onboardingState: JobsInquiryOnboardingState, ote?: number | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, quotaAttainmentByTeamPerPeriod?: number | null | undefined, quotaAttainmentPerLastYear?: number | null | undefined, quotaAttainmentPerPeriod?: number | null | undefined, rankOnTeam?: number | null | undefined, revenue?: number | null | undefined, salesCycleLength?: JobsInquirySalesCycleLength | null | undefined, salesMethodologies?: Array<JobsInquirySalesMethodology> | null | undefined, sdrQuotaPerPeriod?: string | null | undefined, sdrQuotaTypes?: Array<JobsInquirySdrQuota> | null | undefined, state: JobsInquiryState, teamSize?: number | null | undefined, vpDepartmentSize?: JobsInquiryVpDepartmentSize | null | undefined, vpManagedRoles?: Array<JobsInquiryVpManagedRole> | null | undefined, vpQuotaType?: JobsInquiryVpQuota | null | undefined, willingToRelocate?: boolean | null | undefined, desiredCompanySeriesStages?: Array<{ __typename?: 'CompanySeriesStage', description: string, id: string, name: string, slug: CompanySeriesStageSlug }> | null | undefined } | null | undefined };

export type AnonymousProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type AnonymousProfileQuery = { __typename?: 'Query', anonymous: { __typename?: 'CurrentUser', id: string, username?: string | null | undefined, warRoomAvatarUrl?: string | null | undefined } };

export type LastProfileUsedQueryVariables = Exact<{ [key: string]: never; }>;


export type LastProfileUsedQuery = { __typename?: 'Query', lastProfileUsed: Activity };

export type PublicProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicProfileQuery = { __typename?: 'Query', public: { __typename?: 'PublicPortfolioCurrentUser', firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined, configuration: { __typename?: 'PublicPortfolioConfiguration', isPublic: boolean } } };

export type ClientFragmentFragment = { __typename?: 'Client', id: string, isPublic: boolean, position?: number | null | undefined, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } };

export type CreateClientForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: CreateClientForPublicPortfolioCurrentUserInput;
}>;


export type CreateClientForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', createClientForPublicPortfolioCurrentUser?: { __typename?: 'Client', id: string, isPublic: boolean, position?: number | null | undefined, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } } | null | undefined };

export type CreateCustomCompanyMutationVariables = Exact<{
  input: CreateCustomCompanyInput;
}>;


export type CreateCustomCompanyMutation = { __typename?: 'Mutation', createCustomCompany?: { __typename?: 'Company', id: string, name: string } | null | undefined };

export type DestroyClientForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: DestroyClientForPublicPortfolioCurrentUserInput;
}>;


export type DestroyClientForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', destroyClientForPublicPortfolioCurrentUser?: { __typename?: 'Client', id: string, isPublic: boolean, position?: number | null | undefined, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } } | null | undefined };

export type UpdateClientForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: UpdateClientForPublicPortfolioCurrentUserInput;
}>;


export type UpdateClientForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', updateClientForPublicPortfolioCurrentUser?: { __typename?: 'Client', id: string, isPublic: boolean, position?: number | null | undefined, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } } | null | undefined };

export type UpdateClientPositionForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: UpdateClientPositionForPublicPortfolioCurrentUserInput;
}>;


export type UpdateClientPositionForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', updateClientPositionForPublicPortfolioCurrentUser?: { __typename?: 'PublicPortfolioCurrentUser', clients?: Array<{ __typename?: 'Client', id: string, isPublic: boolean, position?: number | null | undefined, company: { __typename?: 'Company', id: string, name: string, logoUrl?: string | null | undefined } }> | null | undefined } | null | undefined };

export type PublicPortfolioConnectionsQueryVariables = Exact<{
  slug: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type PublicPortfolioConnectionsQuery = { __typename?: 'Query', publicPortfolioConnections?: { __typename?: 'PublicPortfolioUser', slug: string, firstname?: string | null | undefined, lastname?: string | null | undefined, connections?: { __typename?: 'ConnectionConnection', totalCount: number, nodes: Array<{ __typename?: 'Connection', requestId?: string | null | undefined, receivedRequestId?: string | null | undefined, avatarUrl?: string | null | undefined, currentPosition?: string | null | undefined, firstname?: string | null | undefined, lastname?: string | null | undefined, slug: string, connected?: boolean | null | undefined, currentCompany?: { __typename?: 'Company', name: string } | null | undefined }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null | undefined } } | null | undefined } | null | undefined };

export type PortfolioEditUpdateJobsInquiryMutationMutationVariables = Exact<{
  input: UpdateInquiryInput;
}>;


export type PortfolioEditUpdateJobsInquiryMutationMutation = { __typename?: 'Mutation', updateJobsInquiry?: { __typename?: 'JobsInquiry', aeLeadSourceOther?: string | null | undefined, aeLeadSourcesMain?: Array<JobsInquiryAeLeadSource> | null | undefined, aeQuotaPerPeriod?: number | null | undefined, aeQuotaTypeMain?: JobsInquiryAeQuota | null | undefined, aeQuotaTypeOther?: string | null | undefined, baseSalary?: number | null | undefined, csmAccountsNumber?: JobsInquiryCsmAccountNumber | null | undefined, csmQuotaMetricMain?: Array<JobsInquiryCsmQuotaMetric> | null | undefined, csmQuotaMetricOther?: string | null | undefined, csmQuotaPeriodMain?: JobsInquiryCsmQuotaPeriod | null | undefined, csmQuotaPeriodOther?: string | null | undefined, csmQuotaTypeMain?: JobsInquiryCsmQuota | null | undefined, csmRenewalValue?: JobsInquiryCsmRenewalValue | null | undefined, csmTotalBusinessValue?: JobsInquiryCsmBusinessValue | null | undefined, csmUpsellValue?: JobsInquiryCsmUpsellValue | null | undefined, currency?: Currency | null | undefined, dealSize?: JobsInquiryDealSize | null | undefined, id: string, ote?: number | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, quotaAttainmentByTeamPerPeriod?: number | null | undefined, quotaAttainmentPerLastYear?: number | null | undefined, quotaAttainmentPerPeriod?: number | null | undefined, rankOnTeam?: number | null | undefined, revenue?: number | null | undefined, salesCycleLength?: JobsInquirySalesCycleLength | null | undefined, salesMethodologies?: Array<JobsInquirySalesMethodology> | null | undefined, sdrQuotaPerPeriod?: string | null | undefined, sdrQuotaTypes?: Array<JobsInquirySdrQuota> | null | undefined, state: JobsInquiryState, teamSize?: number | null | undefined, vpDepartmentSize?: JobsInquiryVpDepartmentSize | null | undefined, vpManagedRoles?: Array<JobsInquiryVpManagedRole> | null | undefined, vpQuotaType?: JobsInquiryVpQuota | null | undefined, filledAt?: any | null | undefined } | null | undefined };

export type ExpressDesireToImportConnectionsForPublicPortfolioUserMutationVariables = Exact<{ [key: string]: never; }>;


export type ExpressDesireToImportConnectionsForPublicPortfolioUserMutation = { __typename?: 'Mutation', expressDesireToImportConnectionsForPublicPortfolioUser?: boolean | null | undefined };

export type PublicPortfolioConnectionsImportModalQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicPortfolioConnectionsImportModalQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, lastContactsSyncedAt?: any | null | undefined } };

export type ConnectionsSuggestionsQueryVariables = Exact<{
  type: ConnectionSuggestionType;
  after?: InputMaybe<Scalars['String']>;
}>;


export type ConnectionsSuggestionsQuery = { __typename?: 'Query', connectionSuggestions: { __typename?: 'ConnectionSuggestionInterfaceConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean }, edges: Array<{ __typename?: 'ConnectionSuggestionInterfaceEdge', node?: { __typename?: 'ConnectionTopSuggestionUser', avatarUrl?: string | null | undefined, position?: string | null | undefined, id: string, name: string } | { __typename?: 'UserContact', id: string, name: string } | null | undefined }> } };

export type PublicPortfolioPublicConnectionsModalQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicPortfolioPublicConnectionsModalQuery = { __typename?: 'Query', publicPortfolioUser?: { __typename?: 'PublicPortfolioUser', slug: string, firstname?: string | null | undefined, lastname?: string | null | undefined, connections?: { __typename?: 'ConnectionConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean }, edges: Array<{ __typename?: 'ConnectionEdge', node?: { __typename?: 'Connection', slug: string, firstname?: string | null | undefined, lastname?: string | null | undefined, avatarUrl?: string | null | undefined, currentPosition?: string | null | undefined, currentCompany?: { __typename?: 'Company', name: string } | null | undefined } | null | undefined }> } | null | undefined, configuration: { __typename?: 'PublicPortfolioConfiguration', sectionConnectionsIsPublic: boolean } } | null | undefined };

export type PublicPortfolioConfigurationQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicPortfolioConfigurationQuery = { __typename?: 'Query', publicPortfolioUser?: { __typename?: 'PublicPortfolioUser', configuration: { __typename?: 'PublicPortfolioConfiguration', sectionConnectionsIsPublic: boolean } } | null | undefined };

export type UpdateConnectionsSectionVisibilityMutationVariables = Exact<{
  input: UpdateConfigurationForPublicPortfolioCurrentUserInput;
}>;


export type UpdateConnectionsSectionVisibilityMutation = { __typename?: 'Mutation', updateConfigurationForPublicPortfolioCurrentUser?: { __typename?: 'PublicPortfolioConfiguration', sectionConnectionsIsPublic: boolean } | null | undefined };

export type PublicPortfolioUserInfoQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicPortfolioUserInfoQuery = { __typename?: 'Query', publicPortfolioUserInfo?: { __typename?: 'PublicPortfolioUser', slug: string, firstname?: string | null | undefined } | null | undefined };

export type PublicPortfolioEducationHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicPortfolioEducationHistoryQuery = { __typename?: 'Query', educationHistory: { __typename?: 'EducationHistory', fieldOfStudy?: string | null | undefined, id?: string | null | undefined, degreeName?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, manuallyEdited: boolean, university?: { __typename?: 'University', id: string, slug?: string | null | undefined, name: string, logoUrl?: string | null | undefined, custom: boolean, verified: boolean, parent?: { __typename?: 'University', slug?: string | null | undefined, name: string, logoUrl?: string | null | undefined } | null | undefined } | null | undefined } };

export type CreateEducationHistoryForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: CreateEducationHistoryForPublicPortfolioCurrentUserInput;
}>;


export type CreateEducationHistoryForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', createEducationHistoryForPublicPortfolioCurrentUser?: { __typename?: 'EducationHistory', id?: string | null | undefined, degreeName?: string | null | undefined, startDate?: any | null | undefined, endDate?: any | null | undefined, manuallyEdited: boolean, university?: { __typename?: 'University', id: string, slug?: string | null | undefined, name: string, logoUrl?: string | null | undefined, custom: boolean, verified: boolean, parent?: { __typename?: 'University', slug?: string | null | undefined, name: string, logoUrl?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type CreateCustomUniversityMutationVariables = Exact<{
  input: CreateCustomUniversityInput;
}>;


export type CreateCustomUniversityMutation = { __typename?: 'Mutation', createCustomUniversity?: { __typename?: 'University', id: string, name: string } | null | undefined };

export type EducationHistoryDegreesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type EducationHistoryDegreesQuery = { __typename?: 'Query', universityDegrees: Array<string> };

export type DestroyEducationHistoryForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: DestroyEducationHistoryForPublicPortfolioCurrentUserInput;
}>;


export type DestroyEducationHistoryForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', destroyEducationHistoryForPublicPortfolioCurrentUser?: { __typename?: 'EducationHistory', id?: string | null | undefined } | null | undefined };

export type UpdateEducationHistoryForPublicPortfolioCurrentUserMutationVariables = Exact<{
  input: UpdateEducationHistoryForPublicPortfolioCurrentUserInput;
}>;


export type UpdateEducationHistoryForPublicPortfolioCurrentUserMutation = { __typename?: 'Mutation', updateEducationHistoryForPublicPortfolioCurrentUser?: { __typename?: 'EducationHistory', id?: string | null | undefined } | null | undefined };

export type EducationHistoryUniversitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type EducationHistoryUniversitiesQuery = { __typename?: 'Query', universities: { __typename?: 'UniversityConnection', nodes: Array<{ __typename?: 'University', id: string, name: string }> } };

export type PublicPortfolioStrengthQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicPortfolioStrengthQuery = { __typename?: 'Query', publicPortfolioUser?: { __typename?: 'PublicPortfolioUser', connections?: { __typename?: 'ConnectionConnection', edges: Array<{ __typename?: 'ConnectionEdge', node?: { __typename?: 'Connection', slug: string } | null | undefined }> } | null | undefined, testimonials?: Array<{ __typename?: 'Testimonial', state: TestimonialState }> | null | undefined } | null | undefined };

export type PublicPortfolioHeroQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicPortfolioHeroQuery = { __typename?: 'Query', publicPortfolioUser?: { __typename?: 'PublicPortfolioUser', firstname?: string | null | undefined, connections?: { __typename?: 'ConnectionConnection', totalCount: number } | null | undefined, configuration: { __typename?: 'PublicPortfolioConfiguration', sectionConnectionsIsPublic: boolean, fieldPhoneIsPublic: boolean, fieldPublicEmailIsPublic: boolean, fieldLinkedinSlugIsPublic: boolean, fieldCalendarLinkIsPublic: boolean } } | null | undefined };

export type PublicPortfolioIndexPageCurrentJobsInquiryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicPortfolioIndexPageCurrentJobsInquiryQueryQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', aeLeadSourceOther?: string | null | undefined, aeLeadSourcesMain?: Array<JobsInquiryAeLeadSource> | null | undefined, aeQuotaPerPeriod?: number | null | undefined, aeQuotaTypeMain?: JobsInquiryAeQuota | null | undefined, aeQuotaTypeOther?: string | null | undefined, baseSalary?: number | null | undefined, csmAccountsNumber?: JobsInquiryCsmAccountNumber | null | undefined, csmQuotaMetricMain?: Array<JobsInquiryCsmQuotaMetric> | null | undefined, csmQuotaMetricOther?: string | null | undefined, csmQuotaPeriodMain?: JobsInquiryCsmQuotaPeriod | null | undefined, csmQuotaPeriodOther?: string | null | undefined, csmQuotaTypeMain?: JobsInquiryCsmQuota | null | undefined, csmRenewalValue?: JobsInquiryCsmRenewalValue | null | undefined, csmTotalBusinessValue?: JobsInquiryCsmBusinessValue | null | undefined, csmUpsellValue?: JobsInquiryCsmUpsellValue | null | undefined, currency?: Currency | null | undefined, dealSize?: JobsInquiryDealSize | null | undefined, id: string, ote?: number | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, quotaAttainmentByTeamPerPeriod?: number | null | undefined, quotaAttainmentPerLastYear?: number | null | undefined, quotaAttainmentPerPeriod?: number | null | undefined, rankOnTeam?: number | null | undefined, revenue?: number | null | undefined, salesCycleLength?: JobsInquirySalesCycleLength | null | undefined, salesMethodologies?: Array<JobsInquirySalesMethodology> | null | undefined, sdrQuotaPerPeriod?: string | null | undefined, sdrQuotaTypes?: Array<JobsInquirySdrQuota> | null | undefined, state: JobsInquiryState, teamSize?: number | null | undefined, vpDepartmentSize?: JobsInquiryVpDepartmentSize | null | undefined, vpManagedRoles?: Array<JobsInquiryVpManagedRole> | null | undefined, vpQuotaType?: JobsInquiryVpQuota | null | undefined, filledAt?: any | null | undefined } | null | undefined };

export type PublicPortfolioIndexPageJobsInquiryFragmentFragment = { __typename?: 'JobsInquiry', aeLeadSourceOther?: string | null | undefined, aeLeadSourcesMain?: Array<JobsInquiryAeLeadSource> | null | undefined, aeQuotaPerPeriod?: number | null | undefined, aeQuotaTypeMain?: JobsInquiryAeQuota | null | undefined, aeQuotaTypeOther?: string | null | undefined, baseSalary?: number | null | undefined, csmAccountsNumber?: JobsInquiryCsmAccountNumber | null | undefined, csmQuotaMetricMain?: Array<JobsInquiryCsmQuotaMetric> | null | undefined, csmQuotaMetricOther?: string | null | undefined, csmQuotaPeriodMain?: JobsInquiryCsmQuotaPeriod | null | undefined, csmQuotaPeriodOther?: string | null | undefined, csmQuotaTypeMain?: JobsInquiryCsmQuota | null | undefined, csmRenewalValue?: JobsInquiryCsmRenewalValue | null | undefined, csmTotalBusinessValue?: JobsInquiryCsmBusinessValue | null | undefined, csmUpsellValue?: JobsInquiryCsmUpsellValue | null | undefined, currency?: Currency | null | undefined, dealSize?: JobsInquiryDealSize | null | undefined, id: string, ote?: number | null | undefined, positionMain?: JobsInquiryPosition | null | undefined, positionOther?: string | null | undefined, quotaAttainmentByTeamPerPeriod?: number | null | undefined, quotaAttainmentPerLastYear?: number | null | undefined, quotaAttainmentPerPeriod?: number | null | undefined, rankOnTeam?: number | null | undefined, revenue?: number | null | undefined, salesCycleLength?: JobsInquirySalesCycleLength | null | undefined, salesMethodologies?: Array<JobsInquirySalesMethodology> | null | undefined, sdrQuotaPerPeriod?: string | null | undefined, sdrQuotaTypes?: Array<JobsInquirySdrQuota> | null | undefined, state: JobsInquiryState, teamSize?: number | null | undefined, vpDepartmentSize?: JobsInquiryVpDepartmentSize | null | undefined, vpManagedRoles?: Array<JobsInquiryVpManagedRole> | null | undefined, vpQuotaType?: JobsInquiryVpQuota | null | undefined, filledAt?: any | null | undefined };

export type PublicPortfolioApproveTestimonialSuccessModalQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicPortfolioApproveTestimonialSuccessModalQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, lastContactsSyncedAt?: any | null | undefined } };

export type PublicPortfolioRequestTestimonialSuccessModalQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicPortfolioRequestTestimonialSuccessModalQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, lastContactsSyncedAt?: any | null | undefined } };

export type PublicPortfolioRequestTestimonialsModalQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicPortfolioRequestTestimonialsModalQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, contacts?: Array<{ __typename?: 'UserContact', id: string, name: string, emails: Array<string> }> | null | undefined } };

export type TestimonialsQueryVariables = Exact<{ [key: string]: never; }>;


export type TestimonialsQuery = { __typename?: 'Query', publicPortfolioCurrentUser: { __typename?: 'PublicPortfolioCurrentUser', testimonials?: Array<{ __typename?: 'Testimonial', id: string, description?: string | null | undefined, state: TestimonialState, author: { __typename?: 'TestimonialAuthor', email?: string | null | undefined, firstname?: string | null | undefined, lastname?: string | null | undefined } }> | null | undefined } };

export type LastContactsSyncedQueryVariables = Exact<{ [key: string]: never; }>;


export type LastContactsSyncedQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, lastContactsSyncedAt?: any | null | undefined, lastContactsSyncError?: string | null | undefined } };

export type PublicPortfolioImportContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicPortfolioImportContactsQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, lastContactsSyncedAt?: any | null | undefined } };

export type UniversityQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type UniversityQuery = { __typename?: 'Query', university: { __typename?: 'University', slug?: string | null | undefined, name: string, address?: string | null | undefined, logoUrl?: string | null | undefined, websiteUrl?: string | null | undefined, description?: string | null | undefined, city?: { __typename?: 'City', stateName?: string | null | undefined, name: string } | null | undefined } };

export type UniversityPagesSuggestionsQueryVariables = Exact<{
  slug: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type UniversityPagesSuggestionsQuery = { __typename?: 'Query', universityPagesSuggestions: { __typename?: 'SuggestedUserConnection', totalCount: number, nodes: Array<{ __typename?: 'SuggestedUser', firstname?: string | null | undefined, lastname?: string | null | undefined, slug: string, avatarUrl?: string | null | undefined, currentPosition?: string | null | undefined, currentCompany?: { __typename?: 'Company', name: string } | null | undefined }> } };

export type UniversityPeopleQueryVariables = Exact<{
  slug: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type UniversityPeopleQuery = { __typename?: 'Query', universityPagesPeople: { __typename?: 'AlumniConnection', totalCount: number, nodes: Array<{ __typename?: 'Alumni', slug: string, avatarUrl?: string | null | undefined, firstname?: string | null | undefined, lastname?: string | null | undefined, currentPosition?: string | null | undefined, requestId?: string | null | undefined, receivedRequestId?: string | null | undefined, connected?: boolean | null | undefined, city?: { __typename?: 'City', name: string, stateCode?: string | null | undefined } | null | undefined }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } };

export type WarRoomCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type WarRoomCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, username?: string | null | undefined, warRoomState: string, warRoomAvatarUrl?: string | null | undefined, warRoomDescription?: string | null | undefined, warRoomPosition?: string | null | undefined, warRoomYearsOfExperience?: number | null | undefined, city?: { __typename?: 'City', id: string, name: string, countryCode: string, stateCode?: string | null | undefined } | null | undefined, departments?: Array<{ __typename?: 'Department', id: string, name: string }> | null | undefined, productTypes?: Array<{ __typename?: 'ProductType', id: number, name: string }> | null | undefined, warRoomSalesRoles?: Array<{ __typename?: 'SalesRole', id: string, name: string }> | null | undefined } };

export type WarRoomJobApplicationBannerCurrentJobsInquiryQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type WarRoomJobApplicationBannerCurrentJobsInquiryQueryQuery = { __typename?: 'Query', currentJobsInquiry?: { __typename?: 'JobsInquiry', id: string, state: JobsInquiryState, activeHiringsCount: number } | null | undefined };

export type LifetimeCommissionEarnedQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type LifetimeCommissionEarnedQueryQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: string, warRoomTotalBalance?: number | null | undefined } };



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AcademyArticleSearchResult: ResolverTypeWrapper<AcademyArticleSearchResult>;
  AcademyTopic: ResolverTypeWrapper<AcademyTopic>;
  AcademyTopicConnection: ResolverTypeWrapper<AcademyTopicConnection>;
  AcademyTopicEdge: ResolverTypeWrapper<AcademyTopicEdge>;
  AcceptRequestInput: AcceptRequestInput;
  ActivateJobsInquiryInput: ActivateJobsInquiryInput;
  Activity: Activity;
  Alumni: ResolverTypeWrapper<Alumni>;
  AlumniConnection: ResolverTypeWrapper<AlumniConnection>;
  AlumniEdge: ResolverTypeWrapper<AlumniEdge>;
  Anonymous: ResolverTypeWrapper<Anonymous>;
  ApplyForWarRoomInput: ApplyForWarRoomInput;
  ApproveTestimonialAuthorAttributes: ApproveTestimonialAuthorAttributes;
  ApproveTestimonialForPublicPortfolioCurrentUserInput: ApproveTestimonialForPublicPortfolioCurrentUserInput;
  ArchiveCandidateHiringInput: ArchiveCandidateHiringInput;
  ArchiveTestimonialForPublicPortfolioCurrentUserInput: ArchiveTestimonialForPublicPortfolioCurrentUserInput;
  Article: ResolverTypeWrapper<Article>;
  AttachCompanySeriesStageInput: AttachCompanySeriesStageInput;
  AttachCompanyStageInput: AttachCompanyStageInput;
  AttachDepartmentInput: AttachDepartmentInput;
  AttachProductInput: AttachProductInput;
  AttachSalesRoleInput: AttachSalesRoleInput;
  Author: ResolverTypeWrapper<Author>;
  AverageHittingQuota: ResolverTypeWrapper<AverageHittingQuota>;
  AveragePerAccountSize: ResolverTypeWrapper<AveragePerAccountSize>;
  AveragePerYearsOfExperience: ResolverTypeWrapper<AveragePerYearsOfExperience>;
  AverageSalariesData: ResolverTypeWrapper<AverageSalariesData>;
  AverageTotals: ResolverTypeWrapper<AverageTotals>;
  Award: ResolverTypeWrapper<Award>;
  BaseMatch: ResolverTypeWrapper<BaseMatch>;
  BestCity: ResolverTypeWrapper<BestCity>;
  BigInt: ResolverTypeWrapper<Scalars['BigInt']>;
  BlockUserInput: BlockUserInput;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  CancelRequestInput: CancelRequestInput;
  CandidateAttributes: CandidateAttributes;
  CandidateAttributesVisability: CandidateAttributesVisability;
  City: ResolverTypeWrapper<City>;
  CityConnection: ResolverTypeWrapper<CityConnection>;
  CityEdge: ResolverTypeWrapper<CityEdge>;
  CityMatch: ResolverTypeWrapper<CityMatch>;
  CitySearchParams: CitySearchParams;
  Client: ResolverTypeWrapper<Client>;
  Comment: ResolverTypeWrapper<Omit<Comment, 'author'> & { author: ResolversTypes['UserAuthor'] }>;
  CommentConnection: ResolverTypeWrapper<CommentConnection>;
  CommentEdge: ResolverTypeWrapper<CommentEdge>;
  CommentSortType: CommentSortType;
  CommissionBalance: ResolverTypeWrapper<CommissionBalance>;
  CommissionOnboarding: ResolverTypeWrapper<CommissionOnboarding>;
  CommissionTransaction: ResolverTypeWrapper<CommissionTransaction>;
  CommissionTransactionSubscriptionPayload: ResolverTypeWrapper<CommissionTransactionSubscriptionPayload>;
  CompaniesCategory: ResolverTypeWrapper<CompaniesCategory>;
  CompaniesConnection: ResolverTypeWrapper<CompaniesConnection>;
  CompaniesSort: CompaniesSort;
  Company: ResolverTypeWrapper<Company>;
  CompanyEdge: ResolverTypeWrapper<CompanyEdge>;
  CompanyInterface: ResolversTypes['Company'] | ResolversTypes['RelatedCompany'];
  CompanyPagesAverageRate: ResolverTypeWrapper<CompanyPagesAverageRate>;
  CompanyPagesCatalog: ResolverTypeWrapper<CompanyPagesCatalog>;
  CompanyPagesCatalogPageType: CompanyPagesCatalogPageType;
  CompanyPagesCatalogSearchResult: ResolverTypeWrapper<CompanyPagesCatalogSearchResult>;
  CompanyPagesCreateInterviewInput: CompanyPagesCreateInterviewInput;
  CompanyPagesCreateReviewInput: CompanyPagesCreateReviewInput;
  CompanyPagesCreateSalaryInput: CompanyPagesCreateSalaryInput;
  CompanyPagesDestroyInterviewInput: CompanyPagesDestroyInterviewInput;
  CompanyPagesDestroyReviewInput: CompanyPagesDestroyReviewInput;
  CompanyPagesDestroySalaryInput: CompanyPagesDestroySalaryInput;
  CompanyPagesInterview: ResolverTypeWrapper<CompanyPagesInterview>;
  CompanyPagesInterviewConnection: ResolverTypeWrapper<CompanyPagesInterviewConnection>;
  CompanyPagesInterviewEdge: ResolverTypeWrapper<CompanyPagesInterviewEdge>;
  CompanyPagesInterviewsDifficulty: CompanyPagesInterviewsDifficulty;
  CompanyPagesInterviewsDuration: CompanyPagesInterviewsDuration;
  CompanyPagesInterviewsOrigin: CompanyPagesInterviewsOrigin;
  CompanyPagesInterviewsOutcome: CompanyPagesInterviewsOutcome;
  CompanyPagesRange: ResolverTypeWrapper<CompanyPagesRange>;
  CompanyPagesRate: CompanyPagesRate;
  CompanyPagesReview: ResolverTypeWrapper<CompanyPagesReview>;
  CompanyPagesReviewConnection: ResolverTypeWrapper<CompanyPagesReviewConnection>;
  CompanyPagesReviewEdge: ResolverTypeWrapper<CompanyPagesReviewEdge>;
  CompanyPagesReviewsSalesRepTurnover: CompanyPagesReviewsSalesRepTurnover;
  CompanyPagesReviewsTrajectory: CompanyPagesReviewsTrajectory;
  CompanyPagesReviewsUpwardMobility: CompanyPagesReviewsUpwardMobility;
  CompanyPagesRole: ResolverTypeWrapper<CompanyPagesRole>;
  CompanyPagesRoleConnection: ResolverTypeWrapper<CompanyPagesRoleConnection>;
  CompanyPagesRoleEdge: ResolverTypeWrapper<CompanyPagesRoleEdge>;
  CompanyPagesSalary: ResolverTypeWrapper<CompanyPagesSalary>;
  CompanyPagesSalesTeam: ResolverTypeWrapper<CompanyPagesSalesTeam>;
  CompanyPagesTotalCompensationRange: ResolverTypeWrapper<CompanyPagesTotalCompensationRange>;
  CompanyPagesUpdateInterviewInput: CompanyPagesUpdateInterviewInput;
  CompanyPagesUpdateReviewInput: CompanyPagesUpdateReviewInput;
  CompanyPagesUpdateSalaryInput: CompanyPagesUpdateSalaryInput;
  CompanySearchResult: ResolverTypeWrapper<CompanySearchResult>;
  CompanySeriesStage: ResolverTypeWrapper<CompanySeriesStage>;
  CompanySeriesStageSlug: CompanySeriesStageSlug;
  CompanyStage: ResolverTypeWrapper<CompanyStage>;
  CompleteTooltipInput: CompleteTooltipInput;
  ConfirmTermsOfServiceByPotentialEmployerInput: ConfirmTermsOfServiceByPotentialEmployerInput;
  Connection: ResolverTypeWrapper<Connection>;
  ConnectionConnection: ResolverTypeWrapper<ConnectionConnection>;
  ConnectionEdge: ResolverTypeWrapper<ConnectionEdge>;
  ConnectionSuggestionInterface: ResolversTypes['ConnectionTopSuggestionUser'] | ResolversTypes['UserContact'];
  ConnectionSuggestionInterfaceConnection: ResolverTypeWrapper<ConnectionSuggestionInterfaceConnection>;
  ConnectionSuggestionInterfaceEdge: ResolverTypeWrapper<ConnectionSuggestionInterfaceEdge>;
  ConnectionSuggestionType: ConnectionSuggestionType;
  ConnectionTopSuggestionUser: ResolverTypeWrapper<ConnectionTopSuggestionUser>;
  Contacts: ResolverTypeWrapper<Contacts>;
  Content: ResolversTypes['DealStory'] | ResolversTypes['Link'] | ResolversTypes['LinkedinPost'] | ResolversTypes['Story'] | ResolversTypes['YoutubeLink'];
  Country: ResolverTypeWrapper<Country>;
  CountryState: ResolverTypeWrapper<CountryState>;
  CreateAwardForPublicPortfolioCurrentUserInput: CreateAwardForPublicPortfolioCurrentUserInput;
  CreateClientForPublicPortfolioCurrentUserInput: CreateClientForPublicPortfolioCurrentUserInput;
  CreateCommentInput: CreateCommentInput;
  CreateConnectionsInput: CreateConnectionsInput;
  CreateCustomCompanyInput: CreateCustomCompanyInput;
  CreateCustomDepartmentInput: CreateCustomDepartmentInput;
  CreateCustomProductInput: CreateCustomProductInput;
  CreateCustomSalesRoleInput: CreateCustomSalesRoleInput;
  CreateCustomUniversityInput: CreateCustomUniversityInput;
  CreateDealAttributes: CreateDealAttributes;
  CreateDealsInput: CreateDealsInput;
  CreateDealsSourceInput: CreateDealsSourceInput;
  CreateEducationHistoryForPublicPortfolioCurrentUserInput: CreateEducationHistoryForPublicPortfolioCurrentUserInput;
  CreatePollVoteInput: CreatePollVoteInput;
  CreatePostInput: CreatePostInput;
  CreatePotentialEmployerInput: CreatePotentialEmployerInput;
  CreateRatingInput: CreateRatingInput;
  CreateRequestInput: CreateRequestInput;
  CreateTopicInput: CreateTopicInput;
  CreateWorkHistoryForPublicPortfolioCurrentUserInput: CreateWorkHistoryForPublicPortfolioCurrentUserInput;
  Currency: Currency;
  CurrentUser: ResolverTypeWrapper<CurrentUser>;
  CustomerSegment: ResolverTypeWrapper<CustomerSegment>;
  DeactivateCurrentUserInput: DeactivateCurrentUserInput;
  Deal: ResolverTypeWrapper<Deal>;
  DealConnection: ResolverTypeWrapper<DealConnection>;
  DealConnectionInterface: ResolversTypes['DealConnection'] | ResolversTypes['PortfolioDealConnection'];
  DealEdge: ResolverTypeWrapper<DealEdge>;
  DealInterface: ResolversTypes['Deal'] | ResolversTypes['PortfolioDeal'];
  DealStory: ResolverTypeWrapper<DealStory>;
  DealStoryPostAttributes: DealStoryPostAttributes;
  DealsStatistics: ResolverTypeWrapper<DealsStatistics>;
  Department: ResolverTypeWrapper<Department>;
  DestroyAwardForPublicPortfolioCurrentUserInput: DestroyAwardForPublicPortfolioCurrentUserInput;
  DestroyClientForPublicPortfolioCurrentUserInput: DestroyClientForPublicPortfolioCurrentUserInput;
  DestroyCommentInput: DestroyCommentInput;
  DestroyDealInput: DestroyDealInput;
  DestroyEducationHistoryForPublicPortfolioCurrentUserInput: DestroyEducationHistoryForPublicPortfolioCurrentUserInput;
  DestroyPostInput: DestroyPostInput;
  DestroyRatingInput: DestroyRatingInput;
  DestroyTestimonialForPublicPortfolioCurrentUserInput: DestroyTestimonialForPublicPortfolioCurrentUserInput;
  DestroyWorkHistoryForPublicPortfolioCurrentUserInput: DestroyWorkHistoryForPublicPortfolioCurrentUserInput;
  DetachCompanySeriesStageInput: DetachCompanySeriesStageInput;
  DetachCompanyStageInput: DetachCompanyStageInput;
  DetachDepartmentInput: DetachDepartmentInput;
  DetachProductInput: DetachProductInput;
  DetachSalesRoleInput: DetachSalesRoleInput;
  DirectMessagesSubscriptionPayload: ResolverTypeWrapper<DirectMessagesSubscriptionPayload>;
  EarnItem: ResolverTypeWrapper<EarnItem>;
  EducationHistory: ResolverTypeWrapper<EducationHistory>;
  Employee: ResolverTypeWrapper<Employee>;
  EmployeeConnection: ResolverTypeWrapper<EmployeeConnection>;
  EmployeeEdge: ResolverTypeWrapper<EmployeeEdge>;
  EndorseTestimonialAuthorAttributes: EndorseTestimonialAuthorAttributes;
  EndorseTestimonialForPublicPortfolioUserInput: EndorseTestimonialForPublicPortfolioUserInput;
  Expectation: ResolverTypeWrapper<Expectation>;
  ExpressDesireToImportConnectionsForPublicPortfolioUserInput: ExpressDesireToImportConnectionsForPublicPortfolioUserInput;
  File: ResolverTypeWrapper<File>;
  FillInquiryInput: FillInquiryInput;
  FindOrCreateCompanyAttributes: FindOrCreateCompanyAttributes;
  FindOrCreateDepartmentAttributes: FindOrCreateDepartmentAttributes;
  FinishOnboardingInput: FinishOnboardingInput;
  FireHiringEventInput: FireHiringEventInput;
  FlagIssueInput: FlagIssueInput;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  FloatRangeRightBoundOptional: ResolverTypeWrapper<FloatRangeRightBoundOptional>;
  FloatRangeRightBoundOptionalInput: FloatRangeRightBoundOptionalInput;
  GenericMatch: ResolversTypes['BaseMatch'] | ResolversTypes['CityMatch'] | ResolversTypes['UniversityMatch'] | ResolversTypes['WorkHistoryMatch'];
  GeoPositionAttributes: GeoPositionAttributes;
  HighlightedText: ResolverTypeWrapper<HighlightedText>;
  HiringResendIntroduceEmailInput: HiringResendIntroduceEmailInput;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  IP: ResolverTypeWrapper<Scalars['IP']>;
  ISO8601Date: ResolverTypeWrapper<Scalars['ISO8601Date']>;
  ISO8601DateTime: ResolverTypeWrapper<Scalars['ISO8601DateTime']>;
  Industry: ResolverTypeWrapper<Industry>;
  InquiryFakeHiringAttributes: InquiryFakeHiringAttributes;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  IntRangeRightBoundOptional: ResolverTypeWrapper<IntRangeRightBoundOptional>;
  IntRangeRightBoundOptionalInput: IntRangeRightBoundOptionalInput;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  JobsBaseInquiryInterface: ResolversTypes['JobsInquiry'] | ResolversTypes['JobsModeratorsInquiry'];
  JobsCandidateInterface: ResolversTypes['JobsModeratorsCandidate'] | ResolversTypes['JobsRecruitersCandidate'];
  JobsCandidatesUpdateHiringInput: JobsCandidatesUpdateHiringInput;
  JobsEmployer: ResolverTypeWrapper<JobsEmployer>;
  JobsEmployersAnnualRevenue: JobsEmployersAnnualRevenue;
  JobsEmployersFunding: JobsEmployersFunding;
  JobsEmployersSalesTeamSize: JobsEmployersSalesTeamSize;
  JobsFieldsAccessLevel: JobsFieldsAccessLevel;
  JobsFieldsBooleanInterface: ResolversTypes['JobsModeratorsFieldsBoolean'] | ResolversTypes['JobsRecruitersFieldsBoolean'];
  JobsFieldsCategoryInterface: ResolversTypes['JobsModeratorsFieldsCategory'] | ResolversTypes['JobsRecruitersFieldsCategory'];
  JobsFieldsConfiguration: ResolverTypeWrapper<JobsFieldsConfiguration>;
  JobsFieldsFloatInterface: ResolversTypes['JobsModeratorsFieldsFloat'] | ResolversTypes['JobsRecruitersFieldsFloat'];
  JobsFieldsFloatRangeInterface: ResolversTypes['JobsModeratorsFieldsFloatRange'] | ResolversTypes['JobsRecruitersFieldsFloatRange'];
  JobsFieldsIntegerInterface: ResolversTypes['JobsModeratorsFieldsInteger'] | ResolversTypes['JobsRecruitersFieldsInteger'];
  JobsFieldsIntegerRangeInterface: ResolversTypes['JobsModeratorsFieldsIntegerRange'] | ResolversTypes['JobsRecruitersFieldsIntegerRange'];
  JobsFieldsInterface: ResolversTypes['JobsModeratorsFieldsBoolean'] | ResolversTypes['JobsModeratorsFieldsFloat'] | ResolversTypes['JobsModeratorsFieldsFloatRange'] | ResolversTypes['JobsModeratorsFieldsInteger'] | ResolversTypes['JobsModeratorsFieldsIntegerRange'] | ResolversTypes['JobsModeratorsFieldsMultiSelect'] | ResolversTypes['JobsModeratorsFieldsMultiSelectRecord'] | ResolversTypes['JobsModeratorsFieldsSingleSelect'] | ResolversTypes['JobsModeratorsFieldsSingleSelectRecord'] | ResolversTypes['JobsModeratorsFieldsString'] | ResolversTypes['JobsModeratorsFieldsStringArray'] | ResolversTypes['JobsRecruitersFieldsBoolean'] | ResolversTypes['JobsRecruitersFieldsFloat'] | ResolversTypes['JobsRecruitersFieldsFloatRange'] | ResolversTypes['JobsRecruitersFieldsInteger'] | ResolversTypes['JobsRecruitersFieldsIntegerRange'] | ResolversTypes['JobsRecruitersFieldsMultiSelect'] | ResolversTypes['JobsRecruitersFieldsMultiSelectRecord'] | ResolversTypes['JobsRecruitersFieldsSingleSelect'] | ResolversTypes['JobsRecruitersFieldsSingleSelectRecord'] | ResolversTypes['JobsRecruitersFieldsString'] | ResolversTypes['JobsRecruitersFieldsStringArray'];
  JobsFieldsRangePlaceholder: ResolverTypeWrapper<JobsFieldsRangePlaceholder>;
  JobsFieldsRecordType: JobsFieldsRecordType;
  JobsFieldsScope: JobsFieldsScope;
  JobsFieldsSelectInterface: ResolversTypes['JobsModeratorsFieldsMultiSelect'] | ResolversTypes['JobsModeratorsFieldsSingleSelect'] | ResolversTypes['JobsRecruitersFieldsMultiSelect'] | ResolversTypes['JobsRecruitersFieldsSingleSelect'];
  JobsFieldsSelectOption: ResolverTypeWrapper<JobsFieldsSelectOption>;
  JobsFieldsSingleSelectRecordInterface: ResolversTypes['JobsModeratorsFieldsMultiSelectRecord'] | ResolversTypes['JobsModeratorsFieldsSingleSelectRecord'] | ResolversTypes['JobsRecruitersFieldsMultiSelectRecord'] | ResolversTypes['JobsRecruitersFieldsSingleSelectRecord'];
  JobsFieldsStringArrayInterface: ResolversTypes['JobsModeratorsFieldsStringArray'] | ResolversTypes['JobsRecruitersFieldsStringArray'];
  JobsFieldsStringInterface: ResolversTypes['JobsModeratorsFieldsString'] | ResolversTypes['JobsRecruitersFieldsString'];
  JobsFieldsTooltip: ResolverTypeWrapper<JobsFieldsTooltip>;
  JobsFlexAppliedCriteria: JobsFlexAppliedCriteria;
  JobsFlexBandwidth: JobsFlexBandwidth;
  JobsFlexFlexConsideredCompanyType: JobsFlexFlexConsideredCompanyType;
  JobsFlexRole: JobsFlexRole;
  JobsHiring: ResolverTypeWrapper<JobsHiring>;
  JobsHiringBadge: JobsHiringBadge;
  JobsHiringCandidateState: JobsHiringCandidateState;
  JobsHiringEventName: JobsHiringEventName;
  JobsHiringMeeting: JobsHiringMeeting;
  JobsHiringOrigin: JobsHiringOrigin;
  JobsHiringSubmissionSource: JobsHiringSubmissionSource;
  JobsInquiry: ResolverTypeWrapper<JobsInquiry>;
  JobsInquiryActivationOrigin: JobsInquiryActivationOrigin;
  JobsInquiryAeLeadSource: JobsInquiryAeLeadSource;
  JobsInquiryAeQuota: JobsInquiryAeQuota;
  JobsInquiryCsmAccountNumber: JobsInquiryCsmAccountNumber;
  JobsInquiryCsmBusinessValue: JobsInquiryCsmBusinessValue;
  JobsInquiryCsmQuota: JobsInquiryCsmQuota;
  JobsInquiryCsmQuotaMetric: JobsInquiryCsmQuotaMetric;
  JobsInquiryCsmQuotaPeriod: JobsInquiryCsmQuotaPeriod;
  JobsInquiryCsmRenewalValue: JobsInquiryCsmRenewalValue;
  JobsInquiryCsmUpsellValue: JobsInquiryCsmUpsellValue;
  JobsInquiryDealBreaker: JobsInquiryDealBreaker;
  JobsInquiryDealSize: JobsInquiryDealSize;
  JobsInquiryEmployment: JobsInquiryEmployment;
  JobsInquiryFakeHiring: ResolverTypeWrapper<JobsInquiryFakeHiring>;
  JobsInquiryOnboardingState: JobsInquiryOnboardingState;
  JobsInquiryPosition: JobsInquiryPosition;
  JobsInquirySalesCycleLength: JobsInquirySalesCycleLength;
  JobsInquirySalesMethodology: JobsInquirySalesMethodology;
  JobsInquirySdrQuota: JobsInquirySdrQuota;
  JobsInquirySource: JobsInquirySource;
  JobsInquiryState: JobsInquiryState;
  JobsInquiryVpDepartmentSize: JobsInquiryVpDepartmentSize;
  JobsInquiryVpManagedRole: JobsInquiryVpManagedRole;
  JobsInquiryVpQuota: JobsInquiryVpQuota;
  JobsJobSearchStatus: JobsJobSearchStatus;
  JobsModeratorsActivateVacancyInput: JobsModeratorsActivateVacancyInput;
  JobsModeratorsCandidate: ResolverTypeWrapper<JobsModeratorsCandidate>;
  JobsModeratorsCandidateVisibilityOfAttributes: ResolverTypeWrapper<JobsModeratorsCandidateVisibilityOfAttributes>;
  JobsModeratorsCreateEmployerInput: JobsModeratorsCreateEmployerInput;
  JobsModeratorsCreateHiringInput: JobsModeratorsCreateHiringInput;
  JobsModeratorsCreateHiringsInput: JobsModeratorsCreateHiringsInput;
  JobsModeratorsCreateInquiryNoteInput: JobsModeratorsCreateInquiryNoteInput;
  JobsModeratorsCreateVacancyInput: JobsModeratorsCreateVacancyInput;
  JobsModeratorsCreateVacancySubmissionInput: JobsModeratorsCreateVacancySubmissionInput;
  JobsModeratorsDeactivateVacancyInput: JobsModeratorsDeactivateVacancyInput;
  JobsModeratorsDeleteVacancyInput: JobsModeratorsDeleteVacancyInput;
  JobsModeratorsDestroyInquiryNoteInput: JobsModeratorsDestroyInquiryNoteInput;
  JobsModeratorsEditEmployersClientsInput: JobsModeratorsEditEmployersClientsInput;
  JobsModeratorsEditEmployersRecruitersInput: JobsModeratorsEditEmployersRecruitersInput;
  JobsModeratorsEmployer: ResolverTypeWrapper<JobsModeratorsEmployer>;
  JobsModeratorsEmployerClient: ResolverTypeWrapper<JobsModeratorsEmployerClient>;
  JobsModeratorsEmployerClientAttributes: JobsModeratorsEmployerClientAttributes;
  JobsModeratorsEmployerConnection: ResolverTypeWrapper<JobsModeratorsEmployerConnection>;
  JobsModeratorsEmployerEdge: ResolverTypeWrapper<JobsModeratorsEmployerEdge>;
  JobsModeratorsEmployerHiringGroups: ResolverTypeWrapper<JobsModeratorsEmployerHiringGroups>;
  JobsModeratorsEmployerSortAttributes: JobsModeratorsEmployerSortAttributes;
  JobsModeratorsEmployerSortField: JobsModeratorsEmployerSortField;
  JobsModeratorsEmployerSubscription: ResolverTypeWrapper<JobsModeratorsEmployerSubscription>;
  JobsModeratorsEmployerSubscriptionState: JobsModeratorsEmployerSubscriptionState;
  JobsModeratorsEmployerSubscriptionType: JobsModeratorsEmployerSubscriptionType;
  JobsModeratorsEmployersAccountOwner: ResolverTypeWrapper<JobsModeratorsEmployersAccountOwner>;
  JobsModeratorsField: ResolversTypes['JobsModeratorsFieldsBoolean'] | ResolversTypes['JobsModeratorsFieldsFloat'] | ResolversTypes['JobsModeratorsFieldsFloatRange'] | ResolversTypes['JobsModeratorsFieldsInteger'] | ResolversTypes['JobsModeratorsFieldsIntegerRange'] | ResolversTypes['JobsModeratorsFieldsMultiSelect'] | ResolversTypes['JobsModeratorsFieldsMultiSelectRecord'] | ResolversTypes['JobsModeratorsFieldsSingleSelect'] | ResolversTypes['JobsModeratorsFieldsSingleSelectRecord'] | ResolversTypes['JobsModeratorsFieldsString'] | ResolversTypes['JobsModeratorsFieldsStringArray'];
  JobsModeratorsFieldValueInterface: ResolversTypes['JobsModeratorsFieldValuesBoolean'] | ResolversTypes['JobsModeratorsFieldValuesFloat'] | ResolversTypes['JobsModeratorsFieldValuesFloatRange'] | ResolversTypes['JobsModeratorsFieldValuesInteger'] | ResolversTypes['JobsModeratorsFieldValuesIntegerRange'] | ResolversTypes['JobsModeratorsFieldValuesMultiSelect'] | ResolversTypes['JobsModeratorsFieldValuesMultiSelectRecord'] | ResolversTypes['JobsModeratorsFieldValuesSingleSelect'] | ResolversTypes['JobsModeratorsFieldValuesSingleSelectRecord'] | ResolversTypes['JobsModeratorsFieldValuesString'] | ResolversTypes['JobsModeratorsFieldValuesStringArray'];
  JobsModeratorsFieldValuesBoolean: ResolverTypeWrapper<Omit<JobsModeratorsFieldValuesBoolean, 'field'> & { field: ResolversTypes['JobsModeratorsField'] }>;
  JobsModeratorsFieldValuesFloat: ResolverTypeWrapper<Omit<JobsModeratorsFieldValuesFloat, 'field'> & { field: ResolversTypes['JobsModeratorsField'] }>;
  JobsModeratorsFieldValuesFloatRange: ResolverTypeWrapper<Omit<JobsModeratorsFieldValuesFloatRange, 'field'> & { field: ResolversTypes['JobsModeratorsField'] }>;
  JobsModeratorsFieldValuesInteger: ResolverTypeWrapper<Omit<JobsModeratorsFieldValuesInteger, 'field'> & { field: ResolversTypes['JobsModeratorsField'] }>;
  JobsModeratorsFieldValuesIntegerRange: ResolverTypeWrapper<Omit<JobsModeratorsFieldValuesIntegerRange, 'field'> & { field: ResolversTypes['JobsModeratorsField'] }>;
  JobsModeratorsFieldValuesMultiSelect: ResolverTypeWrapper<Omit<JobsModeratorsFieldValuesMultiSelect, 'field'> & { field: ResolversTypes['JobsModeratorsField'] }>;
  JobsModeratorsFieldValuesMultiSelectRecord: ResolverTypeWrapper<Omit<JobsModeratorsFieldValuesMultiSelectRecord, 'field' | 'records'> & { field: ResolversTypes['JobsModeratorsField'], records: Array<ResolversTypes['JobsModeratorsFieldValuesSelectRecordType']> }>;
  JobsModeratorsFieldValuesSelectRecordType: ResolversTypes['City'] | ResolversTypes['Company'] | ResolversTypes['Department'] | ResolversTypes['Industry'];
  JobsModeratorsFieldValuesSingleSelect: ResolverTypeWrapper<Omit<JobsModeratorsFieldValuesSingleSelect, 'field'> & { field: ResolversTypes['JobsModeratorsField'] }>;
  JobsModeratorsFieldValuesSingleSelectRecord: ResolverTypeWrapper<Omit<JobsModeratorsFieldValuesSingleSelectRecord, 'field' | 'record'> & { field: ResolversTypes['JobsModeratorsField'], record: ResolversTypes['JobsModeratorsFieldValuesSelectRecordType'] }>;
  JobsModeratorsFieldValuesString: ResolverTypeWrapper<Omit<JobsModeratorsFieldValuesString, 'field'> & { field: ResolversTypes['JobsModeratorsField'] }>;
  JobsModeratorsFieldValuesStringArray: ResolverTypeWrapper<Omit<JobsModeratorsFieldValuesStringArray, 'field'> & { field: ResolversTypes['JobsModeratorsField'] }>;
  JobsModeratorsFieldsAccessLevel: JobsModeratorsFieldsAccessLevel;
  JobsModeratorsFieldsBoolean: ResolverTypeWrapper<JobsModeratorsFieldsBoolean>;
  JobsModeratorsFieldsBooleanAttributes: JobsModeratorsFieldsBooleanAttributes;
  JobsModeratorsFieldsCategory: ResolverTypeWrapper<Omit<JobsModeratorsFieldsCategory, 'fields'> & { fields: Array<ResolversTypes['JobsModeratorsField']> }>;
  JobsModeratorsFieldsFloat: ResolverTypeWrapper<JobsModeratorsFieldsFloat>;
  JobsModeratorsFieldsFloatAttributes: JobsModeratorsFieldsFloatAttributes;
  JobsModeratorsFieldsFloatRange: ResolverTypeWrapper<JobsModeratorsFieldsFloatRange>;
  JobsModeratorsFieldsFloatRangeAttributes: JobsModeratorsFieldsFloatRangeAttributes;
  JobsModeratorsFieldsInteger: ResolverTypeWrapper<JobsModeratorsFieldsInteger>;
  JobsModeratorsFieldsIntegerAttributes: JobsModeratorsFieldsIntegerAttributes;
  JobsModeratorsFieldsIntegerRange: ResolverTypeWrapper<JobsModeratorsFieldsIntegerRange>;
  JobsModeratorsFieldsIntegerRangeAttributes: JobsModeratorsFieldsIntegerRangeAttributes;
  JobsModeratorsFieldsMultiSelect: ResolverTypeWrapper<JobsModeratorsFieldsMultiSelect>;
  JobsModeratorsFieldsMultiSelectAttributes: JobsModeratorsFieldsMultiSelectAttributes;
  JobsModeratorsFieldsMultiSelectRecord: ResolverTypeWrapper<JobsModeratorsFieldsMultiSelectRecord>;
  JobsModeratorsFieldsMultiSelectRecordAttributes: JobsModeratorsFieldsMultiSelectRecordAttributes;
  JobsModeratorsFieldsSingleSelect: ResolverTypeWrapper<JobsModeratorsFieldsSingleSelect>;
  JobsModeratorsFieldsSingleSelectAttributes: JobsModeratorsFieldsSingleSelectAttributes;
  JobsModeratorsFieldsSingleSelectRecord: ResolverTypeWrapper<JobsModeratorsFieldsSingleSelectRecord>;
  JobsModeratorsFieldsSingleSelectRecordAttributes: JobsModeratorsFieldsSingleSelectRecordAttributes;
  JobsModeratorsFieldsString: ResolverTypeWrapper<JobsModeratorsFieldsString>;
  JobsModeratorsFieldsStringArray: ResolverTypeWrapper<JobsModeratorsFieldsStringArray>;
  JobsModeratorsFieldsStringArrayAttributes: JobsModeratorsFieldsStringArrayAttributes;
  JobsModeratorsFieldsStringAttributes: JobsModeratorsFieldsStringAttributes;
  JobsModeratorsFireHiringEventInput: JobsModeratorsFireHiringEventInput;
  JobsModeratorsFireInquiryEventInput: JobsModeratorsFireInquiryEventInput;
  JobsModeratorsHiring: ResolverTypeWrapper<JobsModeratorsHiring>;
  JobsModeratorsHiringConnection: ResolverTypeWrapper<JobsModeratorsHiringConnection>;
  JobsModeratorsHiringEdge: ResolverTypeWrapper<JobsModeratorsHiringEdge>;
  JobsModeratorsHiringEventName: JobsModeratorsHiringEventName;
  JobsModeratorsHiringExplanation: ResolverTypeWrapper<JobsModeratorsHiringExplanation>;
  JobsModeratorsHiringSortAttributes: JobsModeratorsHiringSortAttributes;
  JobsModeratorsHiringSortField: JobsModeratorsHiringSortField;
  JobsModeratorsHiringState: JobsModeratorsHiringState;
  JobsModeratorsHiringStateCounter: ResolverTypeWrapper<JobsModeratorsHiringStateCounter>;
  JobsModeratorsInquiry: ResolverTypeWrapper<JobsModeratorsInquiry>;
  JobsModeratorsInquiryConnection: ResolverTypeWrapper<JobsModeratorsInquiryConnection>;
  JobsModeratorsInquiryEdge: ResolverTypeWrapper<JobsModeratorsInquiryEdge>;
  JobsModeratorsInquiryEventName: JobsModeratorsInquiryEventName;
  JobsModeratorsInquiryMatch: ResolverTypeWrapper<JobsModeratorsInquiryMatch>;
  JobsModeratorsInquiryNote: ResolverTypeWrapper<JobsModeratorsInquiryNote>;
  JobsModeratorsInquiryNoteMainCategory: JobsModeratorsInquiryNoteMainCategory;
  JobsModeratorsInquiryNoteSubcategory: JobsModeratorsInquiryNoteSubcategory;
  JobsModeratorsInquirySortAttributes: JobsModeratorsInquirySortAttributes;
  JobsModeratorsInquirySortField: JobsModeratorsInquirySortField;
  JobsModeratorsMatchInquiryInput: JobsModeratorsMatchInquiryInput;
  JobsModeratorsMatchInquiryPayload: ResolverTypeWrapper<JobsModeratorsMatchInquiryPayload>;
  JobsModeratorsMergeVacancyInput: JobsModeratorsMergeVacancyInput;
  JobsModeratorsOpsRejectionReason: ResolverTypeWrapper<JobsModeratorsOpsRejectionReason>;
  JobsModeratorsRecruiter: ResolverTypeWrapper<JobsModeratorsRecruiter>;
  JobsModeratorsRecruiterAttributes: JobsModeratorsRecruiterAttributes;
  JobsModeratorsRejectInquiryVacancySuggestionByOpsInput: JobsModeratorsRejectInquiryVacancySuggestionByOpsInput;
  JobsModeratorsRejectJobsHiringByOpsInput: JobsModeratorsRejectJobsHiringByOpsInput;
  JobsModeratorsRemoveInquiryInput: JobsModeratorsRemoveInquiryInput;
  JobsModeratorsRenewActiveJobStatusInput: JobsModeratorsRenewActiveJobStatusInput;
  JobsModeratorsScheduleMeetingInput: JobsModeratorsScheduleMeetingInput;
  JobsModeratorsScheduledMessage: ResolverTypeWrapper<JobsModeratorsScheduledMessage>;
  JobsModeratorsSubmitHiringInput: JobsModeratorsSubmitHiringInput;
  JobsModeratorsUpdateCompanyInput: JobsModeratorsUpdateCompanyInput;
  JobsModeratorsUpdateEmployerInput: JobsModeratorsUpdateEmployerInput;
  JobsModeratorsUpdateHiringInput: JobsModeratorsUpdateHiringInput;
  JobsModeratorsUpdateInquiryInput: JobsModeratorsUpdateInquiryInput;
  JobsModeratorsUpdateSubmittedHiringInput: JobsModeratorsUpdateSubmittedHiringInput;
  JobsModeratorsUpdateUserInput: JobsModeratorsUpdateUserInput;
  JobsModeratorsUpdateVacancyInput: JobsModeratorsUpdateVacancyInput;
  JobsModeratorsUpdateVacancySubmissionInput: JobsModeratorsUpdateVacancySubmissionInput;
  JobsModeratorsUser: ResolverTypeWrapper<JobsModeratorsUser>;
  JobsModeratorsVacancy: ResolverTypeWrapper<Omit<JobsModeratorsVacancy, 'fieldValues'> & { fieldValues: Array<ResolversTypes['JobsModeratorsVacancyFieldValue']> }>;
  JobsModeratorsVacancyConnection: ResolverTypeWrapper<JobsModeratorsVacancyConnection>;
  JobsModeratorsVacancyCreator: ResolverTypeWrapper<JobsModeratorsVacancyCreator>;
  JobsModeratorsVacancyCreatorInterface: ResolversTypes['JobsModeratorsVacancyCreator'];
  JobsModeratorsVacancyEdge: ResolverTypeWrapper<JobsModeratorsVacancyEdge>;
  JobsModeratorsVacancyFieldValue: ResolversTypes['JobsModeratorsFieldValuesBoolean'] | ResolversTypes['JobsModeratorsFieldValuesFloat'] | ResolversTypes['JobsModeratorsFieldValuesFloatRange'] | ResolversTypes['JobsModeratorsFieldValuesInteger'] | ResolversTypes['JobsModeratorsFieldValuesIntegerRange'] | ResolversTypes['JobsModeratorsFieldValuesMultiSelect'] | ResolversTypes['JobsModeratorsFieldValuesMultiSelectRecord'] | ResolversTypes['JobsModeratorsFieldValuesSingleSelect'] | ResolversTypes['JobsModeratorsFieldValuesSingleSelectRecord'] | ResolversTypes['JobsModeratorsFieldValuesString'] | ResolversTypes['JobsModeratorsFieldValuesStringArray'];
  JobsModeratorsVacancyMatch: ResolverTypeWrapper<JobsModeratorsVacancyMatch>;
  JobsModeratorsVacancySortAttributes: JobsModeratorsVacancySortAttributes;
  JobsModeratorsVacancySortField: JobsModeratorsVacancySortField;
  JobsModeratorsVacancySubmission: ResolverTypeWrapper<JobsModeratorsVacancySubmission>;
  JobsModeratorsVacancySubmissionVisibilityAttributes: JobsModeratorsVacancySubmissionVisibilityAttributes;
  JobsRecruiter: ResolverTypeWrapper<JobsRecruiter>;
  JobsRecruiterLead: JobsRecruiterLead;
  JobsRecruiterState: JobsRecruiterState;
  JobsRecruitersAcceptCandidateInput: JobsRecruitersAcceptCandidateInput;
  JobsRecruitersActivateCurrentRecruiterInput: JobsRecruitersActivateCurrentRecruiterInput;
  JobsRecruitersActivateVacancyInput: JobsRecruitersActivateVacancyInput;
  JobsRecruitersCandidate: ResolverTypeWrapper<JobsRecruitersCandidate>;
  JobsRecruitersCandidateConnection: ResolverTypeWrapper<JobsRecruitersCandidateConnection>;
  JobsRecruitersCandidateEdge: ResolverTypeWrapper<JobsRecruitersCandidateEdge>;
  JobsRecruitersCandidateState: JobsRecruitersCandidateState;
  JobsRecruitersClient: ResolverTypeWrapper<JobsRecruitersClient>;
  JobsRecruitersCompleteTooltipInput: JobsRecruitersCompleteTooltipInput;
  JobsRecruitersCreateCustomCompanyInput: JobsRecruitersCreateCustomCompanyInput;
  JobsRecruitersCreateEmployerInput: JobsRecruitersCreateEmployerInput;
  JobsRecruitersCreateStripeBillingUrlInput: JobsRecruitersCreateStripeBillingUrlInput;
  JobsRecruitersCreateStripeSessionUrlInput: JobsRecruitersCreateStripeSessionUrlInput;
  JobsRecruitersCreateVacancyInput: JobsRecruitersCreateVacancyInput;
  JobsRecruitersDeleteEmployerInput: JobsRecruitersDeleteEmployerInput;
  JobsRecruitersDeleteRecruiterInput: JobsRecruitersDeleteRecruiterInput;
  JobsRecruitersDeleteVacancyFieldInput: JobsRecruitersDeleteVacancyFieldInput;
  JobsRecruitersDeleteVacancyInput: JobsRecruitersDeleteVacancyInput;
  JobsRecruitersDestroyCandidateInput: JobsRecruitersDestroyCandidateInput;
  JobsRecruitersDistribution: ResolverTypeWrapper<JobsRecruitersDistribution>;
  JobsRecruitersDistributionBin: ResolverTypeWrapper<JobsRecruitersDistributionBin>;
  JobsRecruitersEditRecruiterInput: JobsRecruitersEditRecruiterInput;
  JobsRecruitersEmployer: ResolverTypeWrapper<JobsRecruitersEmployer>;
  JobsRecruitersEmployerAttributes: JobsRecruitersEmployerAttributes;
  JobsRecruitersEmployerRejectionReason: JobsRecruitersEmployerRejectionReason;
  JobsRecruitersEmployerSubscription: ResolverTypeWrapper<JobsRecruitersEmployerSubscription>;
  JobsRecruitersEnableVacanciesInput: JobsRecruitersEnableVacanciesInput;
  JobsRecruitersField: ResolversTypes['JobsRecruitersFieldsBoolean'] | ResolversTypes['JobsRecruitersFieldsFloat'] | ResolversTypes['JobsRecruitersFieldsFloatRange'] | ResolversTypes['JobsRecruitersFieldsInteger'] | ResolversTypes['JobsRecruitersFieldsIntegerRange'] | ResolversTypes['JobsRecruitersFieldsMultiSelect'] | ResolversTypes['JobsRecruitersFieldsMultiSelectRecord'] | ResolversTypes['JobsRecruitersFieldsSingleSelect'] | ResolversTypes['JobsRecruitersFieldsSingleSelectRecord'] | ResolversTypes['JobsRecruitersFieldsString'] | ResolversTypes['JobsRecruitersFieldsStringArray'];
  JobsRecruitersFieldValueInterface: ResolversTypes['JobsRecruitersFieldValuesBoolean'] | ResolversTypes['JobsRecruitersFieldValuesFloat'] | ResolversTypes['JobsRecruitersFieldValuesFloatRange'] | ResolversTypes['JobsRecruitersFieldValuesInteger'] | ResolversTypes['JobsRecruitersFieldValuesIntegerRange'] | ResolversTypes['JobsRecruitersFieldValuesMultiSelect'] | ResolversTypes['JobsRecruitersFieldValuesMultiSelectRecord'] | ResolversTypes['JobsRecruitersFieldValuesSingleSelect'] | ResolversTypes['JobsRecruitersFieldValuesSingleSelectRecord'] | ResolversTypes['JobsRecruitersFieldValuesString'] | ResolversTypes['JobsRecruitersFieldValuesStringArray'];
  JobsRecruitersFieldValuesBoolean: ResolverTypeWrapper<Omit<JobsRecruitersFieldValuesBoolean, 'field'> & { field: ResolversTypes['JobsRecruitersField'] }>;
  JobsRecruitersFieldValuesFloat: ResolverTypeWrapper<Omit<JobsRecruitersFieldValuesFloat, 'field'> & { field: ResolversTypes['JobsRecruitersField'] }>;
  JobsRecruitersFieldValuesFloatRange: ResolverTypeWrapper<Omit<JobsRecruitersFieldValuesFloatRange, 'field'> & { field: ResolversTypes['JobsRecruitersField'] }>;
  JobsRecruitersFieldValuesInteger: ResolverTypeWrapper<Omit<JobsRecruitersFieldValuesInteger, 'field'> & { field: ResolversTypes['JobsRecruitersField'] }>;
  JobsRecruitersFieldValuesIntegerRange: ResolverTypeWrapper<Omit<JobsRecruitersFieldValuesIntegerRange, 'field'> & { field: ResolversTypes['JobsRecruitersField'] }>;
  JobsRecruitersFieldValuesMultiSelect: ResolverTypeWrapper<Omit<JobsRecruitersFieldValuesMultiSelect, 'field'> & { field: ResolversTypes['JobsRecruitersField'] }>;
  JobsRecruitersFieldValuesMultiSelectRecord: ResolverTypeWrapper<Omit<JobsRecruitersFieldValuesMultiSelectRecord, 'field' | 'records'> & { field: ResolversTypes['JobsRecruitersField'], records: Array<ResolversTypes['JobsRecruitersFieldValuesSelectRecordType']> }>;
  JobsRecruitersFieldValuesSelectRecordType: ResolversTypes['City'] | ResolversTypes['Company'] | ResolversTypes['Department'] | ResolversTypes['Industry'];
  JobsRecruitersFieldValuesSingleSelect: ResolverTypeWrapper<Omit<JobsRecruitersFieldValuesSingleSelect, 'field'> & { field: ResolversTypes['JobsRecruitersField'] }>;
  JobsRecruitersFieldValuesSingleSelectRecord: ResolverTypeWrapper<Omit<JobsRecruitersFieldValuesSingleSelectRecord, 'field' | 'record'> & { field: ResolversTypes['JobsRecruitersField'], record: ResolversTypes['JobsRecruitersFieldValuesSelectRecordType'] }>;
  JobsRecruitersFieldValuesString: ResolverTypeWrapper<Omit<JobsRecruitersFieldValuesString, 'field'> & { field: ResolversTypes['JobsRecruitersField'] }>;
  JobsRecruitersFieldValuesStringArray: ResolverTypeWrapper<Omit<JobsRecruitersFieldValuesStringArray, 'field'> & { field: ResolversTypes['JobsRecruitersField'] }>;
  JobsRecruitersFieldsBoolean: ResolverTypeWrapper<JobsRecruitersFieldsBoolean>;
  JobsRecruitersFieldsBooleanAttributes: JobsRecruitersFieldsBooleanAttributes;
  JobsRecruitersFieldsCategory: ResolverTypeWrapper<Omit<JobsRecruitersFieldsCategory, 'fields'> & { fields: Array<ResolversTypes['JobsRecruitersField']> }>;
  JobsRecruitersFieldsFloat: ResolverTypeWrapper<JobsRecruitersFieldsFloat>;
  JobsRecruitersFieldsFloatAttributes: JobsRecruitersFieldsFloatAttributes;
  JobsRecruitersFieldsFloatRange: ResolverTypeWrapper<JobsRecruitersFieldsFloatRange>;
  JobsRecruitersFieldsFloatRangeAttributes: JobsRecruitersFieldsFloatRangeAttributes;
  JobsRecruitersFieldsInteger: ResolverTypeWrapper<JobsRecruitersFieldsInteger>;
  JobsRecruitersFieldsIntegerAttributes: JobsRecruitersFieldsIntegerAttributes;
  JobsRecruitersFieldsIntegerRange: ResolverTypeWrapper<JobsRecruitersFieldsIntegerRange>;
  JobsRecruitersFieldsIntegerRangeAttributes: JobsRecruitersFieldsIntegerRangeAttributes;
  JobsRecruitersFieldsMultiSelect: ResolverTypeWrapper<JobsRecruitersFieldsMultiSelect>;
  JobsRecruitersFieldsMultiSelectAttributes: JobsRecruitersFieldsMultiSelectAttributes;
  JobsRecruitersFieldsMultiSelectRecord: ResolverTypeWrapper<JobsRecruitersFieldsMultiSelectRecord>;
  JobsRecruitersFieldsMultiSelectRecordAttributes: JobsRecruitersFieldsMultiSelectRecordAttributes;
  JobsRecruitersFieldsSingleSelect: ResolverTypeWrapper<JobsRecruitersFieldsSingleSelect>;
  JobsRecruitersFieldsSingleSelectAttributes: JobsRecruitersFieldsSingleSelectAttributes;
  JobsRecruitersFieldsSingleSelectRecord: ResolverTypeWrapper<JobsRecruitersFieldsSingleSelectRecord>;
  JobsRecruitersFieldsSingleSelectRecordAttributes: JobsRecruitersFieldsSingleSelectRecordAttributes;
  JobsRecruitersFieldsString: ResolverTypeWrapper<JobsRecruitersFieldsString>;
  JobsRecruitersFieldsStringArray: ResolverTypeWrapper<JobsRecruitersFieldsStringArray>;
  JobsRecruitersFieldsStringArrayAttributes: JobsRecruitersFieldsStringArrayAttributes;
  JobsRecruitersFieldsStringAttributes: JobsRecruitersFieldsStringAttributes;
  JobsRecruitersImportGreenhouseVacanciesInput: JobsRecruitersImportGreenhouseVacanciesInput;
  JobsRecruitersInquiry: ResolverTypeWrapper<JobsRecruitersInquiry>;
  JobsRecruitersMarkCandidateAsViewedInput: JobsRecruitersMarkCandidateAsViewedInput;
  JobsRecruitersMatchVacancyInput: JobsRecruitersMatchVacancyInput;
  JobsRecruitersPeopleForHiring: JobsRecruitersPeopleForHiring;
  JobsRecruitersRecruiter: ResolverTypeWrapper<JobsRecruitersRecruiter>;
  JobsRecruitersRecruiterAttributes: JobsRecruitersRecruiterAttributes;
  JobsRecruitersRecruiterRole: JobsRecruitersRecruiterRole;
  JobsRecruitersRejectCandidateInput: JobsRecruitersRejectCandidateInput;
  JobsRecruitersRolesForHiring: JobsRecruitersRolesForHiring;
  JobsRecruitersSendRecruiterAuthTokenInput: JobsRecruitersSendRecruiterAuthTokenInput;
  JobsRecruitersSubscriptionProductSlug: JobsRecruitersSubscriptionProductSlug;
  JobsRecruitersUpdateCurrentEmployerInput: JobsRecruitersUpdateCurrentEmployerInput;
  JobsRecruitersUpdateCurrentRecruiterInput: JobsRecruitersUpdateCurrentRecruiterInput;
  JobsRecruitersUpdateCustomCompanyInput: JobsRecruitersUpdateCustomCompanyInput;
  JobsRecruitersUpdateVacancyFieldInput: JobsRecruitersUpdateVacancyFieldInput;
  JobsRecruitersUpdateVacancyInput: JobsRecruitersUpdateVacancyInput;
  JobsRecruitersVacancy: ResolverTypeWrapper<Omit<JobsRecruitersVacancy, 'fieldValues'> & { fieldValues: Array<ResolversTypes['JobsRecruitersVacancyFieldValue']> }>;
  JobsRecruitersVacancyFieldValue: ResolversTypes['JobsRecruitersFieldValuesBoolean'] | ResolversTypes['JobsRecruitersFieldValuesFloat'] | ResolversTypes['JobsRecruitersFieldValuesFloatRange'] | ResolversTypes['JobsRecruitersFieldValuesInteger'] | ResolversTypes['JobsRecruitersFieldValuesIntegerRange'] | ResolversTypes['JobsRecruitersFieldValuesMultiSelect'] | ResolversTypes['JobsRecruitersFieldValuesMultiSelectRecord'] | ResolversTypes['JobsRecruitersFieldValuesSingleSelect'] | ResolversTypes['JobsRecruitersFieldValuesSingleSelectRecord'] | ResolversTypes['JobsRecruitersFieldValuesString'] | ResolversTypes['JobsRecruitersFieldValuesStringArray'];
  JobsRecruitersVacancyPromptTemplate: ResolverTypeWrapper<JobsRecruitersVacancyPromptTemplate>;
  JobsRecruitersVacancySubmission: ResolverTypeWrapper<JobsRecruitersVacancySubmission>;
  JobsRole: JobsRole;
  JobsVacancy: ResolverTypeWrapper<JobsVacancy>;
  JobsVacancyEmployment: JobsVacancyEmployment;
  JobsVacancyState: JobsVacancyState;
  JobsVacancySubmission: ResolverTypeWrapper<JobsVacancySubmission>;
  JobsVacancySubmissionBrandMaturity: JobsVacancySubmissionBrandMaturity;
  JobsVacancySubmissionInterface: ResolversTypes['JobsModeratorsVacancySubmission'] | ResolversTypes['JobsRecruitersVacancySubmission'] | ResolversTypes['JobsVacancySubmission'];
  JobsVacancySubmissionVisibilityOfAttributes: ResolverTypeWrapper<JobsVacancySubmissionVisibilityOfAttributes>;
  Link: ResolverTypeWrapper<Link>;
  LinkedinPost: ResolverTypeWrapper<LinkedinPost>;
  LinkedinProfileImportedPayload: ResolverTypeWrapper<LinkedinProfileImportedPayload>;
  Location: ResolversTypes['City'] | ResolversTypes['CountryState'];
  LocationType: LocationType;
  MarkCommentsViewedInput: MarkCommentsViewedInput;
  MarkPostsAsReadInput: MarkPostsAsReadInput;
  MatchJobsInquiryAfterOnboardingInput: MatchJobsInquiryAfterOnboardingInput;
  Message: ResolverTypeWrapper<Message>;
  MessageConnection: ResolverTypeWrapper<MessageConnection>;
  MessageEdge: ResolverTypeWrapper<MessageEdge>;
  Mutation: ResolverTypeWrapper<{}>;
  Notification: ResolverTypeWrapper<Omit<Notification, 'referenceable'> & { referenceable?: Maybe<ResolversTypes['NotificationReferenceable']> }>;
  NotificationConnection: ResolverTypeWrapper<NotificationConnection>;
  NotificationEdge: ResolverTypeWrapper<NotificationEdge>;
  NotificationKind: NotificationKind;
  NotificationReferenceable: ResolversTypes['Comment'] | ResolversTypes['JobsHiring'] | ResolversTypes['Post'] | ResolversTypes['Rating'] | ResolversTypes['SalesGptQuery'] | ResolversTypes['Testimonial'] | ResolversTypes['User'];
  OnboardingData: ResolverTypeWrapper<OnboardingData>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  Platform: Platform;
  Poll: ResolverTypeWrapper<Poll>;
  PollAttributes: PollAttributes;
  PollChoice: ResolverTypeWrapper<PollChoice>;
  PollChoiceAttributes: PollChoiceAttributes;
  PollVote: ResolverTypeWrapper<PollVote>;
  PollVoteConnection: ResolverTypeWrapper<PollVoteConnection>;
  PollVoteEdge: ResolverTypeWrapper<PollVoteEdge>;
  PortfolioCurrentUser: ResolverTypeWrapper<PortfolioCurrentUser>;
  PortfolioDeal: ResolverTypeWrapper<PortfolioDeal>;
  PortfolioDealConnection: ResolverTypeWrapper<PortfolioDealConnection>;
  PortfolioDealEdge: ResolverTypeWrapper<PortfolioDealEdge>;
  PortfolioDealQuarter: ResolverTypeWrapper<PortfolioDealQuarter>;
  PortfolioDealsSource: ResolverTypeWrapper<PortfolioDealsSource>;
  PortfolioRanking: ResolverTypeWrapper<PortfolioRanking>;
  PortfolioUserSearchResult: ResolverTypeWrapper<PortfolioUserSearchResult>;
  Post: ResolverTypeWrapper<Omit<Post, 'author' | 'content'> & { author: ResolversTypes['UserAuthor'], content: ResolversTypes['Content'] }>;
  PostConnection: ResolverTypeWrapper<PostConnection>;
  PostEdge: ResolverTypeWrapper<PostEdge>;
  PostView: ResolverTypeWrapper<PostView>;
  PostViewConnection: ResolverTypeWrapper<PostViewConnection>;
  PostViewEdge: ResolverTypeWrapper<PostViewEdge>;
  PotentialEmployer: ResolverTypeWrapper<PotentialEmployer>;
  ProductType: ResolverTypeWrapper<ProductType>;
  Public: ResolverTypeWrapper<Public>;
  PublicPortfolioConfiguration: ResolverTypeWrapper<PublicPortfolioConfiguration>;
  PublicPortfolioCurrentUser: ResolverTypeWrapper<PublicPortfolioCurrentUser>;
  PublicPortfolioUser: ResolverTypeWrapper<PublicPortfolioUser>;
  PublicPortfolioUserIterface: ResolversTypes['PublicPortfolioCurrentUser'] | ResolversTypes['PublicPortfolioUser'];
  Query: ResolverTypeWrapper<{}>;
  Rating: ResolverTypeWrapper<Omit<Rating, 'reactable'> & { reactable: ResolversTypes['Reactable'] }>;
  RatingConnection: ResolverTypeWrapper<RatingConnection>;
  RatingEdge: ResolverTypeWrapper<RatingEdge>;
  ReRequestTestimonialForPublicPortfolioCurrentUserInput: ReRequestTestimonialForPublicPortfolioCurrentUserInput;
  Reactable: ResolversTypes['Comment'] | ResolversTypes['Post'];
  ReadAllNotificationsInput: ReadAllNotificationsInput;
  ReadNotificationInput: ReadNotificationInput;
  ReadRequestsInput: ReadRequestsInput;
  ReadThreadEvent: ResolverTypeWrapper<ReadThreadEvent>;
  ReadThreadMessagesInput: ReadThreadMessagesInput;
  RefreshInquiryInput: RefreshInquiryInput;
  Region: ResolverTypeWrapper<Region>;
  RegionConnection: ResolverTypeWrapper<RegionConnection>;
  RegionEdge: ResolverTypeWrapper<RegionEdge>;
  RejectJobsHiringInput: RejectJobsHiringInput;
  RejectRequestInput: RejectRequestInput;
  RelatedCompany: ResolverTypeWrapper<RelatedCompany>;
  RelatedCompanyPageResponse: ResolverTypeWrapper<RelatedCompanyPageResponse>;
  RemoveConnectionInput: RemoveConnectionInput;
  RenewActiveJobStatusInput: RenewActiveJobStatusInput;
  ReportSalesGptFeedbackInput: ReportSalesGptFeedbackInput;
  Request: ResolverTypeWrapper<Request>;
  RequestConnection: ResolverTypeWrapper<RequestConnection>;
  RequestEdge: ResolverTypeWrapper<RequestEdge>;
  RequestParticipant: ResolverTypeWrapper<RequestParticipant>;
  RequestTestimonialForPublicPortfolioCurrentUserInput: RequestTestimonialForPublicPortfolioCurrentUserInput;
  RoleCategory: ResolverTypeWrapper<RoleCategory>;
  SalesDirectoryPage: ResolverTypeWrapper<SalesDirectoryPage>;
  SalesDirectoryUser: ResolverTypeWrapper<SalesDirectoryUser>;
  SalesGptFeedback: SalesGptFeedback;
  SalesGptQuery: ResolverTypeWrapper<SalesGptQuery>;
  SalesRole: ResolverTypeWrapper<SalesRole>;
  SalesTeamTenureAverage: ResolverTypeWrapper<SalesTeamTenureAverage>;
  SalesTeamTenureAverages: ResolverTypeWrapper<SalesTeamTenureAverages>;
  SaveSalesGptSummaryInput: SaveSalesGptSummaryInput;
  SayThanksInput: SayThanksInput;
  ScheduleHiringMeetingInput: ScheduleHiringMeetingInput;
  SearchInfo: ResolverTypeWrapper<SearchInfo>;
  SearchResultCategory: SearchResultCategory;
  SearchResultInterface: ResolversTypes['AcademyArticleSearchResult'] | ResolversTypes['CompanyPagesCatalogSearchResult'] | ResolversTypes['CompanySearchResult'] | ResolversTypes['PortfolioUserSearchResult'] | ResolversTypes['WarRoomPostCommentSearchResult'] | ResolversTypes['WarRoomPostSearchResult'] | ResolversTypes['WarRoomUserSearchResult'];
  SearchResultInterfaceConnection: ResolverTypeWrapper<SearchResultInterfaceConnection>;
  SearchResultInterfaceEdge: ResolverTypeWrapper<SearchResultInterfaceEdge>;
  SearchResultsCategory: ResolverTypeWrapper<SearchResultsCategory>;
  SearchSummaryType: SearchSummaryType;
  SendMessageInput: SendMessageInput;
  SendSuperInviteInput: SendSuperInviteInput;
  SortOrder: SortOrder;
  StartTestimonialEndorsingForPublicPortfolioUserInput: StartTestimonialEndorsingForPublicPortfolioUserInput;
  Story: ResolverTypeWrapper<Story>;
  String: ResolverTypeWrapper<Scalars['String']>;
  Subscription: ResolverTypeWrapper<{}>;
  SuggestedUser: ResolverTypeWrapper<Omit<SuggestedUser, 'matchMetadata'> & { matchMetadata?: Maybe<ResolversTypes['GenericMatch']> }>;
  SuggestedUserConnection: ResolverTypeWrapper<SuggestedUserConnection>;
  SuggestedUserEdge: ResolverTypeWrapper<SuggestedUserEdge>;
  Testimonial: ResolverTypeWrapper<Testimonial>;
  TestimonialAuthor: ResolverTypeWrapper<TestimonialAuthor>;
  TestimonialRequestor: ResolverTypeWrapper<TestimonialRequestor>;
  TestimonialState: TestimonialState;
  Thread: ResolverTypeWrapper<Thread>;
  Tooltip: ResolverTypeWrapper<Tooltip>;
  Topic: ResolverTypeWrapper<Topic>;
  TopicConnection: ResolverTypeWrapper<TopicConnection>;
  TopicEdge: ResolverTypeWrapper<TopicEdge>;
  TotalCompensationRange: ResolverTypeWrapper<TotalCompensationRange>;
  TriggerContactsFetchingInput: TriggerContactsFetchingInput;
  TriggerLinkedinScrapingInput: TriggerLinkedinScrapingInput;
  UnblockUserInput: UnblockUserInput;
  UndoTestimonialForPublicPortfolioCurrentUserInput: UndoTestimonialForPublicPortfolioCurrentUserInput;
  University: ResolverTypeWrapper<University>;
  UniversityConnection: ResolverTypeWrapper<UniversityConnection>;
  UniversityEdge: ResolverTypeWrapper<UniversityEdge>;
  UniversityMatch: ResolverTypeWrapper<UniversityMatch>;
  UpdateArticleInput: UpdateArticleInput;
  UpdateAwardForPublicPortfolioCurrentUserInput: UpdateAwardForPublicPortfolioCurrentUserInput;
  UpdateClientForPublicPortfolioCurrentUserInput: UpdateClientForPublicPortfolioCurrentUserInput;
  UpdateClientPositionForPublicPortfolioCurrentUserInput: UpdateClientPositionForPublicPortfolioCurrentUserInput;
  UpdateCommentInput: UpdateCommentInput;
  UpdateConfigurationForPublicPortfolioCurrentUserInput: UpdateConfigurationForPublicPortfolioCurrentUserInput;
  UpdateCurrentPortfolioUserInput: UpdateCurrentPortfolioUserInput;
  UpdateCurrentUserInput: UpdateCurrentUserInput;
  UpdateDealInput: UpdateDealInput;
  UpdateEducationHistoryForPublicPortfolioCurrentUserInput: UpdateEducationHistoryForPublicPortfolioCurrentUserInput;
  UpdateInquiryInput: UpdateInquiryInput;
  UpdatePostInput: UpdatePostInput;
  UpdatePublicPortfolioCurrentUserInput: UpdatePublicPortfolioCurrentUserInput;
  UpdateTestimonialPositionForPublicPortfolioCurrentUserInput: UpdateTestimonialPositionForPublicPortfolioCurrentUserInput;
  UpdateWorkHistoryForPublicPortfolioCurrentUserInput: UpdateWorkHistoryForPublicPortfolioCurrentUserInput;
  UpsertDealQuarterInput: UpsertDealQuarterInput;
  User: ResolverTypeWrapper<User>;
  UserAchievement: ResolverTypeWrapper<UserAchievement>;
  UserAuthor: ResolversTypes['Anonymous'] | ResolversTypes['Public'];
  UserConnection: ResolverTypeWrapper<UserConnection>;
  UserContact: ResolverTypeWrapper<UserContact>;
  UserEdge: ResolverTypeWrapper<UserEdge>;
  UserPost: ResolverTypeWrapper<UserPost>;
  UserPostConnection: ResolverTypeWrapper<UserPostConnection>;
  UserPostEdge: ResolverTypeWrapper<UserPostEdge>;
  UserSearch: ResolverTypeWrapper<UserSearch>;
  VendorDbUser: ResolverTypeWrapper<VendorDbUser>;
  ViewAllNotificationsInput: ViewAllNotificationsInput;
  WarRoomPostCommentSearchResult: ResolverTypeWrapper<WarRoomPostCommentSearchResult>;
  WarRoomPostSearchResult: ResolverTypeWrapper<WarRoomPostSearchResult>;
  WarRoomUserSearchResult: ResolverTypeWrapper<WarRoomUserSearchResult>;
  WorkHistory: ResolverTypeWrapper<WorkHistory>;
  WorkHistoryMatch: ResolverTypeWrapper<WorkHistoryMatch>;
  YoutubeLink: ResolverTypeWrapper<YoutubeLink>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AcademyArticleSearchResult: AcademyArticleSearchResult;
  AcademyTopic: AcademyTopic;
  AcademyTopicConnection: AcademyTopicConnection;
  AcademyTopicEdge: AcademyTopicEdge;
  AcceptRequestInput: AcceptRequestInput;
  ActivateJobsInquiryInput: ActivateJobsInquiryInput;
  Alumni: Alumni;
  AlumniConnection: AlumniConnection;
  AlumniEdge: AlumniEdge;
  Anonymous: Anonymous;
  ApplyForWarRoomInput: ApplyForWarRoomInput;
  ApproveTestimonialAuthorAttributes: ApproveTestimonialAuthorAttributes;
  ApproveTestimonialForPublicPortfolioCurrentUserInput: ApproveTestimonialForPublicPortfolioCurrentUserInput;
  ArchiveCandidateHiringInput: ArchiveCandidateHiringInput;
  ArchiveTestimonialForPublicPortfolioCurrentUserInput: ArchiveTestimonialForPublicPortfolioCurrentUserInput;
  Article: Article;
  AttachCompanySeriesStageInput: AttachCompanySeriesStageInput;
  AttachCompanyStageInput: AttachCompanyStageInput;
  AttachDepartmentInput: AttachDepartmentInput;
  AttachProductInput: AttachProductInput;
  AttachSalesRoleInput: AttachSalesRoleInput;
  Author: Author;
  AverageHittingQuota: AverageHittingQuota;
  AveragePerAccountSize: AveragePerAccountSize;
  AveragePerYearsOfExperience: AveragePerYearsOfExperience;
  AverageSalariesData: AverageSalariesData;
  AverageTotals: AverageTotals;
  Award: Award;
  BaseMatch: BaseMatch;
  BestCity: BestCity;
  BigInt: Scalars['BigInt'];
  BlockUserInput: BlockUserInput;
  Boolean: Scalars['Boolean'];
  CancelRequestInput: CancelRequestInput;
  CandidateAttributes: CandidateAttributes;
  CandidateAttributesVisability: CandidateAttributesVisability;
  City: City;
  CityConnection: CityConnection;
  CityEdge: CityEdge;
  CityMatch: CityMatch;
  CitySearchParams: CitySearchParams;
  Client: Client;
  Comment: Omit<Comment, 'author'> & { author: ResolversParentTypes['UserAuthor'] };
  CommentConnection: CommentConnection;
  CommentEdge: CommentEdge;
  CommissionBalance: CommissionBalance;
  CommissionOnboarding: CommissionOnboarding;
  CommissionTransaction: CommissionTransaction;
  CommissionTransactionSubscriptionPayload: CommissionTransactionSubscriptionPayload;
  CompaniesCategory: CompaniesCategory;
  CompaniesConnection: CompaniesConnection;
  Company: Company;
  CompanyEdge: CompanyEdge;
  CompanyInterface: ResolversParentTypes['Company'] | ResolversParentTypes['RelatedCompany'];
  CompanyPagesAverageRate: CompanyPagesAverageRate;
  CompanyPagesCatalog: CompanyPagesCatalog;
  CompanyPagesCatalogSearchResult: CompanyPagesCatalogSearchResult;
  CompanyPagesCreateInterviewInput: CompanyPagesCreateInterviewInput;
  CompanyPagesCreateReviewInput: CompanyPagesCreateReviewInput;
  CompanyPagesCreateSalaryInput: CompanyPagesCreateSalaryInput;
  CompanyPagesDestroyInterviewInput: CompanyPagesDestroyInterviewInput;
  CompanyPagesDestroyReviewInput: CompanyPagesDestroyReviewInput;
  CompanyPagesDestroySalaryInput: CompanyPagesDestroySalaryInput;
  CompanyPagesInterview: CompanyPagesInterview;
  CompanyPagesInterviewConnection: CompanyPagesInterviewConnection;
  CompanyPagesInterviewEdge: CompanyPagesInterviewEdge;
  CompanyPagesRange: CompanyPagesRange;
  CompanyPagesReview: CompanyPagesReview;
  CompanyPagesReviewConnection: CompanyPagesReviewConnection;
  CompanyPagesReviewEdge: CompanyPagesReviewEdge;
  CompanyPagesRole: CompanyPagesRole;
  CompanyPagesRoleConnection: CompanyPagesRoleConnection;
  CompanyPagesRoleEdge: CompanyPagesRoleEdge;
  CompanyPagesSalary: CompanyPagesSalary;
  CompanyPagesSalesTeam: CompanyPagesSalesTeam;
  CompanyPagesTotalCompensationRange: CompanyPagesTotalCompensationRange;
  CompanyPagesUpdateInterviewInput: CompanyPagesUpdateInterviewInput;
  CompanyPagesUpdateReviewInput: CompanyPagesUpdateReviewInput;
  CompanyPagesUpdateSalaryInput: CompanyPagesUpdateSalaryInput;
  CompanySearchResult: CompanySearchResult;
  CompanySeriesStage: CompanySeriesStage;
  CompanyStage: CompanyStage;
  CompleteTooltipInput: CompleteTooltipInput;
  ConfirmTermsOfServiceByPotentialEmployerInput: ConfirmTermsOfServiceByPotentialEmployerInput;
  Connection: Connection;
  ConnectionConnection: ConnectionConnection;
  ConnectionEdge: ConnectionEdge;
  ConnectionSuggestionInterface: ResolversParentTypes['ConnectionTopSuggestionUser'] | ResolversParentTypes['UserContact'];
  ConnectionSuggestionInterfaceConnection: ConnectionSuggestionInterfaceConnection;
  ConnectionSuggestionInterfaceEdge: ConnectionSuggestionInterfaceEdge;
  ConnectionTopSuggestionUser: ConnectionTopSuggestionUser;
  Contacts: Contacts;
  Content: ResolversParentTypes['DealStory'] | ResolversParentTypes['Link'] | ResolversParentTypes['LinkedinPost'] | ResolversParentTypes['Story'] | ResolversParentTypes['YoutubeLink'];
  Country: Country;
  CountryState: CountryState;
  CreateAwardForPublicPortfolioCurrentUserInput: CreateAwardForPublicPortfolioCurrentUserInput;
  CreateClientForPublicPortfolioCurrentUserInput: CreateClientForPublicPortfolioCurrentUserInput;
  CreateCommentInput: CreateCommentInput;
  CreateConnectionsInput: CreateConnectionsInput;
  CreateCustomCompanyInput: CreateCustomCompanyInput;
  CreateCustomDepartmentInput: CreateCustomDepartmentInput;
  CreateCustomProductInput: CreateCustomProductInput;
  CreateCustomSalesRoleInput: CreateCustomSalesRoleInput;
  CreateCustomUniversityInput: CreateCustomUniversityInput;
  CreateDealAttributes: CreateDealAttributes;
  CreateDealsInput: CreateDealsInput;
  CreateDealsSourceInput: CreateDealsSourceInput;
  CreateEducationHistoryForPublicPortfolioCurrentUserInput: CreateEducationHistoryForPublicPortfolioCurrentUserInput;
  CreatePollVoteInput: CreatePollVoteInput;
  CreatePostInput: CreatePostInput;
  CreatePotentialEmployerInput: CreatePotentialEmployerInput;
  CreateRatingInput: CreateRatingInput;
  CreateRequestInput: CreateRequestInput;
  CreateTopicInput: CreateTopicInput;
  CreateWorkHistoryForPublicPortfolioCurrentUserInput: CreateWorkHistoryForPublicPortfolioCurrentUserInput;
  CurrentUser: CurrentUser;
  CustomerSegment: CustomerSegment;
  DeactivateCurrentUserInput: DeactivateCurrentUserInput;
  Deal: Deal;
  DealConnection: DealConnection;
  DealConnectionInterface: ResolversParentTypes['DealConnection'] | ResolversParentTypes['PortfolioDealConnection'];
  DealEdge: DealEdge;
  DealInterface: ResolversParentTypes['Deal'] | ResolversParentTypes['PortfolioDeal'];
  DealStory: DealStory;
  DealStoryPostAttributes: DealStoryPostAttributes;
  DealsStatistics: DealsStatistics;
  Department: Department;
  DestroyAwardForPublicPortfolioCurrentUserInput: DestroyAwardForPublicPortfolioCurrentUserInput;
  DestroyClientForPublicPortfolioCurrentUserInput: DestroyClientForPublicPortfolioCurrentUserInput;
  DestroyCommentInput: DestroyCommentInput;
  DestroyDealInput: DestroyDealInput;
  DestroyEducationHistoryForPublicPortfolioCurrentUserInput: DestroyEducationHistoryForPublicPortfolioCurrentUserInput;
  DestroyPostInput: DestroyPostInput;
  DestroyRatingInput: DestroyRatingInput;
  DestroyTestimonialForPublicPortfolioCurrentUserInput: DestroyTestimonialForPublicPortfolioCurrentUserInput;
  DestroyWorkHistoryForPublicPortfolioCurrentUserInput: DestroyWorkHistoryForPublicPortfolioCurrentUserInput;
  DetachCompanySeriesStageInput: DetachCompanySeriesStageInput;
  DetachCompanyStageInput: DetachCompanyStageInput;
  DetachDepartmentInput: DetachDepartmentInput;
  DetachProductInput: DetachProductInput;
  DetachSalesRoleInput: DetachSalesRoleInput;
  DirectMessagesSubscriptionPayload: DirectMessagesSubscriptionPayload;
  EarnItem: EarnItem;
  EducationHistory: EducationHistory;
  Employee: Employee;
  EmployeeConnection: EmployeeConnection;
  EmployeeEdge: EmployeeEdge;
  EndorseTestimonialAuthorAttributes: EndorseTestimonialAuthorAttributes;
  EndorseTestimonialForPublicPortfolioUserInput: EndorseTestimonialForPublicPortfolioUserInput;
  Expectation: Expectation;
  ExpressDesireToImportConnectionsForPublicPortfolioUserInput: ExpressDesireToImportConnectionsForPublicPortfolioUserInput;
  File: File;
  FillInquiryInput: FillInquiryInput;
  FindOrCreateCompanyAttributes: FindOrCreateCompanyAttributes;
  FindOrCreateDepartmentAttributes: FindOrCreateDepartmentAttributes;
  FinishOnboardingInput: FinishOnboardingInput;
  FireHiringEventInput: FireHiringEventInput;
  FlagIssueInput: FlagIssueInput;
  Float: Scalars['Float'];
  FloatRangeRightBoundOptional: FloatRangeRightBoundOptional;
  FloatRangeRightBoundOptionalInput: FloatRangeRightBoundOptionalInput;
  GenericMatch: ResolversParentTypes['BaseMatch'] | ResolversParentTypes['CityMatch'] | ResolversParentTypes['UniversityMatch'] | ResolversParentTypes['WorkHistoryMatch'];
  GeoPositionAttributes: GeoPositionAttributes;
  HighlightedText: HighlightedText;
  HiringResendIntroduceEmailInput: HiringResendIntroduceEmailInput;
  ID: Scalars['ID'];
  IP: Scalars['IP'];
  ISO8601Date: Scalars['ISO8601Date'];
  ISO8601DateTime: Scalars['ISO8601DateTime'];
  Industry: Industry;
  InquiryFakeHiringAttributes: InquiryFakeHiringAttributes;
  Int: Scalars['Int'];
  IntRangeRightBoundOptional: IntRangeRightBoundOptional;
  IntRangeRightBoundOptionalInput: IntRangeRightBoundOptionalInput;
  JSON: Scalars['JSON'];
  JobsBaseInquiryInterface: ResolversParentTypes['JobsInquiry'] | ResolversParentTypes['JobsModeratorsInquiry'];
  JobsCandidateInterface: ResolversParentTypes['JobsModeratorsCandidate'] | ResolversParentTypes['JobsRecruitersCandidate'];
  JobsCandidatesUpdateHiringInput: JobsCandidatesUpdateHiringInput;
  JobsEmployer: JobsEmployer;
  JobsFieldsBooleanInterface: ResolversParentTypes['JobsModeratorsFieldsBoolean'] | ResolversParentTypes['JobsRecruitersFieldsBoolean'];
  JobsFieldsCategoryInterface: ResolversParentTypes['JobsModeratorsFieldsCategory'] | ResolversParentTypes['JobsRecruitersFieldsCategory'];
  JobsFieldsConfiguration: JobsFieldsConfiguration;
  JobsFieldsFloatInterface: ResolversParentTypes['JobsModeratorsFieldsFloat'] | ResolversParentTypes['JobsRecruitersFieldsFloat'];
  JobsFieldsFloatRangeInterface: ResolversParentTypes['JobsModeratorsFieldsFloatRange'] | ResolversParentTypes['JobsRecruitersFieldsFloatRange'];
  JobsFieldsIntegerInterface: ResolversParentTypes['JobsModeratorsFieldsInteger'] | ResolversParentTypes['JobsRecruitersFieldsInteger'];
  JobsFieldsIntegerRangeInterface: ResolversParentTypes['JobsModeratorsFieldsIntegerRange'] | ResolversParentTypes['JobsRecruitersFieldsIntegerRange'];
  JobsFieldsInterface: ResolversParentTypes['JobsModeratorsFieldsBoolean'] | ResolversParentTypes['JobsModeratorsFieldsFloat'] | ResolversParentTypes['JobsModeratorsFieldsFloatRange'] | ResolversParentTypes['JobsModeratorsFieldsInteger'] | ResolversParentTypes['JobsModeratorsFieldsIntegerRange'] | ResolversParentTypes['JobsModeratorsFieldsMultiSelect'] | ResolversParentTypes['JobsModeratorsFieldsMultiSelectRecord'] | ResolversParentTypes['JobsModeratorsFieldsSingleSelect'] | ResolversParentTypes['JobsModeratorsFieldsSingleSelectRecord'] | ResolversParentTypes['JobsModeratorsFieldsString'] | ResolversParentTypes['JobsModeratorsFieldsStringArray'] | ResolversParentTypes['JobsRecruitersFieldsBoolean'] | ResolversParentTypes['JobsRecruitersFieldsFloat'] | ResolversParentTypes['JobsRecruitersFieldsFloatRange'] | ResolversParentTypes['JobsRecruitersFieldsInteger'] | ResolversParentTypes['JobsRecruitersFieldsIntegerRange'] | ResolversParentTypes['JobsRecruitersFieldsMultiSelect'] | ResolversParentTypes['JobsRecruitersFieldsMultiSelectRecord'] | ResolversParentTypes['JobsRecruitersFieldsSingleSelect'] | ResolversParentTypes['JobsRecruitersFieldsSingleSelectRecord'] | ResolversParentTypes['JobsRecruitersFieldsString'] | ResolversParentTypes['JobsRecruitersFieldsStringArray'];
  JobsFieldsRangePlaceholder: JobsFieldsRangePlaceholder;
  JobsFieldsSelectInterface: ResolversParentTypes['JobsModeratorsFieldsMultiSelect'] | ResolversParentTypes['JobsModeratorsFieldsSingleSelect'] | ResolversParentTypes['JobsRecruitersFieldsMultiSelect'] | ResolversParentTypes['JobsRecruitersFieldsSingleSelect'];
  JobsFieldsSelectOption: JobsFieldsSelectOption;
  JobsFieldsSingleSelectRecordInterface: ResolversParentTypes['JobsModeratorsFieldsMultiSelectRecord'] | ResolversParentTypes['JobsModeratorsFieldsSingleSelectRecord'] | ResolversParentTypes['JobsRecruitersFieldsMultiSelectRecord'] | ResolversParentTypes['JobsRecruitersFieldsSingleSelectRecord'];
  JobsFieldsStringArrayInterface: ResolversParentTypes['JobsModeratorsFieldsStringArray'] | ResolversParentTypes['JobsRecruitersFieldsStringArray'];
  JobsFieldsStringInterface: ResolversParentTypes['JobsModeratorsFieldsString'] | ResolversParentTypes['JobsRecruitersFieldsString'];
  JobsFieldsTooltip: JobsFieldsTooltip;
  JobsHiring: JobsHiring;
  JobsInquiry: JobsInquiry;
  JobsInquiryFakeHiring: JobsInquiryFakeHiring;
  JobsModeratorsActivateVacancyInput: JobsModeratorsActivateVacancyInput;
  JobsModeratorsCandidate: JobsModeratorsCandidate;
  JobsModeratorsCandidateVisibilityOfAttributes: JobsModeratorsCandidateVisibilityOfAttributes;
  JobsModeratorsCreateEmployerInput: JobsModeratorsCreateEmployerInput;
  JobsModeratorsCreateHiringInput: JobsModeratorsCreateHiringInput;
  JobsModeratorsCreateHiringsInput: JobsModeratorsCreateHiringsInput;
  JobsModeratorsCreateInquiryNoteInput: JobsModeratorsCreateInquiryNoteInput;
  JobsModeratorsCreateVacancyInput: JobsModeratorsCreateVacancyInput;
  JobsModeratorsCreateVacancySubmissionInput: JobsModeratorsCreateVacancySubmissionInput;
  JobsModeratorsDeactivateVacancyInput: JobsModeratorsDeactivateVacancyInput;
  JobsModeratorsDeleteVacancyInput: JobsModeratorsDeleteVacancyInput;
  JobsModeratorsDestroyInquiryNoteInput: JobsModeratorsDestroyInquiryNoteInput;
  JobsModeratorsEditEmployersClientsInput: JobsModeratorsEditEmployersClientsInput;
  JobsModeratorsEditEmployersRecruitersInput: JobsModeratorsEditEmployersRecruitersInput;
  JobsModeratorsEmployer: JobsModeratorsEmployer;
  JobsModeratorsEmployerClient: JobsModeratorsEmployerClient;
  JobsModeratorsEmployerClientAttributes: JobsModeratorsEmployerClientAttributes;
  JobsModeratorsEmployerConnection: JobsModeratorsEmployerConnection;
  JobsModeratorsEmployerEdge: JobsModeratorsEmployerEdge;
  JobsModeratorsEmployerHiringGroups: JobsModeratorsEmployerHiringGroups;
  JobsModeratorsEmployerSortAttributes: JobsModeratorsEmployerSortAttributes;
  JobsModeratorsEmployerSubscription: JobsModeratorsEmployerSubscription;
  JobsModeratorsEmployersAccountOwner: JobsModeratorsEmployersAccountOwner;
  JobsModeratorsField: ResolversParentTypes['JobsModeratorsFieldsBoolean'] | ResolversParentTypes['JobsModeratorsFieldsFloat'] | ResolversParentTypes['JobsModeratorsFieldsFloatRange'] | ResolversParentTypes['JobsModeratorsFieldsInteger'] | ResolversParentTypes['JobsModeratorsFieldsIntegerRange'] | ResolversParentTypes['JobsModeratorsFieldsMultiSelect'] | ResolversParentTypes['JobsModeratorsFieldsMultiSelectRecord'] | ResolversParentTypes['JobsModeratorsFieldsSingleSelect'] | ResolversParentTypes['JobsModeratorsFieldsSingleSelectRecord'] | ResolversParentTypes['JobsModeratorsFieldsString'] | ResolversParentTypes['JobsModeratorsFieldsStringArray'];
  JobsModeratorsFieldValueInterface: ResolversParentTypes['JobsModeratorsFieldValuesBoolean'] | ResolversParentTypes['JobsModeratorsFieldValuesFloat'] | ResolversParentTypes['JobsModeratorsFieldValuesFloatRange'] | ResolversParentTypes['JobsModeratorsFieldValuesInteger'] | ResolversParentTypes['JobsModeratorsFieldValuesIntegerRange'] | ResolversParentTypes['JobsModeratorsFieldValuesMultiSelect'] | ResolversParentTypes['JobsModeratorsFieldValuesMultiSelectRecord'] | ResolversParentTypes['JobsModeratorsFieldValuesSingleSelect'] | ResolversParentTypes['JobsModeratorsFieldValuesSingleSelectRecord'] | ResolversParentTypes['JobsModeratorsFieldValuesString'] | ResolversParentTypes['JobsModeratorsFieldValuesStringArray'];
  JobsModeratorsFieldValuesBoolean: Omit<JobsModeratorsFieldValuesBoolean, 'field'> & { field: ResolversParentTypes['JobsModeratorsField'] };
  JobsModeratorsFieldValuesFloat: Omit<JobsModeratorsFieldValuesFloat, 'field'> & { field: ResolversParentTypes['JobsModeratorsField'] };
  JobsModeratorsFieldValuesFloatRange: Omit<JobsModeratorsFieldValuesFloatRange, 'field'> & { field: ResolversParentTypes['JobsModeratorsField'] };
  JobsModeratorsFieldValuesInteger: Omit<JobsModeratorsFieldValuesInteger, 'field'> & { field: ResolversParentTypes['JobsModeratorsField'] };
  JobsModeratorsFieldValuesIntegerRange: Omit<JobsModeratorsFieldValuesIntegerRange, 'field'> & { field: ResolversParentTypes['JobsModeratorsField'] };
  JobsModeratorsFieldValuesMultiSelect: Omit<JobsModeratorsFieldValuesMultiSelect, 'field'> & { field: ResolversParentTypes['JobsModeratorsField'] };
  JobsModeratorsFieldValuesMultiSelectRecord: Omit<JobsModeratorsFieldValuesMultiSelectRecord, 'field' | 'records'> & { field: ResolversParentTypes['JobsModeratorsField'], records: Array<ResolversParentTypes['JobsModeratorsFieldValuesSelectRecordType']> };
  JobsModeratorsFieldValuesSelectRecordType: ResolversParentTypes['City'] | ResolversParentTypes['Company'] | ResolversParentTypes['Department'] | ResolversParentTypes['Industry'];
  JobsModeratorsFieldValuesSingleSelect: Omit<JobsModeratorsFieldValuesSingleSelect, 'field'> & { field: ResolversParentTypes['JobsModeratorsField'] };
  JobsModeratorsFieldValuesSingleSelectRecord: Omit<JobsModeratorsFieldValuesSingleSelectRecord, 'field' | 'record'> & { field: ResolversParentTypes['JobsModeratorsField'], record: ResolversParentTypes['JobsModeratorsFieldValuesSelectRecordType'] };
  JobsModeratorsFieldValuesString: Omit<JobsModeratorsFieldValuesString, 'field'> & { field: ResolversParentTypes['JobsModeratorsField'] };
  JobsModeratorsFieldValuesStringArray: Omit<JobsModeratorsFieldValuesStringArray, 'field'> & { field: ResolversParentTypes['JobsModeratorsField'] };
  JobsModeratorsFieldsBoolean: JobsModeratorsFieldsBoolean;
  JobsModeratorsFieldsBooleanAttributes: JobsModeratorsFieldsBooleanAttributes;
  JobsModeratorsFieldsCategory: Omit<JobsModeratorsFieldsCategory, 'fields'> & { fields: Array<ResolversParentTypes['JobsModeratorsField']> };
  JobsModeratorsFieldsFloat: JobsModeratorsFieldsFloat;
  JobsModeratorsFieldsFloatAttributes: JobsModeratorsFieldsFloatAttributes;
  JobsModeratorsFieldsFloatRange: JobsModeratorsFieldsFloatRange;
  JobsModeratorsFieldsFloatRangeAttributes: JobsModeratorsFieldsFloatRangeAttributes;
  JobsModeratorsFieldsInteger: JobsModeratorsFieldsInteger;
  JobsModeratorsFieldsIntegerAttributes: JobsModeratorsFieldsIntegerAttributes;
  JobsModeratorsFieldsIntegerRange: JobsModeratorsFieldsIntegerRange;
  JobsModeratorsFieldsIntegerRangeAttributes: JobsModeratorsFieldsIntegerRangeAttributes;
  JobsModeratorsFieldsMultiSelect: JobsModeratorsFieldsMultiSelect;
  JobsModeratorsFieldsMultiSelectAttributes: JobsModeratorsFieldsMultiSelectAttributes;
  JobsModeratorsFieldsMultiSelectRecord: JobsModeratorsFieldsMultiSelectRecord;
  JobsModeratorsFieldsMultiSelectRecordAttributes: JobsModeratorsFieldsMultiSelectRecordAttributes;
  JobsModeratorsFieldsSingleSelect: JobsModeratorsFieldsSingleSelect;
  JobsModeratorsFieldsSingleSelectAttributes: JobsModeratorsFieldsSingleSelectAttributes;
  JobsModeratorsFieldsSingleSelectRecord: JobsModeratorsFieldsSingleSelectRecord;
  JobsModeratorsFieldsSingleSelectRecordAttributes: JobsModeratorsFieldsSingleSelectRecordAttributes;
  JobsModeratorsFieldsString: JobsModeratorsFieldsString;
  JobsModeratorsFieldsStringArray: JobsModeratorsFieldsStringArray;
  JobsModeratorsFieldsStringArrayAttributes: JobsModeratorsFieldsStringArrayAttributes;
  JobsModeratorsFieldsStringAttributes: JobsModeratorsFieldsStringAttributes;
  JobsModeratorsFireHiringEventInput: JobsModeratorsFireHiringEventInput;
  JobsModeratorsFireInquiryEventInput: JobsModeratorsFireInquiryEventInput;
  JobsModeratorsHiring: JobsModeratorsHiring;
  JobsModeratorsHiringConnection: JobsModeratorsHiringConnection;
  JobsModeratorsHiringEdge: JobsModeratorsHiringEdge;
  JobsModeratorsHiringExplanation: JobsModeratorsHiringExplanation;
  JobsModeratorsHiringSortAttributes: JobsModeratorsHiringSortAttributes;
  JobsModeratorsHiringStateCounter: JobsModeratorsHiringStateCounter;
  JobsModeratorsInquiry: JobsModeratorsInquiry;
  JobsModeratorsInquiryConnection: JobsModeratorsInquiryConnection;
  JobsModeratorsInquiryEdge: JobsModeratorsInquiryEdge;
  JobsModeratorsInquiryMatch: JobsModeratorsInquiryMatch;
  JobsModeratorsInquiryNote: JobsModeratorsInquiryNote;
  JobsModeratorsInquirySortAttributes: JobsModeratorsInquirySortAttributes;
  JobsModeratorsMatchInquiryInput: JobsModeratorsMatchInquiryInput;
  JobsModeratorsMatchInquiryPayload: JobsModeratorsMatchInquiryPayload;
  JobsModeratorsMergeVacancyInput: JobsModeratorsMergeVacancyInput;
  JobsModeratorsOpsRejectionReason: JobsModeratorsOpsRejectionReason;
  JobsModeratorsRecruiter: JobsModeratorsRecruiter;
  JobsModeratorsRecruiterAttributes: JobsModeratorsRecruiterAttributes;
  JobsModeratorsRejectInquiryVacancySuggestionByOpsInput: JobsModeratorsRejectInquiryVacancySuggestionByOpsInput;
  JobsModeratorsRejectJobsHiringByOpsInput: JobsModeratorsRejectJobsHiringByOpsInput;
  JobsModeratorsRemoveInquiryInput: JobsModeratorsRemoveInquiryInput;
  JobsModeratorsRenewActiveJobStatusInput: JobsModeratorsRenewActiveJobStatusInput;
  JobsModeratorsScheduleMeetingInput: JobsModeratorsScheduleMeetingInput;
  JobsModeratorsScheduledMessage: JobsModeratorsScheduledMessage;
  JobsModeratorsSubmitHiringInput: JobsModeratorsSubmitHiringInput;
  JobsModeratorsUpdateCompanyInput: JobsModeratorsUpdateCompanyInput;
  JobsModeratorsUpdateEmployerInput: JobsModeratorsUpdateEmployerInput;
  JobsModeratorsUpdateHiringInput: JobsModeratorsUpdateHiringInput;
  JobsModeratorsUpdateInquiryInput: JobsModeratorsUpdateInquiryInput;
  JobsModeratorsUpdateSubmittedHiringInput: JobsModeratorsUpdateSubmittedHiringInput;
  JobsModeratorsUpdateUserInput: JobsModeratorsUpdateUserInput;
  JobsModeratorsUpdateVacancyInput: JobsModeratorsUpdateVacancyInput;
  JobsModeratorsUpdateVacancySubmissionInput: JobsModeratorsUpdateVacancySubmissionInput;
  JobsModeratorsUser: JobsModeratorsUser;
  JobsModeratorsVacancy: Omit<JobsModeratorsVacancy, 'fieldValues'> & { fieldValues: Array<ResolversParentTypes['JobsModeratorsVacancyFieldValue']> };
  JobsModeratorsVacancyConnection: JobsModeratorsVacancyConnection;
  JobsModeratorsVacancyCreator: JobsModeratorsVacancyCreator;
  JobsModeratorsVacancyCreatorInterface: ResolversParentTypes['JobsModeratorsVacancyCreator'];
  JobsModeratorsVacancyEdge: JobsModeratorsVacancyEdge;
  JobsModeratorsVacancyFieldValue: ResolversParentTypes['JobsModeratorsFieldValuesBoolean'] | ResolversParentTypes['JobsModeratorsFieldValuesFloat'] | ResolversParentTypes['JobsModeratorsFieldValuesFloatRange'] | ResolversParentTypes['JobsModeratorsFieldValuesInteger'] | ResolversParentTypes['JobsModeratorsFieldValuesIntegerRange'] | ResolversParentTypes['JobsModeratorsFieldValuesMultiSelect'] | ResolversParentTypes['JobsModeratorsFieldValuesMultiSelectRecord'] | ResolversParentTypes['JobsModeratorsFieldValuesSingleSelect'] | ResolversParentTypes['JobsModeratorsFieldValuesSingleSelectRecord'] | ResolversParentTypes['JobsModeratorsFieldValuesString'] | ResolversParentTypes['JobsModeratorsFieldValuesStringArray'];
  JobsModeratorsVacancyMatch: JobsModeratorsVacancyMatch;
  JobsModeratorsVacancySortAttributes: JobsModeratorsVacancySortAttributes;
  JobsModeratorsVacancySubmission: JobsModeratorsVacancySubmission;
  JobsModeratorsVacancySubmissionVisibilityAttributes: JobsModeratorsVacancySubmissionVisibilityAttributes;
  JobsRecruiter: JobsRecruiter;
  JobsRecruitersAcceptCandidateInput: JobsRecruitersAcceptCandidateInput;
  JobsRecruitersActivateCurrentRecruiterInput: JobsRecruitersActivateCurrentRecruiterInput;
  JobsRecruitersActivateVacancyInput: JobsRecruitersActivateVacancyInput;
  JobsRecruitersCandidate: JobsRecruitersCandidate;
  JobsRecruitersCandidateConnection: JobsRecruitersCandidateConnection;
  JobsRecruitersCandidateEdge: JobsRecruitersCandidateEdge;
  JobsRecruitersClient: JobsRecruitersClient;
  JobsRecruitersCompleteTooltipInput: JobsRecruitersCompleteTooltipInput;
  JobsRecruitersCreateCustomCompanyInput: JobsRecruitersCreateCustomCompanyInput;
  JobsRecruitersCreateEmployerInput: JobsRecruitersCreateEmployerInput;
  JobsRecruitersCreateStripeBillingUrlInput: JobsRecruitersCreateStripeBillingUrlInput;
  JobsRecruitersCreateStripeSessionUrlInput: JobsRecruitersCreateStripeSessionUrlInput;
  JobsRecruitersCreateVacancyInput: JobsRecruitersCreateVacancyInput;
  JobsRecruitersDeleteEmployerInput: JobsRecruitersDeleteEmployerInput;
  JobsRecruitersDeleteRecruiterInput: JobsRecruitersDeleteRecruiterInput;
  JobsRecruitersDeleteVacancyFieldInput: JobsRecruitersDeleteVacancyFieldInput;
  JobsRecruitersDeleteVacancyInput: JobsRecruitersDeleteVacancyInput;
  JobsRecruitersDestroyCandidateInput: JobsRecruitersDestroyCandidateInput;
  JobsRecruitersDistribution: JobsRecruitersDistribution;
  JobsRecruitersDistributionBin: JobsRecruitersDistributionBin;
  JobsRecruitersEditRecruiterInput: JobsRecruitersEditRecruiterInput;
  JobsRecruitersEmployer: JobsRecruitersEmployer;
  JobsRecruitersEmployerAttributes: JobsRecruitersEmployerAttributes;
  JobsRecruitersEmployerSubscription: JobsRecruitersEmployerSubscription;
  JobsRecruitersEnableVacanciesInput: JobsRecruitersEnableVacanciesInput;
  JobsRecruitersField: ResolversParentTypes['JobsRecruitersFieldsBoolean'] | ResolversParentTypes['JobsRecruitersFieldsFloat'] | ResolversParentTypes['JobsRecruitersFieldsFloatRange'] | ResolversParentTypes['JobsRecruitersFieldsInteger'] | ResolversParentTypes['JobsRecruitersFieldsIntegerRange'] | ResolversParentTypes['JobsRecruitersFieldsMultiSelect'] | ResolversParentTypes['JobsRecruitersFieldsMultiSelectRecord'] | ResolversParentTypes['JobsRecruitersFieldsSingleSelect'] | ResolversParentTypes['JobsRecruitersFieldsSingleSelectRecord'] | ResolversParentTypes['JobsRecruitersFieldsString'] | ResolversParentTypes['JobsRecruitersFieldsStringArray'];
  JobsRecruitersFieldValueInterface: ResolversParentTypes['JobsRecruitersFieldValuesBoolean'] | ResolversParentTypes['JobsRecruitersFieldValuesFloat'] | ResolversParentTypes['JobsRecruitersFieldValuesFloatRange'] | ResolversParentTypes['JobsRecruitersFieldValuesInteger'] | ResolversParentTypes['JobsRecruitersFieldValuesIntegerRange'] | ResolversParentTypes['JobsRecruitersFieldValuesMultiSelect'] | ResolversParentTypes['JobsRecruitersFieldValuesMultiSelectRecord'] | ResolversParentTypes['JobsRecruitersFieldValuesSingleSelect'] | ResolversParentTypes['JobsRecruitersFieldValuesSingleSelectRecord'] | ResolversParentTypes['JobsRecruitersFieldValuesString'] | ResolversParentTypes['JobsRecruitersFieldValuesStringArray'];
  JobsRecruitersFieldValuesBoolean: Omit<JobsRecruitersFieldValuesBoolean, 'field'> & { field: ResolversParentTypes['JobsRecruitersField'] };
  JobsRecruitersFieldValuesFloat: Omit<JobsRecruitersFieldValuesFloat, 'field'> & { field: ResolversParentTypes['JobsRecruitersField'] };
  JobsRecruitersFieldValuesFloatRange: Omit<JobsRecruitersFieldValuesFloatRange, 'field'> & { field: ResolversParentTypes['JobsRecruitersField'] };
  JobsRecruitersFieldValuesInteger: Omit<JobsRecruitersFieldValuesInteger, 'field'> & { field: ResolversParentTypes['JobsRecruitersField'] };
  JobsRecruitersFieldValuesIntegerRange: Omit<JobsRecruitersFieldValuesIntegerRange, 'field'> & { field: ResolversParentTypes['JobsRecruitersField'] };
  JobsRecruitersFieldValuesMultiSelect: Omit<JobsRecruitersFieldValuesMultiSelect, 'field'> & { field: ResolversParentTypes['JobsRecruitersField'] };
  JobsRecruitersFieldValuesMultiSelectRecord: Omit<JobsRecruitersFieldValuesMultiSelectRecord, 'field' | 'records'> & { field: ResolversParentTypes['JobsRecruitersField'], records: Array<ResolversParentTypes['JobsRecruitersFieldValuesSelectRecordType']> };
  JobsRecruitersFieldValuesSelectRecordType: ResolversParentTypes['City'] | ResolversParentTypes['Company'] | ResolversParentTypes['Department'] | ResolversParentTypes['Industry'];
  JobsRecruitersFieldValuesSingleSelect: Omit<JobsRecruitersFieldValuesSingleSelect, 'field'> & { field: ResolversParentTypes['JobsRecruitersField'] };
  JobsRecruitersFieldValuesSingleSelectRecord: Omit<JobsRecruitersFieldValuesSingleSelectRecord, 'field' | 'record'> & { field: ResolversParentTypes['JobsRecruitersField'], record: ResolversParentTypes['JobsRecruitersFieldValuesSelectRecordType'] };
  JobsRecruitersFieldValuesString: Omit<JobsRecruitersFieldValuesString, 'field'> & { field: ResolversParentTypes['JobsRecruitersField'] };
  JobsRecruitersFieldValuesStringArray: Omit<JobsRecruitersFieldValuesStringArray, 'field'> & { field: ResolversParentTypes['JobsRecruitersField'] };
  JobsRecruitersFieldsBoolean: JobsRecruitersFieldsBoolean;
  JobsRecruitersFieldsBooleanAttributes: JobsRecruitersFieldsBooleanAttributes;
  JobsRecruitersFieldsCategory: Omit<JobsRecruitersFieldsCategory, 'fields'> & { fields: Array<ResolversParentTypes['JobsRecruitersField']> };
  JobsRecruitersFieldsFloat: JobsRecruitersFieldsFloat;
  JobsRecruitersFieldsFloatAttributes: JobsRecruitersFieldsFloatAttributes;
  JobsRecruitersFieldsFloatRange: JobsRecruitersFieldsFloatRange;
  JobsRecruitersFieldsFloatRangeAttributes: JobsRecruitersFieldsFloatRangeAttributes;
  JobsRecruitersFieldsInteger: JobsRecruitersFieldsInteger;
  JobsRecruitersFieldsIntegerAttributes: JobsRecruitersFieldsIntegerAttributes;
  JobsRecruitersFieldsIntegerRange: JobsRecruitersFieldsIntegerRange;
  JobsRecruitersFieldsIntegerRangeAttributes: JobsRecruitersFieldsIntegerRangeAttributes;
  JobsRecruitersFieldsMultiSelect: JobsRecruitersFieldsMultiSelect;
  JobsRecruitersFieldsMultiSelectAttributes: JobsRecruitersFieldsMultiSelectAttributes;
  JobsRecruitersFieldsMultiSelectRecord: JobsRecruitersFieldsMultiSelectRecord;
  JobsRecruitersFieldsMultiSelectRecordAttributes: JobsRecruitersFieldsMultiSelectRecordAttributes;
  JobsRecruitersFieldsSingleSelect: JobsRecruitersFieldsSingleSelect;
  JobsRecruitersFieldsSingleSelectAttributes: JobsRecruitersFieldsSingleSelectAttributes;
  JobsRecruitersFieldsSingleSelectRecord: JobsRecruitersFieldsSingleSelectRecord;
  JobsRecruitersFieldsSingleSelectRecordAttributes: JobsRecruitersFieldsSingleSelectRecordAttributes;
  JobsRecruitersFieldsString: JobsRecruitersFieldsString;
  JobsRecruitersFieldsStringArray: JobsRecruitersFieldsStringArray;
  JobsRecruitersFieldsStringArrayAttributes: JobsRecruitersFieldsStringArrayAttributes;
  JobsRecruitersFieldsStringAttributes: JobsRecruitersFieldsStringAttributes;
  JobsRecruitersImportGreenhouseVacanciesInput: JobsRecruitersImportGreenhouseVacanciesInput;
  JobsRecruitersInquiry: JobsRecruitersInquiry;
  JobsRecruitersMarkCandidateAsViewedInput: JobsRecruitersMarkCandidateAsViewedInput;
  JobsRecruitersMatchVacancyInput: JobsRecruitersMatchVacancyInput;
  JobsRecruitersRecruiter: JobsRecruitersRecruiter;
  JobsRecruitersRecruiterAttributes: JobsRecruitersRecruiterAttributes;
  JobsRecruitersRejectCandidateInput: JobsRecruitersRejectCandidateInput;
  JobsRecruitersSendRecruiterAuthTokenInput: JobsRecruitersSendRecruiterAuthTokenInput;
  JobsRecruitersUpdateCurrentEmployerInput: JobsRecruitersUpdateCurrentEmployerInput;
  JobsRecruitersUpdateCurrentRecruiterInput: JobsRecruitersUpdateCurrentRecruiterInput;
  JobsRecruitersUpdateCustomCompanyInput: JobsRecruitersUpdateCustomCompanyInput;
  JobsRecruitersUpdateVacancyFieldInput: JobsRecruitersUpdateVacancyFieldInput;
  JobsRecruitersUpdateVacancyInput: JobsRecruitersUpdateVacancyInput;
  JobsRecruitersVacancy: Omit<JobsRecruitersVacancy, 'fieldValues'> & { fieldValues: Array<ResolversParentTypes['JobsRecruitersVacancyFieldValue']> };
  JobsRecruitersVacancyFieldValue: ResolversParentTypes['JobsRecruitersFieldValuesBoolean'] | ResolversParentTypes['JobsRecruitersFieldValuesFloat'] | ResolversParentTypes['JobsRecruitersFieldValuesFloatRange'] | ResolversParentTypes['JobsRecruitersFieldValuesInteger'] | ResolversParentTypes['JobsRecruitersFieldValuesIntegerRange'] | ResolversParentTypes['JobsRecruitersFieldValuesMultiSelect'] | ResolversParentTypes['JobsRecruitersFieldValuesMultiSelectRecord'] | ResolversParentTypes['JobsRecruitersFieldValuesSingleSelect'] | ResolversParentTypes['JobsRecruitersFieldValuesSingleSelectRecord'] | ResolversParentTypes['JobsRecruitersFieldValuesString'] | ResolversParentTypes['JobsRecruitersFieldValuesStringArray'];
  JobsRecruitersVacancyPromptTemplate: JobsRecruitersVacancyPromptTemplate;
  JobsRecruitersVacancySubmission: JobsRecruitersVacancySubmission;
  JobsVacancy: JobsVacancy;
  JobsVacancySubmission: JobsVacancySubmission;
  JobsVacancySubmissionInterface: ResolversParentTypes['JobsModeratorsVacancySubmission'] | ResolversParentTypes['JobsRecruitersVacancySubmission'] | ResolversParentTypes['JobsVacancySubmission'];
  JobsVacancySubmissionVisibilityOfAttributes: JobsVacancySubmissionVisibilityOfAttributes;
  Link: Link;
  LinkedinPost: LinkedinPost;
  LinkedinProfileImportedPayload: LinkedinProfileImportedPayload;
  Location: ResolversParentTypes['City'] | ResolversParentTypes['CountryState'];
  MarkCommentsViewedInput: MarkCommentsViewedInput;
  MarkPostsAsReadInput: MarkPostsAsReadInput;
  MatchJobsInquiryAfterOnboardingInput: MatchJobsInquiryAfterOnboardingInput;
  Message: Message;
  MessageConnection: MessageConnection;
  MessageEdge: MessageEdge;
  Mutation: {};
  Notification: Omit<Notification, 'referenceable'> & { referenceable?: Maybe<ResolversParentTypes['NotificationReferenceable']> };
  NotificationConnection: NotificationConnection;
  NotificationEdge: NotificationEdge;
  NotificationReferenceable: ResolversParentTypes['Comment'] | ResolversParentTypes['JobsHiring'] | ResolversParentTypes['Post'] | ResolversParentTypes['Rating'] | ResolversParentTypes['SalesGptQuery'] | ResolversParentTypes['Testimonial'] | ResolversParentTypes['User'];
  OnboardingData: OnboardingData;
  PageInfo: PageInfo;
  Poll: Poll;
  PollAttributes: PollAttributes;
  PollChoice: PollChoice;
  PollChoiceAttributes: PollChoiceAttributes;
  PollVote: PollVote;
  PollVoteConnection: PollVoteConnection;
  PollVoteEdge: PollVoteEdge;
  PortfolioCurrentUser: PortfolioCurrentUser;
  PortfolioDeal: PortfolioDeal;
  PortfolioDealConnection: PortfolioDealConnection;
  PortfolioDealEdge: PortfolioDealEdge;
  PortfolioDealQuarter: PortfolioDealQuarter;
  PortfolioDealsSource: PortfolioDealsSource;
  PortfolioRanking: PortfolioRanking;
  PortfolioUserSearchResult: PortfolioUserSearchResult;
  Post: Omit<Post, 'author' | 'content'> & { author: ResolversParentTypes['UserAuthor'], content: ResolversParentTypes['Content'] };
  PostConnection: PostConnection;
  PostEdge: PostEdge;
  PostView: PostView;
  PostViewConnection: PostViewConnection;
  PostViewEdge: PostViewEdge;
  PotentialEmployer: PotentialEmployer;
  ProductType: ProductType;
  Public: Public;
  PublicPortfolioConfiguration: PublicPortfolioConfiguration;
  PublicPortfolioCurrentUser: PublicPortfolioCurrentUser;
  PublicPortfolioUser: PublicPortfolioUser;
  PublicPortfolioUserIterface: ResolversParentTypes['PublicPortfolioCurrentUser'] | ResolversParentTypes['PublicPortfolioUser'];
  Query: {};
  Rating: Omit<Rating, 'reactable'> & { reactable: ResolversParentTypes['Reactable'] };
  RatingConnection: RatingConnection;
  RatingEdge: RatingEdge;
  ReRequestTestimonialForPublicPortfolioCurrentUserInput: ReRequestTestimonialForPublicPortfolioCurrentUserInput;
  Reactable: ResolversParentTypes['Comment'] | ResolversParentTypes['Post'];
  ReadAllNotificationsInput: ReadAllNotificationsInput;
  ReadNotificationInput: ReadNotificationInput;
  ReadRequestsInput: ReadRequestsInput;
  ReadThreadEvent: ReadThreadEvent;
  ReadThreadMessagesInput: ReadThreadMessagesInput;
  RefreshInquiryInput: RefreshInquiryInput;
  Region: Region;
  RegionConnection: RegionConnection;
  RegionEdge: RegionEdge;
  RejectJobsHiringInput: RejectJobsHiringInput;
  RejectRequestInput: RejectRequestInput;
  RelatedCompany: RelatedCompany;
  RelatedCompanyPageResponse: RelatedCompanyPageResponse;
  RemoveConnectionInput: RemoveConnectionInput;
  RenewActiveJobStatusInput: RenewActiveJobStatusInput;
  ReportSalesGptFeedbackInput: ReportSalesGptFeedbackInput;
  Request: Request;
  RequestConnection: RequestConnection;
  RequestEdge: RequestEdge;
  RequestParticipant: RequestParticipant;
  RequestTestimonialForPublicPortfolioCurrentUserInput: RequestTestimonialForPublicPortfolioCurrentUserInput;
  RoleCategory: RoleCategory;
  SalesDirectoryPage: SalesDirectoryPage;
  SalesDirectoryUser: SalesDirectoryUser;
  SalesGptQuery: SalesGptQuery;
  SalesRole: SalesRole;
  SalesTeamTenureAverage: SalesTeamTenureAverage;
  SalesTeamTenureAverages: SalesTeamTenureAverages;
  SaveSalesGptSummaryInput: SaveSalesGptSummaryInput;
  SayThanksInput: SayThanksInput;
  ScheduleHiringMeetingInput: ScheduleHiringMeetingInput;
  SearchInfo: SearchInfo;
  SearchResultInterface: ResolversParentTypes['AcademyArticleSearchResult'] | ResolversParentTypes['CompanyPagesCatalogSearchResult'] | ResolversParentTypes['CompanySearchResult'] | ResolversParentTypes['PortfolioUserSearchResult'] | ResolversParentTypes['WarRoomPostCommentSearchResult'] | ResolversParentTypes['WarRoomPostSearchResult'] | ResolversParentTypes['WarRoomUserSearchResult'];
  SearchResultInterfaceConnection: SearchResultInterfaceConnection;
  SearchResultInterfaceEdge: SearchResultInterfaceEdge;
  SearchResultsCategory: SearchResultsCategory;
  SendMessageInput: SendMessageInput;
  SendSuperInviteInput: SendSuperInviteInput;
  StartTestimonialEndorsingForPublicPortfolioUserInput: StartTestimonialEndorsingForPublicPortfolioUserInput;
  Story: Story;
  String: Scalars['String'];
  Subscription: {};
  SuggestedUser: Omit<SuggestedUser, 'matchMetadata'> & { matchMetadata?: Maybe<ResolversParentTypes['GenericMatch']> };
  SuggestedUserConnection: SuggestedUserConnection;
  SuggestedUserEdge: SuggestedUserEdge;
  Testimonial: Testimonial;
  TestimonialAuthor: TestimonialAuthor;
  TestimonialRequestor: TestimonialRequestor;
  Thread: Thread;
  Tooltip: Tooltip;
  Topic: Topic;
  TopicConnection: TopicConnection;
  TopicEdge: TopicEdge;
  TotalCompensationRange: TotalCompensationRange;
  TriggerContactsFetchingInput: TriggerContactsFetchingInput;
  TriggerLinkedinScrapingInput: TriggerLinkedinScrapingInput;
  UnblockUserInput: UnblockUserInput;
  UndoTestimonialForPublicPortfolioCurrentUserInput: UndoTestimonialForPublicPortfolioCurrentUserInput;
  University: University;
  UniversityConnection: UniversityConnection;
  UniversityEdge: UniversityEdge;
  UniversityMatch: UniversityMatch;
  UpdateArticleInput: UpdateArticleInput;
  UpdateAwardForPublicPortfolioCurrentUserInput: UpdateAwardForPublicPortfolioCurrentUserInput;
  UpdateClientForPublicPortfolioCurrentUserInput: UpdateClientForPublicPortfolioCurrentUserInput;
  UpdateClientPositionForPublicPortfolioCurrentUserInput: UpdateClientPositionForPublicPortfolioCurrentUserInput;
  UpdateCommentInput: UpdateCommentInput;
  UpdateConfigurationForPublicPortfolioCurrentUserInput: UpdateConfigurationForPublicPortfolioCurrentUserInput;
  UpdateCurrentPortfolioUserInput: UpdateCurrentPortfolioUserInput;
  UpdateCurrentUserInput: UpdateCurrentUserInput;
  UpdateDealInput: UpdateDealInput;
  UpdateEducationHistoryForPublicPortfolioCurrentUserInput: UpdateEducationHistoryForPublicPortfolioCurrentUserInput;
  UpdateInquiryInput: UpdateInquiryInput;
  UpdatePostInput: UpdatePostInput;
  UpdatePublicPortfolioCurrentUserInput: UpdatePublicPortfolioCurrentUserInput;
  UpdateTestimonialPositionForPublicPortfolioCurrentUserInput: UpdateTestimonialPositionForPublicPortfolioCurrentUserInput;
  UpdateWorkHistoryForPublicPortfolioCurrentUserInput: UpdateWorkHistoryForPublicPortfolioCurrentUserInput;
  UpsertDealQuarterInput: UpsertDealQuarterInput;
  User: User;
  UserAchievement: UserAchievement;
  UserAuthor: ResolversParentTypes['Anonymous'] | ResolversParentTypes['Public'];
  UserConnection: UserConnection;
  UserContact: UserContact;
  UserEdge: UserEdge;
  UserPost: UserPost;
  UserPostConnection: UserPostConnection;
  UserPostEdge: UserPostEdge;
  UserSearch: UserSearch;
  VendorDbUser: VendorDbUser;
  ViewAllNotificationsInput: ViewAllNotificationsInput;
  WarRoomPostCommentSearchResult: WarRoomPostCommentSearchResult;
  WarRoomPostSearchResult: WarRoomPostSearchResult;
  WarRoomUserSearchResult: WarRoomUserSearchResult;
  WorkHistory: WorkHistory;
  WorkHistoryMatch: WorkHistoryMatch;
  YoutubeLink: YoutubeLink;
};

export type AcademyArticleSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcademyArticleSearchResult'] = ResolversParentTypes['AcademyArticleSearchResult']> = {
  article?: Resolver<ResolversTypes['Article'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcademyTopicResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcademyTopic'] = ResolversParentTypes['AcademyTopic']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  weight?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcademyTopicConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcademyTopicConnection'] = ResolversParentTypes['AcademyTopicConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AcademyTopicEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['AcademyTopic']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AcademyTopicEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AcademyTopicEdge'] = ResolversParentTypes['AcademyTopicEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AcademyTopic']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlumniResolvers<ContextType = any, ParentType extends ResolversParentTypes['Alumni'] = ResolversParentTypes['Alumni']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  connected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  currentPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receivedRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  requestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlumniConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlumniConnection'] = ResolversParentTypes['AlumniConnection']> = {
  edges?: Resolver<Array<ResolversTypes['AlumniEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Alumni']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlumniEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlumniEdge'] = ResolversParentTypes['AlumniEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Alumni']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnonymousResolvers<ContextType = any, ParentType extends ResolversParentTypes['Anonymous'] = ResolversParentTypes['Anonymous']> = {
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomAvatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomPosition?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  warRoomUserAchievements?: Resolver<Array<ResolversTypes['UserAchievement']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ArticleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Article'] = ResolversParentTypes['Article']> = {
  academyTopic?: Resolver<ResolversTypes['AcademyTopic'], ParentType, ContextType>;
  author?: Resolver<Maybe<ResolversTypes['Author']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  html?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isNew?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSoon?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isUpdated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  markdown?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  previewImage?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  seoDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seoTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  weight?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Author'] = ResolversParentTypes['Author']> = {
  avatar?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  joinedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  linkUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  warRoomProfileSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AverageHittingQuotaResolvers<ContextType = any, ParentType extends ResolversParentTypes['AverageHittingQuota'] = ResolversParentTypes['AverageHittingQuota']> = {
  hitQuotaLastYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  segmentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AveragePerAccountSizeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AveragePerAccountSize'] = ResolversParentTypes['AveragePerAccountSize']> = {
  basePay?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  comissionAtFullQuota?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  customerSegmentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signingPlusStock?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AveragePerYearsOfExperienceResolvers<ContextType = any, ParentType extends ResolversParentTypes['AveragePerYearsOfExperience'] = ResolversParentTypes['AveragePerYearsOfExperience']> = {
  basePay?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  comissionAtFullQuota?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  signingPlusStock?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  yearsRange?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AverageSalariesDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AverageSalariesData'] = ResolversParentTypes['AverageSalariesData']> = {
  averagePerAccountSize?: Resolver<Array<ResolversTypes['AveragePerAccountSize']>, ParentType, ContextType>;
  averagePerYearsOfExperience?: Resolver<Array<ResolversTypes['AveragePerYearsOfExperience']>, ParentType, ContextType>;
  averageTotals?: Resolver<ResolversTypes['AverageTotals'], ParentType, ContextType>;
  hittingQuota?: Resolver<Array<ResolversTypes['AverageHittingQuota']>, ParentType, ContextType>;
  totalCompensationRange?: Resolver<ResolversTypes['TotalCompensationRange'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AverageTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AverageTotals'] = ResolversParentTypes['AverageTotals']> = {
  baseSalary?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  commissionAtFullQuota?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  signingPlusStock?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalCompensation?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AwardResolvers<ContextType = any, ParentType extends ResolversParentTypes['Award'] = ResolversParentTypes['Award']> = {
  icon?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BaseMatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['BaseMatch'] = ResolversParentTypes['BaseMatch']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BestCityResolvers<ContextType = any, ParentType extends ResolversParentTypes['BestCity'] = ResolversParentTypes['BestCity']> = {
  avgBasePay?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  avgHittingQuotaPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  avgOte?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  avgOverallRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  avgTotalAnnualCompensation?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  avgWorkLifeBalanceRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface BigIntScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigInt'], any> {
  name: 'BigInt';
}

export type CityResolvers<ContextType = any, ParentType extends ResolversParentTypes['City'] = ResolversParentTypes['City']> = {
  continentCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  continentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  countryFlagEmoji?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  metroAreaShortName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stateCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stateName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CityConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CityConnection'] = ResolversParentTypes['CityConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CityEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['City']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CityEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CityEdge'] = ResolversParentTypes['CityEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CityMatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['CityMatch'] = ResolversParentTypes['CityMatch']> = {
  cityName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientResolvers<ContextType = any, ParentType extends ResolversParentTypes['Client'] = ResolversParentTypes['Client']> = {
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  workHistory?: Resolver<Maybe<ResolversTypes['WorkHistory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Comment'] = ResolversParentTypes['Comment']> = {
  author?: Resolver<ResolversTypes['UserAuthor'], ParentType, ContextType>;
  children?: Resolver<ResolversTypes['CommentConnection'], ParentType, ContextType, RequireFields<CommentChildrenArgs, never>>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  currentUserRating?: Resolver<Maybe<ResolversTypes['Rating']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  highlightedText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAnonymous?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  markedByUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  media?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['Comment']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  post?: Resolver<ResolversTypes['Post'], ParentType, ContextType>;
  postId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  previewText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratings?: Resolver<ResolversTypes['RatingConnection'], ParentType, ContextType, RequireFields<CommentRatingsArgs, never>>;
  rawText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  textUpdatedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  totalRating?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommentConnection'] = ResolversParentTypes['CommentConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CommentEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Comment']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommentEdge'] = ResolversParentTypes['CommentEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Comment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommissionBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommissionBalance'] = ResolversParentTypes['CommissionBalance']> = {
  currentBalance?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  delta?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommissionOnboardingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommissionOnboarding'] = ResolversParentTypes['CommissionOnboarding']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['EarnItem']>>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommissionTransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommissionTransaction'] = ResolversParentTypes['CommissionTransaction']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommissionTransactionSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommissionTransactionSubscriptionPayload'] = ResolversParentTypes['CommissionTransactionSubscriptionPayload']> = {
  commissionChange?: Resolver<Maybe<ResolversTypes['CommissionBalance']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompaniesCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompaniesCategory'] = ResolversParentTypes['CompaniesCategory']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompaniesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompaniesConnection'] = ResolversParentTypes['CompaniesConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CompanyEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Company']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCompaniesWithData?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Company'] = ResolversParentTypes['Company']> = {
  averageTimeForAPromotion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageTimeForPromotion?: Resolver<Maybe<ResolversTypes['CompanyPagesAverageRate']>, ParentType, ContextType>;
  averageTimeInTheCompany?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  averageWorktime?: Resolver<Maybe<ResolversTypes['CompanyPagesAverageRate']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  companyPagesSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  compensationRange?: Resolver<Maybe<ResolversTypes['CompanyPagesRange']>, ParentType, ContextType>;
  compensationRanking?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  compensationRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  custom?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  domain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employeeCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hitQuota?: Resolver<Maybe<ResolversTypes['CompanyPagesAverageRate']>, ParentType, ContextType>;
  homepageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  industries?: Resolver<Maybe<Array<ResolversTypes['Industry']>>, ParentType, ContextType>;
  interviews?: Resolver<Maybe<ResolversTypes['CompanyPagesInterviewConnection']>, ParentType, ContextType, RequireFields<CompanyInterviewsArgs, never>>;
  investmentRound?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobSatisfactionRanking?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  jobSatisfactionRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lowerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  overallRanking?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  overallRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quotaFairnessRanking?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quotaFairnessRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  relatedCompanyPages?: Resolver<Maybe<ResolversTypes['RelatedCompanyPageResponse']>, ParentType, ContextType>;
  repsHittingQuotaPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  repsHittingQuotaRanking?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  repsHittingQuotaRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reviews?: Resolver<Maybe<ResolversTypes['CompanyPagesReviewConnection']>, ParentType, ContextType, RequireFields<CompanyReviewsArgs, never>>;
  roles?: Resolver<Maybe<Array<ResolversTypes['CompanyPagesRole']>>, ParentType, ContextType, RequireFields<CompanyRolesArgs, 'roleCategoryId'>>;
  salesTeam?: Resolver<Maybe<ResolversTypes['CompanyPagesSalesTeam']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalFunding?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  webSiteUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workLifeBalanceRanking?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  workLifeBalanceRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyEdge'] = ResolversParentTypes['CompanyEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyInterface'] = ResolversParentTypes['CompanyInterface']> = {
  __resolveType: TypeResolveFn<'Company' | 'RelatedCompany', ParentType, ContextType>;
  employeeCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentRound?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalFunding?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  webSiteUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type CompanyPagesAverageRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesAverageRate'] = ResolversParentTypes['CompanyPagesAverageRate']> = {
  rate?: Resolver<Maybe<ResolversTypes['CompanyPagesRate']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesCatalogResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesCatalog'] = ResolversParentTypes['CompanyPagesCatalog']> = {
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerSegment?: Resolver<Maybe<ResolversTypes['CustomerSegment']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pageType?: Resolver<ResolversTypes['CompanyPagesCatalogPageType'], ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['Region']>, ParentType, ContextType>;
  roleCategory?: Resolver<Maybe<ResolversTypes['RoleCategory']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesCatalogSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesCatalogSearchResult'] = ResolversParentTypes['CompanyPagesCatalogSearchResult']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  page?: Resolver<ResolversTypes['CompanyPagesCatalog'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesInterviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesInterview'] = ResolversParentTypes['CompanyPagesInterview']> = {
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  customerSegment?: Resolver<Maybe<ResolversTypes['CustomerSegment']>, ParentType, ContextType>;
  difficulty?: Resolver<Maybe<ResolversTypes['CompanyPagesInterviewsDifficulty']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['CompanyPagesInterviewsDuration']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  interviewedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  jobTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  org?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['CompanyPagesInterviewsOrigin']>, ParentType, ContextType>;
  outcome?: Resolver<Maybe<ResolversTypes['CompanyPagesInterviewsOutcome']>, ParentType, ContextType>;
  process?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  questions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recommendationToPrepare?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roleCategory?: Resolver<Maybe<ResolversTypes['RoleCategory']>, ParentType, ContextType>;
  totalInterviews?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesInterviewConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesInterviewConnection'] = ResolversParentTypes['CompanyPagesInterviewConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CompanyPagesInterviewEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CompanyPagesInterview']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesInterviewEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesInterviewEdge'] = ResolversParentTypes['CompanyPagesInterviewEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CompanyPagesInterview']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesRange'] = ResolversParentTypes['CompanyPagesRange']> = {
  avg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesReviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesReview'] = ResolversParentTypes['CompanyPagesReview']> = {
  aboutCulture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adviceForNewReps?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adviceToManagment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  cons?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  customerSegment?: Resolver<Maybe<ResolversTypes['CustomerSegment']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecommended?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  jobTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  org?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  overallRating?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pros?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaFairness?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roleCategory?: Resolver<Maybe<ResolversTypes['RoleCategory']>, ParentType, ContextType>;
  salesRepTurnover?: Resolver<Maybe<ResolversTypes['CompanyPagesReviewsSalesRepTurnover']>, ParentType, ContextType>;
  trajectory?: Resolver<Maybe<ResolversTypes['CompanyPagesReviewsTrajectory']>, ParentType, ContextType>;
  upwardMobility?: Resolver<Maybe<ResolversTypes['CompanyPagesReviewsUpwardMobility']>, ParentType, ContextType>;
  workLifeBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesReviewConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesReviewConnection'] = ResolversParentTypes['CompanyPagesReviewConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CompanyPagesReviewEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CompanyPagesReview']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesReviewEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesReviewEdge'] = ResolversParentTypes['CompanyPagesReviewEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CompanyPagesReview']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesRole'] = ResolversParentTypes['CompanyPagesRole']> = {
  baseRange?: Resolver<Maybe<ResolversTypes['CompanyPagesRange']>, ParentType, ContextType>;
  baseRangeRelativeAverage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionRange?: Resolver<Maybe<ResolversTypes['CompanyPagesRange']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  oteRange?: Resolver<Maybe<ResolversTypes['CompanyPagesRange']>, ParentType, ContextType>;
  oteRangeRelativeAverage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  roleCategory?: Resolver<ResolversTypes['RoleCategory'], ParentType, ContextType>;
  salaries?: Resolver<Maybe<Array<ResolversTypes['CompanyPagesSalary']>>, ParentType, ContextType, RequireFields<CompanyPagesRoleSalariesArgs, never>>;
  totalCompensationRange?: Resolver<Maybe<ResolversTypes['CompanyPagesTotalCompensationRange']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesRoleConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesRoleConnection'] = ResolversParentTypes['CompanyPagesRoleConnection']> = {
  edges?: Resolver<Array<ResolversTypes['CompanyPagesRoleEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CompanyPagesRole']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesRoleEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesRoleEdge'] = ResolversParentTypes['CompanyPagesRoleEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['CompanyPagesRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesSalaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesSalary'] = ResolversParentTypes['CompanyPagesSalary']> = {
  accountSize?: Resolver<Maybe<ResolversTypes['CustomerSegment']>, ParentType, ContextType>;
  basePay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  comissionAtFullQuota?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyYearsOfExperience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  entryDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  hitCompensation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hitQuotaLastYear?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  level?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  org?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ote?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  prevYearTotalCompensation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['CompanyPagesRole']>, ParentType, ContextType>;
  signingBonus?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  signingPlusStock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  stockBonus?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalAnnualCompensation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalYearsOfExperience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesSalesTeamResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesSalesTeam'] = ResolversParentTypes['CompanyPagesSalesTeam']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  peopleWorkingLonger?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  peopleWorkingLongerAverage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tenureAverage?: Resolver<ResolversTypes['SalesTeamTenureAverages'], ParentType, ContextType>;
  timeToPromotion?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  timeToPromotionAverage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyPagesTotalCompensationRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPagesTotalCompensationRange'] = ResolversParentTypes['CompanyPagesTotalCompensationRange']> = {
  average?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanySearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanySearchResult'] = ResolversParentTypes['CompanySearchResult']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanySeriesStageResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanySeriesStage'] = ResolversParentTypes['CompanySeriesStage']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['CompanySeriesStageSlug'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyStageResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyStage'] = ResolversParentTypes['CompanyStage']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Connection'] = ResolversParentTypes['Connection']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  connected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  currentCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  currentPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receivedRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  requestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectionConnection'] = ResolversParentTypes['ConnectionConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ConnectionEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Connection']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectionEdge'] = ResolversParentTypes['ConnectionEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Connection']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionSuggestionInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectionSuggestionInterface'] = ResolversParentTypes['ConnectionSuggestionInterface']> = {
  __resolveType: TypeResolveFn<'ConnectionTopSuggestionUser' | 'UserContact', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ConnectionSuggestionInterfaceConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectionSuggestionInterfaceConnection'] = ResolversParentTypes['ConnectionSuggestionInterfaceConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ConnectionSuggestionInterfaceEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ConnectionSuggestionInterface']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionSuggestionInterfaceEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectionSuggestionInterfaceEdge'] = ResolversParentTypes['ConnectionSuggestionInterfaceEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['ConnectionSuggestionInterface']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConnectionTopSuggestionUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConnectionTopSuggestionUser'] = ResolversParentTypes['ConnectionTopSuggestionUser']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Contacts'] = ResolversParentTypes['Contacts']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Content'] = ResolversParentTypes['Content']> = {
  __resolveType: TypeResolveFn<'DealStory' | 'Link' | 'LinkedinPost' | 'Story' | 'YoutubeLink', ParentType, ContextType>;
};

export type CountryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Country'] = ResolversParentTypes['Country']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CountryStateResolvers<ContextType = any, ParentType extends ResolversParentTypes['CountryState'] = ResolversParentTypes['CountryState']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentUser'] = ResolversParentTypes['CurrentUser']> = {
  abTests?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  achievements?: Resolver<Maybe<Array<ResolversTypes['UserAchievement']>>, ParentType, ContextType>;
  achievementsProgress?: Resolver<Maybe<Array<ResolversTypes['UserAchievement']>>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  admin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  autoName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  calendarLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  commentsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  companySeriesStages?: Resolver<Maybe<Array<ResolversTypes['CompanySeriesStage']>>, ParentType, ContextType>;
  companyStages?: Resolver<Maybe<Array<ResolversTypes['CompanyStage']>>, ParentType, ContextType>;
  contacts?: Resolver<Maybe<Array<ResolversTypes['UserContact']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  departmentIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<ResolversTypes['Department']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enabledFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  facebookUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fakeVacancyIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasSeenNewReferProgram?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  industries?: Resolver<Maybe<Array<ResolversTypes['Industry']>>, ParentType, ContextType>;
  industry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instagramUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inviteReferrerUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  languages?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastColleaguesSyncError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastColleaguesSyncedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  lastContactsSyncError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastContactsSyncedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  lastLinkedinSyncError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastLinkedinSyncedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  lastSeenAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinProfilePicUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onboardingState?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  onboardingVacancy?: Resolver<Maybe<ResolversTypes['JobsVacancy']>, ParentType, ContextType>;
  orderPosition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  personalEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  posts?: Resolver<Maybe<Array<ResolversTypes['Post']>>, ParentType, ContextType>;
  postsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  prevScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  privateHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productTypeIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  productTypes?: Resolver<Maybe<Array<ResolversTypes['ProductType']>>, ParentType, ContextType>;
  public?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  publicEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referralsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesRoles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  solidClients?: Resolver<Maybe<Array<ResolversTypes['Client']>>, ParentType, ContextType>;
  submittedCompaniesData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  superInviteMarker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tooltips?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  toured?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  twitterUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uiTheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unreadConnectionRequestsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unreadWarRoomNotifications?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<CurrentUserUnreadWarRoomNotificationsArgs, 'platform'>>;
  unseenWarRoomNotifications?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<CurrentUserUnseenWarRoomNotificationsArgs, 'platform'>>;
  unusedSuperInvitesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomAvatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomCompanySeriesStageIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  warRoomCompanyStageIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  warRoomCurrentBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  warRoomDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomIndustryIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  warRoomJobSearchStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomJobSearchStatusExpiredAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  warRoomPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomSalesRoleIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  warRoomSalesRoles?: Resolver<Maybe<Array<ResolversTypes['SalesRole']>>, ParentType, ContextType>;
  warRoomState?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  warRoomTotalBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  warRoomYearsOfExperience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  websiteUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomerSegmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomerSegment'] = ResolversParentTypes['CustomerSegment']> = {
  emoji?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DealResolvers<ContextType = any, ParentType extends ResolversParentTypes['Deal'] = ResolversParentTypes['Deal']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  closeDate?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<ResolversTypes['Department']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  interactionsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrivateCompany?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrivateDepartments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  post?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DealConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DealConnection'] = ResolversParentTypes['DealConnection']> = {
  edges?: Resolver<Array<ResolversTypes['DealEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Deal']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  statistics?: Resolver<ResolversTypes['DealsStatistics'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DealConnectionInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['DealConnectionInterface'] = ResolversParentTypes['DealConnectionInterface']> = {
  __resolveType: TypeResolveFn<'DealConnection' | 'PortfolioDealConnection', ParentType, ContextType>;
  statistics?: Resolver<ResolversTypes['DealsStatistics'], ParentType, ContextType>;
};

export type DealEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DealEdge'] = ResolversParentTypes['DealEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Deal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DealInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['DealInterface'] = ResolversParentTypes['DealInterface']> = {
  __resolveType: TypeResolveFn<'Deal' | 'PortfolioDeal', ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  closeDate?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<ResolversTypes['Department']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  interactionsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrivateCompany?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrivateDepartments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  post?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType>;
};

export type DealStoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['DealStory'] = ResolversParentTypes['DealStory']> = {
  coverContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coverFileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coverFileSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  coverUpdatedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  coverUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  deal?: Resolver<ResolversTypes['Deal'], ParentType, ContextType>;
  highlightedText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  previewImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rawText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  textImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DealsStatisticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['DealsStatistics'] = ResolversParentTypes['DealsStatistics']> = {
  totalAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DepartmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Department'] = ResolversParentTypes['Department']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  custom?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  emoji?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  users?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectMessagesSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectMessagesSubscriptionPayload'] = ResolversParentTypes['DirectMessagesSubscriptionPayload']> = {
  newMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  readThreadEvent?: Resolver<Maybe<ResolversTypes['ReadThreadEvent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EarnItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EarnItem'] = ResolversParentTypes['EarnItem']> = {
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EducationHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['EducationHistory'] = ResolversParentTypes['EducationHistory']> = {
  degreeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  fieldOfStudy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  manuallyEdited?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  schoolName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  university?: Resolver<Maybe<ResolversTypes['University']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Employee'] = ResolversParentTypes['Employee']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  connected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  currentPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receivedRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  requestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeConnection'] = ResolversParentTypes['EmployeeConnection']> = {
  edges?: Resolver<Array<ResolversTypes['EmployeeEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Employee']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeeEdge'] = ResolversParentTypes['EmployeeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Employee']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExpectationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Expectation'] = ResolversParentTypes['Expectation']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FileResolvers<ContextType = any, ParentType extends ResolversParentTypes['File'] = ResolversParentTypes['File']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signedId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FloatRangeRightBoundOptionalResolvers<ContextType = any, ParentType extends ResolversParentTypes['FloatRangeRightBoundOptional'] = ResolversParentTypes['FloatRangeRightBoundOptional']> = {
  max?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenericMatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenericMatch'] = ResolversParentTypes['GenericMatch']> = {
  __resolveType: TypeResolveFn<'BaseMatch' | 'CityMatch' | 'UniversityMatch' | 'WorkHistoryMatch', ParentType, ContextType>;
};

export type HighlightedTextResolvers<ContextType = any, ParentType extends ResolversParentTypes['HighlightedText'] = ResolversParentTypes['HighlightedText']> = {
  highlightFrom?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  highlightTo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface IpScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['IP'], any> {
  name: 'IP';
}

export interface Iso8601DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ISO8601Date'], any> {
  name: 'ISO8601Date';
}

export interface Iso8601DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ISO8601DateTime'], any> {
  name: 'ISO8601DateTime';
}

export type IndustryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Industry'] = ResolversParentTypes['Industry']> = {
  emoji?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IntRangeRightBoundOptionalResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntRangeRightBoundOptional'] = ResolversParentTypes['IntRangeRightBoundOptional']> = {
  max?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type JobsBaseInquiryInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsBaseInquiryInterface'] = ResolversParentTypes['JobsBaseInquiryInterface']> = {
  __resolveType: TypeResolveFn<'JobsInquiry' | 'JobsModeratorsInquiry', ParentType, ContextType>;
  accomplishments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aeAnnualizedQuota?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  aeLeadSourceOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aeLeadSourcesMain?: Resolver<Maybe<Array<ResolversTypes['JobsInquiryAeLeadSource']>>, ParentType, ContextType>;
  aeQuotaPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  aeQuotaTypeMain?: Resolver<Maybe<ResolversTypes['JobsInquiryAeQuota']>, ParentType, ContextType>;
  aeQuotaTypeOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  baseSalary?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  clientDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmAccountsNumber?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmAccountNumber']>, ParentType, ContextType>;
  csmQuotaMetricMain?: Resolver<Maybe<Array<ResolversTypes['JobsInquiryCsmQuotaMetric']>>, ParentType, ContextType>;
  csmQuotaMetricOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmQuotaPeriodMain?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmQuotaPeriod']>, ParentType, ContextType>;
  csmQuotaPeriodOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmQuotaTypeMain?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmQuota']>, ParentType, ContextType>;
  csmQuotaTypeOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmRenewalValue?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmRenewalValue']>, ParentType, ContextType>;
  csmTotalBusinessValue?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmBusinessValue']>, ParentType, ContextType>;
  csmUpsellValue?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmUpsellValue']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  dealBreakerOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealBreakersMain?: Resolver<Maybe<Array<ResolversTypes['JobsInquiryDealBreaker']>>, ParentType, ContextType>;
  dealSize?: Resolver<Maybe<ResolversTypes['JobsInquiryDealSize']>, ParentType, ContextType>;
  desiredCompanySeriesStages?: Resolver<Maybe<Array<ResolversTypes['CompanySeriesStage']>>, ParentType, ContextType>;
  employmentTypes?: Resolver<Array<ResolversTypes['JobsInquiryEmployment']>, ParentType, ContextType>;
  filledAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  flexAppliedCriteria?: Resolver<Maybe<Array<ResolversTypes['JobsFlexAppliedCriteria']>>, ParentType, ContextType>;
  flexBandwidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexBriefVideoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexConsideredCompanyTypes?: Resolver<Maybe<Array<ResolversTypes['JobsFlexFlexConsideredCompanyType']>>, ParentType, ContextType>;
  flexOnboardingState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexPreviousExperience?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  flexReasonForParticipation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexRoles?: Resolver<Maybe<Array<ResolversTypes['JobsFlexRole']>>, ParentType, ContextType>;
  flexState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexUnderstandingOfSales?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idealJobDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastActiveAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  onboardingState?: Resolver<ResolversTypes['JobsInquiryOnboardingState'], ParentType, ContextType>;
  ote?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  positionMain?: Resolver<Maybe<ResolversTypes['JobsInquiryPosition']>, ParentType, ContextType>;
  positionOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentByTeamPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quotaAttainmentPerLastYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quotaAttainmentPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rankOnTeam?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  revenue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salesCycleLength?: Resolver<Maybe<ResolversTypes['JobsInquirySalesCycleLength']>, ParentType, ContextType>;
  salesMethodologies?: Resolver<Maybe<Array<ResolversTypes['JobsInquirySalesMethodology']>>, ParentType, ContextType>;
  sdrQuotaPerPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sdrQuotaTypes?: Resolver<Maybe<Array<ResolversTypes['JobsInquirySdrQuota']>>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['JobsInquiryState'], ParentType, ContextType>;
  teamSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vpDepartmentSize?: Resolver<Maybe<ResolversTypes['JobsInquiryVpDepartmentSize']>, ParentType, ContextType>;
  vpManagedRoles?: Resolver<Maybe<Array<ResolversTypes['JobsInquiryVpManagedRole']>>, ParentType, ContextType>;
  vpQuotaType?: Resolver<Maybe<ResolversTypes['JobsInquiryVpQuota']>, ParentType, ContextType>;
  vpResponsibilities?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  willingToRelocate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type JobsCandidateInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsCandidateInterface'] = ResolversParentTypes['JobsCandidateInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsCandidate' | 'JobsRecruitersCandidate', ParentType, ContextType>;
  annualQuota?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badges?: Resolver<Maybe<Array<ResolversTypes['JobsHiringBadge']>>, ParentType, ContextType>;
  baseSalary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bullet1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bullet2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  captions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  csmAccountsNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmQuotaMetric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmQuotaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmRenewalValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmTotalBusinessValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmUpsellValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  dealSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexAppliedCriteria?: Resolver<Maybe<Array<ResolversTypes['JobsFlexAppliedCriteria']>>, ParentType, ContextType>;
  flexBandwidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexBriefVideoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexPreviousExperience?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  flexReasonForParticipation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexRoles?: Resolver<Maybe<Array<ResolversTypes['JobsFlexRole']>>, ParentType, ContextType>;
  flexUnderstandingOfSales?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headline1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headline2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headline3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idealJobDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  initials?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inquiredPosition?: Resolver<Maybe<ResolversTypes['JobsInquiryPosition']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  leadSources?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketingHeadline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentByTeamPerPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentPerLastYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salesCycleLength?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  teamRanking?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  vpDepartmentSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vpManagedRoles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vpQuotaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  willingToRelocate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type JobsEmployerResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsEmployer'] = ResolversParentTypes['JobsEmployer']> = {
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  descriptionHtml?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  keyPoints?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  roleUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsFieldsBooleanInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsBooleanInterface'] = ResolversParentTypes['JobsFieldsBooleanInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldsBoolean' | 'JobsRecruitersFieldsBoolean', ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type JobsFieldsCategoryInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsCategoryInterface'] = ResolversParentTypes['JobsFieldsCategoryInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldsCategory' | 'JobsRecruitersFieldsCategory', ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type JobsFieldsConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsConfiguration'] = ResolversParentTypes['JobsFieldsConfiguration']> = {
  autocomplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsFieldsFloatInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsFloatInterface'] = ResolversParentTypes['JobsFieldsFloatInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldsFloat' | 'JobsRecruitersFieldsFloat', ParentType, ContextType>;
  placeholder?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['FloatRangeRightBoundOptional']>, ParentType, ContextType>;
};

export type JobsFieldsFloatRangeInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsFloatRangeInterface'] = ResolversParentTypes['JobsFieldsFloatRangeInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldsFloatRange' | 'JobsRecruitersFieldsFloatRange', ParentType, ContextType>;
  placeholder?: Resolver<ResolversTypes['JobsFieldsRangePlaceholder'], ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['FloatRangeRightBoundOptional']>, ParentType, ContextType>;
};

export type JobsFieldsIntegerInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsIntegerInterface'] = ResolversParentTypes['JobsFieldsIntegerInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldsInteger' | 'JobsRecruitersFieldsInteger', ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['IntRangeRightBoundOptional']>, ParentType, ContextType>;
};

export type JobsFieldsIntegerRangeInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsIntegerRangeInterface'] = ResolversParentTypes['JobsFieldsIntegerRangeInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldsIntegerRange' | 'JobsRecruitersFieldsIntegerRange', ParentType, ContextType>;
  placeholder?: Resolver<ResolversTypes['JobsFieldsRangePlaceholder'], ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['IntRangeRightBoundOptional']>, ParentType, ContextType>;
};

export type JobsFieldsInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsInterface'] = ResolversParentTypes['JobsFieldsInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldsBoolean' | 'JobsModeratorsFieldsFloat' | 'JobsModeratorsFieldsFloatRange' | 'JobsModeratorsFieldsInteger' | 'JobsModeratorsFieldsIntegerRange' | 'JobsModeratorsFieldsMultiSelect' | 'JobsModeratorsFieldsMultiSelectRecord' | 'JobsModeratorsFieldsSingleSelect' | 'JobsModeratorsFieldsSingleSelectRecord' | 'JobsModeratorsFieldsString' | 'JobsModeratorsFieldsStringArray' | 'JobsRecruitersFieldsBoolean' | 'JobsRecruitersFieldsFloat' | 'JobsRecruitersFieldsFloatRange' | 'JobsRecruitersFieldsInteger' | 'JobsRecruitersFieldsIntegerRange' | 'JobsRecruitersFieldsMultiSelect' | 'JobsRecruitersFieldsMultiSelectRecord' | 'JobsRecruitersFieldsSingleSelect' | 'JobsRecruitersFieldsSingleSelectRecord' | 'JobsRecruitersFieldsString' | 'JobsRecruitersFieldsStringArray', ParentType, ContextType>;
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
};

export type JobsFieldsRangePlaceholderResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsRangePlaceholder'] = ResolversParentTypes['JobsFieldsRangePlaceholder']> = {
  max?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsFieldsSelectInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsSelectInterface'] = ResolversParentTypes['JobsFieldsSelectInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldsMultiSelect' | 'JobsModeratorsFieldsSingleSelect' | 'JobsRecruitersFieldsMultiSelect' | 'JobsRecruitersFieldsSingleSelect', ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['JobsFieldsSelectOption']>, ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type JobsFieldsSelectOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsSelectOption'] = ResolversParentTypes['JobsFieldsSelectOption']> = {
  default?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsFieldsSingleSelectRecordInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsSingleSelectRecordInterface'] = ResolversParentTypes['JobsFieldsSingleSelectRecordInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldsMultiSelectRecord' | 'JobsModeratorsFieldsSingleSelectRecord' | 'JobsRecruitersFieldsMultiSelectRecord' | 'JobsRecruitersFieldsSingleSelectRecord', ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordType?: Resolver<ResolversTypes['JobsFieldsRecordType'], ParentType, ContextType>;
};

export type JobsFieldsStringArrayInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsStringArrayInterface'] = ResolversParentTypes['JobsFieldsStringArrayInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldsStringArray' | 'JobsRecruitersFieldsStringArray', ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type JobsFieldsStringInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsStringInterface'] = ResolversParentTypes['JobsFieldsStringInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldsString' | 'JobsRecruitersFieldsString', ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type JobsFieldsTooltipResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsFieldsTooltip'] = ResolversParentTypes['JobsFieldsTooltip']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsHiringResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsHiring'] = ResolversParentTypes['JobsHiring']> = {
  acceptedByEmployer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  candidateState?: Resolver<Maybe<ResolversTypes['JobsHiringCandidateState']>, ParentType, ContextType>;
  candidateStateUpdatedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  candidateStateViewed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['JobsEmployer'], ParentType, ContextType>;
  hashid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hoursToExpire?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  origin?: Resolver<ResolversTypes['JobsHiringOrigin'], ParentType, ContextType>;
  vacancy?: Resolver<Maybe<ResolversTypes['JobsVacancy']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsInquiryResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsInquiry'] = ResolversParentTypes['JobsInquiry']> = {
  accomplishments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  activeHirings?: Resolver<Maybe<Array<ResolversTypes['JobsHiring']>>, ParentType, ContextType>;
  activeHiringsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  aeAnnualizedQuota?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  aeLeadSourceOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aeLeadSourcesMain?: Resolver<Maybe<Array<ResolversTypes['JobsInquiryAeLeadSource']>>, ParentType, ContextType>;
  aeQuotaPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  aeQuotaTypeMain?: Resolver<Maybe<ResolversTypes['JobsInquiryAeQuota']>, ParentType, ContextType>;
  aeQuotaTypeOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  baseSalary?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  clientDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmAccountsNumber?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmAccountNumber']>, ParentType, ContextType>;
  csmQuotaMetricMain?: Resolver<Maybe<Array<ResolversTypes['JobsInquiryCsmQuotaMetric']>>, ParentType, ContextType>;
  csmQuotaMetricOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmQuotaPeriodMain?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmQuotaPeriod']>, ParentType, ContextType>;
  csmQuotaPeriodOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmQuotaTypeMain?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmQuota']>, ParentType, ContextType>;
  csmQuotaTypeOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmRenewalValue?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmRenewalValue']>, ParentType, ContextType>;
  csmTotalBusinessValue?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmBusinessValue']>, ParentType, ContextType>;
  csmUpsellValue?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmUpsellValue']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  dealBreakerOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealBreakersMain?: Resolver<Maybe<Array<ResolversTypes['JobsInquiryDealBreaker']>>, ParentType, ContextType>;
  dealSize?: Resolver<Maybe<ResolversTypes['JobsInquiryDealSize']>, ParentType, ContextType>;
  desiredCompanySeriesStages?: Resolver<Maybe<Array<ResolversTypes['CompanySeriesStage']>>, ParentType, ContextType>;
  employmentTypes?: Resolver<Array<ResolversTypes['JobsInquiryEmployment']>, ParentType, ContextType>;
  fakeHiring?: Resolver<Maybe<ResolversTypes['JobsInquiryFakeHiring']>, ParentType, ContextType>;
  filledAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  flexAppliedCriteria?: Resolver<Maybe<Array<ResolversTypes['JobsFlexAppliedCriteria']>>, ParentType, ContextType>;
  flexBandwidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexBriefVideoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexConsideredCompanyTypes?: Resolver<Maybe<Array<ResolversTypes['JobsFlexFlexConsideredCompanyType']>>, ParentType, ContextType>;
  flexOnboardingState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexPreviousExperience?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  flexReasonForParticipation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexRoles?: Resolver<Maybe<Array<ResolversTypes['JobsFlexRole']>>, ParentType, ContextType>;
  flexState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexUnderstandingOfSales?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hiringsForReview?: Resolver<Maybe<Array<ResolversTypes['JobsHiring']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idealJobDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastActiveAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  onboardingState?: Resolver<ResolversTypes['JobsInquiryOnboardingState'], ParentType, ContextType>;
  ote?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  positionMain?: Resolver<Maybe<ResolversTypes['JobsInquiryPosition']>, ParentType, ContextType>;
  positionOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentByTeamPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quotaAttainmentPerLastYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quotaAttainmentPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rankOnTeam?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  revenue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salesCycleLength?: Resolver<Maybe<ResolversTypes['JobsInquirySalesCycleLength']>, ParentType, ContextType>;
  salesMethodologies?: Resolver<Maybe<Array<ResolversTypes['JobsInquirySalesMethodology']>>, ParentType, ContextType>;
  sdrQuotaPerPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sdrQuotaTypes?: Resolver<Maybe<Array<ResolversTypes['JobsInquirySdrQuota']>>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['JobsInquirySource'], ParentType, ContextType>;
  stale?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['JobsInquiryState'], ParentType, ContextType>;
  teamSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vpDepartmentSize?: Resolver<Maybe<ResolversTypes['JobsInquiryVpDepartmentSize']>, ParentType, ContextType>;
  vpManagedRoles?: Resolver<Maybe<Array<ResolversTypes['JobsInquiryVpManagedRole']>>, ParentType, ContextType>;
  vpQuotaType?: Resolver<Maybe<ResolversTypes['JobsInquiryVpQuota']>, ParentType, ContextType>;
  vpResponsibilities?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  willingToRelocate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsInquiryFakeHiringResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsInquiryFakeHiring'] = ResolversParentTypes['JobsInquiryFakeHiring']> = {
  candidateState?: Resolver<ResolversTypes['JobsHiringCandidateState'], ParentType, ContextType>;
  vacancy?: Resolver<Maybe<ResolversTypes['JobsVacancy']>, ParentType, ContextType>;
  vacancyUid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsCandidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsCandidate'] = ResolversParentTypes['JobsModeratorsCandidate']> = {
  annualQuota?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badges?: Resolver<Maybe<Array<ResolversTypes['JobsHiringBadge']>>, ParentType, ContextType>;
  baseSalary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bullet1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bullet2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  captions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  clients?: Resolver<Array<ResolversTypes['Client']>, ParentType, ContextType>;
  csmAccountsNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmQuotaMetric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmQuotaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmRenewalValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmTotalBusinessValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmUpsellValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  dealSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  departments?: Resolver<Array<ResolversTypes['Department']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexAppliedCriteria?: Resolver<Maybe<Array<ResolversTypes['JobsFlexAppliedCriteria']>>, ParentType, ContextType>;
  flexBandwidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexBriefVideoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexPreviousExperience?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  flexReasonForParticipation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexRoles?: Resolver<Maybe<Array<ResolversTypes['JobsFlexRole']>>, ParentType, ContextType>;
  flexUnderstandingOfSales?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headline1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headline2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headline3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idealJobDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  initials?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inquiredPosition?: Resolver<Maybe<ResolversTypes['JobsInquiryPosition']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  leadSources?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketingHeadline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentByTeamPerPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentPerLastYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salesCycleLength?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['JobsModeratorsHiringState'], ParentType, ContextType>;
  teamRanking?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  visibilityOfAttributes?: Resolver<ResolversTypes['JobsModeratorsCandidateVisibilityOfAttributes'], ParentType, ContextType>;
  vpDepartmentSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vpManagedRoles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vpQuotaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  willingToRelocate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  workHistories?: Resolver<Array<ResolversTypes['WorkHistory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsCandidateVisibilityOfAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsCandidateVisibilityOfAttributes'] = ResolversParentTypes['JobsModeratorsCandidateVisibilityOfAttributes']> = {
  isAnnualQuotaVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isBaseSalaryVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isBullet1Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isBullet2Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isClientsVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCsmAccountsNumberVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCsmQuotaMetricVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCsmQuotaTypeVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCsmRenewalValueVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCsmTotalBusinessValueVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCsmUpsellValueVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDealSizeVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDepartmentsVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFlexAppliedCriteriaVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFlexBandwidthVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFlexBriefVideoUrlVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFlexPreviousExperienceVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFlexRatingVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFlexReasonForParticipationVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFlexRolesVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFlexUnderstandingOfSalesVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isHeadline1Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isHeadline2Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isHeadline3Visible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isIdealJobDescriptionVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLeadSourcesVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLinkedinUrlVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMarketingHeadlineVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOteVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQuotaAttainmentByTeamPerPeriodVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQuotaAttainmentPerLastYearVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQuotaAttainmentPerPeriodVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSalesCycleLengthVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTeamRankingVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVpDepartmentSizeVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVpManagedRolesVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isVpQuotaTypeVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isWorkHistoriesVisible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsEmployerResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsEmployer'] = ResolversParentTypes['JobsModeratorsEmployer']> = {
  accountOwner?: Resolver<Maybe<ResolversTypes['JobsModeratorsEmployersAccountOwner']>, ParentType, ContextType>;
  activatedVacancies?: Resolver<Array<ResolversTypes['JobsModeratorsVacancy']>, ParentType, ContextType>;
  activatedVacanciesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  activatedVacanciesHeadcount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  clients?: Resolver<Array<ResolversTypes['JobsModeratorsEmployerClient']>, ParentType, ContextType>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  daysSinceLastHiringReviewed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  descriptionHtml?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  descriptionMarkdown?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  greenhouseIntegrated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hiringProcessHtml?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hiringProcessMarkdown?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hiringsHiredCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hiringsInterviewedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hiringsIntroducedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hiringsOfferedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hiringsScheduledCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hiringsToExpireCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hiringsToReviewCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  keyPoints?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  recruiters?: Resolver<Array<ResolversTypes['JobsModeratorsRecruiter']>, ParentType, ContextType>;
  roleUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slackChannel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  talentAccessSubscription?: Resolver<Maybe<ResolversTypes['JobsModeratorsEmployerSubscription']>, ParentType, ContextType>;
  vacancies?: Resolver<Array<ResolversTypes['JobsModeratorsVacancy']>, ParentType, ContextType>;
  vacanciesToMergeWith?: Resolver<Array<ResolversTypes['JobsModeratorsVacancy']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsEmployerClientResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsEmployerClient'] = ResolversParentTypes['JobsModeratorsEmployerClient']> = {
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['JobsModeratorsEmployer'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsEmployerConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsEmployerConnection'] = ResolversParentTypes['JobsModeratorsEmployerConnection']> = {
  edges?: Resolver<Array<ResolversTypes['JobsModeratorsEmployerEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['JobsModeratorsEmployer']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsEmployerEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsEmployerEdge'] = ResolversParentTypes['JobsModeratorsEmployerEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['JobsModeratorsEmployer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsEmployerHiringGroupsResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsEmployerHiringGroups'] = ResolversParentTypes['JobsModeratorsEmployerHiringGroups']> = {
  hiringsAccepted?: Resolver<Maybe<Array<ResolversTypes['JobsModeratorsHiring']>>, ParentType, ContextType>;
  hiringsInProcess?: Resolver<Maybe<Array<ResolversTypes['JobsModeratorsHiring']>>, ParentType, ContextType>;
  hiringsInReview?: Resolver<Maybe<Array<ResolversTypes['JobsModeratorsHiring']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsEmployerSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsEmployerSubscription'] = ResolversParentTypes['JobsModeratorsEmployerSubscription']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsEmployersAccountOwnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsEmployersAccountOwner'] = ResolversParentTypes['JobsModeratorsEmployersAccountOwner']> = {
  calendarLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  slackId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['JobsModeratorsUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsField'] = ResolversParentTypes['JobsModeratorsField']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldsBoolean' | 'JobsModeratorsFieldsFloat' | 'JobsModeratorsFieldsFloatRange' | 'JobsModeratorsFieldsInteger' | 'JobsModeratorsFieldsIntegerRange' | 'JobsModeratorsFieldsMultiSelect' | 'JobsModeratorsFieldsMultiSelectRecord' | 'JobsModeratorsFieldsSingleSelect' | 'JobsModeratorsFieldsSingleSelectRecord' | 'JobsModeratorsFieldsString' | 'JobsModeratorsFieldsStringArray', ParentType, ContextType>;
};

export type JobsModeratorsFieldValueInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValueInterface'] = ResolversParentTypes['JobsModeratorsFieldValueInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldValuesBoolean' | 'JobsModeratorsFieldValuesFloat' | 'JobsModeratorsFieldValuesFloatRange' | 'JobsModeratorsFieldValuesInteger' | 'JobsModeratorsFieldValuesIntegerRange' | 'JobsModeratorsFieldValuesMultiSelect' | 'JobsModeratorsFieldValuesMultiSelectRecord' | 'JobsModeratorsFieldValuesSingleSelect' | 'JobsModeratorsFieldValuesSingleSelectRecord' | 'JobsModeratorsFieldValuesString' | 'JobsModeratorsFieldValuesStringArray', ParentType, ContextType>;
  field?: Resolver<ResolversTypes['JobsModeratorsField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type JobsModeratorsFieldValuesBooleanResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValuesBoolean'] = ResolversParentTypes['JobsModeratorsFieldValuesBoolean']> = {
  field?: Resolver<ResolversTypes['JobsModeratorsField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldValuesFloatResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValuesFloat'] = ResolversParentTypes['JobsModeratorsFieldValuesFloat']> = {
  field?: Resolver<ResolversTypes['JobsModeratorsField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldValuesFloatRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValuesFloatRange'] = ResolversParentTypes['JobsModeratorsFieldValuesFloatRange']> = {
  field?: Resolver<ResolversTypes['JobsModeratorsField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['FloatRangeRightBoundOptional']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldValuesIntegerResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValuesInteger'] = ResolversParentTypes['JobsModeratorsFieldValuesInteger']> = {
  field?: Resolver<ResolversTypes['JobsModeratorsField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldValuesIntegerRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValuesIntegerRange'] = ResolversParentTypes['JobsModeratorsFieldValuesIntegerRange']> = {
  field?: Resolver<ResolversTypes['JobsModeratorsField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['IntRangeRightBoundOptional']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldValuesMultiSelectResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValuesMultiSelect'] = ResolversParentTypes['JobsModeratorsFieldValuesMultiSelect']> = {
  field?: Resolver<ResolversTypes['JobsModeratorsField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldValuesMultiSelectRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValuesMultiSelectRecord'] = ResolversParentTypes['JobsModeratorsFieldValuesMultiSelectRecord']> = {
  field?: Resolver<ResolversTypes['JobsModeratorsField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  records?: Resolver<Array<ResolversTypes['JobsModeratorsFieldValuesSelectRecordType']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldValuesSelectRecordTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValuesSelectRecordType'] = ResolversParentTypes['JobsModeratorsFieldValuesSelectRecordType']> = {
  __resolveType: TypeResolveFn<'City' | 'Company' | 'Department' | 'Industry', ParentType, ContextType>;
};

export type JobsModeratorsFieldValuesSingleSelectResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValuesSingleSelect'] = ResolversParentTypes['JobsModeratorsFieldValuesSingleSelect']> = {
  field?: Resolver<ResolversTypes['JobsModeratorsField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldValuesSingleSelectRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValuesSingleSelectRecord'] = ResolversParentTypes['JobsModeratorsFieldValuesSingleSelectRecord']> = {
  field?: Resolver<ResolversTypes['JobsModeratorsField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  record?: Resolver<ResolversTypes['JobsModeratorsFieldValuesSelectRecordType'], ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldValuesStringResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValuesString'] = ResolversParentTypes['JobsModeratorsFieldValuesString']> = {
  field?: Resolver<ResolversTypes['JobsModeratorsField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldValuesStringArrayResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldValuesStringArray'] = ResolversParentTypes['JobsModeratorsFieldValuesStringArray']> = {
  field?: Resolver<ResolversTypes['JobsModeratorsField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  values?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldsBooleanResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldsBoolean'] = ResolversParentTypes['JobsModeratorsFieldsBoolean']> = {
  accessLevels?: Resolver<Array<ResolversTypes['JobsModeratorsFieldsAccessLevel']>, ParentType, ContextType>;
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsModeratorsFieldsCategory'], ParentType, ContextType>;
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['JobsFieldsScope']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldsCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldsCategory'] = ResolversParentTypes['JobsModeratorsFieldsCategory']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fields?: Resolver<Array<ResolversTypes['JobsModeratorsField']>, ParentType, ContextType, RequireFields<JobsModeratorsFieldsCategoryFieldsArgs, never>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isStaticCategory?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldsFloatResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldsFloat'] = ResolversParentTypes['JobsModeratorsFieldsFloat']> = {
  accessLevels?: Resolver<Array<ResolversTypes['JobsModeratorsFieldsAccessLevel']>, ParentType, ContextType>;
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsModeratorsFieldsCategory'], ParentType, ContextType>;
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['FloatRangeRightBoundOptional']>, ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['JobsFieldsScope']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldsFloatRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldsFloatRange'] = ResolversParentTypes['JobsModeratorsFieldsFloatRange']> = {
  accessLevels?: Resolver<Array<ResolversTypes['JobsModeratorsFieldsAccessLevel']>, ParentType, ContextType>;
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsModeratorsFieldsCategory'], ParentType, ContextType>;
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<ResolversTypes['JobsFieldsRangePlaceholder'], ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['FloatRangeRightBoundOptional']>, ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['JobsFieldsScope']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldsIntegerResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldsInteger'] = ResolversParentTypes['JobsModeratorsFieldsInteger']> = {
  accessLevels?: Resolver<Array<ResolversTypes['JobsModeratorsFieldsAccessLevel']>, ParentType, ContextType>;
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsModeratorsFieldsCategory'], ParentType, ContextType>;
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['IntRangeRightBoundOptional']>, ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['JobsFieldsScope']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldsIntegerRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldsIntegerRange'] = ResolversParentTypes['JobsModeratorsFieldsIntegerRange']> = {
  accessLevels?: Resolver<Array<ResolversTypes['JobsModeratorsFieldsAccessLevel']>, ParentType, ContextType>;
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsModeratorsFieldsCategory'], ParentType, ContextType>;
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<ResolversTypes['JobsFieldsRangePlaceholder'], ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['IntRangeRightBoundOptional']>, ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['JobsFieldsScope']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldsMultiSelectResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldsMultiSelect'] = ResolversParentTypes['JobsModeratorsFieldsMultiSelect']> = {
  accessLevels?: Resolver<Array<ResolversTypes['JobsModeratorsFieldsAccessLevel']>, ParentType, ContextType>;
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsModeratorsFieldsCategory'], ParentType, ContextType>;
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['JobsFieldsSelectOption']>, ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['JobsFieldsScope']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldsMultiSelectRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldsMultiSelectRecord'] = ResolversParentTypes['JobsModeratorsFieldsMultiSelectRecord']> = {
  accessLevels?: Resolver<Array<ResolversTypes['JobsModeratorsFieldsAccessLevel']>, ParentType, ContextType>;
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsModeratorsFieldsCategory'], ParentType, ContextType>;
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recordType?: Resolver<ResolversTypes['JobsFieldsRecordType'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['JobsFieldsScope']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldsSingleSelectResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldsSingleSelect'] = ResolversParentTypes['JobsModeratorsFieldsSingleSelect']> = {
  accessLevels?: Resolver<Array<ResolversTypes['JobsModeratorsFieldsAccessLevel']>, ParentType, ContextType>;
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsModeratorsFieldsCategory'], ParentType, ContextType>;
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['JobsFieldsSelectOption']>, ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['JobsFieldsScope']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldsSingleSelectRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldsSingleSelectRecord'] = ResolversParentTypes['JobsModeratorsFieldsSingleSelectRecord']> = {
  accessLevels?: Resolver<Array<ResolversTypes['JobsModeratorsFieldsAccessLevel']>, ParentType, ContextType>;
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsModeratorsFieldsCategory'], ParentType, ContextType>;
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recordType?: Resolver<ResolversTypes['JobsFieldsRecordType'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['JobsFieldsScope']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldsStringResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldsString'] = ResolversParentTypes['JobsModeratorsFieldsString']> = {
  accessLevels?: Resolver<Array<ResolversTypes['JobsModeratorsFieldsAccessLevel']>, ParentType, ContextType>;
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsModeratorsFieldsCategory'], ParentType, ContextType>;
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['JobsFieldsScope']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsFieldsStringArrayResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsFieldsStringArray'] = ResolversParentTypes['JobsModeratorsFieldsStringArray']> = {
  accessLevels?: Resolver<Array<ResolversTypes['JobsModeratorsFieldsAccessLevel']>, ParentType, ContextType>;
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsModeratorsFieldsCategory'], ParentType, ContextType>;
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  scopes?: Resolver<Array<ResolversTypes['JobsFieldsScope']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsHiringResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsHiring'] = ResolversParentTypes['JobsModeratorsHiring']> = {
  acceptedByCandidateAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  acceptedByEmployerAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  acceptedByOpsAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  availableEvents?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['JobsModeratorsEmployer'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inquiry?: Resolver<ResolversTypes['JobsModeratorsInquiry'], ParentType, ContextType>;
  interviewDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  interviewNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  introductionDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  matchingModelInterpretation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matchingScore?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  origin?: Resolver<ResolversTypes['JobsHiringOrigin'], ParentType, ContextType>;
  scheduledMessages?: Resolver<Maybe<Array<ResolversTypes['JobsModeratorsScheduledMessage']>>, ParentType, ContextType>;
  secondsInState?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['JobsModeratorsHiringState'], ParentType, ContextType>;
  stateUpdatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  submittedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  talentPortalUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vacancy?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancy']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsHiringConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsHiringConnection'] = ResolversParentTypes['JobsModeratorsHiringConnection']> = {
  edges?: Resolver<Array<ResolversTypes['JobsModeratorsHiringEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['JobsModeratorsHiring']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsHiringEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsHiringEdge'] = ResolversParentTypes['JobsModeratorsHiringEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['JobsModeratorsHiring']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsHiringExplanationResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsHiringExplanation'] = ResolversParentTypes['JobsModeratorsHiringExplanation']> = {
  badges?: Resolver<Maybe<Array<ResolversTypes['JobsHiringBadge']>>, ParentType, ContextType>;
  bullet1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bullet2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headline1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headline2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headline3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsHiringStateCounterResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsHiringStateCounter'] = ResolversParentTypes['JobsModeratorsHiringStateCounter']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['JobsModeratorsHiringState'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsInquiryResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsInquiry'] = ResolversParentTypes['JobsModeratorsInquiry']> = {
  accomplishments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aeAnnualizedQuota?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  aeLeadSourceOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aeLeadSourcesMain?: Resolver<Maybe<Array<ResolversTypes['JobsInquiryAeLeadSource']>>, ParentType, ContextType>;
  aeQuotaPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  aeQuotaTypeMain?: Resolver<Maybe<ResolversTypes['JobsInquiryAeQuota']>, ParentType, ContextType>;
  aeQuotaTypeOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assignee?: Resolver<Maybe<ResolversTypes['JobsModeratorsUser']>, ParentType, ContextType>;
  availableEvents?: Resolver<Maybe<Array<ResolversTypes['JobsModeratorsInquiryEventName']>>, ParentType, ContextType>;
  baseSalary?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  canCreateHirings?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  clientDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmAccountsNumber?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmAccountNumber']>, ParentType, ContextType>;
  csmQuotaMetricMain?: Resolver<Maybe<Array<ResolversTypes['JobsInquiryCsmQuotaMetric']>>, ParentType, ContextType>;
  csmQuotaMetricOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmQuotaPeriodMain?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmQuotaPeriod']>, ParentType, ContextType>;
  csmQuotaPeriodOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmQuotaTypeMain?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmQuota']>, ParentType, ContextType>;
  csmQuotaTypeOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmRenewalValue?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmRenewalValue']>, ParentType, ContextType>;
  csmTotalBusinessValue?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmBusinessValue']>, ParentType, ContextType>;
  csmUpsellValue?: Resolver<Maybe<ResolversTypes['JobsInquiryCsmUpsellValue']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  dealBreakerOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dealBreakersMain?: Resolver<Maybe<Array<ResolversTypes['JobsInquiryDealBreaker']>>, ParentType, ContextType>;
  dealSize?: Resolver<Maybe<ResolversTypes['JobsInquiryDealSize']>, ParentType, ContextType>;
  desiredCompanySeriesStages?: Resolver<Maybe<Array<ResolversTypes['CompanySeriesStage']>>, ParentType, ContextType>;
  employmentTypes?: Resolver<Array<ResolversTypes['JobsInquiryEmployment']>, ParentType, ContextType>;
  filledAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  flexAppliedCriteria?: Resolver<Maybe<Array<ResolversTypes['JobsFlexAppliedCriteria']>>, ParentType, ContextType>;
  flexBandwidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexBriefVideoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexConsideredCompanyTypes?: Resolver<Maybe<Array<ResolversTypes['JobsFlexFlexConsideredCompanyType']>>, ParentType, ContextType>;
  flexOnboardingState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexPreviousExperience?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  flexReasonForParticipation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexRoles?: Resolver<Maybe<Array<ResolversTypes['JobsFlexRole']>>, ParentType, ContextType>;
  flexState?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexUnderstandingOfSales?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frontUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hirings?: Resolver<Maybe<Array<ResolversTypes['JobsModeratorsHiring']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idealJobDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastActiveAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  lastNote?: Resolver<Maybe<ResolversTypes['JobsModeratorsInquiryNote']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<Array<ResolversTypes['JobsModeratorsInquiryNote']>>, ParentType, ContextType>;
  onboardingState?: Resolver<ResolversTypes['JobsInquiryOnboardingState'], ParentType, ContextType>;
  ote?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  positionMain?: Resolver<Maybe<ResolversTypes['JobsInquiryPosition']>, ParentType, ContextType>;
  positionOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentByTeamPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quotaAttainmentPerLastYear?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quotaAttainmentPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rankOnTeam?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refreshedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  revenue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salesCycleLength?: Resolver<Maybe<ResolversTypes['JobsInquirySalesCycleLength']>, ParentType, ContextType>;
  salesMethodologies?: Resolver<Maybe<Array<ResolversTypes['JobsInquirySalesMethodology']>>, ParentType, ContextType>;
  screened?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sdrQuotaPerPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sdrQuotaTypes?: Resolver<Maybe<Array<ResolversTypes['JobsInquirySdrQuota']>>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['JobsInquiryState'], ParentType, ContextType>;
  teamSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tier?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['JobsModeratorsUser']>, ParentType, ContextType>;
  vpDepartmentSize?: Resolver<Maybe<ResolversTypes['JobsInquiryVpDepartmentSize']>, ParentType, ContextType>;
  vpManagedRoles?: Resolver<Maybe<Array<ResolversTypes['JobsInquiryVpManagedRole']>>, ParentType, ContextType>;
  vpQuotaType?: Resolver<Maybe<ResolversTypes['JobsInquiryVpQuota']>, ParentType, ContextType>;
  vpResponsibilities?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  willingToRelocate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  workHistories?: Resolver<Array<ResolversTypes['WorkHistory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsInquiryConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsInquiryConnection'] = ResolversParentTypes['JobsModeratorsInquiryConnection']> = {
  edges?: Resolver<Array<ResolversTypes['JobsModeratorsInquiryEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['JobsModeratorsInquiry']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsInquiryEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsInquiryEdge'] = ResolversParentTypes['JobsModeratorsInquiryEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['JobsModeratorsInquiry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsInquiryMatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsInquiryMatch'] = ResolversParentTypes['JobsModeratorsInquiryMatch']> = {
  inquiry?: Resolver<ResolversTypes['JobsModeratorsInquiry'], ParentType, ContextType>;
  inquiryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  matchingModelInterpretation?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsInquiryNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsInquiryNote'] = ResolversParentTypes['JobsModeratorsInquiryNote']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  hiring?: Resolver<Maybe<ResolversTypes['JobsModeratorsHiring']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inquiry?: Resolver<ResolversTypes['JobsModeratorsInquiry'], ParentType, ContextType>;
  mainCategory?: Resolver<ResolversTypes['JobsModeratorsInquiryNoteMainCategory'], ParentType, ContextType>;
  subcategory?: Resolver<ResolversTypes['JobsModeratorsInquiryNoteSubcategory'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['JobsModeratorsUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsMatchInquiryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsMatchInquiryPayload'] = ResolversParentTypes['JobsModeratorsMatchInquiryPayload']> = {
  clientMutationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inquiry?: Resolver<Maybe<ResolversTypes['JobsModeratorsInquiry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsOpsRejectionReasonResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsOpsRejectionReason'] = ResolversParentTypes['JobsModeratorsOpsRejectionReason']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsRecruiterResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsRecruiter'] = ResolversParentTypes['JobsModeratorsRecruiter']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  schedulingLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slackId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsScheduledMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsScheduledMessage'] = ResolversParentTypes['JobsModeratorsScheduledMessage']> = {
  deliveredAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  failedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheduledAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsUser'] = ResolversParentTypes['JobsModeratorsUser']> = {
  autoName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  companySeriesStages?: Resolver<Maybe<Array<ResolversTypes['CompanySeriesStage']>>, ParentType, ContextType>;
  companyStages?: Resolver<Maybe<Array<ResolversTypes['CompanyStage']>>, ParentType, ContextType>;
  departmentIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<ResolversTypes['Department']>>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  industries?: Resolver<Maybe<Array<ResolversTypes['Industry']>>, ParentType, ContextType>;
  initials?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobsAccountOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productTypeIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  productTypes?: Resolver<Maybe<Array<ResolversTypes['ProductType']>>, ParentType, ContextType>;
  solidClients?: Resolver<Array<ResolversTypes['Client']>, ParentType, ContextType>;
  warRoomCompanySeriesStageIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  warRoomCompanyStageIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  warRoomIndustryIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  warRoomJobSearchStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomJobSearchStatusExpiredAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  warRoomSalesRoleIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  warRoomSalesRoles?: Resolver<Maybe<Array<ResolversTypes['SalesRole']>>, ParentType, ContextType>;
  warRoomYearsOfExperience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsVacancyResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsVacancy'] = ResolversParentTypes['JobsModeratorsVacancy']> = {
  autoCandidateSubmissionsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  cities?: Resolver<Maybe<Array<ResolversTypes['City']>>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countries?: Resolver<Maybe<Array<ResolversTypes['Country']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancyCreator']>, ParentType, ContextType>;
  daysSinceLastHiringReviewed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  defaultSubmission?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancySubmission']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employer?: Resolver<Maybe<ResolversTypes['JobsModeratorsEmployer']>, ParentType, ContextType>;
  employerHiringCategories?: Resolver<Maybe<ResolversTypes['JobsModeratorsEmployerHiringGroups']>, ParentType, ContextType>;
  employmentType?: Resolver<ResolversTypes['JobsVacancyEmployment'], ParentType, ContextType>;
  fieldValues?: Resolver<Array<ResolversTypes['JobsModeratorsVacancyFieldValue']>, ParentType, ContextType>;
  fiveDaysActivity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  fromGreenhouse?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  gptPrompt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headcount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hiringsBacklogLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hiringsHiredCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hiringsInterviewedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hiringsIntroducedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hiringsOfferedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hiringsScheduledCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hiringsToExpireCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hiringsToReviewCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isImportedFromGreenhouse?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lowerTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matchScoreThreshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  openToRemoteWork?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  recruiters?: Resolver<Maybe<Array<ResolversTypes['JobsRecruitersRecruiter']>>, ParentType, ContextType>;
  remoteOnlyAtSelectedLocations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['JobsVacancyState'], ParentType, ContextType>;
  submission?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancySubmission']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsVacancyConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsVacancyConnection'] = ResolversParentTypes['JobsModeratorsVacancyConnection']> = {
  edges?: Resolver<Array<ResolversTypes['JobsModeratorsVacancyEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['JobsModeratorsVacancy']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsVacancyCreatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsVacancyCreator'] = ResolversParentTypes['JobsModeratorsVacancyCreator']> = {
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsVacancyCreatorInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsVacancyCreatorInterface'] = ResolversParentTypes['JobsModeratorsVacancyCreatorInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsVacancyCreator', ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type JobsModeratorsVacancyEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsVacancyEdge'] = ResolversParentTypes['JobsModeratorsVacancyEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancy']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsVacancyFieldValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsVacancyFieldValue'] = ResolversParentTypes['JobsModeratorsVacancyFieldValue']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsFieldValuesBoolean' | 'JobsModeratorsFieldValuesFloat' | 'JobsModeratorsFieldValuesFloatRange' | 'JobsModeratorsFieldValuesInteger' | 'JobsModeratorsFieldValuesIntegerRange' | 'JobsModeratorsFieldValuesMultiSelect' | 'JobsModeratorsFieldValuesMultiSelectRecord' | 'JobsModeratorsFieldValuesSingleSelect' | 'JobsModeratorsFieldValuesSingleSelectRecord' | 'JobsModeratorsFieldValuesString' | 'JobsModeratorsFieldValuesStringArray', ParentType, ContextType>;
};

export type JobsModeratorsVacancyMatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsVacancyMatch'] = ResolversParentTypes['JobsModeratorsVacancyMatch']> = {
  matchingModelInterpretation?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  vacancy?: Resolver<ResolversTypes['JobsModeratorsVacancy'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsModeratorsVacancySubmissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsModeratorsVacancySubmission'] = ResolversParentTypes['JobsModeratorsVacancySubmission']> = {
  avgDealSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avgSalesCycle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  baseSalary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandMaturity?: Resolver<Maybe<ResolversTypes['JobsVacancySubmissionBrandMaturity']>, ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  compensation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  compensationDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerProfile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  industry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint5?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint6?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint7?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  minBandwidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentByTeam?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roleName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visibilityOfAttributes?: Resolver<ResolversTypes['JobsVacancySubmissionVisibilityOfAttributes'], ParentType, ContextType>;
  workType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruiterResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruiter'] = ResolversParentTypes['JobsRecruiter']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schedulingLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersCandidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersCandidate'] = ResolversParentTypes['JobsRecruitersCandidate']> = {
  acceptedByCandidateAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  acceptedByEmployerAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  annualQuota?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badges?: Resolver<Maybe<Array<ResolversTypes['JobsHiringBadge']>>, ParentType, ContextType>;
  baseSalary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bullet1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bullet2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  captions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  clients?: Resolver<Maybe<Array<ResolversTypes['JobsRecruitersClient']>>, ParentType, ContextType>;
  csmAccountsNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmQuotaMetric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmQuotaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmRenewalValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmTotalBusinessValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  csmUpsellValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['Currency']>, ParentType, ContextType>;
  dealSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<ResolversTypes['Department']>>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexAppliedCriteria?: Resolver<Maybe<Array<ResolversTypes['JobsFlexAppliedCriteria']>>, ParentType, ContextType>;
  flexBandwidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexBriefVideoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexPreviousExperience?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  flexReasonForParticipation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flexRoles?: Resolver<Maybe<Array<ResolversTypes['JobsFlexRole']>>, ParentType, ContextType>;
  flexUnderstandingOfSales?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hashid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  headline1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headline2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headline3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hoursToExpire?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idealJobDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  initials?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inquiredPosition?: Resolver<Maybe<ResolversTypes['JobsInquiryPosition']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  leadSources?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketingHeadline?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentByTeamPerPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentPerLastYear?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salesCycleLength?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selectedOnVacancy?: Resolver<Maybe<ResolversTypes['JobsRecruitersVacancy']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['JobsRecruitersCandidateState'], ParentType, ContextType>;
  teamRanking?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  viewed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  vpDepartmentSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vpManagedRoles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vpQuotaType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  willingToRelocate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  workHistories?: Resolver<Maybe<Array<ResolversTypes['WorkHistory']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersCandidateConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersCandidateConnection'] = ResolversParentTypes['JobsRecruitersCandidateConnection']> = {
  edges?: Resolver<Array<ResolversTypes['JobsRecruitersCandidateEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['JobsRecruitersCandidate']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersCandidateEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersCandidateEdge'] = ResolversParentTypes['JobsRecruitersCandidateEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['JobsRecruitersCandidate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersClientResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersClient'] = ResolversParentTypes['JobsRecruitersClient']> = {
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersDistributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersDistribution'] = ResolversParentTypes['JobsRecruitersDistribution']> = {
  distributionBins?: Resolver<Array<ResolversTypes['JobsRecruitersDistributionBin']>, ParentType, ContextType>;
  recommendation?: Resolver<Maybe<ResolversTypes['IntRangeRightBoundOptional']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersDistributionBinResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersDistributionBin'] = ResolversParentTypes['JobsRecruitersDistributionBin']> = {
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  range?: Resolver<ResolversTypes['IntRangeRightBoundOptional'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersEmployerResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersEmployer'] = ResolversParentTypes['JobsRecruitersEmployer']> = {
  annualRevenue?: Resolver<Maybe<ResolversTypes['JobsEmployersAnnualRevenue']>, ParentType, ContextType>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['Country']>, ParentType, ContextType>;
  fundingType?: Resolver<Maybe<ResolversTypes['JobsEmployersFunding']>, ParentType, ContextType>;
  greenhouseError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isGreenhouseHarvestApiKeyPresent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  recruiters?: Resolver<Array<ResolversTypes['JobsRecruitersRecruiter']>, ParentType, ContextType>;
  salesTeamSize?: Resolver<Maybe<ResolversTypes['JobsEmployersSalesTeamSize']>, ParentType, ContextType>;
  talentAccessSubscription?: Resolver<Maybe<ResolversTypes['JobsRecruitersEmployerSubscription']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersEmployerSubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersEmployerSubscription'] = ResolversParentTypes['JobsRecruitersEmployerSubscription']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersField'] = ResolversParentTypes['JobsRecruitersField']> = {
  __resolveType: TypeResolveFn<'JobsRecruitersFieldsBoolean' | 'JobsRecruitersFieldsFloat' | 'JobsRecruitersFieldsFloatRange' | 'JobsRecruitersFieldsInteger' | 'JobsRecruitersFieldsIntegerRange' | 'JobsRecruitersFieldsMultiSelect' | 'JobsRecruitersFieldsMultiSelectRecord' | 'JobsRecruitersFieldsSingleSelect' | 'JobsRecruitersFieldsSingleSelectRecord' | 'JobsRecruitersFieldsString' | 'JobsRecruitersFieldsStringArray', ParentType, ContextType>;
};

export type JobsRecruitersFieldValueInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValueInterface'] = ResolversParentTypes['JobsRecruitersFieldValueInterface']> = {
  __resolveType: TypeResolveFn<'JobsRecruitersFieldValuesBoolean' | 'JobsRecruitersFieldValuesFloat' | 'JobsRecruitersFieldValuesFloatRange' | 'JobsRecruitersFieldValuesInteger' | 'JobsRecruitersFieldValuesIntegerRange' | 'JobsRecruitersFieldValuesMultiSelect' | 'JobsRecruitersFieldValuesMultiSelectRecord' | 'JobsRecruitersFieldValuesSingleSelect' | 'JobsRecruitersFieldValuesSingleSelectRecord' | 'JobsRecruitersFieldValuesString' | 'JobsRecruitersFieldValuesStringArray', ParentType, ContextType>;
  field?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type JobsRecruitersFieldValuesBooleanResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValuesBoolean'] = ResolversParentTypes['JobsRecruitersFieldValuesBoolean']> = {
  field?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldValuesFloatResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValuesFloat'] = ResolversParentTypes['JobsRecruitersFieldValuesFloat']> = {
  field?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldValuesFloatRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValuesFloatRange'] = ResolversParentTypes['JobsRecruitersFieldValuesFloatRange']> = {
  field?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['FloatRangeRightBoundOptional']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldValuesIntegerResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValuesInteger'] = ResolversParentTypes['JobsRecruitersFieldValuesInteger']> = {
  field?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldValuesIntegerRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValuesIntegerRange'] = ResolversParentTypes['JobsRecruitersFieldValuesIntegerRange']> = {
  field?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['IntRangeRightBoundOptional']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldValuesMultiSelectResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValuesMultiSelect'] = ResolversParentTypes['JobsRecruitersFieldValuesMultiSelect']> = {
  field?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  selectedOptions?: Resolver<Array<ResolversTypes['JobsFieldsSelectOption']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  values?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldValuesMultiSelectRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValuesMultiSelectRecord'] = ResolversParentTypes['JobsRecruitersFieldValuesMultiSelectRecord']> = {
  field?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  records?: Resolver<Array<ResolversTypes['JobsRecruitersFieldValuesSelectRecordType']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldValuesSelectRecordTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValuesSelectRecordType'] = ResolversParentTypes['JobsRecruitersFieldValuesSelectRecordType']> = {
  __resolveType: TypeResolveFn<'City' | 'Company' | 'Department' | 'Industry', ParentType, ContextType>;
};

export type JobsRecruitersFieldValuesSingleSelectResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValuesSingleSelect'] = ResolversParentTypes['JobsRecruitersFieldValuesSingleSelect']> = {
  field?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  selectedOption?: Resolver<ResolversTypes['JobsFieldsSelectOption'], ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldValuesSingleSelectRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValuesSingleSelectRecord'] = ResolversParentTypes['JobsRecruitersFieldValuesSingleSelectRecord']> = {
  field?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  record?: Resolver<ResolversTypes['JobsRecruitersFieldValuesSelectRecordType'], ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldValuesStringResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValuesString'] = ResolversParentTypes['JobsRecruitersFieldValuesString']> = {
  field?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldValuesStringArrayResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldValuesStringArray'] = ResolversParentTypes['JobsRecruitersFieldValuesStringArray']> = {
  field?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  negation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  priority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shouldClause?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  values?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldsBooleanResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldsBoolean'] = ResolversParentTypes['JobsRecruitersFieldsBoolean']> = {
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsRecruitersFieldsCategory'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldsCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldsCategory'] = ResolversParentTypes['JobsRecruitersFieldsCategory']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fields?: Resolver<Array<ResolversTypes['JobsRecruitersField']>, ParentType, ContextType, RequireFields<JobsRecruitersFieldsCategoryFieldsArgs, never>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldsFloatResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldsFloat'] = ResolversParentTypes['JobsRecruitersFieldsFloat']> = {
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsRecruitersFieldsCategory'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['FloatRangeRightBoundOptional']>, ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldsFloatRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldsFloatRange'] = ResolversParentTypes['JobsRecruitersFieldsFloatRange']> = {
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsRecruitersFieldsCategory'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<ResolversTypes['JobsFieldsRangePlaceholder'], ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['FloatRangeRightBoundOptional']>, ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldsIntegerResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldsInteger'] = ResolversParentTypes['JobsRecruitersFieldsInteger']> = {
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsRecruitersFieldsCategory'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['IntRangeRightBoundOptional']>, ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldsIntegerRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldsIntegerRange'] = ResolversParentTypes['JobsRecruitersFieldsIntegerRange']> = {
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsRecruitersFieldsCategory'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<ResolversTypes['JobsFieldsRangePlaceholder'], ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  range?: Resolver<Maybe<ResolversTypes['IntRangeRightBoundOptional']>, ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldsMultiSelectResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldsMultiSelect'] = ResolversParentTypes['JobsRecruitersFieldsMultiSelect']> = {
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsRecruitersFieldsCategory'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['JobsFieldsSelectOption']>, ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldsMultiSelectRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldsMultiSelectRecord'] = ResolversParentTypes['JobsRecruitersFieldsMultiSelectRecord']> = {
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsRecruitersFieldsCategory'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recordType?: Resolver<ResolversTypes['JobsFieldsRecordType'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldsSingleSelectResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldsSingleSelect'] = ResolversParentTypes['JobsRecruitersFieldsSingleSelect']> = {
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsRecruitersFieldsCategory'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  options?: Resolver<Array<ResolversTypes['JobsFieldsSelectOption']>, ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldsSingleSelectRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldsSingleSelectRecord'] = ResolversParentTypes['JobsRecruitersFieldsSingleSelectRecord']> = {
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsRecruitersFieldsCategory'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recordType?: Resolver<ResolversTypes['JobsFieldsRecordType'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldsStringResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldsString'] = ResolversParentTypes['JobsRecruitersFieldsString']> = {
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsRecruitersFieldsCategory'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersFieldsStringArrayResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersFieldsStringArray'] = ResolversParentTypes['JobsRecruitersFieldsStringArray']> = {
  availableForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['JobsRecruitersFieldsCategory'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JobsFieldsConfiguration'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  popularForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requiredForRoles?: Resolver<Array<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['JobsFieldsTooltip'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersInquiryResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersInquiry'] = ResolversParentTypes['JobsRecruitersInquiry']> = {
  autoName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  baseSalary?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currentWorkHistory?: Resolver<Maybe<ResolversTypes['WorkHistory']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  linkedinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ote?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  positionMain?: Resolver<Maybe<ResolversTypes['JobsInquiryPosition']>, ParentType, ContextType>;
  positionOther?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentPerPeriod?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersRecruiterResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersRecruiter'] = ResolversParentTypes['JobsRecruitersRecruiter']> = {
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employer?: Resolver<Maybe<ResolversTypes['JobsRecruitersEmployer']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isImpersonateMode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  joinedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  lastSelectedVacancy?: Resolver<Maybe<ResolversTypes['JobsRecruitersVacancy']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  leadType?: Resolver<ResolversTypes['JobsRecruiterLead'], ParentType, ContextType>;
  onboardingStates?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  peopleForHiring?: Resolver<Maybe<ResolversTypes['JobsRecruitersPeopleForHiring']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  questionnaireFractionalSellersType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  questionnaireFreelanceSalesExpertsPurposes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  questionnairePurpose?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  questionnaireRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['JobsRecruitersRecruiterRole'], ParentType, ContextType>;
  rolesForHiring?: Resolver<Maybe<Array<ResolversTypes['JobsRecruitersRolesForHiring']>>, ParentType, ContextType>;
  schedulingLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signInCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['JobsRecruiterState'], ParentType, ContextType>;
  tooltips?: Resolver<Array<ResolversTypes['Tooltip']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersVacancyResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersVacancy'] = ResolversParentTypes['JobsRecruitersVacancy']> = {
  avatarNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  candidates?: Resolver<ResolversTypes['JobsRecruitersCandidateConnection'], ParentType, ContextType, RequireFields<JobsRecruitersVacancyCandidatesArgs, never>>;
  cities?: Resolver<Maybe<Array<ResolversTypes['City']>>, ParentType, ContextType>;
  countries?: Resolver<Maybe<Array<ResolversTypes['Country']>>, ParentType, ContextType>;
  countryStates?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  defaultSubmission?: Resolver<ResolversTypes['JobsRecruitersVacancySubmission'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employmentType?: Resolver<ResolversTypes['JobsVacancyEmployment'], ParentType, ContextType>;
  fieldValueBoolean?: Resolver<Maybe<ResolversTypes['JobsRecruitersFieldValuesBoolean']>, ParentType, ContextType, RequireFields<JobsRecruitersVacancyFieldValueBooleanArgs, 'slug'>>;
  fieldValueFloat?: Resolver<Maybe<ResolversTypes['JobsRecruitersFieldValuesFloat']>, ParentType, ContextType, RequireFields<JobsRecruitersVacancyFieldValueFloatArgs, 'slug'>>;
  fieldValueFloatRange?: Resolver<Maybe<ResolversTypes['JobsRecruitersFieldValuesFloatRange']>, ParentType, ContextType, RequireFields<JobsRecruitersVacancyFieldValueFloatRangeArgs, 'slug'>>;
  fieldValueInteger?: Resolver<Maybe<ResolversTypes['JobsRecruitersFieldValuesInteger']>, ParentType, ContextType, RequireFields<JobsRecruitersVacancyFieldValueIntegerArgs, 'slug'>>;
  fieldValueIntegerRange?: Resolver<Maybe<ResolversTypes['JobsRecruitersFieldValuesIntegerRange']>, ParentType, ContextType, RequireFields<JobsRecruitersVacancyFieldValueIntegerRangeArgs, 'slug'>>;
  fieldValueMultiSelect?: Resolver<Maybe<ResolversTypes['JobsRecruitersFieldValuesMultiSelect']>, ParentType, ContextType, RequireFields<JobsRecruitersVacancyFieldValueMultiSelectArgs, 'slug'>>;
  fieldValueMultiSelectRecord?: Resolver<Maybe<ResolversTypes['JobsRecruitersFieldValuesMultiSelectRecord']>, ParentType, ContextType, RequireFields<JobsRecruitersVacancyFieldValueMultiSelectRecordArgs, 'slug'>>;
  fieldValueSingleSelect?: Resolver<Maybe<ResolversTypes['JobsRecruitersFieldValuesSingleSelect']>, ParentType, ContextType, RequireFields<JobsRecruitersVacancyFieldValueSingleSelectArgs, 'slug'>>;
  fieldValueSingleSelectRecord?: Resolver<Maybe<ResolversTypes['JobsRecruitersFieldValuesSingleSelectRecord']>, ParentType, ContextType, RequireFields<JobsRecruitersVacancyFieldValueSingleSelectRecordArgs, 'slug'>>;
  fieldValueString?: Resolver<Maybe<ResolversTypes['JobsRecruitersFieldValuesString']>, ParentType, ContextType, RequireFields<JobsRecruitersVacancyFieldValueStringArgs, 'slug'>>;
  fieldValueStringArray?: Resolver<Maybe<ResolversTypes['JobsRecruitersFieldValuesStringArray']>, ParentType, ContextType, RequireFields<JobsRecruitersVacancyFieldValueStringArrayArgs, 'slug'>>;
  fieldValues?: Resolver<Array<ResolversTypes['JobsRecruitersVacancyFieldValue']>, ParentType, ContextType>;
  gptPrompt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasExpiredCandidates?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  headcount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isBasedOnVacancy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isImportedFromGreenhouse?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSalesJob?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  openToRemoteWork?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['JobsRole']>, ParentType, ContextType>;
  recruiters?: Resolver<Array<ResolversTypes['JobsRecruitersRecruiter']>, ParentType, ContextType>;
  remoteOnlyAtSelectedLocations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['JobsVacancyState'], ParentType, ContextType>;
  stateUpdatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersVacancyFieldValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersVacancyFieldValue'] = ResolversParentTypes['JobsRecruitersVacancyFieldValue']> = {
  __resolveType: TypeResolveFn<'JobsRecruitersFieldValuesBoolean' | 'JobsRecruitersFieldValuesFloat' | 'JobsRecruitersFieldValuesFloatRange' | 'JobsRecruitersFieldValuesInteger' | 'JobsRecruitersFieldValuesIntegerRange' | 'JobsRecruitersFieldValuesMultiSelect' | 'JobsRecruitersFieldValuesMultiSelectRecord' | 'JobsRecruitersFieldValuesSingleSelect' | 'JobsRecruitersFieldValuesSingleSelectRecord' | 'JobsRecruitersFieldValuesString' | 'JobsRecruitersFieldValuesStringArray', ParentType, ContextType>;
};

export type JobsRecruitersVacancyPromptTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersVacancyPromptTemplate'] = ResolversParentTypes['JobsRecruitersVacancyPromptTemplate']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsRecruitersVacancySubmissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsRecruitersVacancySubmission'] = ResolversParentTypes['JobsRecruitersVacancySubmission']> = {
  avgDealSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avgSalesCycle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  baseSalary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandMaturity?: Resolver<Maybe<ResolversTypes['JobsVacancySubmissionBrandMaturity']>, ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  compensation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  compensationDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerProfile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  industry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint5?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint6?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint7?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  minBandwidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentByTeam?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roleName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visibilityOfAttributes?: Resolver<ResolversTypes['JobsVacancySubmissionVisibilityOfAttributes'], ParentType, ContextType>;
  workType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsVacancyResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsVacancy'] = ResolversParentTypes['JobsVacancy']> = {
  cities?: Resolver<Maybe<Array<ResolversTypes['City']>>, ParentType, ContextType>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  countries?: Resolver<Maybe<Array<ResolversTypes['Country']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['JobsEmployer'], ParentType, ContextType>;
  employmentType?: Resolver<ResolversTypes['JobsVacancyEmployment'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  openToRemoteWork?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  oteRange?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  primaryRecruiter?: Resolver<Maybe<ResolversTypes['JobsRecruiter']>, ParentType, ContextType>;
  submission?: Resolver<Maybe<ResolversTypes['JobsVacancySubmission']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsVacancySubmissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsVacancySubmission'] = ResolversParentTypes['JobsVacancySubmission']> = {
  avgDealSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avgSalesCycle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  baseSalary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandMaturity?: Resolver<Maybe<ResolversTypes['JobsVacancySubmissionBrandMaturity']>, ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  compensation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  compensationDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerProfile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  industry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint5?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint6?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint7?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  minBandwidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentByTeam?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roleName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  workType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JobsVacancySubmissionInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsVacancySubmissionInterface'] = ResolversParentTypes['JobsVacancySubmissionInterface']> = {
  __resolveType: TypeResolveFn<'JobsModeratorsVacancySubmission' | 'JobsRecruitersVacancySubmission' | 'JobsVacancySubmission', ParentType, ContextType>;
  avgDealSize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avgSalesCycle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  baseSalary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brandMaturity?: Resolver<Maybe<ResolversTypes['JobsVacancySubmissionBrandMaturity']>, ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  compensation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  compensationDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customerProfile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  industry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint3?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint4?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint5?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint6?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  keyPoint7?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  location?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  minBandwidth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ote?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotaAttainmentByTeam?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  roleName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  workType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type JobsVacancySubmissionVisibilityOfAttributesResolvers<ContextType = any, ParentType extends ResolversParentTypes['JobsVacancySubmissionVisibilityOfAttributes'] = ResolversParentTypes['JobsVacancySubmissionVisibilityOfAttributes']> = {
  isAvgDealSizeVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isAvgSalesCycleVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isBaseSalaryVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isBrandMaturityVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCompanyNameVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCompensationDescriptionVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCompensationVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCustomerProfileVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isIndustryVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isJobUrlVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKeyPoint1Visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKeyPoint2Visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKeyPoint3Visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKeyPoint4Visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKeyPoint5Visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKeyPoint6Visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isKeyPoint7Visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isLocationVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isMinBandwidthVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isOteVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isQuotaAttainmentByTeamVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRoleNameVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isWorkTypeVisible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['Link'] = ResolversParentTypes['Link']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  highlightedText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  link?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  linkDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkImageContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkImageFileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkImageFileSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  linkImageUpdatedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  linkOriginalImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  previewImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rawText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  textImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkedinPostResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkedinPost'] = ResolversParentTypes['LinkedinPost']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  highlightedText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  linkedinAvatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  linkedinPostUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  linkedinText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  previewImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rawText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  textImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkedinProfileImportedPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkedinProfileImportedPayload'] = ResolversParentTypes['LinkedinProfileImportedPayload']> = {
  isSuccessful?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  portfolioCurrentUser?: Resolver<ResolversTypes['PortfolioCurrentUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = {
  __resolveType: TypeResolveFn<'City' | 'CountryState', ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  media?: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  sender?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  thread?: Resolver<ResolversTypes['Thread'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageConnection'] = ResolversParentTypes['MessageConnection']> = {
  edges?: Resolver<Array<ResolversTypes['MessageEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageEdge'] = ResolversParentTypes['MessageEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptConnectionRequest?: Resolver<Maybe<ResolversTypes['Request']>, ParentType, ContextType, RequireFields<MutationAcceptConnectionRequestArgs, 'input'>>;
  activateJobsInquiry?: Resolver<Maybe<ResolversTypes['JobsInquiry']>, ParentType, ContextType, RequireFields<MutationActivateJobsInquiryArgs, 'input'>>;
  applyForWarRoom?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationApplyForWarRoomArgs, 'input'>>;
  approveTestimonialForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['Testimonial']>, ParentType, ContextType, RequireFields<MutationApproveTestimonialForPublicPortfolioCurrentUserArgs, 'input'>>;
  archiveCandidateHiring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationArchiveCandidateHiringArgs, 'input'>>;
  archiveTestimonialForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['Testimonial']>, ParentType, ContextType, RequireFields<MutationArchiveTestimonialForPublicPortfolioCurrentUserArgs, 'input'>>;
  attachCompanySeriesStage?: Resolver<Maybe<ResolversTypes['CompanySeriesStage']>, ParentType, ContextType, RequireFields<MutationAttachCompanySeriesStageArgs, 'input'>>;
  attachCompanyStage?: Resolver<Maybe<ResolversTypes['CompanyStage']>, ParentType, ContextType, RequireFields<MutationAttachCompanyStageArgs, 'input'>>;
  attachDepartment?: Resolver<Maybe<ResolversTypes['Department']>, ParentType, ContextType, RequireFields<MutationAttachDepartmentArgs, 'input'>>;
  attachProductType?: Resolver<Maybe<ResolversTypes['ProductType']>, ParentType, ContextType, RequireFields<MutationAttachProductTypeArgs, 'input'>>;
  attachSalesRole?: Resolver<Maybe<ResolversTypes['SalesRole']>, ParentType, ContextType, RequireFields<MutationAttachSalesRoleArgs, 'input'>>;
  cancelConnectionRequest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCancelConnectionRequestArgs, 'input'>>;
  completeTooltip?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCompleteTooltipArgs, 'input'>>;
  confirmTermsOfServiceByPotentialEmployer?: Resolver<Maybe<ResolversTypes['PotentialEmployer']>, ParentType, ContextType, RequireFields<MutationConfirmTermsOfServiceByPotentialEmployerArgs, 'input'>>;
  createAwardForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['Award']>, ParentType, ContextType, RequireFields<MutationCreateAwardForPublicPortfolioCurrentUserArgs, 'input'>>;
  createClientForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['Client']>, ParentType, ContextType, RequireFields<MutationCreateClientForPublicPortfolioCurrentUserArgs, 'input'>>;
  createComment?: Resolver<Maybe<ResolversTypes['Comment']>, ParentType, ContextType, RequireFields<MutationCreateCommentArgs, 'input'>>;
  createCompanyPagesInterview?: Resolver<Maybe<ResolversTypes['CompanyPagesInterview']>, ParentType, ContextType, RequireFields<MutationCreateCompanyPagesInterviewArgs, 'input'>>;
  createCompanyPagesReview?: Resolver<Maybe<ResolversTypes['CompanyPagesReview']>, ParentType, ContextType, RequireFields<MutationCreateCompanyPagesReviewArgs, 'input'>>;
  createCompanyPagesSalary?: Resolver<Maybe<ResolversTypes['CompanyPagesSalary']>, ParentType, ContextType, RequireFields<MutationCreateCompanyPagesSalaryArgs, 'input'>>;
  createConnectionRequest?: Resolver<Maybe<ResolversTypes['Request']>, ParentType, ContextType, RequireFields<MutationCreateConnectionRequestArgs, 'input'>>;
  createConnections?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCreateConnectionsArgs, 'input'>>;
  createCustomCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<MutationCreateCustomCompanyArgs, 'input'>>;
  createCustomDepartment?: Resolver<Maybe<ResolversTypes['Department']>, ParentType, ContextType, RequireFields<MutationCreateCustomDepartmentArgs, 'input'>>;
  createCustomProductType?: Resolver<Maybe<ResolversTypes['ProductType']>, ParentType, ContextType, RequireFields<MutationCreateCustomProductTypeArgs, 'input'>>;
  createCustomSalesRole?: Resolver<Maybe<ResolversTypes['SalesRole']>, ParentType, ContextType, RequireFields<MutationCreateCustomSalesRoleArgs, 'input'>>;
  createCustomUniversity?: Resolver<Maybe<ResolversTypes['University']>, ParentType, ContextType, RequireFields<MutationCreateCustomUniversityArgs, 'input'>>;
  createDeals?: Resolver<Maybe<Array<ResolversTypes['PortfolioDeal']>>, ParentType, ContextType, RequireFields<MutationCreateDealsArgs, 'input'>>;
  createDealsSource?: Resolver<Maybe<ResolversTypes['PortfolioDealsSource']>, ParentType, ContextType, RequireFields<MutationCreateDealsSourceArgs, 'input'>>;
  createEducationHistoryForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['EducationHistory']>, ParentType, ContextType, RequireFields<MutationCreateEducationHistoryForPublicPortfolioCurrentUserArgs, 'input'>>;
  createJobsModeratorsEmployer?: Resolver<Maybe<ResolversTypes['JobsModeratorsEmployer']>, ParentType, ContextType, RequireFields<MutationCreateJobsModeratorsEmployerArgs, 'input'>>;
  createJobsModeratorsHiring?: Resolver<Maybe<ResolversTypes['JobsModeratorsHiring']>, ParentType, ContextType, RequireFields<MutationCreateJobsModeratorsHiringArgs, 'input'>>;
  createJobsModeratorsHirings?: Resolver<Maybe<ResolversTypes['JobsModeratorsInquiry']>, ParentType, ContextType, RequireFields<MutationCreateJobsModeratorsHiringsArgs, 'input'>>;
  createJobsModeratorsInquiryNote?: Resolver<Maybe<ResolversTypes['JobsModeratorsInquiryNote']>, ParentType, ContextType, RequireFields<MutationCreateJobsModeratorsInquiryNoteArgs, 'input'>>;
  createPollVote?: Resolver<Maybe<ResolversTypes['PollVote']>, ParentType, ContextType, RequireFields<MutationCreatePollVoteArgs, 'input'>>;
  createPost?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType, RequireFields<MutationCreatePostArgs, 'input'>>;
  createPotentialEmployer?: Resolver<Maybe<ResolversTypes['PotentialEmployer']>, ParentType, ContextType, RequireFields<MutationCreatePotentialEmployerArgs, 'input'>>;
  createRating?: Resolver<Maybe<ResolversTypes['Rating']>, ParentType, ContextType, RequireFields<MutationCreateRatingArgs, 'input'>>;
  createTopic?: Resolver<Maybe<ResolversTypes['Topic']>, ParentType, ContextType, RequireFields<MutationCreateTopicArgs, 'input'>>;
  createWorkHistoryForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['WorkHistory']>, ParentType, ContextType, RequireFields<MutationCreateWorkHistoryForPublicPortfolioCurrentUserArgs, 'input'>>;
  deactivateCurrentUser?: Resolver<Maybe<ResolversTypes['CurrentUser']>, ParentType, ContextType, RequireFields<MutationDeactivateCurrentUserArgs, 'input'>>;
  destroyAwardForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['Award']>, ParentType, ContextType, RequireFields<MutationDestroyAwardForPublicPortfolioCurrentUserArgs, 'input'>>;
  destroyClientForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['Client']>, ParentType, ContextType, RequireFields<MutationDestroyClientForPublicPortfolioCurrentUserArgs, 'input'>>;
  destroyComment?: Resolver<Maybe<ResolversTypes['Comment']>, ParentType, ContextType, RequireFields<MutationDestroyCommentArgs, 'input'>>;
  destroyCompanyPagesInterview?: Resolver<Maybe<ResolversTypes['CompanyPagesInterview']>, ParentType, ContextType, RequireFields<MutationDestroyCompanyPagesInterviewArgs, 'input'>>;
  destroyCompanyPagesReview?: Resolver<Maybe<ResolversTypes['CompanyPagesReview']>, ParentType, ContextType, RequireFields<MutationDestroyCompanyPagesReviewArgs, 'input'>>;
  destroyCompanyPagesSalary?: Resolver<Maybe<ResolversTypes['CompanyPagesSalary']>, ParentType, ContextType, RequireFields<MutationDestroyCompanyPagesSalaryArgs, 'input'>>;
  destroyDeal?: Resolver<Maybe<ResolversTypes['PortfolioDeal']>, ParentType, ContextType, RequireFields<MutationDestroyDealArgs, 'input'>>;
  destroyEducationHistoryForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['EducationHistory']>, ParentType, ContextType, RequireFields<MutationDestroyEducationHistoryForPublicPortfolioCurrentUserArgs, 'input'>>;
  destroyJobsModeratorsInquiryNote?: Resolver<Maybe<ResolversTypes['JobsModeratorsInquiryNote']>, ParentType, ContextType, RequireFields<MutationDestroyJobsModeratorsInquiryNoteArgs, 'input'>>;
  destroyPost?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType, RequireFields<MutationDestroyPostArgs, 'input'>>;
  destroyRating?: Resolver<Maybe<ResolversTypes['Rating']>, ParentType, ContextType, RequireFields<MutationDestroyRatingArgs, 'input'>>;
  destroyTestimonialForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['Testimonial']>, ParentType, ContextType, RequireFields<MutationDestroyTestimonialForPublicPortfolioCurrentUserArgs, 'input'>>;
  destroyWorkHistoryForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['WorkHistory']>, ParentType, ContextType, RequireFields<MutationDestroyWorkHistoryForPublicPortfolioCurrentUserArgs, 'input'>>;
  detachCompanySeriesStage?: Resolver<Maybe<ResolversTypes['CompanySeriesStage']>, ParentType, ContextType, RequireFields<MutationDetachCompanySeriesStageArgs, 'input'>>;
  detachCompanyStage?: Resolver<Maybe<ResolversTypes['CompanyStage']>, ParentType, ContextType, RequireFields<MutationDetachCompanyStageArgs, 'input'>>;
  detachDepartment?: Resolver<Maybe<ResolversTypes['Department']>, ParentType, ContextType, RequireFields<MutationDetachDepartmentArgs, 'input'>>;
  detachProductType?: Resolver<Maybe<ResolversTypes['ProductType']>, ParentType, ContextType, RequireFields<MutationDetachProductTypeArgs, 'input'>>;
  detachSalesRole?: Resolver<Maybe<ResolversTypes['SalesRole']>, ParentType, ContextType, RequireFields<MutationDetachSalesRoleArgs, 'input'>>;
  directMessagesBlockUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationDirectMessagesBlockUserArgs, 'input'>>;
  directMessagesReadThreadMessages?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDirectMessagesReadThreadMessagesArgs, 'input'>>;
  directMessagesSendMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<MutationDirectMessagesSendMessageArgs, 'input'>>;
  directMessagesUnblockUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationDirectMessagesUnblockUserArgs, 'input'>>;
  endorseTestimonialForPublicPortfolioUser?: Resolver<Maybe<ResolversTypes['Testimonial']>, ParentType, ContextType, RequireFields<MutationEndorseTestimonialForPublicPortfolioUserArgs, 'input'>>;
  expressDesireToImportConnectionsForPublicPortfolioUser?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationExpressDesireToImportConnectionsForPublicPortfolioUserArgs, 'input'>>;
  fillJobsInquiry?: Resolver<Maybe<ResolversTypes['JobsInquiry']>, ParentType, ContextType, RequireFields<MutationFillJobsInquiryArgs, 'input'>>;
  finishOnboarding?: Resolver<Maybe<ResolversTypes['CurrentUser']>, ParentType, ContextType, RequireFields<MutationFinishOnboardingArgs, 'input'>>;
  fireJobsHiringEvent?: Resolver<Maybe<ResolversTypes['JobsHiring']>, ParentType, ContextType, RequireFields<MutationFireJobsHiringEventArgs, 'input'>>;
  fireJobsModeratorsHiringEvent?: Resolver<Maybe<ResolversTypes['JobsModeratorsHiring']>, ParentType, ContextType, RequireFields<MutationFireJobsModeratorsHiringEventArgs, 'input'>>;
  fireJobsModeratorsInquiryEvent?: Resolver<Maybe<ResolversTypes['JobsModeratorsInquiry']>, ParentType, ContextType, RequireFields<MutationFireJobsModeratorsInquiryEventArgs, 'input'>>;
  flagIssue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationFlagIssueArgs, 'input'>>;
  hiringResendIntroduceEmail?: Resolver<Maybe<ResolversTypes['JobsHiring']>, ParentType, ContextType, RequireFields<MutationHiringResendIntroduceEmailArgs, 'input'>>;
  jobsModeratorsActivateVacancy?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancy']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsActivateVacancyArgs, 'input'>>;
  jobsModeratorsCreateVacancy?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancy']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsCreateVacancyArgs, 'input'>>;
  jobsModeratorsCreateVacancySubmission?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancySubmission']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsCreateVacancySubmissionArgs, 'input'>>;
  jobsModeratorsDeactivateVacancy?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancy']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsDeactivateVacancyArgs, 'input'>>;
  jobsModeratorsDeleteVacancy?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancy']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsDeleteVacancyArgs, 'input'>>;
  jobsModeratorsEditEmployersClients?: Resolver<Maybe<ResolversTypes['JobsModeratorsEmployer']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsEditEmployersClientsArgs, 'input'>>;
  jobsModeratorsEditEmployersRecruiters?: Resolver<Maybe<ResolversTypes['JobsModeratorsEmployer']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsEditEmployersRecruitersArgs, 'input'>>;
  jobsModeratorsMergeVacancy?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancy']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsMergeVacancyArgs, 'input'>>;
  jobsModeratorsRejectInquiryVacancySuggestionByOps?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsRejectInquiryVacancySuggestionByOpsArgs, 'input'>>;
  jobsModeratorsSubmitHiring?: Resolver<Maybe<ResolversTypes['JobsModeratorsCandidate']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsSubmitHiringArgs, 'input'>>;
  jobsModeratorsUpdateCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsUpdateCompanyArgs, 'input'>>;
  jobsModeratorsUpdateEmployer?: Resolver<Maybe<ResolversTypes['JobsModeratorsEmployer']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsUpdateEmployerArgs, 'input'>>;
  jobsModeratorsUpdateVacancy?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancy']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsUpdateVacancyArgs, 'input'>>;
  jobsModeratorsUpdateVacancySubmission?: Resolver<Maybe<ResolversTypes['JobsModeratorsVacancySubmission']>, ParentType, ContextType, RequireFields<MutationJobsModeratorsUpdateVacancySubmissionArgs, 'input'>>;
  jobsRecruitersAcceptCandidate?: Resolver<Maybe<ResolversTypes['JobsRecruitersCandidate']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersAcceptCandidateArgs, 'input'>>;
  jobsRecruitersActivateCurrentRecruiter?: Resolver<Maybe<ResolversTypes['JobsRecruitersRecruiter']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersActivateCurrentRecruiterArgs, 'input'>>;
  jobsRecruitersActivateVacancy?: Resolver<Maybe<ResolversTypes['JobsRecruitersVacancy']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersActivateVacancyArgs, 'input'>>;
  jobsRecruitersCompleteTooltip?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersCompleteTooltipArgs, 'input'>>;
  jobsRecruitersCreateCustomCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersCreateCustomCompanyArgs, 'input'>>;
  jobsRecruitersCreateEmployer?: Resolver<Maybe<ResolversTypes['JobsRecruitersEmployer']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersCreateEmployerArgs, 'input'>>;
  jobsRecruitersCreateStripeBillingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersCreateStripeBillingUrlArgs, 'input'>>;
  jobsRecruitersCreateStripeSessionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersCreateStripeSessionUrlArgs, 'input'>>;
  jobsRecruitersCreateVacancy?: Resolver<Maybe<ResolversTypes['JobsRecruitersVacancy']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersCreateVacancyArgs, 'input'>>;
  jobsRecruitersDeleteEmployer?: Resolver<Maybe<ResolversTypes['JobsRecruitersRecruiter']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersDeleteEmployerArgs, 'input'>>;
  jobsRecruitersDeleteEmployerRecruiter?: Resolver<Maybe<ResolversTypes['JobsRecruitersRecruiter']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersDeleteEmployerRecruiterArgs, 'input'>>;
  jobsRecruitersDeleteVacancy?: Resolver<Maybe<ResolversTypes['JobsRecruitersVacancy']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersDeleteVacancyArgs, 'input'>>;
  jobsRecruitersDeleteVacancyField?: Resolver<Maybe<ResolversTypes['JobsRecruitersVacancy']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersDeleteVacancyFieldArgs, 'input'>>;
  jobsRecruitersDestroyCandidate?: Resolver<Maybe<ResolversTypes['JobsRecruitersCandidate']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersDestroyCandidateArgs, 'input'>>;
  jobsRecruitersEditEmployersRecruiter?: Resolver<Maybe<ResolversTypes['JobsRecruitersRecruiter']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersEditEmployersRecruiterArgs, 'input'>>;
  jobsRecruitersEnableVacancies?: Resolver<Maybe<Array<ResolversTypes['JobsRecruitersVacancy']>>, ParentType, ContextType, RequireFields<MutationJobsRecruitersEnableVacanciesArgs, 'input'>>;
  jobsRecruitersImportGreenhouseVacancies?: Resolver<Maybe<Array<ResolversTypes['JobsRecruitersVacancy']>>, ParentType, ContextType, RequireFields<MutationJobsRecruitersImportGreenhouseVacanciesArgs, 'input'>>;
  jobsRecruitersMarkCandidateAsViewed?: Resolver<Maybe<ResolversTypes['JobsRecruitersCandidate']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersMarkCandidateAsViewedArgs, 'input'>>;
  jobsRecruitersMatchVacancy?: Resolver<Maybe<ResolversTypes['JobsRecruitersVacancy']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersMatchVacancyArgs, 'input'>>;
  jobsRecruitersRejectCandidate?: Resolver<Maybe<ResolversTypes['JobsRecruitersCandidate']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersRejectCandidateArgs, 'input'>>;
  jobsRecruitersSendRecruiterAuthToken?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersSendRecruiterAuthTokenArgs, 'input'>>;
  jobsRecruitersUpdateCurrentEmployer?: Resolver<Maybe<ResolversTypes['JobsRecruitersEmployer']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersUpdateCurrentEmployerArgs, 'input'>>;
  jobsRecruitersUpdateCurrentRecruiter?: Resolver<Maybe<ResolversTypes['JobsRecruitersRecruiter']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersUpdateCurrentRecruiterArgs, 'input'>>;
  jobsRecruitersUpdateCustomCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersUpdateCustomCompanyArgs, 'input'>>;
  jobsRecruitersUpdateVacancy?: Resolver<Maybe<ResolversTypes['JobsRecruitersVacancy']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersUpdateVacancyArgs, 'input'>>;
  jobsRecruitersUpdateVacancyField?: Resolver<Maybe<ResolversTypes['JobsRecruitersVacancy']>, ParentType, ContextType, RequireFields<MutationJobsRecruitersUpdateVacancyFieldArgs, 'input'>>;
  markCommentsViewed?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType, RequireFields<MutationMarkCommentsViewedArgs, 'input'>>;
  markPostsAsRead?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationMarkPostsAsReadArgs, 'input'>>;
  matchJobsInquiryAfterOnboarding?: Resolver<Maybe<ResolversTypes['JobsInquiry']>, ParentType, ContextType, RequireFields<MutationMatchJobsInquiryAfterOnboardingArgs, 'input'>>;
  matchJobsModeratorsInquiry?: Resolver<Maybe<ResolversTypes['JobsModeratorsMatchInquiryPayload']>, ParentType, ContextType, RequireFields<MutationMatchJobsModeratorsInquiryArgs, 'input'>>;
  reRequestTestimonialForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['Testimonial']>, ParentType, ContextType, RequireFields<MutationReRequestTestimonialForPublicPortfolioCurrentUserArgs, 'input'>>;
  readAllNotifications?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationReadAllNotificationsArgs, 'input'>>;
  readConnectionRequests?: Resolver<Maybe<Array<ResolversTypes['Request']>>, ParentType, ContextType, RequireFields<MutationReadConnectionRequestsArgs, 'input'>>;
  readNotification?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType, RequireFields<MutationReadNotificationArgs, 'input'>>;
  refreshJobsInquiry?: Resolver<Maybe<ResolversTypes['JobsInquiry']>, ParentType, ContextType, RequireFields<MutationRefreshJobsInquiryArgs, 'input'>>;
  rejectConnectionRequest?: Resolver<Maybe<ResolversTypes['Request']>, ParentType, ContextType, RequireFields<MutationRejectConnectionRequestArgs, 'input'>>;
  rejectJobsHiring?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationRejectJobsHiringArgs, 'input'>>;
  rejectJobsModeratorsHiringByOps?: Resolver<Maybe<ResolversTypes['JobsModeratorsHiring']>, ParentType, ContextType, RequireFields<MutationRejectJobsModeratorsHiringByOpsArgs, 'input'>>;
  removeConnection?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationRemoveConnectionArgs, 'input'>>;
  removeJobsModeratorsInquiry?: Resolver<Maybe<ResolversTypes['JobsModeratorsInquiry']>, ParentType, ContextType, RequireFields<MutationRemoveJobsModeratorsInquiryArgs, 'input'>>;
  renewActiveJobStatus?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationRenewActiveJobStatusArgs, 'input'>>;
  renewJobsModeratorsActiveJobStatus?: Resolver<Maybe<ResolversTypes['JobsModeratorsUser']>, ParentType, ContextType, RequireFields<MutationRenewJobsModeratorsActiveJobStatusArgs, 'input'>>;
  reportSalesGptFeedback?: Resolver<Maybe<ResolversTypes['SalesGptQuery']>, ParentType, ContextType, RequireFields<MutationReportSalesGptFeedbackArgs, 'input'>>;
  requestTestimonialForPublicPortfolioCurrentUser?: Resolver<Maybe<Array<ResolversTypes['Testimonial']>>, ParentType, ContextType, RequireFields<MutationRequestTestimonialForPublicPortfolioCurrentUserArgs, 'input'>>;
  saveSalesGptSummary?: Resolver<Maybe<ResolversTypes['SalesGptQuery']>, ParentType, ContextType, RequireFields<MutationSaveSalesGptSummaryArgs, 'input'>>;
  sayThanks?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSayThanksArgs, 'input'>>;
  scheduleHiringMeeting?: Resolver<Maybe<ResolversTypes['JobsHiring']>, ParentType, ContextType, RequireFields<MutationScheduleHiringMeetingArgs, 'input'>>;
  scheduleJobsModeratorsMeeting?: Resolver<Maybe<ResolversTypes['JobsModeratorsHiring']>, ParentType, ContextType, RequireFields<MutationScheduleJobsModeratorsMeetingArgs, 'input'>>;
  sendSuperInvite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationSendSuperInviteArgs, 'input'>>;
  startTestimonialEndorsingForPublicPortfolioUser?: Resolver<Maybe<ResolversTypes['Testimonial']>, ParentType, ContextType, RequireFields<MutationStartTestimonialEndorsingForPublicPortfolioUserArgs, 'input'>>;
  triggerContactsFetching?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationTriggerContactsFetchingArgs, 'input'>>;
  triggerLinkedinScraping?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationTriggerLinkedinScrapingArgs, 'input'>>;
  undoTestimonialForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['Testimonial']>, ParentType, ContextType, RequireFields<MutationUndoTestimonialForPublicPortfolioCurrentUserArgs, 'input'>>;
  updateAcademyArticle?: Resolver<Maybe<ResolversTypes['Article']>, ParentType, ContextType, RequireFields<MutationUpdateAcademyArticleArgs, 'input'>>;
  updateAwardForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['Award']>, ParentType, ContextType, RequireFields<MutationUpdateAwardForPublicPortfolioCurrentUserArgs, 'input'>>;
  updateClientForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['Client']>, ParentType, ContextType, RequireFields<MutationUpdateClientForPublicPortfolioCurrentUserArgs, 'input'>>;
  updateClientPositionForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['PublicPortfolioCurrentUser']>, ParentType, ContextType, RequireFields<MutationUpdateClientPositionForPublicPortfolioCurrentUserArgs, 'input'>>;
  updateComment?: Resolver<Maybe<ResolversTypes['Comment']>, ParentType, ContextType, RequireFields<MutationUpdateCommentArgs, 'input'>>;
  updateCompanyPagesInterview?: Resolver<Maybe<ResolversTypes['CompanyPagesInterview']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyPagesInterviewArgs, 'input'>>;
  updateCompanyPagesReview?: Resolver<Maybe<ResolversTypes['CompanyPagesReview']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyPagesReviewArgs, 'input'>>;
  updateCompanyPagesSalary?: Resolver<Maybe<ResolversTypes['CompanyPagesSalary']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyPagesSalaryArgs, 'input'>>;
  updateConfigurationForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['PublicPortfolioConfiguration']>, ParentType, ContextType, RequireFields<MutationUpdateConfigurationForPublicPortfolioCurrentUserArgs, 'input'>>;
  updateCurrentPortfolioUser?: Resolver<Maybe<ResolversTypes['PortfolioCurrentUser']>, ParentType, ContextType, RequireFields<MutationUpdateCurrentPortfolioUserArgs, 'input'>>;
  updateCurrentUser?: Resolver<Maybe<ResolversTypes['CurrentUser']>, ParentType, ContextType, RequireFields<MutationUpdateCurrentUserArgs, 'input'>>;
  updateDeal?: Resolver<Maybe<ResolversTypes['PortfolioDeal']>, ParentType, ContextType, RequireFields<MutationUpdateDealArgs, 'input'>>;
  updateEducationHistoryForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['EducationHistory']>, ParentType, ContextType, RequireFields<MutationUpdateEducationHistoryForPublicPortfolioCurrentUserArgs, 'input'>>;
  updateJobsCandidatesHiring?: Resolver<Maybe<ResolversTypes['JobsHiring']>, ParentType, ContextType, RequireFields<MutationUpdateJobsCandidatesHiringArgs, 'input'>>;
  updateJobsInquiry?: Resolver<Maybe<ResolversTypes['JobsInquiry']>, ParentType, ContextType, RequireFields<MutationUpdateJobsInquiryArgs, 'input'>>;
  updateJobsModeratorsHiring?: Resolver<Maybe<ResolversTypes['JobsModeratorsHiring']>, ParentType, ContextType, RequireFields<MutationUpdateJobsModeratorsHiringArgs, 'input'>>;
  updateJobsModeratorsInquiry?: Resolver<Maybe<ResolversTypes['JobsModeratorsInquiry']>, ParentType, ContextType, RequireFields<MutationUpdateJobsModeratorsInquiryArgs, 'input'>>;
  updateJobsModeratorsSubmittedHiring?: Resolver<Maybe<ResolversTypes['JobsModeratorsHiring']>, ParentType, ContextType, RequireFields<MutationUpdateJobsModeratorsSubmittedHiringArgs, 'input'>>;
  updateJobsModeratorsUser?: Resolver<Maybe<ResolversTypes['JobsModeratorsUser']>, ParentType, ContextType, RequireFields<MutationUpdateJobsModeratorsUserArgs, 'input'>>;
  updatePost?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType, RequireFields<MutationUpdatePostArgs, 'input'>>;
  updatePublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['PublicPortfolioCurrentUser']>, ParentType, ContextType, RequireFields<MutationUpdatePublicPortfolioCurrentUserArgs, 'input'>>;
  updateTestimonialPositionForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['Testimonial']>, ParentType, ContextType, RequireFields<MutationUpdateTestimonialPositionForPublicPortfolioCurrentUserArgs, 'input'>>;
  updateWorkHistoryForPublicPortfolioCurrentUser?: Resolver<Maybe<ResolversTypes['WorkHistory']>, ParentType, ContextType, RequireFields<MutationUpdateWorkHistoryForPublicPortfolioCurrentUserArgs, 'input'>>;
  upsertDealQuarter?: Resolver<Maybe<ResolversTypes['PortfolioDealQuarter']>, ParentType, ContextType, RequireFields<MutationUpsertDealQuarterArgs, 'input'>>;
  viewAllNotifications?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationViewAllNotificationsArgs, 'input'>>;
};

export type NotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['NotificationKind'], ParentType, ContextType>;
  readAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  referenceable?: Resolver<Maybe<ResolversTypes['NotificationReferenceable']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  viewedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  warRoomCommissionTransaction?: Resolver<Maybe<ResolversTypes['CommissionTransaction']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationConnection'] = ResolversParentTypes['NotificationConnection']> = {
  edges?: Resolver<Array<ResolversTypes['NotificationEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Notification']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationEdge'] = ResolversParentTypes['NotificationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Notification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationReferenceableResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationReferenceable'] = ResolversParentTypes['NotificationReferenceable']> = {
  __resolveType: TypeResolveFn<'Comment' | 'JobsHiring' | 'Post' | 'Rating' | 'SalesGptQuery' | 'Testimonial' | 'User', ParentType, ContextType>;
};

export type OnboardingDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingData'] = ResolversParentTypes['OnboardingData']> = {
  companyStages?: Resolver<Array<ResolversTypes['CompanyStage']>, ParentType, ContextType>;
  customerSegments?: Resolver<Array<ResolversTypes['CustomerSegment']>, ParentType, ContextType>;
  departments?: Resolver<Array<ResolversTypes['Department']>, ParentType, ContextType>;
  expectations?: Resolver<Array<ResolversTypes['Expectation']>, ParentType, ContextType>;
  industries?: Resolver<Array<ResolversTypes['Industry']>, ParentType, ContextType>;
  jobSearchStatuses?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PollResolvers<ContextType = any, ParentType extends ResolversParentTypes['Poll'] = ResolversParentTypes['Poll']> = {
  choices?: Resolver<Array<ResolversTypes['PollChoice']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  currentUserVote?: Resolver<Maybe<ResolversTypes['PollVote']>, ParentType, ContextType>;
  expiredForCommission?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  post?: Resolver<ResolversTypes['Post'], ParentType, ContextType>;
  postId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  previewUsers?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  votedUsers?: Resolver<ResolversTypes['UserConnection'], ParentType, ContextType, RequireFields<PollVotedUsersArgs, never>>;
  votes?: Resolver<ResolversTypes['PollVoteConnection'], ParentType, ContextType, RequireFields<PollVotesArgs, never>>;
  votesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PollChoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['PollChoice'] = ResolversParentTypes['PollChoice']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  currentVote?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  poll?: Resolver<ResolversTypes['Poll'], ParentType, ContextType>;
  pollId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  votedUsers?: Resolver<ResolversTypes['UserConnection'], ParentType, ContextType, RequireFields<PollChoiceVotedUsersArgs, never>>;
  votes?: Resolver<ResolversTypes['PollVoteConnection'], ParentType, ContextType, RequireFields<PollChoiceVotesArgs, never>>;
  votesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PollVoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['PollVote'] = ResolversParentTypes['PollVote']> = {
  choice?: Resolver<ResolversTypes['PollChoice'], ParentType, ContextType>;
  choiceId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  poll?: Resolver<ResolversTypes['Poll'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PollVoteConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PollVoteConnection'] = ResolversParentTypes['PollVoteConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PollVoteEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['PollVote']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PollVoteEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PollVoteEdge'] = ResolversParentTypes['PollVoteEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PollVote']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioCurrentUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioCurrentUser'] = ResolversParentTypes['PortfolioCurrentUser']> = {
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  customerSegment?: Resolver<Maybe<ResolversTypes['CustomerSegment']>, ParentType, ContextType>;
  dealQuarters?: Resolver<Array<ResolversTypes['PortfolioDealQuarter']>, ParentType, ContextType>;
  deals?: Resolver<ResolversTypes['PortfolioDealConnection'], ParentType, ContextType, RequireFields<PortfolioCurrentUserDealsArgs, never>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  industry?: Resolver<Maybe<ResolversTypes['Industry']>, ParentType, ContextType>;
  lastLinkedinSyncError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastLinkedinSyncedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  productTypes?: Resolver<Array<ResolversTypes['ProductType']>, ParentType, ContextType>;
  ranking?: Resolver<ResolversTypes['PortfolioRanking'], ParentType, ContextType>;
  topDeals?: Resolver<ResolversTypes['PortfolioDealConnection'], ParentType, ContextType, RequireFields<PortfolioCurrentUserTopDealsArgs, never>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioDealResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioDeal'] = ResolversParentTypes['PortfolioDeal']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  closeDate?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<ResolversTypes['Department']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  interactionsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrivateCompany?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrivateDepartments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  post?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioDealConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioDealConnection'] = ResolversParentTypes['PortfolioDealConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PortfolioDealEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['PortfolioDeal']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  statistics?: Resolver<ResolversTypes['DealsStatistics'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioDealEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioDealEdge'] = ResolversParentTypes['PortfolioDealEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PortfolioDeal']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioDealQuarterResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioDealQuarter'] = ResolversParentTypes['PortfolioDealQuarter']> = {
  quarter?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quota?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  revenue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioDealsSourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioDealsSource'] = ResolversParentTypes['PortfolioDealsSource']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioRankingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioRanking'] = ResolversParentTypes['PortfolioRanking']> = {
  rankingByCustomerSegment?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rankingByIndustry?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rankingByLocation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortfolioUserSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioUserSearchResult'] = ResolversParentTypes['PortfolioUserSearchResult']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  portfolioUser?: Resolver<ResolversTypes['PublicPortfolioUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostResolvers<ContextType = any, ParentType extends ResolversParentTypes['Post'] = ResolversParentTypes['Post']> = {
  algorithmMetadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  author?: Resolver<ResolversTypes['UserAuthor'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  comments?: Resolver<ResolversTypes['CommentConnection'], ParentType, ContextType, RequireFields<PostCommentsArgs, 'sortType'>>;
  commentsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  content?: Resolver<ResolversTypes['Content'], ParentType, ContextType>;
  contentId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  currentUserRating?: Resolver<Maybe<ResolversTypes['Rating']>, ParentType, ContextType>;
  files?: Resolver<Maybe<Array<ResolversTypes['File']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAnonymous?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  membersOnly?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  metadataUsers?: Resolver<ResolversTypes['UserPostConnection'], ParentType, ContextType, RequireFields<PostMetadataUsersArgs, never>>;
  newCommentsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  official?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pinned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pinnedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  poll?: Resolver<Maybe<ResolversTypes['Poll']>, ParentType, ContextType>;
  previewComments?: Resolver<ResolversTypes['CommentConnection'], ParentType, ContextType, RequireFields<PostPreviewCommentsArgs, never>>;
  publishedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  ratedUsers?: Resolver<ResolversTypes['UserConnection'], ParentType, ContextType, RequireFields<PostRatedUsersArgs, never>>;
  ratings?: Resolver<ResolversTypes['RatingConnection'], ParentType, ContextType, RequireFields<PostRatingsArgs, never>>;
  searchableComments?: Resolver<Maybe<Array<ResolversTypes['Comment']>>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topicId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  topics?: Resolver<Array<ResolversTypes['Topic']>, ParentType, ContextType>;
  totalRating?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalWeight?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  viewed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  viewers?: Resolver<ResolversTypes['UserConnection'], ParentType, ContextType, RequireFields<PostViewersArgs, never>>;
  views?: Resolver<ResolversTypes['PostViewConnection'], ParentType, ContextType, RequireFields<PostViewsArgs, never>>;
  viewsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostConnection'] = ResolversParentTypes['PostConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PostEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Post']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostEdge'] = ResolversParentTypes['PostEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostViewResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostView'] = ResolversParentTypes['PostView']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  postId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostViewConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostViewConnection'] = ResolversParentTypes['PostViewConnection']> = {
  edges?: Resolver<Array<ResolversTypes['PostViewEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['PostView']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostViewEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostViewEdge'] = ResolversParentTypes['PostViewEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['PostView']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PotentialEmployerResolvers<ContextType = any, ParentType extends ResolversParentTypes['PotentialEmployer'] = ResolversParentTypes['PotentialEmployer']> = {
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  companyBusinessAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyDomain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hashid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberOfHirings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  otherRoles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rolesOfHirings?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProductType'] = ResolversParentTypes['ProductType']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  custom?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  users?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicResolvers<ContextType = any, ParentType extends ResolversParentTypes['Public'] = ResolversParentTypes['Public']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioIsOpened?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicPortfolioConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicPortfolioConfiguration'] = ResolversParentTypes['PublicPortfolioConfiguration']> = {
  fieldCalendarLinkIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fieldLinkedinSlugIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fieldPhoneIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fieldPublicEmailIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sectionAwardsIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sectionClientsIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sectionConnectionsIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sectionContactsIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sectionEducationHistoriesIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sectionHeadlineIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sectionSalesExperienceIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sectionTestimonialsIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sectionWorkHistoriesIsPublic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicPortfolioCurrentUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicPortfolioCurrentUser'] = ResolversParentTypes['PublicPortfolioCurrentUser']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  awards?: Resolver<Maybe<Array<ResolversTypes['Award']>>, ParentType, ContextType>;
  calendarLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  clients?: Resolver<Maybe<Array<ResolversTypes['Client']>>, ParentType, ContextType>;
  companySeriesStages?: Resolver<Maybe<Array<ResolversTypes['CompanySeriesStage']>>, ParentType, ContextType>;
  companyStages?: Resolver<Maybe<Array<ResolversTypes['CompanyStage']>>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['PublicPortfolioConfiguration'], ParentType, ContextType>;
  connections?: Resolver<Maybe<ResolversTypes['ConnectionConnection']>, ParentType, ContextType, RequireFields<PublicPortfolioCurrentUserConnectionsArgs, never>>;
  contacts?: Resolver<Maybe<ResolversTypes['Contacts']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  currentCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  currentPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<ResolversTypes['Department']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  educationHistories?: Resolver<Maybe<Array<ResolversTypes['EducationHistory']>>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  industries?: Resolver<Maybe<Array<ResolversTypes['Industry']>>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productTypes?: Resolver<Maybe<Array<ResolversTypes['ProductType']>>, ParentType, ContextType>;
  publicEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  testimonials?: Resolver<Maybe<Array<ResolversTypes['Testimonial']>>, ParentType, ContextType>;
  tooltips?: Resolver<Array<ResolversTypes['Tooltip']>, ParentType, ContextType>;
  warRoomSalesRoles?: Resolver<Maybe<Array<ResolversTypes['SalesRole']>>, ParentType, ContextType>;
  workHistories?: Resolver<Maybe<Array<ResolversTypes['WorkHistory']>>, ParentType, ContextType>;
  workHistory?: Resolver<ResolversTypes['WorkHistory'], ParentType, ContextType, RequireFields<PublicPortfolioCurrentUserWorkHistoryArgs, 'id'>>;
  yearsOfExperience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicPortfolioUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicPortfolioUser'] = ResolversParentTypes['PublicPortfolioUser']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  awards?: Resolver<Maybe<Array<ResolversTypes['Award']>>, ParentType, ContextType>;
  calendarLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  clients?: Resolver<Maybe<Array<ResolversTypes['Client']>>, ParentType, ContextType>;
  companySeriesStages?: Resolver<Maybe<Array<ResolversTypes['CompanySeriesStage']>>, ParentType, ContextType>;
  companyStages?: Resolver<Maybe<Array<ResolversTypes['CompanyStage']>>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['PublicPortfolioConfiguration'], ParentType, ContextType>;
  connected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  connections?: Resolver<Maybe<ResolversTypes['ConnectionConnection']>, ParentType, ContextType, RequireFields<PublicPortfolioUserConnectionsArgs, never>>;
  contacts?: Resolver<Maybe<ResolversTypes['Contacts']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  currentCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  currentPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<ResolversTypes['Department']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  educationHistories?: Resolver<Maybe<Array<ResolversTypes['EducationHistory']>>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  incomingConnectionRequest?: Resolver<Maybe<ResolversTypes['Request']>, ParentType, ContextType>;
  industries?: Resolver<Maybe<Array<ResolversTypes['Industry']>>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outgoingConnectionRequest?: Resolver<Maybe<ResolversTypes['Request']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productTypes?: Resolver<Maybe<Array<ResolversTypes['ProductType']>>, ParentType, ContextType>;
  publicEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  realUser?: Resolver<Maybe<ResolversTypes['PublicPortfolioUser']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  testimonials?: Resolver<Maybe<Array<ResolversTypes['Testimonial']>>, ParentType, ContextType>;
  warRoomSalesRoles?: Resolver<Maybe<Array<ResolversTypes['SalesRole']>>, ParentType, ContextType>;
  workHistories?: Resolver<Maybe<Array<ResolversTypes['WorkHistory']>>, ParentType, ContextType>;
  yearsOfExperience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PublicPortfolioUserIterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicPortfolioUserIterface'] = ResolversParentTypes['PublicPortfolioUserIterface']> = {
  __resolveType: TypeResolveFn<'PublicPortfolioCurrentUser' | 'PublicPortfolioUser', ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  awards?: Resolver<Maybe<Array<ResolversTypes['Award']>>, ParentType, ContextType>;
  calendarLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  clients?: Resolver<Maybe<Array<ResolversTypes['Client']>>, ParentType, ContextType>;
  companySeriesStages?: Resolver<Maybe<Array<ResolversTypes['CompanySeriesStage']>>, ParentType, ContextType>;
  companyStages?: Resolver<Maybe<Array<ResolversTypes['CompanyStage']>>, ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['PublicPortfolioConfiguration'], ParentType, ContextType>;
  connections?: Resolver<Maybe<ResolversTypes['ConnectionConnection']>, ParentType, ContextType, RequireFields<PublicPortfolioUserIterfaceConnectionsArgs, never>>;
  contacts?: Resolver<Maybe<ResolversTypes['Contacts']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  currentCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  currentPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<ResolversTypes['Department']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  educationHistories?: Resolver<Maybe<Array<ResolversTypes['EducationHistory']>>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  industries?: Resolver<Maybe<Array<ResolversTypes['Industry']>>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productTypes?: Resolver<Maybe<Array<ResolversTypes['ProductType']>>, ParentType, ContextType>;
  publicEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  testimonials?: Resolver<Maybe<Array<ResolversTypes['Testimonial']>>, ParentType, ContextType>;
  warRoomSalesRoles?: Resolver<Maybe<Array<ResolversTypes['SalesRole']>>, ParentType, ContextType>;
  workHistories?: Resolver<Maybe<Array<ResolversTypes['WorkHistory']>>, ParentType, ContextType>;
  yearsOfExperience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  academyArticle?: Resolver<ResolversTypes['Article'], ParentType, ContextType, RequireFields<QueryAcademyArticleArgs, 'slug'>>;
  academyArticles?: Resolver<Array<ResolversTypes['Article']>, ParentType, ContextType, RequireFields<QueryAcademyArticlesArgs, 'topicSlug'>>;
  academyTopics?: Resolver<ResolversTypes['AcademyTopicConnection'], ParentType, ContextType, RequireFields<QueryAcademyTopicsArgs, never>>;
  cities?: Resolver<ResolversTypes['CityConnection'], ParentType, ContextType, RequireFields<QueryCitiesArgs, never>>;
  comment?: Resolver<ResolversTypes['Comment'], ParentType, ContextType, RequireFields<QueryCommentArgs, 'id' | 'parentOnTop'>>;
  comments?: Resolver<ResolversTypes['CommentConnection'], ParentType, ContextType, RequireFields<QueryCommentsArgs, 'postSlug' | 'sortType'>>;
  commissionBalance?: Resolver<ResolversTypes['CommissionBalance'], ParentType, ContextType>;
  commissionOnboarding?: Resolver<ResolversTypes['CommissionOnboarding'], ParentType, ContextType>;
  companies?: Resolver<Maybe<ResolversTypes['CompaniesConnection']>, ParentType, ContextType, RequireFields<QueryCompaniesArgs, 'customerSegmentId' | 'offset' | 'regionId' | 'roleCategoryId' | 'searchLetter' | 'searchTerm' | 'sortType'>>;
  companiesCategories?: Resolver<Array<ResolversTypes['CompaniesCategory']>, ParentType, ContextType, RequireFields<QueryCompaniesCategoriesArgs, never>>;
  companiesSearch?: Resolver<Array<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<QueryCompaniesSearchArgs, 'limit' | 'minScore' | 'query'>>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType, RequireFields<QueryCompanyArgs, never>>;
  companyPagesAverageSalariesData?: Resolver<Maybe<ResolversTypes['AverageSalariesData']>, ParentType, ContextType, RequireFields<QueryCompanyPagesAverageSalariesDataArgs, 'customerSegmentId' | 'regionId' | 'roleCategoryId'>>;
  companyPagesBestCities?: Resolver<Array<ResolversTypes['BestCity']>, ParentType, ContextType, RequireFields<QueryCompanyPagesBestCitiesArgs, 'roleCategoryId'>>;
  companyPagesInterviews?: Resolver<Maybe<ResolversTypes['CompanyPagesInterviewConnection']>, ParentType, ContextType, RequireFields<QueryCompanyPagesInterviewsArgs, never>>;
  companyPagesPeople?: Resolver<ResolversTypes['EmployeeConnection'], ParentType, ContextType, RequireFields<QueryCompanyPagesPeopleArgs, 'slug'>>;
  companyPagesRegions?: Resolver<ResolversTypes['RegionConnection'], ParentType, ContextType, RequireFields<QueryCompanyPagesRegionsArgs, never>>;
  companyPagesReviews?: Resolver<Maybe<ResolversTypes['CompanyPagesReviewConnection']>, ParentType, ContextType, RequireFields<QueryCompanyPagesReviewsArgs, never>>;
  companyPagesRoleCategoriesByCustomerSegment?: Resolver<Maybe<Array<ResolversTypes['RoleCategory']>>, ParentType, ContextType, RequireFields<QueryCompanyPagesRoleCategoriesByCustomerSegmentArgs, 'customerSegmentId'>>;
  companyPagesRoles?: Resolver<Maybe<ResolversTypes['CompanyPagesRoleConnection']>, ParentType, ContextType, RequireFields<QueryCompanyPagesRolesArgs, 'customerSegmentId' | 'roleCategoryId'>>;
  companyRole?: Resolver<Maybe<ResolversTypes['CompanyPagesRole']>, ParentType, ContextType, RequireFields<QueryCompanyRoleArgs, 'companyRoleId'>>;
  connectionRequest?: Resolver<ResolversTypes['Request'], ParentType, ContextType, RequireFields<QueryConnectionRequestArgs, 'id'>>;
  connectionRequestsInbox?: Resolver<ResolversTypes['RequestConnection'], ParentType, ContextType, RequireFields<QueryConnectionRequestsInboxArgs, never>>;
  connectionSuggestions?: Resolver<ResolversTypes['ConnectionSuggestionInterfaceConnection'], ParentType, ContextType, RequireFields<QueryConnectionSuggestionsArgs, 'type'>>;
  currentJobsInquiry?: Resolver<Maybe<ResolversTypes['JobsInquiry']>, ParentType, ContextType>;
  currentUser?: Resolver<ResolversTypes['CurrentUser'], ParentType, ContextType>;
  customerSegments?: Resolver<Array<ResolversTypes['CustomerSegment']>, ParentType, ContextType>;
  deals?: Resolver<ResolversTypes['DealConnection'], ParentType, ContextType, RequireFields<QueryDealsArgs, never>>;
  departments?: Resolver<Array<ResolversTypes['Department']>, ParentType, ContextType>;
  directMessagesBlockedUsers?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  directMessagesSuggestedUsers?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  directMessagesThread?: Resolver<Maybe<ResolversTypes['Thread']>, ParentType, ContextType, RequireFields<QueryDirectMessagesThreadArgs, 'username'>>;
  directMessagesThreads?: Resolver<Array<ResolversTypes['Thread']>, ParentType, ContextType>;
  directMessagesUsersByUsername?: Resolver<Array<ResolversTypes['UserSearch']>, ParentType, ContextType, RequireFields<QueryDirectMessagesUsersByUsernameArgs, 'query'>>;
  educationHistory?: Resolver<ResolversTypes['EducationHistory'], ParentType, ContextType, RequireFields<QueryEducationHistoryArgs, 'id'>>;
  industries?: Resolver<Array<ResolversTypes['Industry']>, ParentType, ContextType>;
  jobsCompanySeriesStages?: Resolver<Array<ResolversTypes['CompanySeriesStage']>, ParentType, ContextType>;
  jobsHiring?: Resolver<ResolversTypes['JobsHiring'], ParentType, ContextType, RequireFields<QueryJobsHiringArgs, 'hashid'>>;
  jobsModeratorsAccountOwners?: Resolver<Array<ResolversTypes['JobsModeratorsEmployersAccountOwner']>, ParentType, ContextType>;
  jobsModeratorsBestHiringsExplanation?: Resolver<ResolversTypes['JobsModeratorsHiringExplanation'], ParentType, ContextType, RequireFields<QueryJobsModeratorsBestHiringsExplanationArgs, 'hiringIds'>>;
  jobsModeratorsCandidate?: Resolver<ResolversTypes['JobsModeratorsCandidate'], ParentType, ContextType, RequireFields<QueryJobsModeratorsCandidateArgs, 'id'>>;
  jobsModeratorsDefaultCandidate?: Resolver<ResolversTypes['JobsModeratorsCandidate'], ParentType, ContextType, RequireFields<QueryJobsModeratorsDefaultCandidateArgs, 'hiringId'>>;
  jobsModeratorsEmployer?: Resolver<Maybe<ResolversTypes['JobsModeratorsEmployer']>, ParentType, ContextType, RequireFields<QueryJobsModeratorsEmployerArgs, 'id'>>;
  jobsModeratorsEmployers?: Resolver<ResolversTypes['JobsModeratorsEmployerConnection'], ParentType, ContextType, RequireFields<QueryJobsModeratorsEmployersArgs, 'needsAttention'>>;
  jobsModeratorsFields?: Resolver<Array<ResolversTypes['JobsModeratorsField']>, ParentType, ContextType, RequireFields<QueryJobsModeratorsFieldsArgs, never>>;
  jobsModeratorsFieldsCategories?: Resolver<Array<ResolversTypes['JobsModeratorsFieldsCategory']>, ParentType, ContextType>;
  jobsModeratorsHiring?: Resolver<Maybe<ResolversTypes['JobsModeratorsHiring']>, ParentType, ContextType, RequireFields<QueryJobsModeratorsHiringArgs, 'id'>>;
  jobsModeratorsHiringStates?: Resolver<Array<ResolversTypes['JobsModeratorsHiringState']>, ParentType, ContextType>;
  jobsModeratorsHiringStatesWithCounters?: Resolver<Array<ResolversTypes['JobsModeratorsHiringStateCounter']>, ParentType, ContextType>;
  jobsModeratorsHirings?: Resolver<Maybe<ResolversTypes['JobsModeratorsHiringConnection']>, ParentType, ContextType, RequireFields<QueryJobsModeratorsHiringsArgs, 'pageSize'>>;
  jobsModeratorsInquiries?: Resolver<Maybe<ResolversTypes['JobsModeratorsInquiryConnection']>, ParentType, ContextType, RequireFields<QueryJobsModeratorsInquiriesArgs, never>>;
  jobsModeratorsInquiry?: Resolver<Maybe<ResolversTypes['JobsModeratorsInquiry']>, ParentType, ContextType, RequireFields<QueryJobsModeratorsInquiryArgs, 'id'>>;
  jobsModeratorsInquiryStates?: Resolver<Array<ResolversTypes['JobsInquiryState']>, ParentType, ContextType>;
  jobsModeratorsOpsRejectionReasons?: Resolver<Array<ResolversTypes['JobsModeratorsOpsRejectionReason']>, ParentType, ContextType>;
  jobsModeratorsRecruiters?: Resolver<Array<ResolversTypes['JobsModeratorsUser']>, ParentType, ContextType>;
  jobsModeratorsSuggestedInquiries?: Resolver<Array<ResolversTypes['JobsModeratorsInquiryMatch']>, ParentType, ContextType, RequireFields<QueryJobsModeratorsSuggestedInquiriesArgs, 'limit' | 'vacancyId'>>;
  jobsModeratorsSuggestedVacancies?: Resolver<Array<ResolversTypes['JobsModeratorsVacancyMatch']>, ParentType, ContextType, RequireFields<QueryJobsModeratorsSuggestedVacanciesArgs, 'inquiryId' | 'limit'>>;
  jobsModeratorsVacancies?: Resolver<ResolversTypes['JobsModeratorsVacancyConnection'], ParentType, ContextType, RequireFields<QueryJobsModeratorsVacanciesArgs, never>>;
  jobsModeratorsVacancy?: Resolver<ResolversTypes['JobsModeratorsVacancy'], ParentType, ContextType, RequireFields<QueryJobsModeratorsVacancyArgs, 'id'>>;
  jobsRecruitersCandidate?: Resolver<ResolversTypes['JobsRecruitersCandidate'], ParentType, ContextType, RequireFields<QueryJobsRecruitersCandidateArgs, 'hashid'>>;
  jobsRecruitersCandidates?: Resolver<ResolversTypes['JobsRecruitersCandidateConnection'], ParentType, ContextType, RequireFields<QueryJobsRecruitersCandidatesArgs, never>>;
  jobsRecruitersCheckEmployerExistence?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryJobsRecruitersCheckEmployerExistenceArgs, 'companyId'>>;
  jobsRecruitersCheckRecruiterExistence?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryJobsRecruitersCheckRecruiterExistenceArgs, 'email'>>;
  jobsRecruitersCompanyCategorySuggestions?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryJobsRecruitersCompanyCategorySuggestionsArgs, 'companyId'>>;
  jobsRecruitersCurrentRecruiter?: Resolver<Maybe<ResolversTypes['JobsRecruitersRecruiter']>, ParentType, ContextType>;
  jobsRecruitersEmployerRecruiters?: Resolver<Maybe<Array<ResolversTypes['JobsRecruitersRecruiter']>>, ParentType, ContextType>;
  jobsRecruitersField?: Resolver<ResolversTypes['JobsRecruitersField'], ParentType, ContextType, RequireFields<QueryJobsRecruitersFieldArgs, 'slug'>>;
  jobsRecruitersFields?: Resolver<Array<ResolversTypes['JobsRecruitersField']>, ParentType, ContextType, RequireFields<QueryJobsRecruitersFieldsArgs, never>>;
  jobsRecruitersFieldsCategories?: Resolver<Array<ResolversTypes['JobsRecruitersFieldsCategory']>, ParentType, ContextType>;
  jobsRecruitersInquiry?: Resolver<Maybe<ResolversTypes['JobsRecruitersInquiry']>, ParentType, ContextType, RequireFields<QueryJobsRecruitersInquiryArgs, 'hashId'>>;
  jobsRecruitersOteDistribution?: Resolver<Maybe<ResolversTypes['JobsRecruitersDistribution']>, ParentType, ContextType, RequireFields<QueryJobsRecruitersOteDistributionArgs, 'useAverageCandidateIntake' | 'vacancyId'>>;
  jobsRecruitersVacancies?: Resolver<Array<ResolversTypes['JobsRecruitersVacancy']>, ParentType, ContextType, RequireFields<QueryJobsRecruitersVacanciesArgs, 'states'>>;
  jobsRecruitersVacancy?: Resolver<ResolversTypes['JobsRecruitersVacancy'], ParentType, ContextType, RequireFields<QueryJobsRecruitersVacancyArgs, 'id'>>;
  jobsRecruitersVacancyPromptTemplates?: Resolver<Array<ResolversTypes['JobsRecruitersVacancyPromptTemplate']>, ParentType, ContextType, RequireFields<QueryJobsRecruitersVacancyPromptTemplatesArgs, 'employmentType' | 'position'>>;
  jobsVacancy?: Resolver<ResolversTypes['JobsVacancy'], ParentType, ContextType, RequireFields<QueryJobsVacancyArgs, 'uid'>>;
  leaderboard?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  notifications?: Resolver<Maybe<ResolversTypes['NotificationConnection']>, ParentType, ContextType, RequireFields<QueryNotificationsArgs, 'kinds' | 'platform'>>;
  onboardingData?: Resolver<ResolversTypes['OnboardingData'], ParentType, ContextType>;
  outgoingConnectionRequests?: Resolver<ResolversTypes['RequestConnection'], ParentType, ContextType, RequireFields<QueryOutgoingConnectionRequestsArgs, never>>;
  peopleYouMightKnow?: Resolver<ResolversTypes['SuggestedUserConnection'], ParentType, ContextType, RequireFields<QueryPeopleYouMightKnowArgs, never>>;
  personalFeedPosts?: Resolver<Array<ResolversTypes['Post']>, ParentType, ContextType, RequireFields<QueryPersonalFeedPostsArgs, 'offset'>>;
  pinnedPosts?: Resolver<ResolversTypes['PostConnection'], ParentType, ContextType, RequireFields<QueryPinnedPostsArgs, never>>;
  popularTopics?: Resolver<Array<ResolversTypes['Topic']>, ParentType, ContextType>;
  portfolioCurrentUser?: Resolver<ResolversTypes['PortfolioCurrentUser'], ParentType, ContextType>;
  portfolioDeal?: Resolver<ResolversTypes['PortfolioDeal'], ParentType, ContextType, RequireFields<QueryPortfolioDealArgs, 'id'>>;
  post?: Resolver<Maybe<ResolversTypes['Post']>, ParentType, ContextType, RequireFields<QueryPostArgs, 'slug'>>;
  posts?: Resolver<ResolversTypes['PostConnection'], ParentType, ContextType, RequireFields<QueryPostsArgs, never>>;
  productTypes?: Resolver<Array<ResolversTypes['ProductType']>, ParentType, ContextType>;
  publicPortfolioConnections?: Resolver<Maybe<ResolversTypes['ConnectionConnection']>, ParentType, ContextType, RequireFields<QueryPublicPortfolioConnectionsArgs, 'slug'>>;
  publicPortfolioCurrentUser?: Resolver<ResolversTypes['PublicPortfolioCurrentUser'], ParentType, ContextType>;
  publicPortfolioUser?: Resolver<Maybe<ResolversTypes['PublicPortfolioUser']>, ParentType, ContextType, RequireFields<QueryPublicPortfolioUserArgs, 'slug'>>;
  publicPortfolioUserTestifySign?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryPublicPortfolioUserTestifySignArgs, 'slug'>>;
  roleCategories?: Resolver<Array<ResolversTypes['RoleCategory']>, ParentType, ContextType>;
  salesDirectoryProfiles?: Resolver<ResolversTypes['SalesDirectoryPage'], ParentType, ContextType, RequireFields<QuerySalesDirectoryProfilesArgs, 'page' | 'perPage' | 'prefix'>>;
  salesGptFlexCta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QuerySalesGptFlexCtaArgs, 'sessionId'>>;
  salesGptQuery?: Resolver<ResolversTypes['SalesGptQuery'], ParentType, ContextType, RequireFields<QuerySalesGptQueryArgs, 'sessionId'>>;
  salesRoles?: Resolver<Array<ResolversTypes['SalesRole']>, ParentType, ContextType>;
  search?: Resolver<ResolversTypes['SearchInfo'], ParentType, ContextType, RequireFields<QuerySearchArgs, 'filterCategories' | 'page' | 'perPage' | 'produceAiSummary' | 'query'>>;
  searchLocations?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType, RequireFields<QuerySearchLocationsArgs, 'countryName' | 'first' | 'term' | 'types'>>;
  searchUsers?: Resolver<Array<ResolversTypes['UserSearch']>, ParentType, ContextType, RequireFields<QuerySearchUsersArgs, never>>;
  suggestedGeolocation?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType, RequireFields<QuerySuggestedGeolocationArgs, never>>;
  suggestedLinkedinProfiles?: Resolver<Array<ResolversTypes['VendorDbUser']>, ParentType, ContextType>;
  testimonial?: Resolver<ResolversTypes['Testimonial'], ParentType, ContextType, RequireFields<QueryTestimonialArgs, 'sign'>>;
  topFlexJobsVacancies?: Resolver<Maybe<Array<ResolversTypes['JobsVacancy']>>, ParentType, ContextType>;
  topics?: Resolver<ResolversTypes['TopicConnection'], ParentType, ContextType, RequireFields<QueryTopicsArgs, never>>;
  universities?: Resolver<ResolversTypes['UniversityConnection'], ParentType, ContextType, RequireFields<QueryUniversitiesArgs, never>>;
  university?: Resolver<ResolversTypes['University'], ParentType, ContextType, RequireFields<QueryUniversityArgs, 'slug'>>;
  universityDegrees?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryUniversityDegreesArgs, never>>;
  universityPagesPeople?: Resolver<ResolversTypes['AlumniConnection'], ParentType, ContextType, RequireFields<QueryUniversityPagesPeopleArgs, 'slug'>>;
  universityPagesSuggestions?: Resolver<ResolversTypes['SuggestedUserConnection'], ParentType, ContextType, RequireFields<QueryUniversityPagesSuggestionsArgs, 'slug'>>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUserArgs, 'username'>>;
  userPosts?: Resolver<ResolversTypes['PostConnection'], ParentType, ContextType, RequireFields<QueryUserPostsArgs, never>>;
  userPublicPosts?: Resolver<ResolversTypes['PostConnection'], ParentType, ContextType, RequireFields<QueryUserPublicPostsArgs, 'slug'>>;
  userReferrer?: Resolver<Maybe<ResolversTypes['SuggestedUser']>, ParentType, ContextType, RequireFields<QueryUserReferrerArgs, 'invite'>>;
  warRoomSearchPosts?: Resolver<Array<ResolversTypes['Post']>, ParentType, ContextType, RequireFields<QueryWarRoomSearchPostsArgs, never>>;
  warRoomSuggestedActivityType?: Resolver<ResolversTypes['Activity'], ParentType, ContextType>;
  warRoomUnreadPostsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type RatingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Rating'] = ResolversParentTypes['Rating']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reactable?: Resolver<ResolversTypes['Reactable'], ParentType, ContextType>;
  reactableId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  reactableType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RatingConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RatingConnection'] = ResolversParentTypes['RatingConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RatingEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Rating']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RatingEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RatingEdge'] = ResolversParentTypes['RatingEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Rating']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReactableResolvers<ContextType = any, ParentType extends ResolversParentTypes['Reactable'] = ResolversParentTypes['Reactable']> = {
  __resolveType: TypeResolveFn<'Comment' | 'Post', ParentType, ContextType>;
};

export type ReadThreadEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReadThreadEvent'] = ResolversParentTypes['ReadThreadEvent']> = {
  readAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  threadId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Region'] = ResolversParentTypes['Region']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  section?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegionConnection'] = ResolversParentTypes['RegionConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RegionEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Region']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegionEdge'] = ResolversParentTypes['RegionEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Region']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelatedCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelatedCompany'] = ResolversParentTypes['RelatedCompany']> = {
  employeeCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentRound?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalFunding?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  webSiteUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RelatedCompanyPageResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['RelatedCompanyPageResponse'] = ResolversParentTypes['RelatedCompanyPageResponse']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['RelatedCompany']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['Request'] = ResolversParentTypes['Request']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  read?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  receiver?: Resolver<ResolversTypes['RequestParticipant'], ParentType, ContextType>;
  requestee?: Resolver<Maybe<ResolversTypes['RequestParticipant']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestConnection'] = ResolversParentTypes['RequestConnection']> = {
  edges?: Resolver<Array<ResolversTypes['RequestEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Request']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestEdge'] = ResolversParentTypes['RequestEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Request']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RequestParticipantResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestParticipant'] = ResolversParentTypes['RequestParticipant']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  currentPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleCategory'] = ResolversParentTypes['RoleCategory']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesDirectoryPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesDirectoryPage'] = ResolversParentTypes['SalesDirectoryPage']> = {
  currentPage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  profiles?: Resolver<Array<ResolversTypes['SalesDirectoryUser']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPages?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesDirectoryUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesDirectoryUser'] = ResolversParentTypes['SalesDirectoryUser']> = {
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesGptQueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesGptQuery'] = ResolversParentTypes['SalesGptQuery']> = {
  flexCta?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  query?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  sources?: Resolver<Maybe<ResolversTypes['SearchResultInterfaceConnection']>, ParentType, ContextType, RequireFields<SalesGptQuerySourcesArgs, never>>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summaryType?: Resolver<ResolversTypes['SearchSummaryType'], ParentType, ContextType>;
  wasCompanyPagesDataUsed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  wasExternalDataUsed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesRole'] = ResolversParentTypes['SalesRole']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesTeamTenureAverageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesTeamTenureAverage'] = ResolversParentTypes['SalesTeamTenureAverage']> = {
  average?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  experience?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesTeamTenureAveragesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesTeamTenureAverages'] = ResolversParentTypes['SalesTeamTenureAverages']> = {
  ae?: Resolver<ResolversTypes['SalesTeamTenureAverage'], ParentType, ContextType>;
  sdr?: Resolver<ResolversTypes['SalesTeamTenureAverage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchInfo'] = ResolversParentTypes['SearchInfo']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  results?: Resolver<Array<ResolversTypes['SearchResultsCategory']>, ParentType, ContextType>;
  salesGptQuery?: Resolver<Maybe<ResolversTypes['SalesGptQuery']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchResultInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchResultInterface'] = ResolversParentTypes['SearchResultInterface']> = {
  __resolveType: TypeResolveFn<'AcademyArticleSearchResult' | 'CompanyPagesCatalogSearchResult' | 'CompanySearchResult' | 'PortfolioUserSearchResult' | 'WarRoomPostCommentSearchResult' | 'WarRoomPostSearchResult' | 'WarRoomUserSearchResult', ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SearchResultInterfaceConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchResultInterfaceConnection'] = ResolversParentTypes['SearchResultInterfaceConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SearchResultInterfaceEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['SearchResultInterface']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchResultInterfaceEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchResultInterfaceEdge'] = ResolversParentTypes['SearchResultInterfaceEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['SearchResultInterface']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchResultsCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchResultsCategory'] = ResolversParentTypes['SearchResultsCategory']> = {
  category?: Resolver<ResolversTypes['SearchResultCategory'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['SearchResultInterface']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Story'] = ResolversParentTypes['Story']> = {
  coverContentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coverFileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coverFileSize?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  coverUpdatedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  coverUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  highlightedText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  previewImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rawText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  textImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  commissionTransactions?: SubscriptionResolver<ResolversTypes['CommissionTransactionSubscriptionPayload'], "commissionTransactions", ParentType, ContextType>;
  directMessages?: SubscriptionResolver<ResolversTypes['DirectMessagesSubscriptionPayload'], "directMessages", ParentType, ContextType>;
  linkedinProfileImported?: SubscriptionResolver<ResolversTypes['LinkedinProfileImportedPayload'], "linkedinProfileImported", ParentType, ContextType>;
};

export type SuggestedUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedUser'] = ResolversParentTypes['SuggestedUser']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentCompany?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  currentPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matchMetadata?: Resolver<Maybe<ResolversTypes['GenericMatch']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestedUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedUserConnection'] = ResolversParentTypes['SuggestedUserConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SuggestedUserEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['SuggestedUser']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestedUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuggestedUserEdge'] = ResolversParentTypes['SuggestedUserEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['SuggestedUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestimonialResolvers<ContextType = any, ParentType extends ResolversParentTypes['Testimonial'] = ResolversParentTypes['Testimonial']> = {
  author?: Resolver<ResolversTypes['TestimonialAuthor'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  requestor?: Resolver<ResolversTypes['TestimonialRequestor'], ParentType, ContextType>;
  sign?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  skills?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['TestimonialState'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestimonialAuthorResolvers<ContextType = any, ParentType extends ResolversParentTypes['TestimonialAuthor'] = ResolversParentTypes['TestimonialAuthor']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TestimonialRequestorResolvers<ContextType = any, ParentType extends ResolversParentTypes['TestimonialRequestor'] = ResolversParentTypes['TestimonialRequestor']> = {
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ThreadResolvers<ContextType = any, ParentType extends ResolversParentTypes['Thread'] = ResolversParentTypes['Thread']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  messages?: Resolver<ResolversTypes['MessageConnection'], ParentType, ContextType, RequireFields<ThreadMessagesArgs, never>>;
  otherUser?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  unreadMessages?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TooltipResolvers<ContextType = any, ParentType extends ResolversParentTypes['Tooltip'] = ResolversParentTypes['Tooltip']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopicResolvers<ContextType = any, ParentType extends ResolversParentTypes['Topic'] = ResolversParentTypes['Topic']> = {
  author?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  emoji?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  posts?: Resolver<ResolversTypes['PostConnection'], ParentType, ContextType, RequireFields<TopicPostsArgs, never>>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopicConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopicConnection'] = ResolversParentTypes['TopicConnection']> = {
  edges?: Resolver<Array<ResolversTypes['TopicEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Topic']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopicEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopicEdge'] = ResolversParentTypes['TopicEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Topic']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TotalCompensationRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TotalCompensationRange'] = ResolversParentTypes['TotalCompensationRange']> = {
  maxCompensationRange?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  minCompensationRange?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityResolvers<ContextType = any, ParentType extends ResolversParentTypes['University'] = ResolversParentTypes['University']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  custom?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['University']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  websiteUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityConnection'] = ResolversParentTypes['UniversityConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UniversityEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['University']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityEdge'] = ResolversParentTypes['UniversityEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['University']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UniversityMatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['UniversityMatch'] = ResolversParentTypes['UniversityMatch']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  universityName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  abTests?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  achievements?: Resolver<Maybe<Array<ResolversTypes['UserAchievement']>>, ParentType, ContextType>;
  achievementsProgress?: Resolver<Maybe<Array<ResolversTypes['UserAchievement']>>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  admin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  autoName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  calendarLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['City']>, ParentType, ContextType>;
  commentsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  companySeriesStages?: Resolver<Maybe<Array<ResolversTypes['CompanySeriesStage']>>, ParentType, ContextType>;
  companyStages?: Resolver<Maybe<Array<ResolversTypes['CompanyStage']>>, ParentType, ContextType>;
  contacts?: Resolver<Maybe<Array<ResolversTypes['UserContact']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  departmentIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  departments?: Resolver<Maybe<Array<ResolversTypes['Department']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enabledFeatures?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  facebookUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fakeVacancyIds?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasSeenNewReferProgram?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  industries?: Resolver<Maybe<Array<ResolversTypes['Industry']>>, ParentType, ContextType>;
  industry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instagramUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inviteReferrerUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  languages?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastColleaguesSyncError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastColleaguesSyncedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  lastContactsSyncError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastContactsSyncedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  lastLinkedinSyncError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastLinkedinSyncedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  lastSeenAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinProfilePicUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinSlug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onboardingState?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  onboardingVacancy?: Resolver<Maybe<ResolversTypes['JobsVacancy']>, ParentType, ContextType>;
  orderPosition?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  personalEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  posts?: Resolver<Maybe<Array<ResolversTypes['Post']>>, ParentType, ContextType>;
  postsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  prevScore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  privateHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productTypeIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  productTypes?: Resolver<Maybe<Array<ResolversTypes['ProductType']>>, ParentType, ContextType>;
  public?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  publicEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referralsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  salesRoles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  score?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  solidClients?: Resolver<Maybe<Array<ResolversTypes['Client']>>, ParentType, ContextType>;
  submittedCompaniesData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  superInviteMarker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tooltips?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  toured?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  twitterUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uiTheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unreadConnectionRequestsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unreadWarRoomNotifications?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<UserUnreadWarRoomNotificationsArgs, 'platform'>>;
  unseenWarRoomNotifications?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<UserUnseenWarRoomNotificationsArgs, 'platform'>>;
  unusedSuperInvitesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomAvatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomCompanySeriesStageIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  warRoomCompanyStageIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  warRoomCurrentBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  warRoomDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomIndustryIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  warRoomJobSearchStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomJobSearchStatusExpiredAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  warRoomPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomSalesRoleIds?: Resolver<Maybe<Array<ResolversTypes['Int']>>, ParentType, ContextType>;
  warRoomSalesRoles?: Resolver<Maybe<Array<ResolversTypes['SalesRole']>>, ParentType, ContextType>;
  warRoomState?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  warRoomTotalBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  warRoomYearsOfExperience?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  websiteUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAchievementResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAchievement'] = ResolversParentTypes['UserAchievement']> = {
  achieved?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  helpMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  level?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  stateMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAuthorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAuthor'] = ResolversParentTypes['UserAuthor']> = {
  __resolveType: TypeResolveFn<'Anonymous' | 'Public', ParentType, ContextType>;
};

export type UserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserConnection'] = ResolversParentTypes['UserConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UserEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserContact'] = ResolversParentTypes['UserContact']> = {
  emails?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserEdge'] = ResolversParentTypes['UserEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPostResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPost'] = ResolversParentTypes['UserPost']> = {
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  post?: Resolver<ResolversTypes['Post'], ParentType, ContextType>;
  postId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  postViewedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPostConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPostConnection'] = ResolversParentTypes['UserPostConnection']> = {
  edges?: Resolver<Array<ResolversTypes['UserPostEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['UserPost']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPostEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPostEdge'] = ResolversParentTypes['UserPostEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['UserPost']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserSearchResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserSearch'] = ResolversParentTypes['UserSearch']> = {
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warRoomAvatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VendorDbUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['VendorDbUser'] = ResolversParentTypes['VendorDbUser']> = {
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emails?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkedinSlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WarRoomPostCommentSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['WarRoomPostCommentSearchResult'] = ResolversParentTypes['WarRoomPostCommentSearchResult']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  highlightedText?: Resolver<ResolversTypes['HighlightedText'], ParentType, ContextType>;
  record?: Resolver<ResolversTypes['Comment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WarRoomPostSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['WarRoomPostSearchResult'] = ResolversParentTypes['WarRoomPostSearchResult']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  comments?: Resolver<Maybe<Array<ResolversTypes['WarRoomPostCommentSearchResult']>>, ParentType, ContextType>;
  post?: Resolver<ResolversTypes['Post'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WarRoomUserSearchResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['WarRoomUserSearchResult'] = ResolversParentTypes['WarRoomUserSearchResult']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  warRoomUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkHistory'] = ResolversParentTypes['WorkHistory']> = {
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  currentWorkplace?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WorkHistoryMatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['WorkHistoryMatch'] = ResolversParentTypes['WorkHistoryMatch']> = {
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companySlug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  positionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type YoutubeLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['YoutubeLink'] = ResolversParentTypes['YoutubeLink']> = {
  coverUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  highlightedText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  link?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  previewImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rawText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  textImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AcademyArticleSearchResult?: AcademyArticleSearchResultResolvers<ContextType>;
  AcademyTopic?: AcademyTopicResolvers<ContextType>;
  AcademyTopicConnection?: AcademyTopicConnectionResolvers<ContextType>;
  AcademyTopicEdge?: AcademyTopicEdgeResolvers<ContextType>;
  Alumni?: AlumniResolvers<ContextType>;
  AlumniConnection?: AlumniConnectionResolvers<ContextType>;
  AlumniEdge?: AlumniEdgeResolvers<ContextType>;
  Anonymous?: AnonymousResolvers<ContextType>;
  Article?: ArticleResolvers<ContextType>;
  Author?: AuthorResolvers<ContextType>;
  AverageHittingQuota?: AverageHittingQuotaResolvers<ContextType>;
  AveragePerAccountSize?: AveragePerAccountSizeResolvers<ContextType>;
  AveragePerYearsOfExperience?: AveragePerYearsOfExperienceResolvers<ContextType>;
  AverageSalariesData?: AverageSalariesDataResolvers<ContextType>;
  AverageTotals?: AverageTotalsResolvers<ContextType>;
  Award?: AwardResolvers<ContextType>;
  BaseMatch?: BaseMatchResolvers<ContextType>;
  BestCity?: BestCityResolvers<ContextType>;
  BigInt?: GraphQLScalarType;
  City?: CityResolvers<ContextType>;
  CityConnection?: CityConnectionResolvers<ContextType>;
  CityEdge?: CityEdgeResolvers<ContextType>;
  CityMatch?: CityMatchResolvers<ContextType>;
  Client?: ClientResolvers<ContextType>;
  Comment?: CommentResolvers<ContextType>;
  CommentConnection?: CommentConnectionResolvers<ContextType>;
  CommentEdge?: CommentEdgeResolvers<ContextType>;
  CommissionBalance?: CommissionBalanceResolvers<ContextType>;
  CommissionOnboarding?: CommissionOnboardingResolvers<ContextType>;
  CommissionTransaction?: CommissionTransactionResolvers<ContextType>;
  CommissionTransactionSubscriptionPayload?: CommissionTransactionSubscriptionPayloadResolvers<ContextType>;
  CompaniesCategory?: CompaniesCategoryResolvers<ContextType>;
  CompaniesConnection?: CompaniesConnectionResolvers<ContextType>;
  Company?: CompanyResolvers<ContextType>;
  CompanyEdge?: CompanyEdgeResolvers<ContextType>;
  CompanyInterface?: CompanyInterfaceResolvers<ContextType>;
  CompanyPagesAverageRate?: CompanyPagesAverageRateResolvers<ContextType>;
  CompanyPagesCatalog?: CompanyPagesCatalogResolvers<ContextType>;
  CompanyPagesCatalogSearchResult?: CompanyPagesCatalogSearchResultResolvers<ContextType>;
  CompanyPagesInterview?: CompanyPagesInterviewResolvers<ContextType>;
  CompanyPagesInterviewConnection?: CompanyPagesInterviewConnectionResolvers<ContextType>;
  CompanyPagesInterviewEdge?: CompanyPagesInterviewEdgeResolvers<ContextType>;
  CompanyPagesRange?: CompanyPagesRangeResolvers<ContextType>;
  CompanyPagesReview?: CompanyPagesReviewResolvers<ContextType>;
  CompanyPagesReviewConnection?: CompanyPagesReviewConnectionResolvers<ContextType>;
  CompanyPagesReviewEdge?: CompanyPagesReviewEdgeResolvers<ContextType>;
  CompanyPagesRole?: CompanyPagesRoleResolvers<ContextType>;
  CompanyPagesRoleConnection?: CompanyPagesRoleConnectionResolvers<ContextType>;
  CompanyPagesRoleEdge?: CompanyPagesRoleEdgeResolvers<ContextType>;
  CompanyPagesSalary?: CompanyPagesSalaryResolvers<ContextType>;
  CompanyPagesSalesTeam?: CompanyPagesSalesTeamResolvers<ContextType>;
  CompanyPagesTotalCompensationRange?: CompanyPagesTotalCompensationRangeResolvers<ContextType>;
  CompanySearchResult?: CompanySearchResultResolvers<ContextType>;
  CompanySeriesStage?: CompanySeriesStageResolvers<ContextType>;
  CompanyStage?: CompanyStageResolvers<ContextType>;
  Connection?: ConnectionResolvers<ContextType>;
  ConnectionConnection?: ConnectionConnectionResolvers<ContextType>;
  ConnectionEdge?: ConnectionEdgeResolvers<ContextType>;
  ConnectionSuggestionInterface?: ConnectionSuggestionInterfaceResolvers<ContextType>;
  ConnectionSuggestionInterfaceConnection?: ConnectionSuggestionInterfaceConnectionResolvers<ContextType>;
  ConnectionSuggestionInterfaceEdge?: ConnectionSuggestionInterfaceEdgeResolvers<ContextType>;
  ConnectionTopSuggestionUser?: ConnectionTopSuggestionUserResolvers<ContextType>;
  Contacts?: ContactsResolvers<ContextType>;
  Content?: ContentResolvers<ContextType>;
  Country?: CountryResolvers<ContextType>;
  CountryState?: CountryStateResolvers<ContextType>;
  CurrentUser?: CurrentUserResolvers<ContextType>;
  CustomerSegment?: CustomerSegmentResolvers<ContextType>;
  Deal?: DealResolvers<ContextType>;
  DealConnection?: DealConnectionResolvers<ContextType>;
  DealConnectionInterface?: DealConnectionInterfaceResolvers<ContextType>;
  DealEdge?: DealEdgeResolvers<ContextType>;
  DealInterface?: DealInterfaceResolvers<ContextType>;
  DealStory?: DealStoryResolvers<ContextType>;
  DealsStatistics?: DealsStatisticsResolvers<ContextType>;
  Department?: DepartmentResolvers<ContextType>;
  DirectMessagesSubscriptionPayload?: DirectMessagesSubscriptionPayloadResolvers<ContextType>;
  EarnItem?: EarnItemResolvers<ContextType>;
  EducationHistory?: EducationHistoryResolvers<ContextType>;
  Employee?: EmployeeResolvers<ContextType>;
  EmployeeConnection?: EmployeeConnectionResolvers<ContextType>;
  EmployeeEdge?: EmployeeEdgeResolvers<ContextType>;
  Expectation?: ExpectationResolvers<ContextType>;
  File?: FileResolvers<ContextType>;
  FloatRangeRightBoundOptional?: FloatRangeRightBoundOptionalResolvers<ContextType>;
  GenericMatch?: GenericMatchResolvers<ContextType>;
  HighlightedText?: HighlightedTextResolvers<ContextType>;
  IP?: GraphQLScalarType;
  ISO8601Date?: GraphQLScalarType;
  ISO8601DateTime?: GraphQLScalarType;
  Industry?: IndustryResolvers<ContextType>;
  IntRangeRightBoundOptional?: IntRangeRightBoundOptionalResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JobsBaseInquiryInterface?: JobsBaseInquiryInterfaceResolvers<ContextType>;
  JobsCandidateInterface?: JobsCandidateInterfaceResolvers<ContextType>;
  JobsEmployer?: JobsEmployerResolvers<ContextType>;
  JobsFieldsBooleanInterface?: JobsFieldsBooleanInterfaceResolvers<ContextType>;
  JobsFieldsCategoryInterface?: JobsFieldsCategoryInterfaceResolvers<ContextType>;
  JobsFieldsConfiguration?: JobsFieldsConfigurationResolvers<ContextType>;
  JobsFieldsFloatInterface?: JobsFieldsFloatInterfaceResolvers<ContextType>;
  JobsFieldsFloatRangeInterface?: JobsFieldsFloatRangeInterfaceResolvers<ContextType>;
  JobsFieldsIntegerInterface?: JobsFieldsIntegerInterfaceResolvers<ContextType>;
  JobsFieldsIntegerRangeInterface?: JobsFieldsIntegerRangeInterfaceResolvers<ContextType>;
  JobsFieldsInterface?: JobsFieldsInterfaceResolvers<ContextType>;
  JobsFieldsRangePlaceholder?: JobsFieldsRangePlaceholderResolvers<ContextType>;
  JobsFieldsSelectInterface?: JobsFieldsSelectInterfaceResolvers<ContextType>;
  JobsFieldsSelectOption?: JobsFieldsSelectOptionResolvers<ContextType>;
  JobsFieldsSingleSelectRecordInterface?: JobsFieldsSingleSelectRecordInterfaceResolvers<ContextType>;
  JobsFieldsStringArrayInterface?: JobsFieldsStringArrayInterfaceResolvers<ContextType>;
  JobsFieldsStringInterface?: JobsFieldsStringInterfaceResolvers<ContextType>;
  JobsFieldsTooltip?: JobsFieldsTooltipResolvers<ContextType>;
  JobsHiring?: JobsHiringResolvers<ContextType>;
  JobsInquiry?: JobsInquiryResolvers<ContextType>;
  JobsInquiryFakeHiring?: JobsInquiryFakeHiringResolvers<ContextType>;
  JobsModeratorsCandidate?: JobsModeratorsCandidateResolvers<ContextType>;
  JobsModeratorsCandidateVisibilityOfAttributes?: JobsModeratorsCandidateVisibilityOfAttributesResolvers<ContextType>;
  JobsModeratorsEmployer?: JobsModeratorsEmployerResolvers<ContextType>;
  JobsModeratorsEmployerClient?: JobsModeratorsEmployerClientResolvers<ContextType>;
  JobsModeratorsEmployerConnection?: JobsModeratorsEmployerConnectionResolvers<ContextType>;
  JobsModeratorsEmployerEdge?: JobsModeratorsEmployerEdgeResolvers<ContextType>;
  JobsModeratorsEmployerHiringGroups?: JobsModeratorsEmployerHiringGroupsResolvers<ContextType>;
  JobsModeratorsEmployerSubscription?: JobsModeratorsEmployerSubscriptionResolvers<ContextType>;
  JobsModeratorsEmployersAccountOwner?: JobsModeratorsEmployersAccountOwnerResolvers<ContextType>;
  JobsModeratorsField?: JobsModeratorsFieldResolvers<ContextType>;
  JobsModeratorsFieldValueInterface?: JobsModeratorsFieldValueInterfaceResolvers<ContextType>;
  JobsModeratorsFieldValuesBoolean?: JobsModeratorsFieldValuesBooleanResolvers<ContextType>;
  JobsModeratorsFieldValuesFloat?: JobsModeratorsFieldValuesFloatResolvers<ContextType>;
  JobsModeratorsFieldValuesFloatRange?: JobsModeratorsFieldValuesFloatRangeResolvers<ContextType>;
  JobsModeratorsFieldValuesInteger?: JobsModeratorsFieldValuesIntegerResolvers<ContextType>;
  JobsModeratorsFieldValuesIntegerRange?: JobsModeratorsFieldValuesIntegerRangeResolvers<ContextType>;
  JobsModeratorsFieldValuesMultiSelect?: JobsModeratorsFieldValuesMultiSelectResolvers<ContextType>;
  JobsModeratorsFieldValuesMultiSelectRecord?: JobsModeratorsFieldValuesMultiSelectRecordResolvers<ContextType>;
  JobsModeratorsFieldValuesSelectRecordType?: JobsModeratorsFieldValuesSelectRecordTypeResolvers<ContextType>;
  JobsModeratorsFieldValuesSingleSelect?: JobsModeratorsFieldValuesSingleSelectResolvers<ContextType>;
  JobsModeratorsFieldValuesSingleSelectRecord?: JobsModeratorsFieldValuesSingleSelectRecordResolvers<ContextType>;
  JobsModeratorsFieldValuesString?: JobsModeratorsFieldValuesStringResolvers<ContextType>;
  JobsModeratorsFieldValuesStringArray?: JobsModeratorsFieldValuesStringArrayResolvers<ContextType>;
  JobsModeratorsFieldsBoolean?: JobsModeratorsFieldsBooleanResolvers<ContextType>;
  JobsModeratorsFieldsCategory?: JobsModeratorsFieldsCategoryResolvers<ContextType>;
  JobsModeratorsFieldsFloat?: JobsModeratorsFieldsFloatResolvers<ContextType>;
  JobsModeratorsFieldsFloatRange?: JobsModeratorsFieldsFloatRangeResolvers<ContextType>;
  JobsModeratorsFieldsInteger?: JobsModeratorsFieldsIntegerResolvers<ContextType>;
  JobsModeratorsFieldsIntegerRange?: JobsModeratorsFieldsIntegerRangeResolvers<ContextType>;
  JobsModeratorsFieldsMultiSelect?: JobsModeratorsFieldsMultiSelectResolvers<ContextType>;
  JobsModeratorsFieldsMultiSelectRecord?: JobsModeratorsFieldsMultiSelectRecordResolvers<ContextType>;
  JobsModeratorsFieldsSingleSelect?: JobsModeratorsFieldsSingleSelectResolvers<ContextType>;
  JobsModeratorsFieldsSingleSelectRecord?: JobsModeratorsFieldsSingleSelectRecordResolvers<ContextType>;
  JobsModeratorsFieldsString?: JobsModeratorsFieldsStringResolvers<ContextType>;
  JobsModeratorsFieldsStringArray?: JobsModeratorsFieldsStringArrayResolvers<ContextType>;
  JobsModeratorsHiring?: JobsModeratorsHiringResolvers<ContextType>;
  JobsModeratorsHiringConnection?: JobsModeratorsHiringConnectionResolvers<ContextType>;
  JobsModeratorsHiringEdge?: JobsModeratorsHiringEdgeResolvers<ContextType>;
  JobsModeratorsHiringExplanation?: JobsModeratorsHiringExplanationResolvers<ContextType>;
  JobsModeratorsHiringStateCounter?: JobsModeratorsHiringStateCounterResolvers<ContextType>;
  JobsModeratorsInquiry?: JobsModeratorsInquiryResolvers<ContextType>;
  JobsModeratorsInquiryConnection?: JobsModeratorsInquiryConnectionResolvers<ContextType>;
  JobsModeratorsInquiryEdge?: JobsModeratorsInquiryEdgeResolvers<ContextType>;
  JobsModeratorsInquiryMatch?: JobsModeratorsInquiryMatchResolvers<ContextType>;
  JobsModeratorsInquiryNote?: JobsModeratorsInquiryNoteResolvers<ContextType>;
  JobsModeratorsMatchInquiryPayload?: JobsModeratorsMatchInquiryPayloadResolvers<ContextType>;
  JobsModeratorsOpsRejectionReason?: JobsModeratorsOpsRejectionReasonResolvers<ContextType>;
  JobsModeratorsRecruiter?: JobsModeratorsRecruiterResolvers<ContextType>;
  JobsModeratorsScheduledMessage?: JobsModeratorsScheduledMessageResolvers<ContextType>;
  JobsModeratorsUser?: JobsModeratorsUserResolvers<ContextType>;
  JobsModeratorsVacancy?: JobsModeratorsVacancyResolvers<ContextType>;
  JobsModeratorsVacancyConnection?: JobsModeratorsVacancyConnectionResolvers<ContextType>;
  JobsModeratorsVacancyCreator?: JobsModeratorsVacancyCreatorResolvers<ContextType>;
  JobsModeratorsVacancyCreatorInterface?: JobsModeratorsVacancyCreatorInterfaceResolvers<ContextType>;
  JobsModeratorsVacancyEdge?: JobsModeratorsVacancyEdgeResolvers<ContextType>;
  JobsModeratorsVacancyFieldValue?: JobsModeratorsVacancyFieldValueResolvers<ContextType>;
  JobsModeratorsVacancyMatch?: JobsModeratorsVacancyMatchResolvers<ContextType>;
  JobsModeratorsVacancySubmission?: JobsModeratorsVacancySubmissionResolvers<ContextType>;
  JobsRecruiter?: JobsRecruiterResolvers<ContextType>;
  JobsRecruitersCandidate?: JobsRecruitersCandidateResolvers<ContextType>;
  JobsRecruitersCandidateConnection?: JobsRecruitersCandidateConnectionResolvers<ContextType>;
  JobsRecruitersCandidateEdge?: JobsRecruitersCandidateEdgeResolvers<ContextType>;
  JobsRecruitersClient?: JobsRecruitersClientResolvers<ContextType>;
  JobsRecruitersDistribution?: JobsRecruitersDistributionResolvers<ContextType>;
  JobsRecruitersDistributionBin?: JobsRecruitersDistributionBinResolvers<ContextType>;
  JobsRecruitersEmployer?: JobsRecruitersEmployerResolvers<ContextType>;
  JobsRecruitersEmployerSubscription?: JobsRecruitersEmployerSubscriptionResolvers<ContextType>;
  JobsRecruitersField?: JobsRecruitersFieldResolvers<ContextType>;
  JobsRecruitersFieldValueInterface?: JobsRecruitersFieldValueInterfaceResolvers<ContextType>;
  JobsRecruitersFieldValuesBoolean?: JobsRecruitersFieldValuesBooleanResolvers<ContextType>;
  JobsRecruitersFieldValuesFloat?: JobsRecruitersFieldValuesFloatResolvers<ContextType>;
  JobsRecruitersFieldValuesFloatRange?: JobsRecruitersFieldValuesFloatRangeResolvers<ContextType>;
  JobsRecruitersFieldValuesInteger?: JobsRecruitersFieldValuesIntegerResolvers<ContextType>;
  JobsRecruitersFieldValuesIntegerRange?: JobsRecruitersFieldValuesIntegerRangeResolvers<ContextType>;
  JobsRecruitersFieldValuesMultiSelect?: JobsRecruitersFieldValuesMultiSelectResolvers<ContextType>;
  JobsRecruitersFieldValuesMultiSelectRecord?: JobsRecruitersFieldValuesMultiSelectRecordResolvers<ContextType>;
  JobsRecruitersFieldValuesSelectRecordType?: JobsRecruitersFieldValuesSelectRecordTypeResolvers<ContextType>;
  JobsRecruitersFieldValuesSingleSelect?: JobsRecruitersFieldValuesSingleSelectResolvers<ContextType>;
  JobsRecruitersFieldValuesSingleSelectRecord?: JobsRecruitersFieldValuesSingleSelectRecordResolvers<ContextType>;
  JobsRecruitersFieldValuesString?: JobsRecruitersFieldValuesStringResolvers<ContextType>;
  JobsRecruitersFieldValuesStringArray?: JobsRecruitersFieldValuesStringArrayResolvers<ContextType>;
  JobsRecruitersFieldsBoolean?: JobsRecruitersFieldsBooleanResolvers<ContextType>;
  JobsRecruitersFieldsCategory?: JobsRecruitersFieldsCategoryResolvers<ContextType>;
  JobsRecruitersFieldsFloat?: JobsRecruitersFieldsFloatResolvers<ContextType>;
  JobsRecruitersFieldsFloatRange?: JobsRecruitersFieldsFloatRangeResolvers<ContextType>;
  JobsRecruitersFieldsInteger?: JobsRecruitersFieldsIntegerResolvers<ContextType>;
  JobsRecruitersFieldsIntegerRange?: JobsRecruitersFieldsIntegerRangeResolvers<ContextType>;
  JobsRecruitersFieldsMultiSelect?: JobsRecruitersFieldsMultiSelectResolvers<ContextType>;
  JobsRecruitersFieldsMultiSelectRecord?: JobsRecruitersFieldsMultiSelectRecordResolvers<ContextType>;
  JobsRecruitersFieldsSingleSelect?: JobsRecruitersFieldsSingleSelectResolvers<ContextType>;
  JobsRecruitersFieldsSingleSelectRecord?: JobsRecruitersFieldsSingleSelectRecordResolvers<ContextType>;
  JobsRecruitersFieldsString?: JobsRecruitersFieldsStringResolvers<ContextType>;
  JobsRecruitersFieldsStringArray?: JobsRecruitersFieldsStringArrayResolvers<ContextType>;
  JobsRecruitersInquiry?: JobsRecruitersInquiryResolvers<ContextType>;
  JobsRecruitersRecruiter?: JobsRecruitersRecruiterResolvers<ContextType>;
  JobsRecruitersVacancy?: JobsRecruitersVacancyResolvers<ContextType>;
  JobsRecruitersVacancyFieldValue?: JobsRecruitersVacancyFieldValueResolvers<ContextType>;
  JobsRecruitersVacancyPromptTemplate?: JobsRecruitersVacancyPromptTemplateResolvers<ContextType>;
  JobsRecruitersVacancySubmission?: JobsRecruitersVacancySubmissionResolvers<ContextType>;
  JobsVacancy?: JobsVacancyResolvers<ContextType>;
  JobsVacancySubmission?: JobsVacancySubmissionResolvers<ContextType>;
  JobsVacancySubmissionInterface?: JobsVacancySubmissionInterfaceResolvers<ContextType>;
  JobsVacancySubmissionVisibilityOfAttributes?: JobsVacancySubmissionVisibilityOfAttributesResolvers<ContextType>;
  Link?: LinkResolvers<ContextType>;
  LinkedinPost?: LinkedinPostResolvers<ContextType>;
  LinkedinProfileImportedPayload?: LinkedinProfileImportedPayloadResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  MessageConnection?: MessageConnectionResolvers<ContextType>;
  MessageEdge?: MessageEdgeResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Notification?: NotificationResolvers<ContextType>;
  NotificationConnection?: NotificationConnectionResolvers<ContextType>;
  NotificationEdge?: NotificationEdgeResolvers<ContextType>;
  NotificationReferenceable?: NotificationReferenceableResolvers<ContextType>;
  OnboardingData?: OnboardingDataResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Poll?: PollResolvers<ContextType>;
  PollChoice?: PollChoiceResolvers<ContextType>;
  PollVote?: PollVoteResolvers<ContextType>;
  PollVoteConnection?: PollVoteConnectionResolvers<ContextType>;
  PollVoteEdge?: PollVoteEdgeResolvers<ContextType>;
  PortfolioCurrentUser?: PortfolioCurrentUserResolvers<ContextType>;
  PortfolioDeal?: PortfolioDealResolvers<ContextType>;
  PortfolioDealConnection?: PortfolioDealConnectionResolvers<ContextType>;
  PortfolioDealEdge?: PortfolioDealEdgeResolvers<ContextType>;
  PortfolioDealQuarter?: PortfolioDealQuarterResolvers<ContextType>;
  PortfolioDealsSource?: PortfolioDealsSourceResolvers<ContextType>;
  PortfolioRanking?: PortfolioRankingResolvers<ContextType>;
  PortfolioUserSearchResult?: PortfolioUserSearchResultResolvers<ContextType>;
  Post?: PostResolvers<ContextType>;
  PostConnection?: PostConnectionResolvers<ContextType>;
  PostEdge?: PostEdgeResolvers<ContextType>;
  PostView?: PostViewResolvers<ContextType>;
  PostViewConnection?: PostViewConnectionResolvers<ContextType>;
  PostViewEdge?: PostViewEdgeResolvers<ContextType>;
  PotentialEmployer?: PotentialEmployerResolvers<ContextType>;
  ProductType?: ProductTypeResolvers<ContextType>;
  Public?: PublicResolvers<ContextType>;
  PublicPortfolioConfiguration?: PublicPortfolioConfigurationResolvers<ContextType>;
  PublicPortfolioCurrentUser?: PublicPortfolioCurrentUserResolvers<ContextType>;
  PublicPortfolioUser?: PublicPortfolioUserResolvers<ContextType>;
  PublicPortfolioUserIterface?: PublicPortfolioUserIterfaceResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Rating?: RatingResolvers<ContextType>;
  RatingConnection?: RatingConnectionResolvers<ContextType>;
  RatingEdge?: RatingEdgeResolvers<ContextType>;
  Reactable?: ReactableResolvers<ContextType>;
  ReadThreadEvent?: ReadThreadEventResolvers<ContextType>;
  Region?: RegionResolvers<ContextType>;
  RegionConnection?: RegionConnectionResolvers<ContextType>;
  RegionEdge?: RegionEdgeResolvers<ContextType>;
  RelatedCompany?: RelatedCompanyResolvers<ContextType>;
  RelatedCompanyPageResponse?: RelatedCompanyPageResponseResolvers<ContextType>;
  Request?: RequestResolvers<ContextType>;
  RequestConnection?: RequestConnectionResolvers<ContextType>;
  RequestEdge?: RequestEdgeResolvers<ContextType>;
  RequestParticipant?: RequestParticipantResolvers<ContextType>;
  RoleCategory?: RoleCategoryResolvers<ContextType>;
  SalesDirectoryPage?: SalesDirectoryPageResolvers<ContextType>;
  SalesDirectoryUser?: SalesDirectoryUserResolvers<ContextType>;
  SalesGptQuery?: SalesGptQueryResolvers<ContextType>;
  SalesRole?: SalesRoleResolvers<ContextType>;
  SalesTeamTenureAverage?: SalesTeamTenureAverageResolvers<ContextType>;
  SalesTeamTenureAverages?: SalesTeamTenureAveragesResolvers<ContextType>;
  SearchInfo?: SearchInfoResolvers<ContextType>;
  SearchResultInterface?: SearchResultInterfaceResolvers<ContextType>;
  SearchResultInterfaceConnection?: SearchResultInterfaceConnectionResolvers<ContextType>;
  SearchResultInterfaceEdge?: SearchResultInterfaceEdgeResolvers<ContextType>;
  SearchResultsCategory?: SearchResultsCategoryResolvers<ContextType>;
  Story?: StoryResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SuggestedUser?: SuggestedUserResolvers<ContextType>;
  SuggestedUserConnection?: SuggestedUserConnectionResolvers<ContextType>;
  SuggestedUserEdge?: SuggestedUserEdgeResolvers<ContextType>;
  Testimonial?: TestimonialResolvers<ContextType>;
  TestimonialAuthor?: TestimonialAuthorResolvers<ContextType>;
  TestimonialRequestor?: TestimonialRequestorResolvers<ContextType>;
  Thread?: ThreadResolvers<ContextType>;
  Tooltip?: TooltipResolvers<ContextType>;
  Topic?: TopicResolvers<ContextType>;
  TopicConnection?: TopicConnectionResolvers<ContextType>;
  TopicEdge?: TopicEdgeResolvers<ContextType>;
  TotalCompensationRange?: TotalCompensationRangeResolvers<ContextType>;
  University?: UniversityResolvers<ContextType>;
  UniversityConnection?: UniversityConnectionResolvers<ContextType>;
  UniversityEdge?: UniversityEdgeResolvers<ContextType>;
  UniversityMatch?: UniversityMatchResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserAchievement?: UserAchievementResolvers<ContextType>;
  UserAuthor?: UserAuthorResolvers<ContextType>;
  UserConnection?: UserConnectionResolvers<ContextType>;
  UserContact?: UserContactResolvers<ContextType>;
  UserEdge?: UserEdgeResolvers<ContextType>;
  UserPost?: UserPostResolvers<ContextType>;
  UserPostConnection?: UserPostConnectionResolvers<ContextType>;
  UserPostEdge?: UserPostEdgeResolvers<ContextType>;
  UserSearch?: UserSearchResolvers<ContextType>;
  VendorDbUser?: VendorDbUserResolvers<ContextType>;
  WarRoomPostCommentSearchResult?: WarRoomPostCommentSearchResultResolvers<ContextType>;
  WarRoomPostSearchResult?: WarRoomPostSearchResultResolvers<ContextType>;
  WarRoomUserSearchResult?: WarRoomUserSearchResultResolvers<ContextType>;
  WorkHistory?: WorkHistoryResolvers<ContextType>;
  WorkHistoryMatch?: WorkHistoryMatchResolvers<ContextType>;
  YoutubeLink?: YoutubeLinkResolvers<ContextType>;
};

